import axios from "axios";
import {
  put,
  take,
  takeEvery,
  takeLatest,
  takeLeading,
  delay,
  call,
} from "redux-saga/effects";
import { sagaActions } from "./Action";
import Swal from "sweetalert2";
import {
  //----login-----------
  getUserSuccessAction,
  getUserErrorAction,
  settheLoginIds,
  SetUserREtrieveActions,
  //-----File-=-----Actives
  getSideBarfilesActions,
  ///---TO ---Set---ROle
  setTheRoleName,
  setTheUserEmailIDS,
  SetARole,
  setTheUDSAttendanceTOKEN,
  setTheUDSTOKEN,
  setTheudsEmployeeImage,
  //Forgot-----
  getForgotPasswordErrorMessage,
  getForgotPasswordEmail,
  getForgotPasswordPerosonSuccessResponse,
  getForgotPasswordPerson,
  //Otp---Verify-----
  getOtpVerifyActionsSuccessResponse,
  getOtpVerifyErrorResponse,
  //-----UpdatePassword
  getUpdatedPasswordSuccessResponse,
  getUpdatedPassswordError,
  ////------ROlelist
  getRoleListActions,
  getRoleListSuccessResponseActions,
  getRoleListTotal_pageCounst,
  getRoleListErroResponsen,
  //----ROleCreate------------
  getRoleCreateSuccessActions,
  getRoleCreateErrors,
  ///----Role----Deletes----
  setRoleDeleteErrorActions,
  SetRoleDeleteSuccessResponseCall,
  //----Role---Retrieve
  setRoleRetrieveErrorCall,
  setRoleRetrieveSuccessResponseCall,
  //----Role----Edits--
  setRoleEditErrors,
  setRoleEditSuccessResponse,
  //---Users----Get---List
  setUserActions,
  setUserSuccessResponse,
  setUserErrorsMessage,
  setTotal_count_user,
  ///-----User---Deletes---
  setUserDeleteSuccessResponse,
  setUserDeleteErrorMessage,
  //-----User---Create-----------
  setUserCreateSuccessAction,
  setUserCreateError,
  //---UserREtrieve------
  SetUserRetrieveError,
  SetUserRetrieveSuccessResponse,
  //-----UserEDits---
  SetUserEditsErrorMessage,
  SteUserEditSuccessResponse,
  //-----Geo----LOcations
  ///---State
  SetGeoListTotalCount,
  setGeoStateErrorMessages,
  setGeoStateSuccessResponseActions,
  setGeoLoactionStateAction,
  //---State----Create---
  getStateCreateSuccessResponse,
  getStateErroMessage,
  //---State---Delete
  setSatteDeleteSuccessResponse,
  setStateDeleteErrorMessage,
  ///----State--Edits
  setStateEditErrors,
  setStateEditSuccessResponse,
  setStateRetrirveSuccessActions,
  setStateRetrieveErrorCall,
  //----Regions----
  setRegionActions,
  setRegionSuccessResponse,
  setRegionTotal_counts,
  setRegionsError,
  //---Region---CreateSETBASICFORMdetails
  getRegionCreateSuccessResponse,
  getRegionErroMessage,
  //---rEGION--dELETE
  setRegionDeleteSuccessResponse,
  setRegionDeleteErrorMessage,
  //-----REgion---Retrirve
  setRegionRetrirveSuccessActions,
  setRegionRetrieveErrorCall,
  //---REgion--edits
  setRegionEditSuccessResponse,
  setRegionEditErrors,
  ///---ZONES___
  setZoneActions,
  setZoneSuccessResponse,
  setZoneErrorMessages,
  SteZoneListToTal_counts,
  //---ZONE----Creates---
  getZoneCreateSuccessResponse,
  getZoneErroMessage,
  setZoneDeleteSuccessResponse,
  setZoneDeleteErrorMessage,
  //---ZoneEdit--retrieve
  setZoneRetrieveErrorCall,
  setZoneRetrirveSuccessActions,
  setZoneEditSuccessResponse,
  setZoneEditErrors,
  ///---Clients
  SetClientErrorActions,
  SetClientActions,
  SetClientSuccessRespoenesActions,
  SetClientTotal_CountActions,
  //----Client---Create/Delete
  getClientCreateSuccessResponse,
  getClientErroMessage,
  setCLientDeleteSuccessResponse,
  setClientDeleteErrorMessage,
  //----Client----EDIt----RETRIEVE
  setClientRetrieveErrorCall,
  setClientRetrirveSuccessActions,
  setClientEditSuccessResponse,
  setClientEditErrors,
  //----Client---Branch
  setClientBranchActions,
  setClientBranchesSuccessResponse,
  setClientBranchessTotal_count,
  setCLientBranchesErrorsMessage,
  //---Branches---Create
  setClientBranchCreateSuccessAction,
  setClientBranchCreateError,
  ///----Branch---Deleet
  setClientBranDeleteSuccessResponse,
  setClientBranDeleteErrorMessage,
  //---Edit-----Retrieve
  SetClientBranchesRetrieveSuccessResponse,
  SetClientBranchesREtrieveErrorRetieve,
  SetBranchEditsErrorMessage,
  SetBranchEditSuccessResponse,
  //----Branches----
  setClientBrancheSearchSuccesRespones,
  setClientBranchSearchErrorActions,
  setClientBrancheSearchTotal_counts,
  ///----Shift---
  SetShiftTotal_countActions,
  setshiftListResponseActions,
  setShiftListsActions,
  setShiftErrorMessages,
  //---Shift---Create
  SetShiftCreatedSuccessResponse,
  SteShiftCreateErrorResponse,
  ////---SHift---Delete----
  setShiftDeleteSuccessResponse,
  setShiftDeleteErrorMessages,
  //---Shift------Retrieve , Edit
  SetRetrieveSuccessAction,
  SetShiftRetrieveErrorActions,
  SetShiftEditSuccessActions,
  SetShiftEditsErrorMessages,
  //---Shift--Search
  SetShiftSearchSuccessResponse,
  SetShiftSearchError,
  SetShiftSearchActions,
  SetShiftSearchTotal_Counts,
  //--Employeee
  setEmployeeErrorMessages,
  setEmployeeListResponseActions,
  SetEmployeeTotal_countActions,
  setEmployeetListsActions,
  //---Employee---Create
  SetEmployeeActions,
  SetEmployeeSuccessResponen,
  SetEmployeeErrorActions,
  //---Employee----Delete
  SetEmployeeDeleteSuccessResponen,
  SetEmployeeDeleteErrorActions,
  //---Edit----REtrieve
  SetEmployeeEditcallSuccessResponse,
  SetEmployeeEditcallErrorActions,
  SetEmployeeRetrieveSuccessResponen,
  SetEmployeeRetrieverrorActions,
  //---Employee---Data---list
  SetEmployeeDataTotal_countActions,
  setEmployeeListDATASResponseActions,
  setEmployeeListsActions,
  setEmployeeDataErrorMessages,
  ///---Employee---Person---List
  getEmployeeListPersonsListed,
  setEmployeeListSPersonsResponseActions,
  SetTheInquriyStatus,
  setEmployeeDataPersonsErrorMessages,
  SetEmployeeDataTotal_countPersonsActions,
  //---Employeee--Details---ABout---forms
  setEmployeeListProfileSResponseActions,
  SetEmployeeDataprofileTotal_countActions,
  setEmployeeDataprofileErrorMessages,
  ///----BasicForms-----------------
  SETBasicFOrmError,
  SETBASICFORMdetails,
  //---Address------Actions
  SetAddressFormAction,
  SetAddressFormError,
  ///----IDVerify-----Actions
  SetIdverificationFormError,
  SetIdVerificationFormAction,
  //--Id--verify--Edits
  SetTheIDverifycationEditResponse,
  SetIdverificationEditError,
  setThPanVerifyCounts,

  //---Bank---Details----
  SetBankDataResponeActions,
  setBankDataError,
  //----Educations----------
  SetEducationDataResponeActions,
  setEducationDataError,
  //---Previous---Emp
  SetPreviuousEmpDataResponeActions,
  setPreviousDataError,
  ///--Family--Details----
  SetFamilyEmpDataResponeActions,
  setFamilyDataError,
  ///-Decalaration__From--view
  setDecalarationActionData,
  setDecalarationDataError,
  //--ESI___FORM
  setESIRESPONSESData,
  setESIDataError,
  //--JOB---Offers---Form
  SetJobofferresponse,
  SetJobofferError,
  //---Forms-----Approvals-----------
  SetApprovalResponseActions,
  SetApprovalErrorStatus,
  ///----Verified----Users
  SetVerifiedUsersResponse,
  SetVerifiedUserError,
  SetTotal_counts_for_VerifiedEmployees,
  //----Joining-------------Date-
  SetTheJoiningDateResponseCall,
  SetTheJoiningDateCall,
  SetThaeJoiningDateErrorMessage,
  ///---Signature
  SetSignatureResponses,
  SetSignatureErrorMessage,
  ///---User-----Filter---
  SetUserFilterResponses,
  setTotal_count_userfilter,
  setUserErrorsMessageFilter,
  //---Employee---List-----Filter--PEN-DEC_COMPE-
  setEmployeeListSPersonsFilterResponseActions,
  SetTheInquriyStatusFilter,
  SetEmployeeDataTotal_countPersonsFilterActions,
  setEmployeeDataPersonsFilterErrorMessages,
  //----excel---sheet----uploads----------
  setTheExcelSheetresponseStatus,
  SetTheExcelSheetErrors,
  ///---Excel-----Sheet---TO--Clear---Input--field---in frontend----, to set---the coutn
  ///---actions
  SetTheExcelSheetRender,
  ///--Leave---Type---Create-
  SetLeaveTypeCreate,
  SetLeaveTypeError,
  ///----Leave----type---List---Out
  SetLeaveTypeActions,
  setLeaveTypeResponseTotalCounts,
  SetLeaveTypeListError,
  setLeaveTypeResponses,
  ///---LeaveType---Delete
  setLeaveTypeResponsesDelete,
  SetLeaveTypeDeleteError,
  ////---Leave---Type--_Retrieve
  setLeaveTypeResponsesRetrieve,
  SetLeaveTypeRetrieveError,
  ///---Leave---Type---_Edits
  setLeaveTypeResponsesEdit,
  SetLeaveTypeEditError,
  ////---Leave---Permission---List
  SetTheLeavePermissionListActions,
  SetTheLeavePermissionlistResponse,
  SetTheLeavePermissionListTotal_counts,
  SetTheLeavePermissionListError,
  ////---Leave----Permission---Search---Lisrt
  SetTheLeavePermissionlistSearchResponse,
  SetTheLeavePermissionListSearchTotal_counts,
  SetTheLeavePermissionListSearchError,
  ///--Leave---Permission---Delete---
  SetTheLeavePermissionDeleteResponse,
  SetTheLeavePermissionDeleteError,
  /////---Leave----Permission--Retrieve---
  SettheLeaveRetrievePremissionActions,
  SetTheLeavePermissionErrorRetrieve,
  ////----Leave----Permission---Edits--
  SettheLeaveEditsPremissionActions,
  SetTheLeavePermissionErrorEdits,
  ///---DashBoards----
  setTheDashboardResponses,
  setTheDashboardErrors,
  ///---Leave---Status-----
  setLeaveStatusLisPersonsResponseActions,
  SetTheInquriyLeaveStatus,
  SetLeaveStatusLisDataTotal_countPersonsActions,
  setLeaveStatusLisDataPersonsErrorMessages,
  ///---Excel---Sheet---Upload---get--methods
  getShiftStatusPersonsListed,
  setShiftStatusLisPersonsResponseActions,
  SetShiftDataTotal_countPersonsActions,
  setShiftsDataPersonsErrorMessages,
  ///---shift---Permission
  setTheshiftPermissionRespons,
  setTheShiftPermissionTotal_counts,
  setShiftPermissionError,
  ///---Shift---
  SettheShiftRetrievePremissionActions,
  SetTheShiftermissionErrorRetrieve,
  setShiftPermissionActions,
  SettheShiftditsPremissionActions,
  SetTheShiftPermissionErrorEdits,
  ////---Shift---Deletet---Permission
  SetTheshiftPermissionDeleteResponse,
  SetTheShiftPermissionDeleteError,
  ///---Re--InvestMent------Get--List
  setReinvestmentResponse,
  setReinvestmentTotal_counts,
  setReInvestmentError,
  ///---Reinvestment----retrieve
  SettheReinvestmentRetrieveActions,
  SetReinvestmentErrorRetrieve,
  ////----ReInvestment---Edit---
  setReinvestmentAction,
  SettheReInvestmentResponsesActions,
  SetTheReInvestmentErrorEdits,
  //----Shift---Excel---Sheet---rETRIEVE---
  setTheShiftexcelRetrieveResponse,
  setTheShiftExcelSheetError,
  ///-----On----Duty----get---List
  SetTheOndutyActions,
  SeTheOndutyRespones,
  SetheOndutytatolCounts,
  SetTheIndutyError,
  ////----On---Duty----Retrieve---
  SettheOndutyResponeActions,
  SetTheOndutyErrorRetrieve,
  ///----On----Duty----edits-----
  SettheOndutyEditReponse,
  SetTheOndutyErrorEdits,
  ////---on---Duty===Delete
  SetTheOndutyDeleteResponse,
  SetTheOndutyDeleteError,
  SeTheResignRespones,
  SetheResigntatolCounts,
  SetTheresignError,
  ///----Resign---Retrieve-----
  SettheResignResponeActions,
  SetTheResignErrorRetrieve,
  ///----Resign----Edits----
  SettheResignEditReponse,
  SetTheResignErrorEdits,
  SetTheResignActions,
  ///---Resign----Delete----
  SetTheResginDeleteResponse,
  SetTheResignDeleteError,
  ////----Exit----get----
  SetTheExitActions,
  SeTheExitRespones,
  SetheExittatolCounts,
  SetTheExitError,
  ////---Retrieve---Exit----
  SettheExitResponeActions,
  SetTheExitErrorRetrieve,
  ///---Exit----edit----
  SettheExitEditReponse,
  SetTheExitErrorEdits,
  ///----Exit----Delete----
  SetTheExitDeleteResponse,
  SetTheExitDeleteError,
  ///---Appraisal------------------
  setAppraisalAction,
  setAppraisaltResponse,
  setAppraisalTotal_counts,
  setAppraisalError,
  ////---retrieve====
  SetTheAppraisalRetrieveActions,
  SettheAppraisalRetrieveActions,
  SetAppraisalErrorRetrieve,
  ///-----Edits---
  SetTheAppraisalditsActions,
  SetTheAppraisalErrorEdits,
  SettheAppraisalResponsesActions,
  ///--Pay--SLip---
  setThePayslipAcrions,
  getPaySlipSuccessResponseActions,
  getPaySlipTotal_pageCounst,
  getPaySlipErroResponsen,
  ///--Pay--slip---create
  setThePayslipCreateAcrions,
  getPaySlipSuccessCreaetResponseActions,
  getPaySlipErroCreateResponsen,
  ///--Basic--Form--Create
  SetActionsBasicFormscreateDetails,
  SETBASICFORMcreatedetails,
  SETBasicFOrmcreateError,
  setTheBacisHoldDatas,
  ///------Address--Create--
  SetAddressCreateForm,
  SetAddressFormcreateAction,
  SetAddressFormcreateError,
  ///----Job--Offer--create
  SetJObofferCallAction,
  SetJobofferresponseCreate,
  SetJobofferErrorcreate,
  //----Bank---Detaile-----
  setBankDataCreateActions,
  SetBankDataResponecreateActions,
  setBankDatacreateError,

  ////---Education---
  setEducationDatacreateActions,
  SetEducationDataResponecrateActions,
  setEducationDatacreateError,
  ///---Field---agent-----branch---list
  setThefieldAgentbranchactions,
  setfieldbranchResponseActions,
  setfieldagentErrorMessages,
  SetFieldagentTotalCount,
  ///---Manger---employee-list
  getEmployeeListcreatePersonsListed,
  setEmployeeListSPersonsManagerResponseActions,
  SetTheInquriyStatusmanager,
  setEmployeeDataPersonsManagerErrorMessages,
  SetEmployeeDataTotal_countPersonsManagerActions,
  ///---from---ediy
  SetEmployeeProfileDetailsID,
  SetActionsBasicFormsEditDetails,
  SETBASICFORMEDITdetails,
  setTheUser_ID,
  SETBasicFOrmEditError,
  ///--address--edit---
  SetAddressForm,
  ///--Tabs---
  SetActiveTabs,
  ///---address--edit--
  SetAddressEditForm,
  SetAddressFormEDitAction,
  SetAddressFormEditError,
  ///Job-offerletter-edit
  SetJObofferDITCallAction,
  setHrApprovalCallAction,
  SetJobofferresponseEDIT,
  SetJobofferErrorEDIt,
  ///-----ID_--verify--cation-----Create
  setIdVerificationActionsCreate,
  SetIdVerificationFormcreateAction,
  SetIdverificationFormcreateError,
  ///------- idverification-----verifing
  SetTheIdVerifycationActions,

  ///======bank--Details--Edit----
  setBankDataEditActions,
  SetBankDataResponeEditActions,
  setBankDataEditError,
  ////--Declaration---form-----
  SetDeclarationEditAction,
  setDecalarationEditActionData,
  setDecalarationEditDataError,
  SetDeclarationcreateAction,
  setDecalarationDatacreateError,
  setDecalarationActioncreateData,
  ///----ESI---Form----
  SetESIEditCALLAction,
  setESIRESPONSESEditData,
  setESIDataEditError,
  SetESICraeteCALLAction,
  setESIRESPONSESCreateData,
  setESIDataCraeteError,

  // Upadate No-due form
  SetExitNoDueEditResponeActions,
  SetExitNoDueEditErrorRetrieve,

  ///---
  SetActionsBasicFormsDetails,
  ///---Job--Offer---Infor---retrieve--
  SetJObofferCall,
  ////--Previous----Data----
  setPreviousDataFetchActions,
  SetThePreviousDataResponsesActions,
  setThePreviousErrAction,
  //----Data--FEtch---
  settheDataFetchActions,
  setTheDataFetchRESponse,
  setTheDataFETCHerror,
  ///--Id----verify---Edit--
  setIdVerificationActionsEdit,
  SetIdVerificationFormEditAction,
  SetIdverificationFormEditError,
  //---ID---Verify----Retrieve---
  setIdVerificationActions,
  ///--Bank--Retieve---  settheGrievanceApproveretrieveActions,
  setTheGrievanceApproveretrieveRESponse,
  setTheGrievanceApproveretrieveerror,
  setBankDataActions,

  ///---------Previous----Call
  setPreviousEmpDataCreateActions,
  SetPreviuousEmpDataCreateResponeActions,
  setPreviousDataCreateError,
  setPreviousEmpDataeditActions,
  SetPreviuousEmpDataEditResponeActions,
  setPreviousDataEditError,
  setPreviousEmpDataActions,
  //---declaration---form
  SetDeclarationAction,
  ///---------Pay---slip--Retrieve--
  setThePayslipRtrievecrions,
  getPaySlipSuccessRrtrieveResponseActions,
  getPaySlipErroRetriveResponsen,
  //---Pay--slip---edit
  setThePayslipEditActions,
  getPaySlipSuccessEditResponseActions,
  getPaySlipErroeditResponsen,
  //----grievance----call
  setGrievanceAction,
  setGrievanceResponse,
  setgrievanceTotal_counts,
  setgrievanceError,
  ///--Grievance---Type---Creaet
  settheGrievanceCreateActions,
  setTheGrievanceCreateRESponse,
  setTheGrievanceCreateerror,
  ///--grieveance----delete---
  setThegrieveacncedeleteActions,
  setThegrieveancedeletereponses,
  setThegrieveancedeleteErrors,

  ///------retrieve----
  settheGrievanceRetrieveActions,
  setTheGrievanceRetrieveRESponse,
  setTheGrievanceREtriveerror,
  ///---grievance--tpe----Edit
  settheGrievanceEditActions,
  setTheGrievanceEditRESponse,
  setTheGrievancediterror,
  ///----Form----ID0-----Callls-----
  SetBasiformsID,
  ////---ESI____FROM___-
  SetESICALLAction,
  SetAddressId,
  SetIdVeriications,
  setBankDetailsId,
  SetEducationDetails,
  SetPreviousEmployeeID,
  SetDeclarationId,
  SetEsiFormIdActions,
  SetJobOfferID,
  setEducationDataActions, ///--Retrieve----for---education details--
  setfamliydetailsid,
  ///---Family---datas-----create---Edit---
  setFamilyEmpDatacreateActions,
  SetFamilyEmpDatacreateResponeActions,
  setFamilyDatacreateError,
  SetFamilyEmpDataEditResponeActions,
  setFamilyEmpDataEditActions,
  setFamilyDataEditError,
  ////---Famliy---Details-----Retriev---Call--
  setFamilyEmpDataActions,

  // Performance
  setPerformanceAction,
  setPerformanceResponse,
  setPerformanceTotal_counts,
  setPerformanceError,
  // Performance-type
  setPerformanceRetreveResponse,
  setPerformanceRetreveTotal_counts,
  setPerformanceRetreveError,
  // Performance-Create
  setPerformanceCreateResponse,
  setPerformanceCreateError,
  // Performance-Update
  setPerformanceUpdateResponse,
  setPerformanceUpdateError,
  // Performance-Delete
  setPerformanceDeleteResponse,
  setPerformanceDeleteError,
  setPerformanceChildAction,
  setPerformanceChildResponse,
  setPerformanceChildTotal_counts,
  setPerformanceChildError,
  setPerformanceChildRetreveResponse,
  setPerformanceChildRetreveTotal_counts,
  setPerformanceChildRetreveError,
  setPerformanceChildCreateResponse,
  setPerformanceChildCreateError,
  setPerformanceUpdateChildResponse,
  setPerformanceUpdateChildError,
  setPerformanceChildDeleteResponse,
  setPerformanceChildDeleteError,
  ///---_Education---Details----
  SetEducationDataPutResponeActions,
  setEducationDataPutError,
  ///-----Perform-----
  setPerformanceFieldError,
  setPerformanceFieldTotal_counts,
  setThePerformsFieldResponse,
  ////---Performs-------Field---agent---Retrieve-----Datas
  setThePerformsAgentRetrieveACtion,
  setPerformanceRetrieveFieldResponse,
  setPerformanceRetrieveFielError,
  ///---Sheet---Uploads---
  setTheExcelSheetUploadSTActions,
  setTheExcelSheetuploadERROES,
  setTheSHeetuploaAction,
  ///-----Create--employee----sign
  setThecreateEmploSigAction,
  settheCreateEmployeeResponse,
  settheCreareEmployeErr,
  ///--signature---pad
  SetSignaturePops,
  Files,

  ////--Grievance----Employee---List
  setGrievanceEMPListAction,
  setGrievanceEMpListResponse,
  setgrievanceEmpListTotal_counts,
  setgrievanceEmpListError,

  ///------grieavance--approva;;;-
  SetTheGrievaceApprovalActions,
  setTheGrievanceApprovalResponse,
  setTheGrievanceApprovalErrors,
  ////--Grievance----retriev---for---approve
  settheGrievanceEMPApproveretrieveActions,
  setTheGrievanceApproveEMPretrieveRESponse,
  setTheGrievanceApproveEMPretrieveerror,
  ///--Attendance---Request---
  StetheAttendanceActions,
  SetTheAttendanceResponseActions,
  setTeAttendanceTotal_counts,
  setTheAttendanceListError,
  ////--------------Attendance-------------
  StetheAttendanceRetrievActions,
  SetTheAttendanceResponseRetriveActions,
  setTheAttendanceListRetrieveError,
  /////----Performances----field===agent-----edit===
  setThePerformsAgentEditACtion,
  setPerformanceEditFieldResponse,
  setPerformanceEditFielError,
  ///---create----
  setThePerformsAgentCreateACtion,
  setPerformanceCreateFieldResponse,
  setPerformanceCreateFielError,
  ////-perform----separate---api---call-------with stand--id
  setThePerformsAgentRetrieveseparatestandACtion,
  setPerformanceRetrieveFieldseparateResponse,
  setPerformanceRetrieveFielseparateError,
  ////===================attendance-------------
  StetheAttendanceExportActions,
  SetTheAttendanceResponseExportActions,
  setTheAttendanceListExportError,
  ////--Performance------name----Header--
  setTheNameFormForm,
  ////--Black----list---
  SetTheBlacklistActions,
  SetTheBlackllistResponse,
  SetTheBlackistTotal_counts,
  SetTheBlacklistError,

  /////---black--list---retrieve---
  SetTheBlacklistRetrieveActions,
  SettheBlacklistresponseRetrieveActions,
  SetBlacklistErrorRetrieve,
  //--edit---
  SetTheBlacklistEditsActions,
  SettheBlacklistResponsesActions,
  SetTheBlacklistErrorEdits,
  ////--site---transfer---
  SetTheSiteTransferActions,
  SetThesiteTramsferResponse,
  SetThesiteTramfersTotal_counts,
  SetTheSiteTranferError,
  ///-------site-----Transfer---------retrieve---
  SetTheSiteTransferRetrieveActions,
  SettheSiteTransferRetrieveResponsesActions,
  SetSiteTransferErrorRetrieve,
  ///---site--tramsfer--edit
  SetTheSiteTransferEditsActions,
  SettheSiteTranfserResponsesActions,
  SetTheSiteTramsferErrorEdits,
  ////////--Site---Transfer----------
  SetTheSiteTransferCreateActions,
  SettheSiteTranfserResponsesCreateActions,
  SetTheSiteTramsferErrorCreate,
  ///---black---list-------create---call
  SetTheBlacklistCreateActions,
  SettheBlacklistresponseCreateActions,
  SetBlacklistErrorCreate,
  ///---Send---Notifications---------------------------
  SetThesendNotificationCreateActions,
  setTheNotificationcreateResponse,
  SetTheSendnotificationErrorCreate,
  ///----Pdfformat------dowloads-----------
  sethtmlformatpdfdownoadActions,
  setHtlformatpdfdownloadreponse,
  sethtmlformatpdfdownloaderr,
  ////----Appraisal----html format post call
  setAppraisalHtmlPostActions,
  settheAppraisalHtmlFormatsPostsResponse,
  setTheAppraisalErrorReponseshtmlForm,
  ///---Atttendance---export----get---list
  setAttendanceExportgetlistActions,
  setTheAttendanceExportgetListReponse,
  setTheAttendanceExportTotal_counts,
  setTheAttendanceExportGetListError,
  ///--admin---user---access---list
  setAdminuseraccesslistDatasgetlistActions,
  setTheAdminuseraccesslistDatasgetListReponse,
  setTheAdminuseraccesslistDatasTotal_counts,
  setTheAdminuseraccesslistDatasGetListError,

  ////-admin--crud----opreations-------------
  setadminuseraccessEDITActions,
  settheadminuseraccessEDITPutResponse,
  setTheadminuseraccessEDITReponsesError,
  setadminuseraccessRetrieveActions,
  settheadminuseraccessRetrievePostsResponse,
  setTheadminuseraccessRetrieveReponsesError,
  setadminuseraccessceateActions,
  settheadminuseraccesscratePostsResponse,
  setTheadminuseraccesscrateReponsesError,
  setadminuseraccessdeleteActions,
  settheadminuseraccesdeleteResponse,
  setTheadminuseraccessdeleteReponsesError,

  ///---ID verification----another api imeplementattions
  setIDverifycationanotherapidatasActions,
  settheIDverifycationanotherapidatasResponse,
  setIDverifycationanotherapidatasReponsesError,
  setTheAadharFrontImageDatas,
  setTheAadharBackSideImageDatas,
  setTheAadharFristNumbers,
  setTHnUMBERSRESPONSES,

  ///---Excel---sheet----get--list ,
  setTheExcelsheetUploadDataForEmpCIlent,
  setTheExcelSheetDataforEMpANdclientResponses,
  setExcelSheetgetEmpANdClientReponsesError,
  ///--paySlip---delete==
  setThePayslipDeleteActions,
  getPaySlipSuccessDeleteResponseActions,
  getPaySlipErrodeleteResponsen,
  ///---PassBook--Verifed------
  setTheActionsFroTheBankPassbooks,
  setTheDataAsEncodedDataResponses,
  setTheDatabaseontheEncodededResponses,
  setThePassBookActionsErrorrs,

  ////--Attendance----request0000
  setAttedancelistDatasgetlistActions,
  setTheAttendancesaccesslistDatasgetListReponse,
  setTheAttendanceslistDatasTotal_counts,
  setTheAdttendanceslistDatasGetListError,
  ///---Attendance----request---Approve--
  SetTheAttendanceResponsepproveActions,
  StetheAttendanceApproveActions,
  setTheAttendanceListApproveError,

  ///---oTP----oboarin----testing-- the employee
  setTheActionForOtpPhoneNumbers,
  setTheStatusCodeFortheEmplyeeOnboards, ///--status  code
  setThePhoneNumberOtpREsponses,
  setThePhoneNumberOfOtpVerified_Error,
  //....with number and otp
  setTheActionForOtpwithPhoneNumbers,
  setThePhoneNumberwithOtpREsponses,
  setThePhoneNumberOfwithOtpVerified_Error,
  ///--Pan card---other API
  setTheOtherpARTYaPIaCTIONS,
  setTheOtherPartyApiResponsesActions,
  setTheotherAPtyApiInErrorMsg,
  ///--Active----Based----Employees .
  SetTheActiveEmployeeListACtions,
  setTheActiveEmployeeListActionsResponses,
  setTheActiveEmployeeListErrorReponses,
  setTheActiveEmployeeTotal_counts,
  ///----Make---Inactive the employee--
  setTheApproveEmployeeTOLeftAOffice,
  setTheApproveEmployeeTOleftResponses,
  setTheApproveEmployeeTOleftError,
  ///---active based --retievements-
  setTheRetrieveForApproveEmployeeTOLeftAOffice,
  setTheRetrievForApproveEmployeeTOleftResponses,
  setTheRetieveFroApproveApproveEmployeeTOleftError,
  ///--Active----Based----Employee----Create--
  setTheActiveEmployeeCreatesList,
  setTheActiveEmployeeActionResponses,
  setTheActiveEmployeesResponseInErrorMessage,

  ///--E--Signature Hold Datas ,
  setTheEsignatureCodes,
  ///-----Performance ---sheet---export ,
  SetThePerformanceExportSheetDatasActions,
  setThePerformanceExportSheetDatasReponses,
  setThPerformanceExportSheetDatasErrorReponses,
  //////////-----Appraisal---
  SetTheAppraisalListActions,
  setTheAppraisalListedreponses,
  setTheAAppraiisalEroorerrorReponses,
  setTheAppraisalListCountsTotal_counts,
  //--appraisal-----retrieve--
  SetTheAppraisalRetrieveDatasActions,
  setTheAppraisalRetrieveDatasReponses,
  setTheAppaisalRetrieveSlicesErrorReponses,
  ///----Superviros---list
  setTheSuperviorsListActions,
  setThesuperViorsResponseActionss,
  setTheSuperviorseErrorResponses,
  ///--superviors---gte list
  setTheSuperviorsgeteListActions,
  setTheSuperviorsListActionsResponses,
  setTheSuperviorsListErrorReponses,
  setTheSuperviorsTotal_counts,
  ///-----Attedance list request ----mulitiple selected
  settheAttedanceListMulitipleActions,
  setTheAttedanceListMulitipleResponses,
  setTheAttedanceListErrorMulitiples,
  ///--dashboard--
  SettheEmployeeAttendanceResponseDatas,
  setTheEmployeeDashboardAttedanceResults,
  ////----number seted for the  , gif ,
  setTheIdOne,
  ///---Query---questions--------------
  settheQueryQuestionActions,
  setTheQueryQuestionsResponses,
  setTheQueryQuestionsError,
  setTheQueryQuestionTotalCounts,
  ///---query----actions--create
  setTheQueryQuestionsCreateActions,
  setTheQueryQuestionsCreateResponsive,
  SettheQueryQuestionsCreateError,
  //---query---question--retrieve
  setTheQueryQuestionsRetrieveActions,
  setTheQueryQuestionsRetrieveResponsive,
  SettheQueryQuestionsRetrieveError,
  ///----query---questions---edit
  setTheQueryQuestionsEditActions,
  setTheQueryQuestionsEditResponsive,
  SettheQueryQuestionsEditError,
  //----Sub----querys--------------
  settheQuerySubQuestionActions,
  setTheQuerySubQuestionsResponses,
  setTheQuerySubQuestionsError,
  setTheQuerySubQuestionTotalCounts,
  ////sub---query---create
  setTheQuerySubQuestionsCreateActions,
  setTheQuerySubQuestionsCreateResponsive,
  SettheQuerySubQuestionsCreateError,
  ///---Sub---query
  setTheQuerySubQuestionsRetrieveActions,
  setTheQuerySubQuestionsRetrieveResponsive,
  SettheQuerySubQuestionsRetrieveError,

  //--sub---query
  setTheQuerySubQuestionsEditionsActions,
  setTheQuerySubQuestionsEditionsResponsive,
  SettheQuerySubQuestionsEditionError,

  ///---query==questions---delte
  setTheQueryQuestionsDeleteActions,
  setTheQueryQuestionsdeleteResponsive,
  SettheQueryQuestionsDeletError,
  ////----subquery-----delete
  setTheQuerySUbQuestionsDeleteActions,
  setTheQuerySUbQuestionsdeleteResponsive,
  SettheQuerySUbQuestionsDeletError,

  ///---Tracking---record------
  settheTrackingrecordgetListDataActions,
  setTheTrackingrecordgetListDataResponses,
  setTrackignRecordListDashboardReport,
  setTheQTrackingrecordgetListDatasError,
  setTheTrackingrecordgetListDataTotalCounts,
  ///---Tracking---retrieve---
  setTheQueryTrackingrecordgetListRetrieveActions,
  setTheQueryTrackingrecordgetListRetrieveResponsive,
  SettheTrackingrecordgetListRetrieveError,

  ///-------tracking---edtions---
  setTheTrackingEditionsActions,
  setTheTrackingEditionsResponsive,
  SettheTrackingEditionError,

  ///--tracking-----delete
  setTheTrackingDeleteActions,
  setTheTrackingdeleteResponsive,
  SettheTrackingDeletError,

  ///----tracking----Apply---slice
  setTheTrackingCreateActions,
  setTheTrackingCreateResponses,
  setTheTrackingCreateError,
  //----Finance-----Call
  setThefinanceDataActions,
  setThefinanceResponsiveDatas,
  setTheFinanceErrorResponse,
  setTheFinancetableTotal_Count,
  setTheFinanceCountsDatas,
  setThefinanceResponsivePancardDatas,
  setTheFinancetableTotal_CountPan,
  setThefinanceResponsiveWhatsapppDatas,
  setTheFinancetableTotal_CountwhatsApp,
  setThefinanceResponsiveBankDatas,
  setTheFinancetableTotal_CountBank,
  ///----finance---export
  setThefinanceDataExportActions,
  setThefinanceResponsiveExportDatas,
  setTheFinanceErrorExportResponse,
  ///--attendance---------report
  setTheAttendanceReportActions,
  setTheAttendanceReportResponsiveDatas,
  setTheAttendanceReportTotal_Count,
  setTheAttendanceReportErrorResponse,
  //---onboarder---details
  setTheOnboarderdetailsReportActions,
  setTheOnboarderDetailsResponsiveDatas,
  setTheOnboaderdetailsReportErrorResponse,
  setTheAuthrorzedToatalCounts,

  ///--aadhar---send--otp---verified
  setTheOtherAAdhaarOtpPhoneNuberAction,
  setTheOtherPartyApiAADharReponse,
  settheAAdharPhoneNumberOtpSend,
  setTheClient_id,

  ////----submit-----otp---for aadhar
  setTheaadharsentOtpReportActions,
  setTheAadharsendthesubmitotpResponsiveDatas,
  setTheaadharsubmitotpErrReportErrorResponse,
  setTheSumbitOtpFormsAadhar_verified,

  ///====pan send otp
  setThePANCARDeportActions,
  setTheCLientID,
  setThePANCARDotpResponsiveDatas,
  setThePANCARDrrReportErrorResponse,

  ///---pan card---submit---otp
  setThePANCARDSUBMITeportActions,
  setThePANCARDotpSUBMITResponsiveDatas,
  setThePANCARDSUBMITOTPResponse,
  SetTheSuperviorsListACtions,
  SetTheSuperviorsLisEmployeeeetACtions,
  setTheSuperviorsListEmploeyeeActionsResponses,
  setTheSuperviorsListErrorEmployeeeReponses,
  setUserOptionDatasActions,
  setUserSuccessOptionResponse,
  setoptionResponseTotal_count_user,
  setUserOptionResponserrorsMessage,

  ///---Other--party---bank---verified
  CreateTokenForBankVerifyActions,
  Createtoken_store,
  createToken_store_erro_reposen,
  BankVerifyActions,
  CreateResponse_store,
  createBankverifyed_store_error_reposen,
  setTheTransactionID,
  settheBankHolderName,
  setbankCounts,

  //----------uds----role----employeee---

  ///---login-----------------
  SetTheCustomerUDSEmployeeLogin,
  settheCustomerUDSemployeeloginresponse,
  settheCustomerUDSEmployeeErroMsg,

  ///------send---otp
  SetTheCustomerUDSEmployeeSendOtp,
  settheCustomerUDSemployeeSendOTPresponse,
  settheCustomerUDSEmployeeErroMsgSendOtp,

  ///--UDs---employee-Actions
  setTheUdsLoginPagechange,

  /////-----dashboard-----actionsss

  //Data-----Call
  setTableSuccessData,
  setTableErrorAction,
  setDataTotalPageCounts,
  Setis_show_false,
  setis_show_true,
  ///---Shift----
  SetTheShiftDatasActions,
  SetTheShiftDataresponse,
  setTheShiftDatasError,
  //------attendace---employee---dashboard--data
  setUserOptionDashboardEmployeesActions,
  setUserSuccessDashboardEmplpyeesResponse,
  setoptionResponseDashboardEmployeeTotal_count_user,
  setUserOptionResponseDashboardEmployeerrorsMessage,
  ///---report---
  getRoportpostActions,
  getRoportpostListSuccessResponseActions,
  getRoportPostListErroResponsen,
  ////-------report---post
  getRoportDatasActions,
  getRoportdatsListSuccessResponseActions,
  getRoportsTotal_pageCounst,
  getRoportDatsListErroResponsen,

  ///----Attendance-------UDS---Employeee---actions
  SetTheAttendanceDatasActions,
  SetTheAttendanceDataresponse,
  setTheAttendanceDatasError,
  setTheAttendanceTotal_counts,
  setTheAttendanceLeaveResponses,
  SetLeaveTypeDataresponse,
  setLeaveTypeDataError,
  SetTheAttendancePermissionDataResponse,
  SetAttendancePermissionResponse,
  setTheAttendancePermissionDatasError,
  setTheAttendancePermissionTotal_counts,
  SetCreateLeaveError,
  SetCreateLeaveSuccessResponse,
  SetCreatePermissionSuccessResponse,
  setTheAttendanceResponses,
  SetCreatePermissionError,
  SetOnDutySuccessResponse,
  setTheOnDutyResponses,
  setTheOnDutyTotal_counts,
  setTheOnDutyDatasError,
  SetCreateOnDutySuccessResponse,
  SetTheOnDutyDatasActions,
  SetCreateOnDutyError,
  SetCalendarSuccessResponse,
  setCalendarError,
  SetCheckInOutSuccessResponse,
  SetCheckInOutError,
  SetPayslipSuccessResponse,
  setPayslipError,
  SetFetchReimbursementSuccessResponse,
  SetFetchReimbursementError,
  SetFetchReimbursementResponse,
  ///---put----methid---for check--out
  SetCheckInOutputMethosAction,
  SetCheckInOutAction,
  SetCheckInOutSuccessputmethodResponse,
  SetCheckInOutErrorputmethod,
  setTheAccountExit,
  setAadhar_counts,
  setTheAadhar_front_count,

  ///----user---profile----get
  setTheProfileSignatureActions,
  settheprofileSignatureGetLIStErrorputmethod,
  setTheProfileSignatureGetActionsResponse,
  setTheTotal_counts,
  setTheSonyEmployeeActions,
  setTheSonyEmployeeGetActionsResponse,
  setTheSonyEmployeeTotal_counts,
  settheSonyEmployeeGetLIStErrorputmethod,
  ///---user---profile----put
  setTheProfileSignatureEDITActions,
  setTheProfileSignatureEDITResponse,
  settheprofileSignatureEDITmethod,

  // ---over all reprt
  setOverReportActions,
  setOverReportSuccessResponse,
  setTotal_count_OverReport,
  setOverReportErrorsMessage,
  setTheOverAllReportDatas,
  setThekycapproximatedvalue,
  settheapproximated_values,

  //---create
  setOverReportCreateActions,
  setOverReportSuccessCreateResponse,
  setOverReportErrorsCreateMessage,
  setOverReportRetrieveActions,
  setOverReportSuccessRetrieveResponse,
  setOverReportErrorsRetrieveMessage,
  ///-=-----OverAll---Employeee---List
  setOverReportActionsEmployeeList,
  setOverReportSuccessResponseEmployeeList,
  setTotal_count_OverReportEmployeeList,
  setOverReportErrorsMessageEmployee,
  ///---employee export
  setOverReportActionsExportEmployeeList,
  setOverReportSuccessResponseExportEmployeeList,
  setOverReportErrorsMessageExportEmployee,
  ///----Send---Email---
  setthesendEmailActions,
  setthesendEmailActionsResponse,
  setthesendEmailActionsEditError,

  //--send---email----get---list
  setthesendEmailGetListActions,
  setthesendEmailActionsgetListResponse,
  setthesendEmailActionsGetListError,
  //---Onboard---Over_view---Actions
  setTheDashboardonboadOverviewactions,
  setTheDashboardOnboarderOverviewResponses,
  setTheDashboarOnboarderOverViewdErrors,
  SetTheDashboardonBoardOverViewClientList,
  settheOnboardOverviewDashboardClient,
  setTheBankNameVerification,

  ///---overall---State Name
  SetTheStateGetListActions,
  settheStatesgetListResponse,
  settheStateGetListError,

  ///--resend--otp
  setTheActionResentForOtpPhoneNumbers,
  setTheResentPhoneNumberOtpREsponses,
  setTheStatusResentCodeFortheEmplyeeOnboards,
  setThePhoneNumberResentOfOtpVerified_Error,

  ///----attendance--locaiton---get---list
  setTheAttendanceLocationAction,
  setheAttendanceLocationResponse,
  setTotal_count_AttedanceLocationEmployeeList,
  settheAttendanceLocationErrorMessage,
  ///---Attendance-----location=---Delete
  setTheAttendanceLocationDeleteAction,
  setheAttendanceLocationDeleteResponse,
  settheAttendanceLocationDeletesErrorMessage,

  ///---creation
  setTheAttendanceLocationCreateAction,
  setheAttendanceLocationCreateResponse,
  settheAttendanceLocationCreateErrorMessage,

  ///---Edit---And---Retrieve
  setTheAttendanceLocationRetrieveMetyhodAction,
  setheAttendanceLocationRetrievemethodResponse,
  settheAttendanceLocationRetrieveMethodErrorMessage,
  setTheAttendanceLocationEditionsAction,
  setheAttendanceLocationEditionsResponse,
  settheAttendanceLocationEditionsErrorMessage,
  ///---documents
  setEditedSupportDocument,
  setEditSupportDocumentError,
  startFetchingSupportDocuments,
  setSupportDocuments,
  setSupportDocumentsError,
  ///---HR---onboarding----list
  gettheHRonboardignlisteddatas,
  gettheHRonboardingreponsesdatas,
  settheHRonardingTotal_counts,
  settheHRonboardinggetlisterror,
  ///---My---onboarding----list
  gettheMyonboardignlisteddatas,
  getthemyonboardingreponsesdatas,
  settheMyonardingTotal_counts,
  settheMyonboardinggetlisterror,
  ///---Approve---Request
  getApproveRequestActionListed,
  setApproveRequestPersonsResponseActions,
  SetTheApproveRequestInquriyStatus,
  setApproveRequestPersonsErrorMessages,
  SetApproveRequestTotal_countPersonsActions,

  ///----regenerated pdf
  gettheRegeneratePdfAction,
  gettheRegeneratePdfResponse,
  settheRegeneratorlisterror,

  //--manager---gte--list
  gettheApproveRequestInmnagaerList,
  gettheapproveRequestManagerResponse,
  gettheApproveRequestManagerListError,
  ///--report--delete
  getRoportDeletedActions,
  getRoportdatsListdeletedResponseActions,
  getRoportDatsListErrodeleteResponsen,

  ///---over---time
  setTheOvertimeAction,
  setheOvertimeResponse,
  setTotal_count_OvertimeEmployeeList,
  settheOvertimeErrorMessage,
  ///--approve
  SetOvertimeApproveActions,
  SetOvertimeResponseApproveActions,
  SetOvertimeListApproveError,

  ///----Onboarder---get--datas
  gettheoverallOnboaderDatas,
  getthestoretheoverallOnboaderData,
  gettheoverallonboarderTotalCounts,
  getheOverallonboarderErrorMessage,

  ///rejoining
  gettheStoretheRejoiningActions,
  gettheRejoiningActionResponse,
  gettheRejoingError,

  ///my tickets
  settheMyTicketsDataActions,
  setTheMyticketsgetListDataResponses,
  setTheQMyTicketsListDatasError,
  setTheMyTicketsListDataTotalCounts,
  setTheMyticketsinChartList,
  ///--both user
  setTheActionsBoth_theusers,
  settheActionsreponsesforboththeUDSANDEMP,
  setBoththeUsersTotal_counts,
  setBoththeUserError,

  ///---employees
  SetFetchReimbursementEMPAction,
  SetFetchReimbursementEMPSuccessResponse,
  SetFetchReimbursementEMPResponse,
  SetFetchReimbursementEMPError,
  ////employeee onduty
  setOndutyDatasEmpAction,
  SetOndutyEmployeeDataresponse,
  SetOndutyEmployeetotalcountDataresponse,
  setOndutyEmployeeDataError,
  ///onduty---apply
  setOndutyDatasEmpCreateAction,
  SetOndutyEmployeeDataCreateresponse,
  setOndutyEmployeeDataCreateError,
  ///-employee permission
  SetTheAttendancegetlistempPermissionDatasActions,
  setTheAttendancegetlistempResponses,
  SetAttendancePermissiongetlistempResponse,
  setTheAttendancePermissiongetlistempDatasError,
  setTheAttendancePermissiongetListempTotal_counts,
  //---permission, create
  SetCreatePermissionEmpAction,
  SetCreatePermissionEmpSuccessResponse,
  SetCreatePermissionEmpError,
  ///attendance---regularization
  SetTheAttendancegetlistempRegularizationDatasActions,
  setTheAttendancegetlistempResponsesRegularization,
  SetAttendanceRegularizationlistempResponse,
  setTheAttendanceRegularizationlistempDatasError,
  setTheAttendanceRegularizationListempTotal_counts,
  SetCreateAttendanceRegularizationEmpSuccessResponse,
  SetCreateAttendanceRegularizationEmpError,
  SetCreateAttendanceRegularizationEmpAction,
  ///overtime
  settheOvertimeRegulrizationActions,
  setTheovertimeRegularizationResponse,
  settheOvertimeRegularizationsResponseStore,
  settheOvertimRegularizationErrorMsg,
  setTheOvertimeRegularizationListempTotal_counts,
  setThePayslipDataactionforemp,
  setthePayslipDataforEmp,
  setThePayslipToatal_countForEmp,
  setTheJoiningDateForPayslipEmp,
  setTheErrorofPayslipemp,
  ////----Face Verifications
  SetFaceVerificationAction,
  SetCheckInOutSuccessFaceVerificationmethodResponse,
  SetCheckInOutFaceVerificationErrorputmethod,
  ///--resignation
  setTheresignationForEmp,
  setTheResignationsForEmp,
  setTheResignationForEMpError,
  setTheresignationRetrieveForEmp,
  setTheResignationForEMpretrieveError,
  setTheResignationsRetrieveForEmp,
  ////---No due Form
  settheNodueFormForEmpErrorEditCall,
  settheNoDueFormResponsesDataEditEmployeee,
  settheNodueFormEmpEditActionDatas,
  settheNodueFormForEmpErrorretrirve,
  settheNoDueFormResponsesDataretrieveEmployeee,
  settheNodueFormEmpretrieveActionDatas,
  settheNodueFormEmpActionDatas,
  settheNodueFormForEmpError,
  settheNoDueFormResponsesDataEmployeee,
  setTheCreateOfEmployeeReimbursementActions,
  SetFetchReimbursementEMPCreateSuccessResponse,
  SetFetchReimbursementCreateEMPError,
  settheGrievenceGetListForEMpActions,
  settheActionsreponsesforGrievencegetlistEmp,
  setgrievencegetlistEmpTotal_counts,
  setGrievencegetlistEmpError,
  settheGrievenceGetListForTYPEEMpActions,
  settheActionsreponsesforGrievenceTYPEgetlistEmp,
  setGrievencegetlistEmpTYPEError,
  SetCreateGrievanceApplyEmpAction,
  SetCreateGrievanceApplyEmpError,
  SetCreateGrievanceApplyEmpSuccessResponse,
  ///Help desk for emp
  setHelpDatasEmpAction,
  SetHelpEmployeeDataresponse,
  SetHelpEmployeetotalcountDataresponse,
  setHelpEmployeeDataError,
  setHelpDeskEmpApplyEmpDatasEmpAction,
  SetHelpDeskApplyEmpEmployeeDataresponse,
  setHelpDeskApplyEmpEmployeeDataError,
  setTrackingSubCategoryEmpDatasEmpAction,
  SettrackingSubCategoryEmpEmployeeDataresponse,
  setTrackingSubCategoryEmpEmployeeDataError,
  setTrackingParentDatasEmpAction,
  SettrackingparentEmployeeDataresponse,
  setTrackingparentEmployeeDataError,
  setEmpAttendanceEmpEmpAction,
  SetEmployeeAttendanceEmpDataresponse,
  SetEmpAttendanceEMPtotalcountDataresponse,
  setEmpAttendanceEMPDataError,
  setEmpBlockpostistEmpEmpAction,
  SetEmployeeEmppostListEmpDataresponse,
  setEmpBlockEmppostEMPDataError,
  setEmpBlockGetlistEmpEmpAction,
  SetEmployeeEmpGetListEmpDataresponse,
  setTheBlockEmployeelistDatasForPopup,
  SetEmpEmpGetBlockEMPtotalcountDataresponse,
  setEmpBlockEmpGetEMPDataError,
  setEmpsiteTransferGetlistEmpEmpAction,
  SetEmployeesitetransferListEmpDataresponse,
  SetEmpEmpGesiteTransferEMPtotalcountDataresponse,
  setEmpsiteTransferEmpGetEMPDataError,
  gettheUnboackedEmpActions,
  SetUnbloackedEmployeesEmpDataresponse,
  setEmpUnbloackedEmployeesEMPDataError,
  setEmpClientBranchListEmpEmpAction,
  SetEmployeeClientBrancheListEmpDataresponse,
  setEmpClientBranchForEmpDataError,
  //--site create
  setEmpsiteTransferGetlistCreateEmpEmpAction,
  SetEmployeesitetransferListCreateEmpDataresponse,
  setEmpsiteTransferEmpCreateMPDataError,
  setTheEmpProfileGetAttendanceProfileResponse,
  settheprofileErrorEmpAttendancemethod,
  setTheEMployeeAttendanceProfileActions,
  setTheEMployeeAttendanceupdateProfileActions,
  setTheEmpProfileGetAttendanceupdateProfileResponse,
  settheprofileErrorEmpUpdateAttendancemethod,
  setEmpnoduformfetchdatasempEmpTeamlistEmpEmpAction,
  SetEmployenoduformfetchdatasempempteamListEmpDataresponse,
  setEmpnoduformfetchdatasempgetMPDataError,
  setEmsiteTransferEmployeedatasEmpEmpAction,
  SetEmployeeSitetransferresponseEmpDataresponse,
  setEmpsiteEMPDataError,
  resetSkillAssessmentEmpData,
  setSkillAssessmentEmpDataResponse,
  setSkillAssessmentEmpDataError,
  setSkillAssessmentotal_countEmpDataResponse,
  stateresetStateData,
  setStateDataResponse,
  setStateDataError,
  stateresetRegionData,
  setRegionDataResponse,
  setRegionDataError,
  stateresetZoneData,
  setZoneDataResponse,
  setZoneDataError,
  stateresetDesignationData,
  setDesignationDataResponse,
  setDesignationDataError,
  stateresetBranchData,
  setBranchDataResponse,
  setBranchDataError,
  gettheSkillassessmentRetireveEmpactions,
  gettheSkillassessmentretirvetheActionofemp,
  gettheskillAssessmentEmpretirveemp,
  resetEmployeeDataquestionslist,
  setEmployeeDataquestionslist,
  setErrorquestionslist,
  resetQuestionData,
  setQuestionData,
  setErrorinnerquestions,
  resetQuestionTypeData,
  setQuestionTypeData,
  setErrorQuestionType,
  gettheSkillassessmentputtmethodEmpactions,
  gettheSkillassessmentEmpputmethodstheActionofemp,
  gettheskillAssessmentEmpPuttmethodemp,
  gettheSkillassessmentpostmethodEmpactions,
  gettheSkillassessmentEmppostmethodstheActionofemp,
  gettheskillAssessmentEmpPostmethodemp,

  ///---TICKETING SYSTEM
  // CATEGORY CREATE--------------
  getTheTicketingQuestionsData,
  setTheticketQuestionsResponses,
  setTheticketeQuestionsError,
  setTheticketQuestionTotalCounts,
  setTheTicketQuestionsCreateActions,
  setTheTicketQuestionsCreateResponsive,
  SettheTicketQuestionsCreateError,
  setTheTicketQuestionsretrieveActions,
  setTheTicketQuestionsretrieveResponsive,
  SettheTicketQuestionsretrieveError,
  setTheTickeitingtionsDeleteActions,
  setTheTicketingQuestionsdeleteResponsive,
  SettheTicketingQuestionsDeletError,
  setTheTicketQuestionsEdtionctions,
  setTheTicketQuestionsEditResponsive,
  SettheTicketQuestionsEditError,
  ///---Ticketing---system
  // sub--categorys---------------
  settheTicketSubQuestionActions,
  setTheTicketSubQuestionsResponses,
  setTheTicketSubQuestionsError,
  setTheTicketSubQuestionTotalCounts,
  setTheTicketSubQuestionsCreateActions,
  setTheTicketSubQuestionsCreateResponsive,
  SettheTicketSubQuestionsCreateError,
  setTheTicketSubQuestionsEditionsActions,
  setTheTicketSubQuestionsEditionsResponsive,
  SettheTicketSubQuestionsEditionError,
  setTheTicketSubQuestionsRetrieveActions,
  setTheTicketSubQuestionsRetrieveResponsive,
  SettheTicketSubQuestionsRetrieveError,
  setTheTicketSUbQuestionsDeleteActions,
  setTheTicketSUbQuestionsdeleteResponsive,
  SettheTicketSUbQuestionsDeletError,

  //// raising ticket list
  settheTicketsystemrecordgetListDataActions,
  setTheTicketsystemrecordgetListDataResponses,
  setTicketsystemRecordListDashboardReport,
  setTheQTicketsystemrecordgetListDatasError,
  setTheTicketsystemrecordgetListDataTotalCounts,
  settheTicketingDashboardActions,
  settheTicketingDashboardActiondataStores,
  SettheTicketingDashboardErrDeletError,
  setTheTrackingrecordgetListRetrieveActions,
  SettheTicketingrecordgetListRetrieveError,
  setTheTrackingrecordgetListRetrieveResponsive,
  setthecommentRetieveDatasActions,
  settheCommentRetieveDataList,
  settheCommentRetieveErorActions,
  setTheTrackingrecordgetList_remarksRetrieveActions,
  SettheTicketingrecordgetListRetrieve_remarkError,
  setTheTrackingrecordgetList_remarksRetrieveResponsive,
  settheticketcreateRetieveDatasActions,
  settheticketcreateRetieveDataList,
  settheticketcreateRetieveErorActions,
  settehTicketStatusChanges,
  settheTickeStatusErr,
  settheTicketStatusChangesrespons,
  settheticketTimelineretieveDatasActions,
  settheticketTiemlineRetieveDataList,
  settheticketTimeLineRetieveErorActions,
  setTheticketetailsExportActions,
  setTheTicketsDetailsResponsiveExport,
  SettheTicketsDetailsErrorExport,
  setthefeedbackRetieveDatasActions,
  setthefeedbackRetieveDataList,
  settheFeedbackRetieveErorActions,
  setTheScopeDetailsExportActions,
  setTheScopeDetailsResponsiveExport,
  SettheScopeDetailsErrorExport,
  setTheContacteitDetailsExportActions,
  setTheContactEditDetailsResponsiveExport,
  SettheContactEditDetailsErrorExport,
  setTheCategorydataDetailsExportActions,
  setTheCategoryEditDetailsResponsiveExport,
  SettheCategoryEditDetailsErrorExport,
  setTheSubCategorydataDetailsExportActions,
  setTheSubCategoryEditDetailsResponsiveExport,
  SettheSubCategoryEditDetailsErrorExport,
  setTheSubCategorydataEditandcreateDetailsExportActions,
  setTheSubCategoryEditandcreateDetailsResponsiveExport,
  SettheSubCategoryEditandcreateDetailsErrorExport,
  settheNeardueActions,
  settheeardueresponsestore,
  settheNeardueCallingErrors,
  settheTicketUser_type,
  settheRemarkspostActions,
  settheRemarkspostesponsestore,
  settheremarkdpostCallingErrors,
  setthesubcategorybranchActionListed,
  setthesubcategorybranchResponses,
  setthesubcategorybranchErrors,
  setClientBranchesRetrieveActions,
  setEmployeeProfileDATASActions,
  setTheAllFormPdf,

  // internal
  getTheUDSQuestionsData,
  setTheUDSQuestionsResponses,
  setTheUdsQuestionsError,
  setTheUDsQuestionTotalCounts,
  setTheInternalQuestionsCreateActions,
  setTheInternalQuestionsCreateResponsive,
  SettheInternalQuestionsCreateError,
  setTheInternalCategoryQuestionsEdtionctions,
  setTheinternalCategoryQuestionsEditResponsive,
  SettheinternalcategoryQuestionsEditError,
  setTheInteralcategoryQuestionsretrieveActions,
  setTheInternalcategoryQuestionsretrieveResponsive,
  SettheinternalcategoryQuestionsretrieveError,
  setTheInternalDeleteActions,
  setThInternalQuestionsdeleteResponsive,
  SettheInternalQuestionsDeletError,
  settheqrcodelisted,
  settheqrexportedresponse,
  settheQrcodeexports,
  settheInternalSubQuestionActions,
  setTheInternalSubQuestionsResponses,
  setTheunternalSubQuestionsError,
  setTheInternalSubQuestionTotalCounts,
  setTheInternalSubQuestionsEditionsActions,
  setTheinternalSubQuestionsEditionsResponsive,
  SettheinternalSubQuestionsEditionError,
  setTheinternalSubQuestionsRetrieveActions,
  setTheinternalSubQuestionsRetrieveResponsive,
  SettheInternalSubQuestionsRetrieveError,
  setTheInternalSUbQuestionsDeleteActions,
  setTheInternalSUbQuestionsdeleteResponsive,
  SettheInternalSUbQuestionsDeletError,
  setTheInternalSubQuestionsCreateActions,
  setTheInternalSubQuestionsCreateResponsive,
  SettheInternalSubQuestionsCreateError,
  settheTicketsystem_unregisterrecordgetListDataActions,
  setTheTicketsystem_unregisterrecordgetListDataResponses,
  setTicketsystem_unregisterRecordListDashboardReport,
  setTheQTicketsystem_unregisterrecordgetListDatasError,
  setTheTicketsystem_unregisterrecordgetListDataTotalCounts,
  settheInternalDepartmentsctions,
  setTheInternalDepartmentsResponses,
  setTheinternalDepartmentsError,
  setTheInternalDepartmentsTotalCounts,
  setTheInternalDepartmentCreatedActions,
  setTheInternalDepartmentsCreateResponsive,
  SettheInternalDepartmentsCreateError,
  setTheInternalDepartmentEditActions,
  setTheInternalDepartmentsEditResponsive,
  SettheInternalDepartmentsEditError,
  setTheInternalDepartmentRetrieveActions,
  setTheInternalDepartmentsRetrieveResponsive,
  SettheInternalDepartmentsRetrieveError,
  setTheInternalDepartmentDeleteActions,
  setTheInternalDepartmentsdeleteResponsive,
  SettheInternalDepartmentsDeletError,
  setTheInternalDepartmentlevelusersCreatedActions,
  setTheInternalDepartmentsLevelUsersCreateResponsive,
  SettheInternalDepartmentsLevelUserCreateError,
  getTheLevelUsersListData,
  setTheLevelUsersListResponses,
  setTheLevelUserslistError,
  setTheLevelUserListedTotalCounts,
  setTheInternalDepartmentDelete_usersActions,
  setTheInternalDepartmentsdelete_usersResponsive,
  SettheInternalDepartmentsDelete_usersError,
  setTheInternalDepartmentRetreve_usersActions,
  setTheInternalDepartmentsRetrieve_usersResponsive,
  SettheInternalDepartmentsRetrieve_usersError,
  setTheInternalDepartmentEdtions_usersActions,
  setTheInternalDepartmentsEdtions_usersResponsive,
  SettheInternalDepartmentsEdtions_usersError,
  settheInternalTicketsystemrecordgetListInternalDepartmentsDataActions,
  setTheTicketsystemrecordgetListDataInternalDepartmentResponses,
  setTicketsystemRecordListDashboardInternalDepartmentReport,
  setTheQTicketsystemrecordgetListDatasInternalDepartmentError,
  setTheTicketsystemrecordgetListDataInternalDepartmentTotalCounts,
  settheCreateInternalTickets,
  settheCreateInternalTicketsResponse,
  settheTicketSuccesspopuos,
  SettheInternalInternalTicketCreations,
  setTheInternalDepartmentRetreve_TicketViewsActions,
  setTheInternalDepartmentsRetrieve_TicketViewsResponsive,
  SettheInternalDepartmentsRetrieve_TicketViewsError,
  setTheInternalDepartmentRetreve_TicketFeedbackActions,
  setTheInternalDepartmentsRetrieve_TicketFeedbackResponsive,
  SettheInternalDepartmentsRetrieve_TicketFeedbackError,
  setTheInternalDepartmentRetreve_TicketTicketChangesActions,
  setTheInternalDepartmentsRetrieve_TicketChangesResponsive,
  SettheInternalDepartmentsRetrieve_TicketChangesError,
  setTheInternalDepartmentRetreve_TicketTImelinesActions,
  setTheInternalDepartmentsRetrieve_TicketTimelineResponsive,
  SettheInternalDepartmentsRetrieve_TickeTimelineError,
  setTheInternalDepartmentRetreve_TicketRemarksActions,
  setTheInternalDepartmentsRetrieve_TicketRemarksResponsive,
  SettheInternalDepartmentsRetrieve_TickeRemarkError,
  setTheInternalDepartment_TicketFeedbackPostActions,
  setTheInternalDepartments_TicketFeedbackPostResponsive,
  SettheInternalDepartments_TicketFeedbackPostError,
  settehTicketthankspopup,
  settheinternaldepartmentcommandpostaction,
  settheinternaldepartmentcommandpostresponse,
  settheinternaldepartmentcommandpostError,
  settheTicketsystemInternalrecordgetListDataActions,
  setTheTicketsystemInernalDepaertmentrecordgetListDataResponses,
  setTicketsystemRecord_departmentListDashboardReport,
  setTheQTicketsystemrecordDepartmentgetListDatasError,
  setTheTicketsystemrecordgetDepartmentListDataTotalCounts,
  settheinternaldepartmentcommanddatagetaction,
  settheinternaldepartmentcommandgetdataresponse,
  settheinternaldepartmentcommangetdataError,
  setTheInternalDepartmentRetreve_TicketRemarksCRUDActions,
  setTheInternalDepartmentsRetrieve_TicketRemarksCURDResponsive,
  SettheInternalDepartmentsRetrieve_TickeRemarkCRUDError,
  settheinternaldepartmentRemarksgetaction,
  settheinternaldepartmeentremarksdataresponse,
  settheinternaldepartmentremarkdsdataError,
  settheTicketsystemrecordgetListInternalNearDueDataActions,
  setTheTicketsystemrecordgetListInternalNearDueDataResponses,
  setTicketsystemRecordListInternalNearDueDashboardReport,
  setTheQTicketsystemrecordgetListInternalNearDueDatasError,
  setTheTicketsystemrecordgetListInternaNearDuelDataTotalCounts,
  settheTicketsystemrecordgetListInternalDataActions,
  setTheTicketsystemrecordgetListInternalDataResponses,
  setTicketsystemRecordListInternalDashboardReport,
  setTheQTicketsystemrecordgetListInternalDatasError,
  setTheTicketsystemrecordgetListInternalDataTotalCounts,
  setthereassignandAssignRejectDataActions,
  setthereassignandAssignRejectDataResponse,
  settheReassignTicketpopups,
  setthereassignandAssignRejectDataError,
  settheClientTicketDeatilsDataActions,
  settheClientTicketDetailsDataResponse,
  settheClientTciketDetailsDataError,
  settheTicketUnregisterAssignActions,
  settheTicketUnregisterAssignResponse,
  settheTicketUnregisterAssignError,
  settheTicketescalationActions,
  settheTicketEscalationResponse,
  settheTicketEscalationError,
  settheTicketTicketJourneyActions,
  settheTicketJourneyResponse,
  settheTicketJourneyError,
  settheTicketTicketJourneyClientsideActions,
  settheTicketJourneyResponseclientside,
  settheTicketJourneyErrorclient,
  settheSubticketgetActions,
  settheSubticketgetActionsResponses,
  settheSubticketgetActionsResponseofTracking,
  settheSubticketgetActionsErrors,
  settheSubticketgetActionsTotal_counts,
  settheclientloneticketactions,
  settheclientloneticketresponseActions,
  settheclientloneticketresponseActions_trackingone,
  settheclientloneticketActionsErrors,
  settheclientloneticketAction_total_counts,
  settheClientCategoryDataActions,
  settheClientCategoryDataResponses,
  settheClientCategoryDataError,
  settheClientCategoryDataLonesActions,
  settheClientCategoryDataLonesResponses,
  settheClientCategoryDataLonesError,
  settheClientSubcategorylistedActions,
  settheClientSubcategorylistedresponses,
  settheClientSubcategorylistedError,
  setthenotificationactionDeletelist,
  setthenotificationactionsDeletelistResponses,
  setthenotificationactionsDeletelistErrors,
  setthenotificationactionsgetlist,
  setthenotificationactionsResponses,
  settheNotificationToatalcounts,
  setthenotificationactionsErrors,
  settheEmployeeFormFilled,
  settheNewDashboardRecordsActions,
  settheNewDashboardRecordsResponse,
  settheNewDashboardErrors,
  settheSubAssignDashboardRecordsActions,
  settheSubAssignDashboardRecordsResponse,
  settheSubAssignDashboardErrors,
  settheAdvanceStateDatasHold,
  settheAdvanceStateResponsHold,
  setTheAdvanceStateErrorHold,
  settheAdvanceEmployeeDatasHold,
  settheAdvanceEmployeeResponsHold,
  setTheAdvanceEmployeeErrorHold,
  settheAdvanceEmployeeDatas_countsHold,
  settheAdvanceEmployeeRespons_countHold,
  setTheAdvanceEmployeeError_countsHold,
  settheadvanceEmployeetotal_counts,
  settheAdvancDatas_SecondStateHold,
  settheAdvanceRespons_SecondStatHold,
  setTheAdvanceError_SecondStatHold,
  settheadvance_attendanceloader,
  /// Onboarding pending  records
  settheOnboarderdatalistedactions,
  settheRegionalMangerdata_ResponseHolder,
  settheRegionalManagerErrors,
  getUserdata,
  setRmOnboarderdatas,
  settheinternalDashboardloadBool,

  /// internal support and customer support
  setinternaltable_dashboard,
  settheInternal_dashboard_ResponseHolder,
  settheinternal_dashboard_total_counts,
  settheInterna_dashboard_table_Errors,
  setCustomer_table_dashboard,
  settheCustomer_dashboard_ResponseHolder,
  settheCustomer_dashboard_total_counts,
  settheCustomer_dashboard_table_Errors,
  setState_based_customerdashboard,
  settheState_basedCustomer_dashboard_ResponseHolder,
  settheStateBasedCustomer_dashboard_total_counts,
  settheStateBased_Customer_dashboard_table_Errors,
  setStatebasedInternalTable,
  setstatebasedInternalTableData,
  setstatebasedInternalTotalCount,
  setstatebasedInternalError,
  settheInternalescalationActions,
  settheEscalationResponsehold,
  settheEscalationErrormessgae,
  settheexternalescalation_dashboardsactions,
  settheExternalEscalationResponsehold,
  settheExternalEscalationErrormessgae,
  clearTicketTrendState,
  setTicketTrendData,
  setTicketTrendError,
  clearPerformance_MatrixState,
  setPerformance_matrix_Data,
  setPerformance_Matrix_Error,
  clearCustomerSupportCardState,
  setCustomerSupportCard_StateData,
  setCustomerSupportCard_StateError,
  clearChartCategory_State,
  setCategoryChart_Data,
  setCategoryChart_Error,
  clearCustomerSupportStateChart,
  setCustomerSupportStateChartData,
  setCustomerSupportStateChartError,
  clearCustomerSupportRegionalList,
  setCustomerSupportRegionalListData,
  setCustomerSupportRegionalListError,
  clearCustomerSupportRegionalChart,
  setCustomerSupportRegionalChartData,
  setCustomerSupportRegionalChartError,
  clearCustomerSupportZoneChart,
  setCustomerSupportZoneChartData,
  setCustomerSupportZoneChartError,
  clearCustomerSupportClientChart,
  setCustomerSupportClientChartData,
  setCustomerSupportClientChartError,
  clearCustomerSupportClientList,
  setCustomerSupportClientListData,
  setCustomerSupportClientListError,
  clearCustomerSupportZoneList,
  setCustomerSupportZoneListData,
  setCustomerSupportZoneListError,
  clearCustomerSupportStateList,
  setCustomerSupportStateListData,
  setCustomerSupportStateListError,
  clearCategoryList_State,
  setCategoryList_Data,
  setCategoryList_Error,
  clearCustomPerformanceMatrixState,
  setCustomPerformanceMatrixData,
  setCustomPerformanceMatrixError,

  /// internal
  clearInternalPerformanceState,
  setInternalPerformanceData,
  setInternalPerformanceError,
  clearInternalCategoryTopFive,
  setInternalCategoryTopFive,
  setInternalCategoryTopFiveError,
  clearInternalCategoryList,
  setInternalCategoryList,
  setInternalCategoryListError,
  clearInternalSupportChartState,
  setInternalSupportChartStateData,
  setInternalSupportChartStateError,
  clearInternalSupportRegionalChart,
  setInternalSupportRegionalChartData,
  setInternalSupportRegionalChartError,
  clearInternalSupportRegionalList,
  setInternalSupportRegionalListData,
  setInternalSupportRegionalListError,
  clearInternalSupportZoneChart,
  setInternalSupportZoneChartData,
  setInternalSupportZoneChartError,
  clearInternalSupportZoneList,
  setInternalSupportZoneListData,
  setInternalSupportZoneListError,
  clearInternalSupportClientChart,
  setInternalSupportClientChartData,
  setInternalSupportClientChartError,
  clearInternalSupportClientList,
  setInternalSupportClientListData,
  setInternalSupportClientListError,
  clearInternalSupportStateList,
  setInternalSupportStateListData,
  setInternalSupportStateListError,
  clearInternalCustomPerformanceMatrix,
  setInternalCustomPerformanceMatrixData,
  setInternalCustomPerformanceMatrixError,
  clearInternalSupportGraph_TrendActions,
  setInternalSupportTrendResponseData,
  setInternalSupportTrendsActionsError,
  resetStateData,
  setStateTableData,
  setStateTotalCount,
  setStateError,
  resetRegionalData,
  setRegionalTableData,
  setRegionalTotalCount,
  setRegionalError,
  resetZoneData,
  setZoneTableData,
  setZoneTotalCount,
  setZoneError,
  resetClientData,
  setClientTableData,
  setClientTotalCount,
  setClientError,
  resetZoneData_internal,
  setZoneTableData_internal,
  setZoneTotalCount_internal,
  setZoneError_internal,
  resetClientData_internal,
  setClientTableData_internal,
  setClientTotalCount_internal,
  setClientError_internal,
  resetInternalRegionData,
  setInternalRegionTableData,
  setInternalRegionTotalCount,
  setInternalRegionError,
  resetEmployeeEditActionsdata,
  settheExitignEmp_editActionsresponse,
  setEmployeeEditActionsError,
  resetMasterdashData_internal,
  setMasterdashTableData_internal,
  setMasterdashTotalCount_internal,
  setMasterdashError_internal,
  resetMasterdashData_Crud_opretions,
  setMasterdashTableData_CrudOperation,
  setMasterdashError_Crud_opreation,
  resetOrganizationFilterlist,
  setOrganizationFilterlistData,
  setOrganizationFilterlistError,
  resetClientDivisionLevelDropdown,
  setClientDivisionLevelDropdownData,
  setClientDivisionLevelDropdownError,
  settheAdvanceEmployeeDatas_summaryHold,
  settheAdvanceEmployeeRespons_summaryHold,
  setTheAdvanceEmployeeErrorHold_summary,
  settheadvanceEmployeetotal_counts_summary,
  settheadvance_attendanceloader_summary,
  setGrievanceEMPexportAction,
  setGrievanceEMpExporttResponse,
  setgrievanceEmpExportError,
  setSalaryEMPexportAction,
  setSalaryEmpExportError,
  setSalaryEMpExporttResponse,
  setAppointmentEMPexportAction,
  setAppointmentEMpExporttResponse,
  setAppointmentEmpExportError,
  setSalaryexport_revision_Action,
  setSalaryrevisionExporttResponse,
  setSalaryrevisionExportError,
  setContractRenewalAction,
  setContractRenewalResponse,
  setContractRenewalError,
  setSalaryRevisionChangeAction,
  setSalaryRevisionChangeResponse,
  setSalaryRevisionChangeError,
  setWarningPoorPerformanceAction,
  setWarningPoorPerformanceResponse,
  setWarningPoorPerformanceError,
  setShowCauseAbscondingAction,
  setShowCauseAbscondingResponse,
  setShowCauseAbscondingError,
  setGenerated_letterAction,
  setGenerated_lettersResponse,
  setGeneratedError,

  // for particular client
  settheAdvanceEmployeeDatasparticular_countsHold,
  settheAdvanceEmployeeparticular_Respons_countHold,
  setTheAdvanceEmployee_particularError_countsHold,
  settheAdvanceState_particularDatasHold,
  settheAdvanceState_particularResponsHold,
  setTheAdvanceState_particularErrorHold,
  settheAdvancDatas_Second_particularStateHold,
  settheAdvanceRespons_Second_particularStatHold,
  setTheAdvanceError_Second_particularStatHold,
  settheAdvanceEmployeeDatas_particularHold,
  settheAdvanceEmployeeRespons_particularHold,
  settheadvanceEmployeetotal_counts_particular,
  setTheAdvanceEmployeeErrorHold_particular,
  settheAdvanceEmployeeDatas_summary_particularHold,
  settheAdvanceEmployeeRespons_summary_particularHold,
  settheadvanceEmployeetotal_counts_summary_particular,
  setTheAdvanceEmployeeErrorHold_summary_particular,

  // present urls
  getPresignedUrlRequest,
  getPresignedUrlSuccess,
  getPresignedUrlFailure,
  uploadSignatureRequest,
  uploadSignatureSuccess,
  uploadSignatureFailure,
  setSignatureEmployeeRetrieveAction,
  setSignatureEmployeeRetrieveResponse,
  setSignatureEmployeeRetrieveError,
  setSignatureEmployeeUpdatedAction,
  setSignatureEmployeeUpdatedResponse,
  setSignatureEmployeeUpdatedError,
  getEmployeeEsignRetrieveRequest,
  getEmployeeEsignRetrieveSuccess,
  getEmployeeEsignRetrieveFailure,
  updateEmployeeEsignRequest,
  updateEmployeeEsignSuccess,
  updateEmployeeEsignFailure,
  getPresignedUrlEmployeeEsignRequest,
  getPresignedUrlEmployeeEsignSuccess,
  getPresignedUrlEmployeeEsignFailure,
  uploadSignatureEmployeeEsignRequest,
  setFormReportsUpdatedAction,
  setFormReportsUpdatedResponse,
  setFormReportsUpdatedError,
  setFormExportsUsersRetrieveAction,
  setFormExportsUsersRetrieveResponse,
  setFormExportsUsersRetrieveError,
  SetVerifiedUserActions,
  setSkillAssessmentDashboardCountAction,
  setSkillAssessmentDashboardCountResponse,
  setSkillAssessmentDashboardCountError,
  GetSheetBulkUploadDataRequest,
  GetSheetBulkUploadDataSuccess,
  setOrganizationRmFilterlistData,
  setOrganizationRmFilterlistError,
  GetEmployeeBulkUploadDataSuccess,
  GetEmployeeBulkUploadDataRequest,
  DenaveBulkUploadNewSuccess,
  DenaveBulkUploadNewError,
  GetDenaveBulkUploadNewDataRequest,
  GetDenaveBulkUploadNewDataSuccess,
  GetDenaveBulkUploadNewDataFail,
  SonyBulkUploadSuccess,
  SonyBulkUploadError,
  LetterOnboardingBulkUploadSuccess,
  LetterOnboardingBulkUploadError,
  getLetterOnboardingEmployeeListSuccess,
  getLetterOnboardingEmployeeListFail,
  GetSonyBulkUploadDataRequest,
  GetSonyBulkUploadDataSuccess,
  GetSonyBulkUploadDataFail,
  setThePANCARDVerifyDatas,
  SetJobofferPreviewresponseCreate,
  SetJobofferPreviewErrorcreate,
  SetRemainderMailCallAction,
  SetRemainderMailErrorcreate,
  SetRemainderMailresponseCreate,
  getDenaveStateDataSuccess,
  setHrApprovalErrorEdit,
  SetHrApprovalresponseEDIT,

  setSelfonboardingRetrieveAction,
  setSelfonboardingRetrieveResponse,
  setSelfonboardingRetrieveError,

  getHrmsConnectivityListResponse,
  setHrmsConnectivityListTotalCount,
  setHrmsConnectivityListError,
  getIdCardListResponse,
  setIdCardListTotalCount,
  setIdCardListError,
  setHrmsConnectivityUpdateAction,
  setHrmsConnectivityUpdateResponse,
  setHrmsConnectivityUpdateError,
  setHrmsConnectivityStatusUpdateAction,
  setHrmsConnectivityStatusUpdateResponse,
  setHrmsConnectivityStatusUpdateError,

  getSmartConnectEmployeeListRequest,
  getSmartConnectEmployeeListSuccess,
  getSmartConnectEmployeeListFail,
  getSmartConnectHiringListRequest,
  getSmartConnectHiringListSuccess,
  getSmartConnectHiringListFail,
  smartConnectBulkUploadRequest,
  smartConnectBulkUploadSuccess,
  smartConnectBulkUploadFail,
  getLetterOnboardingEmployeeListRequest,

  //--------------------------------------
} from "./Slice";
//------API----Calls--------------------
import {
  //----Login Api Call-----
  loginapi,
  //----Forgot--Password---
  forgotP,
  //-----Otp-----
  OtpVerify,
  //---Update--Password
  UpdatePassword,
  //----Table---Data
  TableData,
  //---Role---List
  RoleList,
  RoleCreate,
  RoleDeleteapi,
  RoleRetrieve,
  roleEditsApi,
  Userlist,
  UserDelete,
  UserCreate,
  UserRetrieve,
  UserEdit,
  GeoState,
  stateCretae,
  StateDeleteApi,
  StateRetrieve,
  StateEdits,
  RegionList,
  RegionCreate,
  RegionDeleteApi,
  regionRetriev,
  RegionEdit,
  ZONElist,
  Zonecreate,
  ZoneDeleteApi,
  ZoneEditsApi,
  ZoneRetrirve,
  CLientList,
  CLientListAPI,
  ClientDelete,
  ClientCreate,
  ClientEditApi,
  clientRetrieveApi,
  ClientBranchListAPi,
  ClientBranchCre,
  ClientBranchDel,
  ClientBranEdits,
  clientBranRetrieve,
  ClientSearchAPI,
  ShiftCALL,
  ShiftCreateAPI,
  ShiftDeleteAPI,
  ShiftREtrieve,
  ShiftEDITAPI,
  ShiftSearchAPi,
  EmployeeApi,
  EmployeeCretaeApi,
  EmployeeDeleteApi,
  EmployeeRetrieve,
  EmployeeEdit,
  EmployeeDatasApi,
  EmployeeListsPersonsApi,
  EmployeeDetailsAPI,
  BasicFormRetrieveApi,
  AddressAPi,
  IdverifyAPI,
  BankDetailAPI,
  EducationDetailsAPI,
  PreviousAPI,
  FamilyAPi,
  decalarationApi,
  ESiApi,
  JobofferApi,
  IdverificationEditApi,
  FormApprovalApi,
  CompletetdUsers,
  JoiningDateAPI,
  excelSheetuploads,
  LeaveTypeCreateAPi,
  LeaveTypeListAPi,
  LeaveTypeDeleteAPi,
  LeaveTypeRetrievAPi,
  LeavetypeEditApi,
  LeavePermissionlistAPi,
  LeavePermissionDeleteAPi,
  LeavePermissionRetrieevApi,
  LeavePermissionEdits,
  Dashboardapi,
  LeaveStatusApi,
  ExcelSheetgetApi,
  ShiftPermission,
  ShiftEditPermission,
  ShiftRetrievePermission,
  ShiftDeleteAPiPermission,
  ReInvestmentGetApi,
  ReInvestmentretrievetApi,
  ReInvestmentEditApi,
  OndutyGetlistAPI,
  ResginAPI,
  ExitApi,
  AppraisalApi,
  paySlipApi,
  employeeListforFieldAgentApi,
  branchlistfofieldagentapi,
  DataFetchApiForForm,
  PreviousDataApi,
  grievanceApi,
  grievanceApi_export,
  performanceApi,
  performanceChildApi,
  performFieldAgentAPi,
  performfieldagentRetrievespi,
  sheetuploadsApi,
  createEmplosignApi,
  GrievanceEmployeeListApi,
  AttendanceRequestAPi,
  manpowerperformsApi,
  manpowerperformsretrieveStandApi,
  Attendanceexportapi,
  blacklistapi,
  siteTransferapi,
  setnotificationsapi,
  pdfgetlistapi,
  AttendanceExportForUserProfilesGetApi,
  adminuseraccesslist,
  idverificationanotherApi,
  ExcelSheetGetList,
  passbookDatatretrieve,
  AttendaceRequestList,
  SignOtpUrl,
  SignOtpVerified,
  ActiveBasedEmployees,
  PerformanceExportSheet,
  SuperviorsListPutorRemove,
  attendanceRequestAPIPutwithmuil,
  ///----
  baseurlforexport,
  employeedashboard,
  QuesyQuestionsApi,
  QuerySubQuestionsApi,
  TrackingrecordAPi,
  FinancegetApi,
  AttendaceReportApi,
  onboarderDetailsApi,
  aadharsendOtpToNumberApi,
  SubmitOTPAADHARVERIFIEDApi,
  Pancardsendotpapi,
  createTokenPennyapi,
  udsLoginAPI,
  UDSEmployeeSentoptapi, ///-- the baseurl
  //----Login Api Call-----
  onDuty,
  OtpApi,
  payslip,
  Reimbursement,
  requestCheckInOut,
  ShiftDatas,
  leaveType,
  AttendanceAvaliableLeav,
  reportgetdatasapi,
  AttendanceExportUserApi,
  bankPennyDropapi,
  profilesignatureAPI,
  employeeelistAPi,
  overAllReportget,
  overallemployeelisteAPI,
  overallexportapi,
  sendEmailUpdateApi,
  overAllEmployeeListAPI,
  OverallStateAPi,
  AttendancelocationApi,
  Supportdocumentapi,
  MyonoardignApi,
  Manager_list_get,
  overtimeapi,
  Onboardergetlist,
  RejoningAPi,
  KysRejectionapi,
  myTicketApi,
  BothuserandEmpAPIs,
  AttendanceAvailablePermission,
  RegularizationApis,
  FaceVerificationApi,
  empResign,
  NoDueFormEmpAPi,
  GrievanceEmpApi,
  grievenceEmptypegetapi,
  helpdeskGet,
  ParentForHelpApi,
  CateoryForHelpApi,
  EmpAttendanceApi,
  getBlockListApi,
  sitetransferapi,
  ToclientBranchApi,
  EmpProfileapi,
  EmpNoDueFormFetchapi,
  getUnBlockListApi,
  employeesiteempAPi,
  skillassEmplist,
  empstateapi,
  empregionapi,
  empzonelistapi,
  emprolelistapi,
  branchliststrezoapi,
  skillassessmentretrieveapi,
  empquestiongetskillsform,
  innerquestionapi,
  skillassessmenrcrud,
  ticketcategoryapi,
  ticketsubcategoryapi,
  ticketlistapi,
  ticketdashboardapi,
  ticketcomment,
  ticketremarks,
  udsticketlistapi,
  ticketfeedback,
  ticketlineapi,
  ticketexports,
  scopeapi,
  contacteditapi,
  subcategoryscope,
  categoryscope,
  ClientCatecreateapi,
  neardueapi,
  departmentissuesapi,
  branchqrapi,
  departmentsubissuesapi,
  unregisertapi,
  departmentapi,
  leveluserapi,
  internalTickets,
  internalTicketsget,
  internalTickettimeline,
  internalTicketremarks,
  internalfeedbackapi,
  internalcommandapi,
  DepartmentUsersapi,
  InternalNearDueApi,
  InternalDashbaordApi,
  rejectassignReassignapi,
  clientticketview,
  UnregisterAssign,
  escalationlevelapi,
  tickethourneyapi,
  ticketinernalexport,
  subticketapi,
  clientticketsapi,
  clientticketcreateapi,
  clientticketcategoryapi,
  cliensubcategoryapi,
  notifiapilist,
  dhashboardgraphapi,
  subassigneddashboardapi,
  OrganizationAPi,
  advanceattendancecount,
  advanceattendancetable,
  advanceattendanceState,
  advanceSecondstateapi,
  RmOnboardapi,
  Customer_department_dashboardapi,
  internalcategory_dashboardapi,
  CustomerSupport_stateApi,
  InternalStatebasedapi,
  escalation_internal,
  escalation_External,
  trendingtickets,
  categorytopfiveapi,
  custom_card_regionapi,
  custom_statechart,
  custom_rgionlist,
  custom_zoneApi,
  cusstom_clientapi,
  custom_performancematrix,
  internal_trendgraphapi,
  internal_performancematrix,
  internalLevaleusers,
  internal_categoryDataapi,
  percentangecategoryapi,
  internla_ticketHihestapi,
  internal_supportstate,
  internal_supportregion,
  internal_supportzone,
  internal_supportclient,
  employee_Editapi,
  master_dashboard_api,
  organization_listapi,
  clientDivisionLevelDropdownApi,
  attendance_summary_countapi,
  LetterSalaryRevisionApi,
  LetterAppointmentApi,
  salary_revision_letter_change_letter,
  contract_renewel_letter,
  salary_revision_letter,
  warning_poor_perfomance_api,
  showcause_abconding,
  Relinquishment_api,
  Designation_api,
  Role_Change_api,
  transfer_letter_api,
  relieving_letter_api,
  experience_letter_api,
  attendance_summary_countapi_particular,
  advanceattendancecount_particular,
  advanceattendancetable_particular,
  advanceattendanceState_particular,
  advanceSecondstateapi_particular,
  S3putAPICallFunction,
  postAPICallFunction,
  user_retrieve_api,
  user_update_api,
  selfonboardRetriveApi,
  employee_retrieve_apo,
  skill_assessments_dashboard_api,
  SheetBulkUploadApi,
  organizationRm_listapi,
  EmployeeBulkUploadApi,
  denaveBulkUploadNewListApi,
  denaveBulkUploadNewApi,
  jobOfferPreview,
  sendRemainderApi,
  denaveStateGetApi,
  HRonoardignApi,
  hrApprovalEditApi,
  hrmsConnectivityListApi,
  IdCardListApi,
  hrmsConnectivityUpdateApi,
  hrmsConnectivityStatusUpdateApi,
  hrmsConnectivityJobInfoUpdateApi,
  smartCoonectEmployeeListApi,
  smartCoonectEmployeePostApi,
  smartConnectHiringListApi,
  sonyBulkUploadListApi,
  sonyBulkUploadPostApi,
  LetterOnboardingApi,
  LetterOnboardingEmployeeListApi,
  employeeEsignRetriveApi,
  employeeEsignUpdateApi,
  sonyEmployeeLetterCountApi,
} from "../text/apidata";
import { store } from "../Redux/Store";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getLoaderAction } from "./Loader";
import { data } from "jquery";
import App from "../App";
import { months } from "moment";

import config from "./Config"; // Use this line if using configuration file
import { getLoaderAction2 } from "./Loader2";
import { ka } from "date-fns/locale";
import Rejections from "../Component/MainComponent/EmployeeProfile/Rejections";
import { YearView } from "react-calendar";
import { responsiveToast } from "../Component/AppComponent/responsiveToast";
import { useNavigate } from "react-router-dom";

var requiredVersion = config.requiredVersion; // For configuration file

///----------------Login----Call
function* getUserSaga(payload) {
  console.log(
    store.getState().NeededdatasListed.Notificationfirebasetoken,
    "podupoaisd Notificationfirebasetoken",
    payload,
  );

  try {
    yield put(getLoaderAction(true));

    const response = yield axios({
      method: "post",
      url: loginapi,
      // headers: {
      //   Authorization:
      //     // "devicetoken " + store.getState()?.NeededdatasListed?.Notificationfirebasetoken,
      //     `devicetoken : ${store.getState()?.NeededdatasListed?.Notificationfirebasetoken}` ,
      // },
      data: {
        email: payload.payload.data?.email,
        password: payload.payload?.data?.Password,
      },
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(getUserSuccessAction(response.data));
    yield put(getUserdata(response.data.data));
    yield put(getLoaderAction(false));

    yield put(setTheIdOne(2));
    localStorage.setItem("loginUds", "false");
    if (response.data != undefined && response.data.session) {
      yield put(setTheUDSTOKEN(response.data.session.token));
      yield put(settheLoginIds(response.data.data.id));

      localStorage.setItem("token", response.data.session.token);
      localStorage.setItem("websiteversion", requiredVersion);

      localStorage.setItem("userTypes", response.data.data.ticket_user_type);

      localStorage.setItem(
        "userdepartmentTypes",
        response.data.data.department_user_type,
      );

      //  console.log(response.data.session.token , "027340289374guresponse.data");
    }
    // window.location.href = "/";
    // localStorage.setItem("loginUdsEmployee", "true");

    console.log(response.data.data.ticket_user_type, "asdasd ticket_user_type");

    yield put(setTheRoleName(response.data.data.user_role.role)); ///--Role was displayed
    yield put(SetARole(response.data.data.first_name));
    yield put(settheTicketUser_type(response.data.data.ticket_user_type));

    yield put(setTheUserEmailIDS(response.data.data.email));
    yield put(settheCustomerUDSemployeeloginresponse([]));

    if (
      response.data.data.email == "hdfcsales@uds.in" ||
      response.data.data.email == "sbilife@uds.in" ||
      response.data.data.email == "arcolab@uds.in"
    ) {
      yield put(getSideBarfilesActions("Attendance Dashboard "));
    } else {
      yield put(getSideBarfilesActions("Overview"));
    }

    if (typeof payload.payload.Funcations === "function") {
      payload.payload.Funcations();
    }
  } catch (error) {
    localStorage.setItem("loginUds", "true");
    // localStorage.setItem("loginUdsEmployee", "false");
    localStorage.clear();

    yield put(getLoaderAction(false));
    if (error.response.status != 500) {
      // console.log(error, "error");
      yield put(getUserErrorAction(error));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else {
      toast.error(` ${" something went wrong"} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}

///----Dashboard-----------------------
function* SetTheDashboards(payloads) {
  console.log(payloads.payload, "paipdoasdj");

  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: Dashboardapi,
      // params: {
      //   client: payloads.payload.client,
      //   state: payloads.payload.state,
      //   region: payloads.payload.region,
      //   zone: payloads.payload.zone,
      //   from_date: payloads.payload.from_date,
      //   to_date: payloads.payload.to_date,
      //   range: payloads.payload.range,
      // },
      params: payloads.payload,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    console.log(response.data.data, "401");
    yield put(setTheDashboardResponses(response.data.data));

    yield put(getRoleListTotal_pageCounst(response.data.total_count));
    if (response.data.data != undefined) {
      yield put(getLoaderAction(false));
    }
  } catch (error) {
    yield put(getLoaderAction(false));

    if (error.response.status != 500) {
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(setTheDashboardErrors(error));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    } else {
      toast.error(` ${" something went wrong"} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}

function* SetTheDashboardsOnboardOverViewCall(payloads) {
  console.log(payloads.payload, "paipdoasdj");

  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: Dashboardapi,
      params: payloads.payload,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(setTheDashboardOnboarderOverviewResponses(response.data.data));

    // yield put(getRoleListTotal_pageCounst(response.data.total_count));
    if (response.data.data != undefined) {
      yield put(getLoaderAction(false));
    }
  } catch (error) {
    yield put(getLoaderAction(false));

    if (error.response.status != 500) {
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(setTheDashboarOnboarderOverViewdErrors(error));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    } else {
      toast.error(` ${" something went wrong"} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}

//-------------Forgot----Password-------------------
function* getForgotperson(payload) {
  console.log(payload, "2398pjopayload");
  try {
    yield put(getLoaderAction(true));

    const response = yield axios({
      method: "post",
      url: forgotP,
      data: {
        email: payload.payload.InputData.email,
      },
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(getForgotPasswordEmail(payload.payload.InputData.email));
    // window.location.href = "/verify";

    if (typeof payload.payload.Funcations === "function") {
      payload.payload.Funcations();
    }

    yield put(getForgotPasswordPerosonSuccessResponse(response.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getForgotPasswordErrorMessage(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    yield put(getLoaderAction(false));
  }
}

function* ResendOtpSaga(payload) {
  console.log(store.getState().ForgotP.email, "the Store");

  const Content = {
    InputData: {
      email: store.getState().ForgotP.email,
    },
  };
  yield put(getForgotPasswordPerson(Content));
}
//----------------____Verify----Opt--------
function* setVerifyOtp(payload) {
  console.log(store.getState().ForgotP.email, "payloasd", store.getState());
  // console.log(store.getState().ForgotP.email, "emails");
  try {
    yield put(getLoaderAction(true));

    const response = yield axios({
      method: "post",
      url: OtpVerify,
      data: {
        email: store.getState().ForgotP.email,
        otp: `${payload.payload.otp}`,
      },
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    yield put(getLoaderAction(false));

    yield put(getOtpVerifyActionsSuccessResponse(response.data));
    // window.location.href = "/resetpassword";
    //  payload.payload.Funcations()
    if (typeof payload.payload.Funcations === "function") {
      payload.payload.Funcations();
    }
  } catch (error) {
    yield put(getLoaderAction(false));

    yield put(getOtpVerifyErrorResponse(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}
//------Updated----Password--------------------
function* setUpdatePassword(payload) {
  console.log(payload, "972uwejippayload");
  try {
    yield put(getLoaderAction(true));

    const response = yield axios({
      method: "put",
      url: UpdatePassword,
      data: {
        email: store.getState().ForgotP.email,
        password: payload.payload.InputData.password,
      },
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    yield put(getLoaderAction(false));

    if (typeof payload.payload.Funcations === "function") {
      payload.payload.Funcations();
    }

    // window.location.href = "/";
    yield put(getUpdatedPasswordSuccessResponse(response.data));
  } catch (error) {
    yield put(getLoaderAction(false));

    yield put(getUpdatedPassswordError(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}
///-----Role-----LIsts--------------------------
function* getRoleLists(payloads) {
  console.log(payloads, "paylasdasdoads");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: RoleList,
      params: {
        search: payloads.payload.search,
        page_size: payloads.payload.page_size,
        page: payloads.payload.page,
        mode: payloads.payload.mode,
        client: payloads.payload.client,
        white_collar: payloads.payload.white_collar,
        month: payloads.payload.month,
        year: payloads.payload.year,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(getRoleListSuccessResponseActions(response.data.data));
    yield put(getLoaderAction(false));
    yield put(getRoleListTotal_pageCounst(response.data.total_count));
  } catch (error) {
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    yield put(getRoleListErroResponsen(error));
    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}
//-----Role----Create------------------

function* setRoleCreate(payload) {
  console.log(payload, "payload");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: RoleCreate,
      data: {
        role: payload.payload.datas.Role,
        description: payload.payload.datas.description,
        perform_id: payload.payload.datas.perform_id,
        position_number: payload.payload.datas.position_number,
        salary: payload.payload.datas.salary,
        wages: payload.payload.datas.wages,
        client_id: payload.payload.datas.clien_id,
        white_collar: payload.payload.datas.white_collar,
        from_salary: payload.payload.datas.from_salary,
        to_salary: payload.payload.datas.to_salary,
        wbs_element: payload.payload.datas.wbs_element,
        wbs_description: payload.payload.datas.wbs_description,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(getRoleCreateSuccessActions(response.data));
    yield put(getLoaderAction(false));
    const Content = {
      search: "",
      page_size: 20,
      page: payload.payload.currentPage,
      mode: "all",
      client: "",
      white_collar: payload.payload.white_collar_List,
      month: payload.payload.month,
      year: payload.payload.year,
    };
    yield put(getRoleListActions(Content));
  } catch (error) {
    yield put(getRoleCreateErrors(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}
///------Role-----deletes---------------
function* RoleDelete(payload) {
  console.log(payload, "eiywiuypayload");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "delete",
      url: RoleDeleteapi + payload.payload.DeleteId,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(SetRoleDeleteSuccessResponseCall(response.data.data));
    yield put(getLoaderAction(true));
    const Content = {
      search:
        store.getState().PreviousPagePosition.TablePositionPersist
          ?.DesginationStates?.search,
      page_size: 20,
      page: store.getState().PreviousPagePosition.TablePositionPersist
        ?.DesginationStates?.page,
      mode: "all",
      client:
        store.getState().PreviousPagePosition.TablePositionPersist
          ?.DesginationStates?.client,
      white_collar:
        store.getState().PreviousPagePosition.TablePositionPersist
          ?.DesginationStates?.white_collar,
      month:
        store.getState().PreviousPagePosition.TablePositionPersist
          ?.DesginationStates?.month,
      year: store.getState().PreviousPagePosition.TablePositionPersist
        ?.DesginationStates?.year,
    };
    yield put(getRoleListActions(Content));
  } catch (error) {
    yield put(getLoaderAction(false));
    yield put(setRoleDeleteErrorActions(error));
    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}
///-----role------retrive-------
function* getRoleretrieve(payload) {
  console.log(payload, "345payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: RoleRetrieve + payload.payload.EditID + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setRoleRetrieveSuccessResponseCall(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(setRoleRetrieveErrorCall(error));

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}
//-----Role----Edits-----
function* setRoleEdits(payload) {
  console.log(payload, "payload");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "put",
      url: roleEditsApi + payload.payload.EditID + "/",
      data: {
        // role: payload.payload.datas.role,
        // description: payload.payload.datas.description,
        // perform_id: payload.payload.datas.perform_id,
        // position_number: payload.payload.datas.position_number,

        role: payload.payload.datas.role,
        description: payload.payload.datas.description,
        perform_id: payload.payload.datas.perform_id,
        position_number: payload.payload.datas.position_number,
        salary: payload.payload.datas.salary,
        wages: payload.payload.datas.wages,
        client_id: payload.payload.datas.clien_id,
        white_collar: payload.payload.datas.white_collar,
        from_salary: payload.payload.datas.from_salary,
        to_salary: payload.payload.datas.to_salary,
        wbs_element: payload.payload.datas.wbs_element,
        wbs_description: payload.payload.datas.wbs_description,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    const Content = {
      search:
        store.getState().PreviousPagePosition.TablePositionPersist
          ?.DesginationStates?.search,
      page_size: 20,
      page: store.getState().PreviousPagePosition.TablePositionPersist
        ?.DesginationStates?.page,
      mode: "all",
      client:
        store.getState().PreviousPagePosition.TablePositionPersist
          ?.DesginationStates?.client,
      white_collar:
        store.getState().PreviousPagePosition.TablePositionPersist
          ?.DesginationStates?.white_collar,
      month:
        store.getState().PreviousPagePosition.TablePositionPersist
          ?.DesginationStates?.month,
      year: store.getState().PreviousPagePosition.TablePositionPersist
        ?.DesginationStates?.year,
    };
    yield put(getRoleListActions(Content));

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(setRoleEditSuccessResponse(response.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));

    yield put(setRoleEditErrors(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}
///-------Users------------Get_---List
function* getUserList(payloads) {
  // console.log(payloads, "payloajeyuiwyeuywds");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: Userlist,
        // params: {
        //   search: payloads.payload.search,
        //   page_size: payloads.payload.page_size,
        //   page: payloads.payload.page,
        //   month: payloads.payload.month,
        //   year: payloads.payload.year,
        //   white_collar: payloads.payload.white_collar,

        // },
        params: payloads.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setUserSuccessResponse(response.data.data));
      yield put(getLoaderAction2(false));
      yield put(setTotal_count_user(response.data.total_count));
    } catch (error) {
      yield put(setUserErrorsMessage(error));
      yield put(getLoaderAction2(false));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///-------Users------------Get_---List
function* getUserSelectoptionsList(payloads) {
  // console.log(payloads, "payloajeyuiwyeuywds");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: Userlist,
        params: payloads.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setUserSuccessOptionResponse(response.data.data));
      yield put(getLoaderAction(false));
      yield put(setoptionResponseTotal_count_user(response.data.total_count));
    } catch (error) {
      yield put(setUserOptionResponserrorsMessage(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///-------Users------------Get_---List---attendance dshboard
function* getUserSelectAttendanceDashboardListList(payloads) {
  console.log(payloads, "payloajeyuiwyeuywds");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: AttendanceExportUserApi,
        params: payloads.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setUserSuccessDashboardEmplpyeesResponse(response.data.data));
      yield put(getLoaderAction2(false));
      yield put(
        setoptionResponseDashboardEmployeeTotal_count_user(
          response.data.total_count,
        ),
      );
    } catch (error) {
      yield put(setUserOptionResponseDashboardEmployeerrorsMessage(error));
      yield put(getLoaderAction2(false));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///-------Users------------Get_---List
function* getUserListFilter(payloads) {
  console.log(payloads, "payloadssuyeqowueiquw");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: Userlist,
      params: {
        search: payloads.payload.search,
        page_size: payloads.payload.page_size,
        page: payloads.payload.page,
        state: payloads.payload.data.state,
        zone: payloads.payload.data.zone,
        region: payloads.payload.data.region,
        month: payloads.payload.month,
        year: payloads.payload.year,
        white_collar: payloads.payload.white_collar,
        role: payloads.payload.role,
        month: payloads.payload.month,
        year: payloads.payload.year,
        sub_role: payloads.payload.sub_role,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(SetUserFilterResponses(response.data.data));
    yield put(getLoaderAction(false));
    yield put(setTotal_count_userfilter(response.data.total_count));
  } catch (error) {
    yield put(setUserErrorsMessageFilter(error));
    yield put(getLoaderAction(false));

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}

function* setUserCreate(payload) {
  console.log(payload, "029183-payload");

  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: UserCreate,
      data:
        // email: payload.payload.data.email,
        // first_name: payload.payload.data.first_name,
        // last_name: payload.payload.data.last_name,
        // user_name: payload.payload.data.user_name,
        // password: payload.payload.data.password,
        // user_role: payload.payload.data.role,
        // region_id: payload.payload.data.region_id,

        // state_id: payload.payload.data.state_id,
        // zone_id: payload.payload.listdata,
        // user_sign_image: payload.payload.form_data,
        payload.payload.Creationdata,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(setUserCreateSuccessAction(response.data));
    yield put(getLoaderAction(false));
    const Content = {
      search: payload.payload.search,
      page_size: 20,
      month: payload.payload.month,
      year: payload.payload.year,
      white_collar: payload.payload.white_collar,
      page: payload.payload.currentPage,
      state: payload.payload.state,
      region: payload.payload.region,
      zone: payload.payload.zone,
    };
    yield put(setUserActions(Content));
    if (typeof payload.payload.Funcations === "function") {
      payload.payload.Funcations();
    }

    // window.location.href = "/user";
  } catch (error) {
    yield put(setUserCreateError(error));
    yield put(getLoaderAction(false));
    console.log(error, "error");
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    // console.log(error, "9837832error");
    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}

///------User----Delete---------------------
function* UserDeletes(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "delete",
      url: UserDelete + payload.payload.DeleteID + "/",
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(setUserDeleteSuccessResponse(response.data.data));
    yield put(getLoaderAction(false));
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    if (payload.payload.GetAPICALL == 1) {
      const Content = {
        search: "",
        page_size: 20,
        page: payload.payload.currentPage,
        month: payload.payload.month,
        year: payload.payload.year,
        state: payload.payload.state,
        region: payload.payload.region,
        white_collar: true,
        zone: payload.payload.zone,
        sub_role: store.getState().ClientBranchIDs?.KYC_Data?.value,
        role: payload.payload?.role_filter,
      };
      yield put(setUserActions(Content));
    } else if (payload.payload.GetAPICALL == 2) {
      yield put(setTheProfileSignatureActions(payload.payload.Getapiall));
    }
  } catch (error) {
    yield put(getLoaderAction(false));
    yield put(setUserDeleteErrorMessage(error));
    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}
///----User----Retrieve-----
function* getUserRetrieve(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: UserRetrieve + payload.payload.EditId + "/",
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(SetUserRetrieveSuccessResponse(response.data.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(SetUserRetrieveError(error));
    yield put(getLoaderAction(false));
    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}
//-----UserEdits--------------
function* SetUserEdits(payload) {
  if (payload.payload != undefined) {
    yield put(getLoaderAction(true));

    try {
      const response = yield axios({
        method: "put",
        url: UserEdit + payload.payload.EditId + "/",

        data: payload.payload.Creationdata,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      if (payload.payload.reporintrenders) {
        const content_pay = {
          EditId: payload.payload.EditId,
        };
        yield put(SetUserREtrieveActions(content_pay));
      } else {
        const Content = {
          search: payload.payload.search,
          page_size: 20,
          // month: payload.payload.month,
          // year: payload.payload.year,
          page: payload.payload.currentPage,
          white_collar: payload.payload.white_collar,
          state: payload.payload.state,
          region: payload.payload.region,
          zone: payload.payload.zone,
          sub_role: store.getState().ClientBranchIDs?.KYC_Data?.value,
          role: payload.payload?.role_filter,
        };
        yield put(setUserActions(Content));
      }

      toast.success(` ${response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      yield put(SteUserEditSuccessResponse(response.data));
      yield put(getLoaderAction(false));
      payload.payload.setShow(false);

      // window.location.href = "/user";
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(SetUserEditsErrorMessage(error));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

//-----------Profile----Edit---

function* settheProfileUpdate(payload) {
  if (payload.payload != undefined) {
    yield put(getLoaderAction(true));

    try {
      const response = yield axios({
        method: "put",
        url: UserEdit + payload.payload.EditId + "/",
        data: payload.payload.form_data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      toast.success(` ${response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      yield put(setTheProfileSignatureEDITResponse(response.data));
      console.log(response.data, "091270398271");
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(settheprofileSignatureEDITmethod(error));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

////-------Geo----States----------------
function* getGeoState(payloads) {
  if (payloads.payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: GeoState,
        params: {
          search: payloads.payload.search,
          page_size: payloads.payload.page_size,
          page: payloads.payload.page,
        },
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setGeoStateSuccessResponseActions(response.data.data));
      yield put(getLoaderAction(false));
      yield put(SetGeoListTotalCount(response.data.total_count));
    } catch (error) {
      yield put(setGeoStateErrorMessages(error));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
  if (payloads.payload == undefined && payloads.payload == "") {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: GeoState,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setGeoStateSuccessResponseActions(response.data.data));
      yield put(getLoaderAction(false));
      yield put(SetGeoListTotalCount(response.data.total_count));
    } catch (error) {
      yield put(setGeoStateErrorMessages(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}
////------------State---Create---

function* setStateCreate(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: stateCretae,
      data: {
        state_name: payload.payload.datas.State,
        description: payload.payload.datas.description,
        pre_area: payload.payload.datas.pre_area,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(getStateCreateSuccessResponse(response.data));
    yield put(getLoaderAction(false));
    const Content = {
      search: payload.payload.search,
      page_size: 20,
      page: payload.payload.currentPage,
    };
    yield put(setGeoLoactionStateAction(Content));
  } catch (error) {
    yield put(getStateErroMessage(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}
//---state----Delete--------------
function* StateDelete(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "delete",
      url: StateDeleteApi + payload.payload.DeleteID,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(setSatteDeleteSuccessResponse(response.data.data));
    yield put(getLoaderAction(false));
    const Content = {
      search: payload.payload.search,
      page_size: 20,
      page: payload.payload.currentPage,
    };
    yield put(setGeoLoactionStateAction(Content));
  } catch (error) {
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(setStateDeleteErrorMessage(error));
    yield put(getLoaderAction(false));

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}

///-----State------retrive-------
function* getStateRetrieve(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: StateRetrieve + payload.payload.EditId + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setStateRetrirveSuccessActions(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setStateRetrieveErrorCall(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}
//-----State----Edits-----
function* setStateEDITS(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "put",
      url: StateEdits + payload.payload.EditId + "/",
      data: {
        state_name: payload.payload.datas.State,
        description: payload.payload.datas.description,
        pre_area: payload.payload.datas.pre_area,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    const Content = {
      search: payload.payload.search,
      page_size: 20,
      page: payload.payload.currentPage,
    };
    yield put(setGeoLoactionStateAction(Content));
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(setStateEditSuccessResponse(response.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(setStateEditErrors(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}

//-----------_--Regions-----------

function* getRegions(payloads) {
  if (payloads != undefined && !payloads.payload.counts) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: RegionList,
        // params: {
        //   search: payloads.payload.search,
        //   page_size: payloads.payload.page_size,
        //   page: payloads.payload.page,

        // },
        params: payloads.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setRegionSuccessResponse(response.data.data));
      yield put(getLoaderAction(false));
      yield put(setRegionTotal_counts(response.data.total_count));
    } catch (error) {
      yield put(setRegionsError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
  if (payloads == undefined && payloads == "") {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: RegionList,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setRegionSuccessResponse(response.data.data));
      yield put(getLoaderAction(false));
      yield put(setRegionTotal_counts(response.data.total_count));
    } catch (error) {
      yield put(setRegionsError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
  if (
    payloads.payload.counts != undefined &&
    payloads.payload.counts == 2 &&
    payloads.payload.counts != 1 &&
    payloads.payload.state_id != undefined &&
    payloads.payload.state_id != ""
  ) {
    ///---For---the----User-----Create-------------

    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        params: {
          search: payloads.payload.search,
          page_size: payloads.payload.page_size,
          page: payloads.payload.page,
          state: JSON.stringify(payloads.payload.state_id),
        },
        url: RegionList,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setRegionSuccessResponse(response.data.data));
      yield put(getLoaderAction(false));
      yield put(setRegionTotal_counts(response.data.total_count));
    } catch (error) {
      yield put(setRegionsError(error));
      yield put(getLoaderAction(false));
      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
      // toast.error(` ${error.response.data.status.message} `, {
      // position: toast.POSITION.TOP_RIGHT,
      // });
    }
  }

  if (
    payloads.payload.counts != undefined &&
    payloads.payload.counts != 2 &&
    payloads.payload.counts == 1 &&
    payloads.payload.state != undefined &&
    payloads.payload.state != ""
  ) {
    ///---For---the----Client Branch-----Create-------------

    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        params: {
          search: payloads.payload.search,
          page_size: payloads.payload.page_size,
          page: payloads.payload.page,
          state: payloads.payload.state,
        },
        url: RegionList,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setRegionSuccessResponse(response.data.data));
      yield put(getLoaderAction(false));
      yield put(setRegionTotal_counts(response.data.total_count));
    } catch (error) {
      yield put(setRegionsError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}
//----

function* setRegionCreate(payload) {
  // console.log(payload, "2374908payload");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: RegionCreate,
      data: {
        region_name: payload.payload.data.region,
        description: payload.payload.data.Descriptions,
        state_id: payload.payload.data.state_id,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(getRegionCreateSuccessResponse(response.data));
    yield put(getLoaderAction(false));
    const Content = {
      search: payload.payload?.search,
      page_size: 20,
      page: payload.payload.currentPage,
      state: payload.payload.state,
    };
    yield put(setRegionActions(Content));
  } catch (error) {
    yield put(getRegionErroMessage(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}

//---Region----Delete--------------
function* RegionDelete(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "delete",
      url: RegionDeleteApi + payload.payload.DeleteID,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(setRegionDeleteSuccessResponse(response.data.data));
    yield put(getLoaderAction(false));
    const Content = {
      search: payload.payload.search,
      page_size: 20,
      page: payload.payload.currentPage,
      state: payload.payload.state,
    };
    yield put(setRegionActions(Content));
  } catch (error) {
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(getLoaderAction(false));
    yield put(setRegionDeleteErrorMessage(error));

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}
///-----Region------retrive-------
function* getRegionRetrieve(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: regionRetriev + payload.payload.EditId + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setRegionRetrirveSuccessActions(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setRegionRetrieveErrorCall(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}
// //-----Region----Edits-----
function* setReigonEditCall(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "put",
      url: RegionEdit + payload.payload.EditId + "/",
      data: {
        region_name: payload.payload.data.region,
        description: payload.payload.data.Descriptions,
        state_id: payload.payload.data.state_id,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    const Content = {
      search: payload.payload?.search,
      page_size: 20,
      page: payload.payload.currentPage,
      state: payload.payload.state,
    };
    yield put(setRegionActions(Content));
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(setRegionEditSuccessResponse(response.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(setRegionEditErrors(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    yield put(getLoaderAction(false));

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}

//-----------------ZONE-------------------
function* getZONELISt(payloads) {
  if (
    payloads != undefined &&
    !payloads.payload.counts &&
    !payloads.payload.region_id
  ) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: ZONElist,
        params: {
          search: payloads.payload.search,
          page_size: payloads.payload.page_size,
          page: payloads.payload.page,
        },
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setZoneSuccessResponse(response.data.data));
      yield put(getLoaderAction(false));
      yield put(SteZoneListToTal_counts(response.data.total_count));
    } catch (error) {
      yield put(setZoneErrorMessages(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
  if (payloads == undefined && payloads == "") {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: ZONElist,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setZoneSuccessResponse(response.data.data));
      yield put(getLoaderAction(false));
      yield put(SteZoneListToTal_counts(response.data.total_count));
    } catch (error) {
      yield put(setZoneErrorMessages(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
  if (
    !payloads.payload.counts &&
    payloads.payload.region_id != undefined &&
    payloads.payload.region_id != ""
  ) {
    // console.log(payloads, "odow-09-09", payloads.payload.region_id);
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: ZONElist,
        params: {
          search: payloads.payload.search,
          page_size: payloads.payload.page_size,
          page: payloads.payload.page,
          region: JSON.stringify(payloads.payload.region_id),
        },

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setZoneSuccessResponse(response.data.data));
      yield put(getLoaderAction(false));
      yield put(SteZoneListToTal_counts(response.data.total_count));
    } catch (error) {
      yield put(setZoneErrorMessages(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }

  if (
    payloads.payload.counts == 1 &&
    payloads.payload.region_id != undefined &&
    payloads.payload.region_id != ""
  ) {
    // console.log(payloads, "test", payloads.payload.region_id);
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: ZONElist,
        params: {
          search: payloads.payload.search,
          page_size: payloads.payload.page_size,
          page: payloads.payload.page,
          region: payloads.payload.region_id,
        },

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setZoneSuccessResponse(response.data.data));
      yield put(getLoaderAction(false));
      yield put(SteZoneListToTal_counts(response.data.total_count));
    } catch (error) {
      yield put(setZoneErrorMessages(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }

  if (payloads.payload.counts == 3) {
    // console.log(payloads, "test", payloads.payload.region_id);
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: ZONElist,
        // params: {
        //   search: payloads.payload.search,
        //   page_size: payloads.payload.page_size,
        //   page: payloads.payload.page,
        //   region: payloads.payload.region_id,
        // },

        params: payloads.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setZoneSuccessResponse(response.data.data));
      yield put(getLoaderAction(false));
      yield put(SteZoneListToTal_counts(response.data.total_count));
    } catch (error) {
      yield put(setZoneErrorMessages(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }

  if (payloads.payload.counts == 4) {
    // console.log(payloads, "test", payloads.payload.region_id);
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: ZONElist,
        params: {
          search: payloads.payload.search,
          page_size: payloads.payload.page_size,
          page: payloads.payload.page,
          // region: payloads.payload.region_id,
          client: payloads.payload.client,
        },

        // params: payloads.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setZoneSuccessResponse(response.data.data));
      yield put(getLoaderAction(false));
      yield put(SteZoneListToTal_counts(response.data.total_count));
    } catch (error) {
      yield put(setZoneErrorMessages(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* setzoneCreate(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: Zonecreate,
      data: {
        zone_name: payload.payload.datas.Zone,
        description: payload.payload.datas.description,
        region_id: payload.payload.datas.region_id,
        state_id: payload.payload.datas.state_id,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(getZoneCreateSuccessResponse(response.data));
    yield put(getLoaderAction(false));

    const Content = {
      search: payload.payload.search,
      page_size: 20,
      page: payload.payload.currentPage,
      state: payload.payload.state,
      region: payload.payload.region,
      counts: 3,
    };
    yield put(setZoneActions(Content));
  } catch (error) {
    yield put(getZoneErroMessage(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}
//---Zone----Delete--------------
function* ZoneDeleteCall(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "delete",
      url: ZoneDeleteApi + payload.payload.DeleteID,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(setZoneDeleteSuccessResponse(response.data.data));
    yield put(getLoaderAction(false));
    const Content = {
      search: "",
      page_size: 20,
      page: payload.payload.currentPage,
    };
    yield put(setZoneActions(Content));
  } catch (error) {
    yield put(getLoaderAction(false));
    yield put(setZoneDeleteErrorMessage(error));
    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

function* getZoneRetrieve(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: ZoneRetrirve + payload.payload.EditId + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setZoneRetrirveSuccessActions(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(setZoneRetrieveErrorCall(error));

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}
// //-----State----Edits-----
function* setZoneEdiyCall(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "put",
      url: ZoneEditsApi + payload.payload.EditId + "/",
      data: {
        zone_name: payload.payload.datas.Zone,
        description: payload.payload.datas.description,
        region_id: payload.payload.datas.region_id,
        state_id: payload.payload.datas.state_id,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    const Content = {
      search: payload.payload.search,
      page_size: 20,
      page: payload.payload.currentPage,
      state: payload.payload.state,
      region: payload.payload.region,
      counts: 3,
      state: payload.payload.state,
    };
    yield put(setZoneActions(Content));
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(setZoneEditSuccessResponse(response.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(setZoneEditErrors(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}
//--------CLientLIST
function* getCLientLIsts(payloads) {
  console.log(payloads, "payloadsdsfwsed");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: CLientListAPI,
      params: {
        search: payloads.payload.search,
        page_size: payloads.payload.page_size,
        page: payloads.payload.page,
        // project_number: payloads.payload.project_number,
        // pre_area: payloads.payload.pre_area,
        // month: payloads.payload.month,
        // year: payloads.payload.year,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(SetClientSuccessRespoenesActions(response.data.data));
    yield put(getLoaderAction(false));
    yield put(SetClientTotal_CountActions(response.data.total_count));
  } catch (error) {
    yield put(SetClientErrorActions(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}

////----CLient----Create
function* ClientCreateCall(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: ClientCreate,
      data: {
        client_name: payload.payload.datas.Client,
        description: payload.payload.datas.description,
        pre_area: payload.payload.datas.pre_area,
        project_number: payload.payload.datas.project_number,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(getClientCreateSuccessResponse(response.data));
    yield put(getLoaderAction(false));

    const Content = {
      search:
        store.getState().PreviousPagePosition.TablePositionPersist?.clientPage
          ?.search,
      page_size: 20,
      page: store.getState().PreviousPagePosition.TablePositionPersist
        ?.clientPage?.page,
    };
    yield put(SetClientActions(Content));
  } catch (error) {
    yield put(getClientErroMessage(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}
//---Client----Delete--------------
function* ClientDleteCall(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "delete",
      url: ClientDelete + payload.payload.DeleteID,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(setCLientDeleteSuccessResponse(response.data.data));
    yield put(getLoaderAction(false));
    const Content = {
      search:
        store.getState().PreviousPagePosition.TablePositionPersist?.clientPage
          ?.search,
      page_size: 20,
      page: store.getState().PreviousPagePosition.TablePositionPersist
        ?.clientPage?.page,
    };
    yield put(SetClientActions(Content));
  } catch (error) {
    yield put(setClientDeleteErrorMessage(error));
    yield put(getLoaderAction(false));

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}
function* getClientRetrieve(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: clientRetrieveApi + payload.payload.EditId + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setClientRetrirveSuccessActions(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setClientRetrieveErrorCall(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}
// //-----State----Edits-----
function* setClientEditCall(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "put",
      url: ClientEditApi + payload.payload.EditId + "/",
      data: {
        client_name: payload.payload.datas.Client,
        description: payload.payload.datas.description,
        pre_area: payload.payload.datas.pre_area,
        project_number: payload.payload.datas.project_number,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    const Content = {
      search:
        store.getState().PreviousPagePosition.TablePositionPersist?.clientPage
          ?.search,
      page_size: 20,
      page: store.getState().PreviousPagePosition.TablePositionPersist
        ?.clientPage?.page,
    };
    yield put(SetClientActions(Content));
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(setClientEditSuccessResponse(response.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(setClientEditErrors(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}

///-----------------cLIENT---branches

function* getClientBranchList(payloads) {
  if (payloads.payload.client) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: ClientBranchListAPi,
        // params: {
        //   search: payloads.payload.search,
        //   page_size: payloads.payload.page_size,
        //   page: payloads.payload.page,
        //   // month: payloads.payload.month,
        //   // year: payloads.payload.year,
        //   client: payloads.payload.client,
        // },
        params: payloads.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setClientBranchesSuccessResponse(response.data.data));
      yield put(getLoaderAction2(false));
      yield put(setClientBranchessTotal_count(response.data.total_count));
    } catch (error) {
      yield put(setCLientBranchesErrorsMessage(error));
      yield put(getLoaderAction2(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  } else {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: ClientBranchListAPi,
        params: {
          search: payloads.payload.search,
          page_size: payloads.payload.page_size,
          page: payloads.payload.page,
        },
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setClientBranchesSuccessResponse(response.data.data));
      yield put(getLoaderAction2(false));
      yield put(setClientBranchessTotal_count(response.data.total_count));
    } catch (error) {
      yield put(setCLientBranchesErrorsMessage(error));
      yield put(getLoaderAction2(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}
///-------------Branches----List
function* getClientBranchSearchList(payloads) {
  console.log(payloads, "posidaosdi payloads");

  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: ClientSearchAPI,
      params: {
        search: payloads.payload.search,
        page_size: payloads.payload.page_size,
        page: payloads.payload.page,
        client: payloads.payload.client,
        zone: payloads.payload.data.zone,
        state: payloads.payload.data.state,
        region: payloads.payload.data.region,
        month: payloads.payload.month,
        year: payloads.payload.year,
        organization: payloads.payload.organization,
      },

      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(setClientBrancheSearchSuccesRespones(response.data.data));
    yield put(getLoaderAction(false));
    yield put(setClientBrancheSearchTotal_counts(response.data.total_count));
  } catch (error) {
    yield put(setClientBranchSearchErrorActions(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}

///-----Branch---Create
function* setBranchCreate(payload) {
  console.log(payload, "payload");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: ClientBranchCre,
      // data: {
      //   client_name: payload.payload.data.client_name,
      //   short_description: payload.payload.data.description,
      //   email: payload.payload.data.Email,
      //   address: payload.payload.data.Address,
      //   phone_number: payload.payload.data.ph,
      //   client_id: payload.payload.data.client_id,
      //   state_id: payload.payload.data.state_id,
      //   region_id: payload.payload.data.region_id,
      //   zone_id: payload.payload.data.zone_id,
      //   latitude: payload.payload.latitude,
      //   longitude: payload.payload.longitude,
      //   wbs_element: payload.payload.data.wbs_element,
      //   // total_permissions: Number(payload.payload.data.total_permissions),
      //   personal_leave: Number(payload.payload.data.personal_leave),

      //   casual_leave: Number(payload.payload.data.casual_leave),
      //   // leave_valid_until: payload.payload.data.leave_valid_until,
      //   // permission_valid_until: payload.payload.data.permission_valid_until,
      //   supervisor_ids:payload.payload.data.supervisor_ids,
      //   leave_types:payload.payload.data.leave_types,
      //   extra_leave:Number(payload.payload.data.extra_leave),
      //   has_leave:payload.payload.has_leave,
      //   l1_user:payload.payload.data.l1_user,
      //   l2_user:payload.payload.data.l2_user,
      //   l3_user:payload.payload.data.l3_user,

      // },
      data: payload.payload.CreatedData,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(setClientBranchCreateSuccessAction(response.data));
    yield put(getLoaderAction(false));

    const Content = {
      search:
        store.getState().PreviousPagePosition.TablePositionPersist
          ?.clientBranchPage?.search,
      page_size: 20,
      page: store.getState().PreviousPagePosition.TablePositionPersist
        ?.clientBranchPage?.page,
      // client: payload.payload.client,
      client:
        store.getState().PreviousPagePosition.TablePositionPersist
          ?.clientBranchPage?.client,
      // month:payload.payload.month,
      // year:payload.payload.year,
    };
    yield put(setClientBranchActions(Content));

    if (typeof payload.payload.Funcations === "function") {
      payload.payload.Funcations();
    }
  } catch (error) {
    yield put(setClientBranchCreateError(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}

function* setBranchEdits(payload) {
  if (payload.payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: ClientBranEdits + payload.payload.EditId + "/",
        // data: {
        //   client_name: payload.payload.data.client_name,
        //   short_description: payload.payload.data.description,
        //   email: payload.payload.data.Email,
        //   address: payload.payload.data.Address,
        //   phone_number: payload.payload.data.ph,
        //   client_id: payload.payload.data.client_id,
        //   state_id: payload.payload.data.state_id,
        //   region_id: payload.payload.data.region_id,
        //   zone_id: payload.payload.data.zone_id,
        //   latitude: payload.payload.latitude,
        //   longitude: payload.payload.longitude,
        //   wbs_element: payload.payload.data.wbs_element,
        //   // total_permissions: Number(payload.payload.data.total_permissions),
        //   personal_leave: Number(payload.payload.data.personal_leave),

        //   casual_leave: Number(payload.payload.data.casual_leave),
        //   // leave_valid_until: payload.payload.data.leave_valid_until,
        //   // permission_valid_until: payload.payload.data.permission_valid_until,
        //   supervisor_ids:payload.payload.data.supervisor_ids,
        //   leave_types:payload.payload.data.leave_types,
        //   extra_leave:Number(payload.payload.data.extra_leave),
        //   has_leave:payload.payload.has_leave,
        // },
        data: payload.payload.editdata,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      const Content = {
        search:
          store.getState().PreviousPagePosition.TablePositionPersist
            ?.clientBranchPage?.search,
        page_size: 20,
        page: store.getState().PreviousPagePosition.TablePositionPersist
          ?.clientBranchPage?.page,
        // client: payload.payload.client,
        client:
          store.getState().PreviousPagePosition.TablePositionPersist
            ?.clientBranchPage?.client,
        // month:payload.payload.month,
        // year:payload.payload.year,
      };
      yield put(setClientBranchActions(Content));

      toast.success(` ${response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (typeof payload.payload.Funcations === "function") {
        payload.payload.Funcations();
      }

      yield put(SetBranchEditSuccessResponse(response.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SetBranchEditsErrorMessage(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* getBranchRetrieve(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: clientBranRetrieve + payload.payload.EditId + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetClientBranchesRetrieveSuccessResponse(response.data.data));
      yield put(getLoaderAction2(false));
    } catch (error) {
      yield put(SetClientBranchesREtrieveErrorRetieve(error));
      yield put(getLoaderAction2(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* setBranchDelete(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "delete",
      url: ClientBranchDel + payload.payload.DeleteID,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(setClientBranDeleteSuccessResponse(response.data.data));
    yield put(getLoaderAction(false));
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    const Content = {
      search: "",
      page_size: 20,
      page: payload.payload.currentPage,
      client: payload.payload.client,
      // month: payload.payload.month,
      // year: payload.payload.year,
    };
    yield put(setClientBranchActions(Content));
  } catch (error) {
    yield put(setClientBranDeleteErrorMessage(error));
    yield put(getLoaderAction(false));

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}
///-----------------SHift----List

function* getShiftListCal(payloads) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: ShiftCALL,
      params: {
        search: payloads.payload.search,
        page_size: payloads.payload.page_size,
        page: payloads.payload.page,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(setshiftListResponseActions(response.data.data));
    yield put(getLoaderAction(false));
    yield put(SetShiftTotal_countActions(response.data.total_count));
  } catch (error) {
    yield put(setShiftErrorMessages(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}

function* getShiftSearch(payloads) {
  console.log(payloads, "payloads");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: ShiftSearchAPi,
      params: {
        search: payloads.payload.search,
        page_size: payloads.payload.page_size,
        page: payloads.payload.page,
        client: payloads.payload.client_id,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(SetShiftSearchSuccessResponse(response.data.data));

    yield put(getLoaderAction(false));
    yield put(SetShiftSearchTotal_Counts(response.data.total_count));
  } catch (error) {
    yield put(SetShiftSearchError(error));
    yield put(getLoaderAction(false));
    // toast.error(` ${error.response.data.status.message} `, {
    //   position: toast.POSITION.TOP_RIGHT,
    // });

    if (
      error.response.data.status != undefined &&
      error.response.data.status.code == 401
    ) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}
//

//----Shift----Create
function* SetShiftCreateCall(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: ShiftCreateAPI,
      data: {
        shift_name: payload.payload.data.Shift_name,
        from_time:
          payload.payload.formattedTime == "NaN:NaN"
            ? null
            : payload.payload.formattedTime,
        end_time:
          payload.payload.formattedEndTime == "NaN:NaN"
            ? null
            : payload.payload.formattedEndTime,
        client_id: payload.payload.data.Client_id,
        excel_code: payload.payload.data.encodeId,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(SetShiftCreatedSuccessResponse(response.data));
    yield put(getLoaderAction(false));
    const Content = {
      search: "",
      page_size: 20,
      page: payload.payload.currentPage,
      client_id: payload.payload.data.Client_id,
    };
    // yield put(setShiftListsActions(Content));
    yield put(SetShiftSearchActions(Content));
    // window.location.href = "/clientbranch";
  } catch (error) {
    yield put(SteShiftCreateErrorResponse(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    if (
      error.response.data.status != undefined &&
      error.response.data.status.code == 401
    ) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}

//-----Shift----Delete---------------
function* ShiftDeleteSaga(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "delete",
      url: ShiftDeleteAPI + payload.payload.DeleteID,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(setShiftDeleteSuccessResponse(response.data.data));
    yield put(getLoaderAction(false));
    const Content = {
      search: "",
      page_size: 20,
      page: payload.payload.currentPageShift,
      client_id: payload.payload.client_id,
    };
    yield put(SetShiftSearchActions(Content));
  } catch (error) {
    yield put(setShiftDeleteErrorMessages(error));
    yield put(getLoaderAction(false));

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}

//-----Shift-----Retrieve
function* getShiftRetrieveCall(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: ShiftREtrieve + payload.payload.EditId + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetRetrieveSuccessAction(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(SetShiftRetrieveErrorActions(error));
    }
  }
}
function* setShiftEdits(payload) {
  if (payload.payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: ShiftEDITAPI + payload.payload.EditId + "/",
        data: {
          shift_name: payload.payload.data.Shift_name,
          // from_time: payload.payload.formattedTime,
          // end_time: payload.payload.formattedEndTime,
          from_time:
            payload.payload.formattedTime == "NaN:NaN"
              ? null
              : payload.payload.formattedTime,
          end_time:
            payload.payload.formattedEndTime == "NaN:NaN"
              ? null
              : payload.payload.formattedEndTime,
          client_id: payload.payload.data.Client_id,
          excel_code: payload.payload.data.encodeId,
        },
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      const Content = {
        search: "",
        page_size: 20,
        page: payload.payload.currentPage,
        client_id: payload.payload.data.Client_id,
      };
      //yield put(setShiftListsActions(Content));
      yield put(SetShiftSearchActions(Content));

      toast.success(` ${response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      //   window.location.href = "/clientbranch";
      yield put(SetShiftEditSuccessActions(response.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SetShiftEditsErrorMessages(error));
      yield put(getLoaderAction(false));

      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

//----Employeee----DatasList----------------------------
function* getEmployeaDatasList(payloads) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: EmployeeDatasApi,
      params: {
        search: payloads.payload.search,
        page_size: payloads.payload.page_size,
        page: payloads.payload.page,
        zone: payloads.payload.data.zone,
        state: payloads.payload.data.state,
        region: payloads.payload.data.region,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(setEmployeeListDATASResponseActions(response.data.data));
    yield put(getLoaderAction(false));
    yield put(SetEmployeeDataTotal_countActions(response.data.total_count));
  } catch (error) {
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    yield put(setEmployeeDataErrorMessages(error));

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}

//--Employee---Singel----Persons---Lists

function* getEmployeaSinglePersonsList(payloads) {
  // console.log(payloads, "payloads");

  try {
    // let paramstest = {
    //   search: payloads.payload.search,
    //   page_size: payloads.payload.page_size,
    //   page: payloads.payload.page,
    //   client: payloads.payload.ids,
    //   is_decline: false,
    //   payroll_approved: false,
    //   is_pending: true,
    //   // create_employee:false ,
    //   from_date: payloads.payload.from_date,
    //   to_date: payloads.payload.to_date,
    //   range: true,
    // };

    // let notPayrol = {
    //   search: payloads.payload.search,
    //   page_size: payloads.payload.page_size,
    //   page: payloads.payload.page,
    //   client: payloads.payload.ids,
    //   from_date: payloads.payload.from_date,
    //   to_date: payloads.payload.to_date,
    //   range: true,
    // };

    // if (payloads.payload.SubRoleList == 0) {
    //   if (payloads.payload.payroll_approved == 3) {
    //     // Payroll is approved
    //     paramstest.payroll_approved = true; // Approve
    //   } else if (payloads.payload.payroll_approved == 2) {
    //     paramstest.is_decline = true; // is_decline - true
    //     paramstest.payroll_approved = false; // payroll_approved - false
    //     // paramstest.is_pending = false;
    //     paramstest.is_pending = true;
    //     // paramstest.create_employee = true
    //   } else if (payloads.payload.payroll_approved == 1) {
    //     //  paramstest.payroll_approved = "1"; // Pending
    //     paramstest.payroll_approved = false;
    //     paramstest.is_pending = true;
    //   }
    // }

    yield put(getLoaderAction2(true));

    const response = yield axios({
      method: "get",
      url: EmployeeListsPersonsApi,
      // params: payloads.payload.SubRoleList == 0 ? paramstest : notPayrol,
      params: payloads.payload,

      // params: {
      //   search: payloads.payload.search,
      //   page_size: payloads.payload.page_size,
      //   page: payloads.payload.page,
      //   client: payloads.payload.ids,
      // },

      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    // yield put(setEmployeeListSPersonsResponseActions(response.data.data));
    if (response.data.data.inquiry_data) {
      yield put(SetTheInquriyStatus(response.data.data.inquiry_data));
    } else {
      yield put(SetTheInquriyStatus([]));
    }

    yield put(
      SetEmployeeDataTotal_countPersonsActions(response.data.total_count),
    );
    // toast.success(` ${response.data.status.message} `, {
    // position: toast.POSITION.TOP_RIGHT,
    // });

    yield put(getLoaderAction2(false));
  } catch (error) {
    yield put(setEmployeeDataPersonsErrorMessages(error));
    yield put(getLoaderAction2(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}

function* gettheApproveRequestEmployeelist(payloads) {
  console.log(payloads, "9081-28payloads");

  try {
    yield put(getLoaderAction2(true));
    const response = yield axios({
      method: "get",
      url: EmployeeListsPersonsApi,
      params: payloads.payload,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    // yield put(setApproveRequestPersonsResponseActions(response.data.data));
    if (response.data.data.inquiry_data != undefined) {
      yield put(
        SetTheApproveRequestInquriyStatus(response.data.data.inquiry_data),
      );
    } else {
      yield put(SetTheApproveRequestInquriyStatus([]));
    }
    yield put(
      SetApproveRequestTotal_countPersonsActions(response.data.total_count),
    );
    yield put(getLoaderAction2(false));
  } catch (error) {
    yield put(getLoaderAction2(false));
    console.log(error, "error8971289");

    if (error.response.status != 500) {
      yield put(setApproveRequestPersonsErrorMessages(error));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    } else {
      // toast.error(` ${" something went wrong"} `, {
      //   position: toast.POSITION.TOP_RIGHT,
      // });

      toast.error(` ${error.response.data} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}

function* getEmployeaSingleLIST_FILTER_PersonsList(payloads) {
  console.log(payloads, "payloasadasdds");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: EmployeeListsPersonsApi,
      params: {
        search: payloads.payload.search,
        page_size: payloads.payload.page_size,
        page: payloads.payload.page,
        is_pending: payloads.payload.selectVal.is_pending,
        is_decline: payloads.payload.selectVal.is_decline,
        approved: payloads.payload.selectVal.approved,
        client: payloads.payload.ids,
        from_date: payloads.payload.from_date,
        to_date: payloads.payload.to_date,
        range: true,
      },

      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    // yield put(setEmployeeListSPersonsFilterResponseActions(response.data.data));
    // yield put(SetTheInquriyStatusFilter(response.data.data.inquiry_data));
    if (response.data.data.inquiry_data != undefined) {
      yield put(SetTheInquriyStatusFilter(response.data.data.inquiry_data));
    } else {
      yield put(SetTheInquriyStatusFilter([]));
    }

    yield put(
      SetEmployeeDataTotal_countPersonsFilterActions(response.data.total_count),
    );
    // toast.success(` ${response.data.status.message} `, {
    // position: toast.POSITION.TOP_RIGHT,
    // });

    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(setEmployeeDataPersonsFilterErrorMessages(error));
    yield put(getLoaderAction(false));

    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}

////--Detail--of---Emplyee

function* getEmployeaSingleFormPersonsList(payloads) {
  try {
    yield put(getLoaderAction2(true));
    const response = yield axios({
      method: "get",
      url: EmployeeDetailsAPI + payloads.payload.ids + "/",
      // params: {
      //   search: payloads.payload.search,
      //   page_size: payloads.payload.page_size,
      //   page: payloads.payload.page,
      // },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(getLoaderAction2(false));

    yield put(setTheAllFormPdf(response.data.data?.create_employee));

    yield put(settheEmployeeFormFilled(response.data.data?.is_pending));

    yield put(setEmployeeListProfileSResponseActions(response.data.data));

    yield put(getLoaderAction2(false));
    yield put(
      SetEmployeeDataprofileTotal_countActions(response.data.total_count),
    );
  } catch (error) {
    yield put(getLoaderAction2(false));

    if (error.response.status != 500) {
      yield put(setEmployeeDataprofileErrorMessages(error));

      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    } else {
      toast.error(` ${" something went wrong"} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}

//-----Employeee---List
function* getEmployeeList(payloads) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: EmployeeApi,
      params: {
        search: payloads.payload.search,
        page_size: payloads.payload.page_size,
        page: payloads.payload.page,
        client: payloads.payload.client_id,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(setEmployeeListResponseActions(response.data.data));
    yield put(getLoaderAction(false));
    yield put(SetEmployeeTotal_countActions(response.data.total_count));
  } catch (error) {
    yield put(setEmployeeErrorMessages(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}

///---EMPLOYEE----cREATE
function* EmployeeCreate(payload) {
  const payloadData = payload.payload;

  const NestedData = payload.payload.inputFields;

  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: EmployeeCretaeApi,
      params: {
        client_id: payload.payload.client_id,
      },
      data: {
        data: NestedData,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(SetEmployeeSuccessResponen(response.data));
    yield put(getLoaderAction(false));
    const Content = {
      search: "",
      page_size: 20,
      page: payload.payload.currentPage,
    };
    yield put(setEmployeetListsActions(Content));
    window.location.href = "/clientDetails";
  } catch (error) {
    yield put(SetEmployeeErrorActions(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}

//----Delete--_Emp
function* EmployeeDelete(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "delete",
      url: EmployeeDeleteApi + payload.payload.DeleteID,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(SetEmployeeDeleteSuccessResponen(response.data.data));
    yield put(getLoaderAction(false));
    const Content = {
      search: "",
      page_size: 20,
      page: payload.payload.currentPage,
    };
    yield put(setEmployeetListsActions(Content));
  } catch (error) {
    yield put(SetEmployeeDeleteErrorActions(error));
    yield put(getLoaderAction(false));
    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}

//---Retrieve---Emp
function* getRetriveEmp(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: EmployeeRetrieve + payload.payload.EditId + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetEmployeeRetrieveSuccessResponen(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(SetEmployeeRetrieverrorActions(error));
      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}
//----Edit---Emp
function* EmployeeEditCall(payload) {
  const payloadData = payload.payload;
  const EditData = payload.payload.datas;

  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "put",
      url: EmployeeEdit + "23234234" + "/",
      data: {
        data: payload.payload.datas,
      },
      params: {
        client_id: payload.payload.client_id,
      },

      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(SetEmployeeEditcallSuccessResponse(response.data));
    yield put(getLoaderAction(false));
    const Content = {
      search: "",
      page_size: 20,
      page: payloadData.currentPage,
    };
    yield put(setEmployeetListsActions(Content));

    window.location.href = "/clientDetails";
  } catch (error) {
    yield put(SetEmployeeEditcallErrorActions(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}

///-----FORMS_------------------

function* getFormBasicDetails(payload) {
  if (
    payload.payload.Retieveid != undefined &&
    payload.payload.Retieveid != ""
  ) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: BasicFormRetrieveApi + payload.payload.Retieveid + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SETBASICFORMdetails(response.data.data));
      yield put(getLoaderAction(false));
      // toast.success(` ${response.data.status.message} `, {
      // position: toast.POSITION.TOP_RIGHT,
      // });
      if (payload.payload.Move != undefined && payload.payload.Move == 3) {
        const payloadsempyeeprofile = {
          search: "",
          page_size: 10,
          page: 1,
          ids:
            store.getState().BasicFormCreated.user_ID == ""
              ? store.getState().EmployeeProfile.EmployeeProfileList.id
              : store.getState().BasicFormCreated.user_ID,
        };

        yield put(setEmployeeProfileDATASActions(payloadsempyeeprofile));
      }
    } catch (error) {
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(SETBasicFOrmError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///----Bacis---From---Create----
function* getFormBasicDetailsCreate(payload) {
  console.log(payload, "asdasdas");
  if (payload.payload != undefined && payload.payload != "") {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: BasicFormRetrieveApi,
        data: payload.payload.form_data,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      // console.log(response.data.data.id, "refsdfsd");
      yield put(setTheBacisHoldDatas(response.data.data));
      yield put(SetBasiformsID(response.data.data.id));
      yield put(SETBASICFORMcreatedetails(response.data.data.timeline_id));
      yield put(getLoaderAction(false));
      // toast.success(` ${response.data.status.message} `, {
      // position: toast.POSITION.TOP_RIGHT,
      // });

      yield put(SetEmployeeProfileDetailsID(response.data.data.user_id));

      // let BasicFormID = {
      //   Retieveid: response.data.data.id,
      // };

      // yield put(SetActionsBasicFormsDetails(BasicFormID));
      const datas = {
        Retieveid: response.data.data.id,
        Move: 3,
      };
      // yield put(SetActiveTabs(2));

      // yield put ((response.data.data.id))
      if (payload.payload.Move == 2) {
        yield put(SetActiveTabs(2));
      }
      if (payload.payload.Move != 2) {
        yield put(SetActionsBasicFormsDetails(datas));
      }

      yield put(SetBasiformsID(response.data.data.id));
      yield put(setTheUser_ID(response.data.data.user_id));
      // yield put(SetActiveTabs(2));
    } catch (error) {
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(SETBasicFOrmcreateError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///----Bacis---From---Edit----
function* getFormBasicDetailsEdit(payload) {
  console.log(payload, "payload");
  if (payload.payload != undefined && payload.payload != "") {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: BasicFormRetrieveApi + payload.payload.Retieveid + "/",
        data: payload.payload.form_data,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SETBASICFORMEDITdetails(response.data.data.timeline_id));
      console.log(response.data.data.timeline_id, "jb jsoax5678");
      yield put(getLoaderAction(false));
      // toast.success(` ${response.data.status.message} `, {
      // position: toast.POSITION.TOP_RIGHT,
      // });
      const datas = {
        Retieveid: payload.payload.Retieveid,
        Move: 3,
      };
      if (!payload.payload.Movedno || payload.payload.Movedno != 2) {
        yield put(SetActiveTabs(2));
      }

      yield put(SetActionsBasicFormsDetails(datas));
      yield put(SetBasiformsID(response.data.data.id));
    } catch (error) {
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(SETBasicFOrmEditError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///----Addresss------------___Forms-------------
function* getAddressFormDetails(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: AddressAPi + payload.payload.Retieveid + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetAddressFormAction(response.data.data));
      yield put(getLoaderAction(false));
      // toast.success(` ${response.data.status.message} `, {
      // position: toast.POSITION.TOP_RIGHT,
      // });
    } catch (error) {
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(SetAddressFormError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///---Address----Create----List---
function* getAddressCreateFormDetails(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    const data = {
      present_address: {
        street_name: payload.payload.data.street_name,
        town_name: payload.payload.data.town_name,
        city_name: payload.payload.data.city_name,
        state_name: payload.payload.data.state_name,
        pin_code: payload.payload.data.pin_code,
      },
      permanent_address: {
        street_name: payload.payload.permanent.street_name1,
        town_name: payload.payload.permanent.town_name1,
        city_name: payload.payload.permanent.city_name1,
        state_name: payload.payload.permanent.state_name1,
        pin_code: payload.payload.permanent.pin_code1,
      },
      is_permanent: payload.payload.check,
      timeline_id: payload.payload.timeline_id,
    };
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: AddressAPi,
        // data: data,
        data: payload.payload.form_data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetAddressFormcreateAction(response.data.data));
      yield put(getLoaderAction(false));

      // toast.success(` ${response.data.status.message} `, {
      // position: toast.POSITION.TOP_RIGHT,
      // });
      yield put(SetAddressId(response.data.data.id));

      const payloadsempyeeprofile = {
        search: "",
        page_size: 10,
        page: 1,
        ids:
          store.getState().BasicFormCreated.user_ID == ""
            ? store.getState().EmployeeProfile.EmployeeProfileList.id
            : store.getState().BasicFormCreated.user_ID,
      };

      yield put(setEmployeeProfileDATASActions(payloadsempyeeprofile));

      // const test = {
      //   Retieveid: response.data.data.id,
      // };

      // yield put(SetAddressForm(test));
      yield put(SetActiveTabs(10));
    } catch (error) {
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(SetAddressFormcreateError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///---Address----Create----List---
function* getAddresseditFormDetails(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    const AddressData = {
      present_address: {
        street_name: payload.payload.data.street_name,
        town_name: payload.payload.data.town_name,
        city_name: payload.payload.data.city_name,
        state_name: payload.payload.data.state_name,
        pin_code: payload.payload.data.pin_code.slice(0, 6),
      },
      permanent_address: {
        street_name: payload.payload.permanent.street_name1,
        town_name: payload.payload.permanent.town_name1,
        city_name: payload.payload.permanent.city_name1,
        state_name: payload.payload.permanent.state_name1,
        pin_code: payload.payload.permanent.pin_code1.slice(0, 6),
      },
      is_permanent: payload.payload.check,
      timeline_id: payload.payload.timeline_id,
    };
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: AddressAPi + payload.payload.id + "/",
        // data: AddressData,
        data: payload.payload.form_data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetAddressFormEDitAction(response.data));
      yield put(getLoaderAction(false));
      // toast.success(` ${response.data.status.message} `, {
      // position: toast.POSITION.TOP_RIGHT,
      // });

      // const payloadsempyeeprofile = {
      //   search: "",
      //   page_size: 10,
      //   page: 1,
      //    ids: store.getState().BasicFormCreated.user_ID == ""
      //    ? store.getState().EmployeeProfile.EmployeeProfileList.id
      //    : store.getState().BasicFormCreated.user_ID,
      // };

      // yield put (setEmployeeProfileDATASActions(payloadsempyeeprofile));

      // const data = {
      //   Retieveid: payload.payload.id,
      // };
      // yield put(SetAddressForm(data));
      yield put(SetActiveTabs(10));
    } catch (error) {
      yield put(getLoaderAction(false));
      // toast.error(` ${error.response.data.status.message} `, {
      //   position: toast.POSITION.TOP_RIGHT,
      // });
      console.log(error, "eerefg");
      yield put(SetAddressFormEditError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///----IDverifications------------___Forms-------------
function* getIdverificationdetails(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: IdverifyAPI + payload.payload.Retieveid + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetIdVerificationFormAction(response.data.data));
      yield put(getLoaderAction2(false));
      // toast.success(` ${response.data.status.message} `, {
      // position: toast.POSITION.TOP_RIGHT,
      // });
    } catch (error) {
      yield put(getLoaderAction2(false));
      yield put(SetIdverificationFormError(error));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///----IDverifications------Create------___Forms-------------
function* getIdverificationCreatedetails(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: IdverifyAPI,
        data: payload.payload.CreateEdForm,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetIdVerificationFormcreateAction(response.data.data));
      yield put(getLoaderAction(false));

      // toast.success(` ${response.data.status.message} `, {
      // position: toast.POSITION.TOP_RIGHT,
      // });

      yield put(SetIdVeriications(response.data.data.id));

      const payloadsempyeeprofile = {
        search: "",
        page_size: 10,
        page: 1,
        ids:
          store.getState().BasicFormCreated.user_ID == ""
            ? store.getState().EmployeeProfile.EmployeeProfileList.id
            : store.getState().BasicFormCreated.user_ID,
      };

      yield put(setEmployeeProfileDATASActions(payloadsempyeeprofile));

      // const test = {
      //   Retieveid: response.data.data.id,
      // };
      // yield put(setIdVerificationActions(test));
      const contect = {
        formdata: payload.payload.formdata,
        Retieveid: response.data.data.id,
        // is_id_verification: true,
        Verified_status: payload.payload.Verified_status,
      };
      yield put(SetTheIdVerifycationActions(contect));
      yield put(SetActiveTabs(4));
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(SetIdverificationFormcreateError(error));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///----IDverifications------Edit------___Forms-------------
function* getIdverificationEditdetails(payload) {
  console.log(payload, "payload");

  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "put",
      url: IdverifyAPI + payload.payload.id + "/",
      data: payload.payload.CreateEdForm,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(SetIdVerificationFormEditAction(response.data.data));
    yield put(getLoaderAction(false));
    // toast.success(` ${response.data.status.message} `, {
    // position: toast.POSITION.TOP_RIGHT,
    // });

    // const contect = {
    //   formdata: payload.payload.formdata,
    //   Retieveid: payload.payload.Retieveid,
    //   // is_id_verification: true,
    //   Verified_status: payload.payload.Verified_status,
    // };

    // yield put(SetTheIdVerifycationActions(contect));

    const payloadsempyeeprofile = {
      search: "",
      page_size: 10,
      page: 1,
      ids:
        store.getState().BasicFormCreated.user_ID == ""
          ? store.getState().EmployeeProfile.EmployeeProfileList.id
          : store.getState().BasicFormCreated.user_ID,
    };

    yield put(setEmployeeProfileDATASActions(payloadsempyeeprofile));

    yield put(SetActiveTabs(4));
    // const Datas = {
    //   Retieveid: payload.payload.Retieveid,
    // };
    // yield put(setIdVerificationActions(Datas));
  } catch (error) {
    yield put(getLoaderAction(false));
    yield put(SetIdverificationFormEditError(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}

///-----Id---verification----Edit----Calls
function* GetIdVerificationEditCalls(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "put",
      url: IdverificationEditApi + payload.payload.Retieveid + "/",
      data: payload.payload.formdata,
      // {
      //   is_id_verification: payload.payload.is_id_verification,
      //   timeline_id: payload.payload.timeline_id,
      // }

      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(SetTheIDverifycationEditResponse(response.data.data));

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    yield put(getLoaderAction(false));
    Swal.close();
    // if (payload.payload.verified_status == 0) {
    // Swal.fire({
    // text: "Employee ID has been Verified",
    // icon: "success",
    // });
    // }
    // else if(payload.payload.verified_status == 1){
    // Swal.fire({
    // text: "Employee ID has been declined",
    // icon: "success",
    // });
    // }
  } catch (error) {
    yield put(getLoaderAction(false));

    yield put(SetIdverificationEditError(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}
///----Bank------------___Forms-------------
function* getBankDetails(payload) {
  console.log(payload, "payload");
  if (payload != undefined && payload.payload.Retieveid != "") {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: BankDetailAPI + payload.payload.Retieveid + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetBankDataResponeActions(response.data.data));
      yield put(getLoaderAction(false));
      yield put(setBankDetailsId(response.data.data.id));
      // toast.success(` ${response.data.status.message} `, {
      // position: toast.POSITION.TOP_RIGHT,
      // });
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(setBankDataError(error));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///----EDUCATIONS------------Details-------------
function* getEDUCATIONDetails(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: EducationDetailsAPI + payload.payload.Retieveid + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetEducationDataResponeActions(response.data.data));
      yield put(getLoaderAction(false));
      // toast.success(` ${response.data.status.message} `, {
      // position: toast.POSITION.TOP_RIGHT,
      // });
      yield put(SetEducationDetails(response.data.data.id));
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(setEducationDataError(error));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///----PreviousEmployeee------------Details-------------
function* PreviousEmployeeCall(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: PreviousAPI,
        params: {
          user: payload.payload.UserId,
        },
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetPreviuousEmpDataResponeActions(response.data.data));
      yield put(getLoaderAction(false));
      // toast.success(` ${response.data.status.message} `, {
      // position: toast.POSITION.TOP_RIGHT,
      // });
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(setPreviousDataError(error));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///----PreviousEmployeee---Craete---------Details-------------
function* PreviousEmployeeCreateCall(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: PreviousAPI,
        data: payload.payload.formdata,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetPreviuousEmpDataCreateResponeActions(response.data.data));
      yield put(getLoaderAction(false));
      // toast.success(` ${response.data.status.message} `, {
      // position: toast.POSITION.TOP_RIGHT,
      // }); yield  put (SetPreviousEmployeeID(response.data.data))
      yield put(SetPreviousEmployeeID(response.data.data.id));

      // const test = {
      //   Retieveid: response.data.data.id,
      //   UserId: response.data.data[0].user_id,
      // };
      // yield put(setPreviousEmpDataActions(test));
      console.log(response.data.data, "scascASc");
      const payloadsempyeeprofile = {
        search: "",
        page_size: 10,
        page: 1,
        ids:
          store.getState().BasicFormCreated.user_ID == ""
            ? store.getState().EmployeeProfile.EmployeeProfileList.id
            : store.getState().BasicFormCreated.user_ID,
      };

      yield put(setEmployeeProfileDATASActions(payloadsempyeeprofile));
      // yield put(SetActiveTabs(7));
      yield put(SetActiveTabs(8));
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(setPreviousDataCreateError(error));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///----PreviousEmployeee---Edit---------Details-------------
function* PreviousEmployeeEditCall(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: PreviousAPI + payload.payload.Retieveid + "/",
        data: payload.payload.formdata,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetPreviuousEmpDataEditResponeActions(response.data.data));
      yield put(getLoaderAction(false));
      // toast.success(` ${response.data.status.message} `, {
      // position: toast.POSITION.TOP_RIGHT,
      // });
      // yield put(SetActiveTabs(7));
      const payloadsempyeeprofile = {
        search: "",
        page_size: 10,
        page: 1,
        ids:
          store.getState().BasicFormCreated.user_ID == ""
            ? store.getState().EmployeeProfile.EmployeeProfileList.id
            : store.getState().BasicFormCreated.user_ID,
      };

      // yield put (setEmployeeProfileDATASActions(payloadsempyeeprofile));

      yield put(SetActiveTabs(8));
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(setPreviousDataEditError(error));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///----Family   Details------------Details-------------
function* FamilyDetailsCall(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: FamilyAPi,
        params: {
          user: payload.payload.UserId,
        },
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetFamilyEmpDataResponeActions(response.data.data));
      yield put(getLoaderAction(false));
      // toast.success(` ${response.data.status.message} `, {
      // position: toast.POSITION.TOP_RIGHT,
      // });
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(setFamilyDataError(error));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///----Family   Details-----------creaet-------------
function* FamilyDetailsCreateCall(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: FamilyAPi,
        data: payload.payload.data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetFamilyEmpDatacreateResponeActions(response.data.data));
      yield put(getLoaderAction(false));
      yield put(SetActiveTabs(8));
      console.log(response.data.data[0].user_id, "user_id");
      yield put(setfamliydetailsid(response.data.data[0].user_id));
      const test = {
        Retieveid: response.data.data[0].id,
        UserId: response.data.data[0].user_id,
      };
      yield put(setFamilyEmpDataActions(test));
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(setFamilyDatacreateError(error));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///----Family   Details-----------creaet-------------
function* FamilyDetailsEditCall(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: FamilyAPi + payload.payload.Retieveid + "/",
        data: payload.payload.data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetFamilyEmpDataEditResponeActions(response.data.data));
      yield put(getLoaderAction(false));
      yield put(SetActiveTabs(8));
      const Datas = {
        Retieveid: payload.payload.Retieveid,
        UserId: payload.payload.UserId,
      };
      yield put(setFamilyEmpDataActions(Datas));
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(setFamilyDataEditError(error));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///----Decalaration   Details------------Details-------------
function* DecalarationDetails(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: decalarationApi + payload.payload.Retieveid + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setDecalarationActionData(response.data.data));
      yield put(getLoaderAction(false));
      // toast.success(` ${response.data.status.message} `, {
      // position: toast.POSITION.TOP_RIGHT,
      // });
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(setDecalarationDataError(error));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///----Decalaration   Create------------Details-------------
function* DecalarationCraeteDetails(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: decalarationApi,
        data: payload.payload.data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setDecalarationActioncreateData(response.data.data));
      yield put(getLoaderAction(false));
      yield put(SetDeclarationId(response.data.data.id));
      const payloadsempyeeprofile = {
        search: "",
        page_size: 10,
        page: 1,
        ids:
          store.getState().BasicFormCreated.user_ID == ""
            ? store.getState().EmployeeProfile.EmployeeProfileList.id
            : store.getState().BasicFormCreated.user_ID,
      };

      yield put(setEmployeeProfileDATASActions(payloadsempyeeprofile));
      // toast.success(` ${response.data.status.message} `, {
      // position: toast.POSITION.TOP_RIGHT,
      // });
      yield put(SetActiveTabs(9));
      // const test = {
      //   Retieveid: response.data.data.id,
      // };
      // yield put(SetDeclarationAction(test));
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(setDecalarationDatacreateError(error));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///----Decalaration   Edit------------Details-------------
function* DecalarationEditDetails(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: decalarationApi + payload.payload.Retieveid + "/",
        data: payload.payload.data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setDecalarationEditActionData(response.data.data));
      yield put(getLoaderAction(false));
      // toast.success(` ${response.data.status.message} `, {
      // position: toast.POSITION.TOP_RIGHT,
      // });

      const payloadsempyeeprofile = {
        search: "",
        page_size: 10,
        page: 1,
        ids:
          store.getState().BasicFormCreated.user_ID == ""
            ? store.getState().EmployeeProfile.EmployeeProfileList.id
            : store.getState().BasicFormCreated.user_ID,
      };

      yield put(setEmployeeProfileDATASActions(payloadsempyeeprofile));
      yield put(SetActiveTabs(9));
      // const RetrieveCAll = {
      //   Retieveid: payload.payload.Retieveid,
      // };

      // yield put(SetDeclarationAction(RetrieveCAll));
    } catch (error) {
      //  console.log(error ,"rerter");
      yield put(getLoaderAction(false));
      yield put(setDecalarationEditDataError(error));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///----ESi   Details------------Details-------------
function* ESICall(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: ESiApi + payload.payload.Retieveid + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setESIRESPONSESData(response.data.data));
      yield put(getLoaderAction(false));
      // toast.success(` ${response.data.status.message} `, {
      // position: toast.POSITION.TOP_RIGHT,
      // });
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(setESIDataError(error));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///----ESi   Details--Edit----------Details-------------
function* ESIEditCallSaga(payload) {
  if (
    payload != undefined &&
    payload.payload.Retieveid != "" &&
    payload.payload.Retieveid != undefined
  ) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: ESiApi + payload.payload.Retieveid + "/",
        data: payload.payload.data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setESIRESPONSESEditData(response.data.data));
      yield put(getLoaderAction(false));
      // toast.success(` ${response.data.status.message} `, {
      // position: toast.POSITION.TOP_RIGHT,
      // });
      // const data = {
      //   Retieveid: payload.payload.Retieveid,
      // };

      // yield put(SetESICALLAction(data));

      // if (payload.payload.Pushtoprofile == 1) {
      //   window.location.href = "/employeeprofile";
      // }

      if (typeof payload.payload.Funcations === "function") {
        payload.payload.Funcations();
      }
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(setESIDataEditError(error));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///----ESi   Details--Create----------Details-------------
function* ESICreateCallSaga(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: ESiApi,
        data: payload.payload.data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setESIRESPONSESCreateData(response.data.data));
      yield put(getLoaderAction(false));
      // toast.success(` ${response.data.status.message} `, {
      // position: toast.POSITION.TOP_RIGHT,
      // });
      // const test = {
      //   Retieveid: response.data.data.id,
      // };
      // yield put(SetESICALLAction(test));
      yield put(getLoaderAction(false));
      const payloadsempyeeprofile = {
        search: "",
        page_size: 10,
        page: 1,
        ids:
          store.getState().BasicFormCreated.user_ID == ""
            ? store.getState().EmployeeProfile.EmployeeProfileList.id
            : store.getState().BasicFormCreated.user_ID,
      };

      yield put(setEmployeeProfileDATASActions(payloadsempyeeprofile));
      // yield put(SetEsiFormIdActions(response.data.data.id));
      // window.location.href = "/managerlist";
      // window.location.href="/employeeprofile";
      if (typeof payload.payload.Funcations === "function") {
        payload.payload.Funcations();
      }
    } catch (error) {
      yield put(getLoaderAction(false));
      if (error.response.status != 500) {
        yield put(setESIDataCraeteError(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });

        if (error.response.data.status.code == 401) {
          console.log("401 erweu", error.response.data.status.code);

          localStorage.clear();
          window.location.href = "/";
        }
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

///----Job---Offer ------------Details-------------
function* JobofferCall(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: JobofferApi + payload.payload.Retieveid + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetJobofferresponse(response.data.data));
      yield put(getLoaderAction(false));
      // toast.success(` ${response.data.status.message} `, {
      // position: toast.POSITION.TOP_RIGHT,
      // });
    } catch (error) {
      yield put(getLoaderAction(false));
      if (error.response.status != 500) {
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
        yield put(SetJobofferError(error));

        if (error.response.data.status.code == 401) {
          console.log("401 erweu", error.response.data.status.code);

          localStorage.clear();
          window.location.href = "/";
        }
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

///----Job---Offer ------------create-------------
function* JoboffercreateCall(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: JobofferApi,
        data: payload.payload.Jobinfocreate,
        // data: {
        //   site_id: payload.payload.data.job_title,
        //   // department: payload.payload.data.department,
        //   department:"wbs",
        //   designation_id: payload.payload.designation_id,
        //   gross_salary: payload.payload.data.gross_salary,
        //   timeline_id: payload.payload.timeline_id,
        //   client_id:payload.payload.data.client_id

        // },
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetJobofferresponseCreate(response.data.data));
      yield put(getLoaderAction(false));
      toast.success(` ${response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      const payloadsempyeeprofile = {
        search: "",
        page_size: 10,
        page: 1,
        ids:
          store.getState().BasicFormCreated.user_ID == ""
            ? store.getState().EmployeeProfile.EmployeeProfileList.id
            : store.getState().BasicFormCreated.user_ID,
      };

      yield put(setEmployeeProfileDATASActions(payloadsempyeeprofile));
      yield put(SetActiveTabs(3));
      yield put(SetJobOfferID(response.data.data.id));

      // const JobInfoCall = {
      //   Retieveid: response.data.data.id,
      // };
      // yield put(SetJObofferCall(JobInfoCall));
    } catch (error) {
      yield put(getLoaderAction(false));
      if (error.response.status != 500) {
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
        yield put(SetJobofferErrorcreate(error));

        if (error.response.data.status.code == 401) {
          console.log("401 erweu", error.response.data.status.code);

          localStorage.clear();
          window.location.href = "/";
        }
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}
///----Job---Offer ------------pREVIEW-------------
function* JobofferPreviewCall(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: jobOfferPreview,
        data: payload.payload?.payload,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetJobofferPreviewresponseCreate(response.data.data));
      yield put(getLoaderAction(false));
      payload?.payload?.setSalaryPreviewPopup(true);
      toast.success(` ${response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      // yield put(SetJObofferCall(JobInfoCall));
    } catch (error) {
      yield put(getLoaderAction(false));
      if (error.response.status != 500) {
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
        yield put(SetJobofferPreviewErrorcreate(error));

        if (error.response.data.status.code == 401) {
          console.log("401 erweu", error.response.data.status.code);

          localStorage.clear();
          window.location.href = "/";
        }
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}
///----REMAINDER eMAIL FOR APPROVAL STAUS -------------------------
function* RemainderMailCall(payload) {
  console.log(payload, "payload");
  if (payload?.payload?.payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: sendRemainderApi,
        data: payload.payload?.payload,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetRemainderMailresponseCreate(response.data.data));
      yield put(getLoaderAction(false));

      toast.success(` ${response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      // yield put(SetJObofferCall(JobInfoCall));
    } catch (error) {
      yield put(getLoaderAction(false));
      if (error.response.status != 500) {
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
        yield put(SetRemainderMailErrorcreate(error));

        if (error.response.data.status.code == 401) {
          console.log("401 erweu", error.response.data.status.code);

          localStorage.clear();
          window.location.href = "/";
        }
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

///----Job---Offer ------------edit-------------
function* JobofferEDITCall(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: JobofferApi + payload.payload.Retieveid + "/",
        // data: {
        //   site_id: payload.payload.data.job_title,
        //   // department: payload.payload.data.department,
        //   department:"wbs",
        //   designation_id: payload.payload.designation_id,
        //   gross_salary: payload.payload.data.gross_salary,
        //   timeline_id: payload.payload.timeline_id,
        //   client_id:payload.payload.data.client_id
        // },
        data: payload.payload.Jobinfocreate,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetJobofferresponseEDIT(response.data.data));
      yield put(getLoaderAction(false));
      toast.success(` ${response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      const payloadsempyeeprofile = {
        search: "",
        page_size: 10,
        page: 1,
        ids:
          store.getState().BasicFormCreated.user_ID == ""
            ? store.getState().EmployeeProfile.EmployeeProfileList.id
            : store.getState().BasicFormCreated.user_ID,
      };

      yield put(setEmployeeProfileDATASActions(payloadsempyeeprofile));

      yield put(SetActiveTabs(3));
      // const JobInfoCall = {
      //   Retieveid: payload.payload.Retieveid,
      // };
      // yield put(SetJObofferCall(JobInfoCall));
    } catch (error) {
      yield put(getLoaderAction(false));
      if (error.response.status != 500) {
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
        yield put(SetJobofferErrorEDIt(error));

        if (error.response.data.status.code == 401) {
          console.log("401 erweu", error.response.data.status.code);

          localStorage.clear();
          window.location.href = "/";
        }
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}
///----hr Approval---Offer ------------edit-------------
function* HrApprovalEDITCall(payload) {
  console.log(payload?.payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: hrApprovalEditApi + payload?.payload.Retieveid + "/",
        // data: {
        //   site_id: payload.payload.data.job_title,
        //   // department: payload.payload.data.department,
        //   department:"wbs",
        //   designation_id: payload.payload.designation_id,
        //   gross_salary: payload.payload.data.gross_salary,
        //   timeline_id: payload.payload.timeline_id,
        //   client_id:payload.payload.data.client_id
        // },
        data: payload?.payload?.body,
        params: payload?.payload?.params,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetHrApprovalresponseEDIT(response.data.data));
      yield put(getLoaderAction(false));
      toast.success(` ${response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      window.location.href = "/hrapprovallist";
      // const payloadsempyeeprofile = {
      //   search: "",
      //   page_size: 10,
      //   page: 1,
      //   ids:
      //     store.getState().BasicFormCreated.user_ID == ""
      //       ? store.getState().EmployeeProfile.EmployeeProfileList.id
      //       : store.getState().BasicFormCreated.user_ID,
      // };

      // yield put(setEmployeeProfileDATASActions(payloadsempyeeprofile));

      yield put(SetActiveTabs(3));
      // const JobInfoCall = {
      //   Retieveid: payload.payload.Retieveid,
      // };
      // yield put(SetJObofferCall(JobInfoCall));
    } catch (error) {
      yield put(getLoaderAction(false));
      if (error.response.status != 500) {
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
        yield put(setHrApprovalErrorEdit(error));

        if (error.response.data.status.code == 401) {
          console.log("401 erweu", error.response.data.status.code);

          localStorage.clear();
          window.location.href = "/";
        }
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

///-------____Forms-----------------Approvals------------------
function* FormApproval(payload) {
  try {
    yield put(getLoaderAction(true));

    if (payload.payload.Decline == 0) {
      const response = yield axios({
        method: "post",
        url: FormApprovalApi + payload.payload.UserId + "/",

        data: {
          is_pending: payload.payload.is_pending,
          is_decline: payload.payload.is_decline,
          create_employee: payload.payload.create_employee,
          payroll_approved: payload.payload.payroll_approved,
          send_whatsapp: payload.payload.send_whatsapp,
        },
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetApprovalResponseActions(response.data.data));
      toast.success(` ${response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      ////----offer --->letter----changes
      if (
        payload.payload.SubRoleList == 1 ||
        payload.payload.SubRoleList == 3
      ) {
        const datas = {
          Ids: payload.payload.UserId,
          date: payload.payload.date,
          send_whatsapp: payload.payload.send_whatsapp,
        };
        yield put(SetTheJoiningDateCall(datas));
      }

      Swal.close();

      yield put(getLoaderAction(false));
    } else if (payload.payload.Decline == 1) {
      const response = yield axios({
        method: "post",
        url: FormApprovalApi + payload.payload.UserId + "/",

        data: {
          is_decline: payload.payload.is_decline,
          is_pending: payload.payload.is_pending,
          //create_employee:payload.payload.create_employee ,
          payroll_approved: payload.payload.payroll_approved,
          reason_for_decline: payload.payload.reason_for_decline,
        },
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      //  console.log(response , "response");
      yield put(SetApprovalResponseActions(response.data.data));
      toast.success(` ${response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(getLoaderAction(false));
    }
  } catch (error) {
    yield put(getLoaderAction(false));

    if (error.response.status != 500) {
      yield put(SetApprovalErrorStatus(error));

      //  console.log(error , "errorweyrop" , error.response.data.status.message);
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      // if (error.response.data.status.code == 401) {
      //   console.log("401 erweu", error.response.data.status.code);

      //   localStorage.clear();
      //   window.location.href = "/";
      // }
    } else {
      toast.error(` ${" something went wrong"} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}
////------Verified-------------__Users----------------
function* VerifiedUsersCall(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: CompletetdUsers + payload.payload.client_id + "/",
      params: {
        search: payload.payload.search,
        page_size: payload.payload.page_size,
        page: payload.payload.page,
        old_employee: payload.payload.old_employee,
        // type: payload.payload.type,
      },

      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    // yield put(SetVerifiedUsersResponse(response.data.data.inquiry_data));
    if (response.data.data.inquiry_data != undefined) {
      yield put(SetVerifiedUsersResponse(response.data.data.inquiry_data));
    } else {
      yield put(SetVerifiedUsersResponse([]));
    }

    yield put(SetTotal_counts_for_VerifiedEmployees(response.data.total_count));
    yield put(getLoaderAction(false));
    // toast.success(` ${response.data.status.message} `, {
    // position: toast.POSITION.TOP_RIGHT,
    // });
  } catch (error) {
    yield put(getLoaderAction(false));
    if (error.response.status != 500) {
      yield put(SetVerifiedUserError(error));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(SetTotal_counts_for_VerifiedEmployees(0));

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    } else {
      toast.error(` ${" something went wrong"} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}

/////--------------Joining---Date-------------------
function* JoiningDateCall(payload) {
  const Forms = payload.payload.date;

  try {
    yield put(getLoaderAction2(true));
    const response = yield axios({
      method: "post",
      url: JoiningDateAPI + payload.payload.Ids + "/",
      params: {
        send_whatsapp: payload.payload.send_whatsapp,
      },
      data: {
        joining_date: payload.payload.date,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(getLoaderAction2(false));
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    yield put(getLoaderAction2(false));
    yield put(SetTheJoiningDateResponseCall(response.data.data));
    yield put(getLoaderAction2(false));

    // if (
    //   response.data.data.letter_id != null &&
    //   response.data.data.letter_id != undefined
    // ) {
    //   window.open(response.data.data.letter_id.media_url);
    // }
    window.location.href = "/employeeprofile";
  } catch (error) {
    yield put(getLoaderAction2(false));

    if (error.response.status != 500) {
      yield put(SetThaeJoiningDateErrorMessage(error));

      if (error.response.data.status.code == 502) {
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    } else {
      toast.error(` ${" something went wrong"} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}
//------------------Excel---sheet----uploads-------------
function* ExcelSheetUploads(payload) {
  console.log(payload, "payload");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: excelSheetuploads,
      // client_id: payload.payload.branchId,
      data:
        // file: payload.payload.data,
        payload.payload.data,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    yield put(getLoaderAction(false));
    yield put(setTheExcelSheetresponseStatus(response.data.data));
    // yield put (  SetTheExcelSheetRender(2) )
    const content = {
      search: "",
      page_size: 20,
      page: payload.payload.pages,
      client_id: payload.payload.branchId,
      user: "",
    };
    yield put(getShiftStatusPersonsListed(content));
  } catch (error) {
    yield put(getLoaderAction(false));
    if (error.response.status != 500) {
      yield put(SetTheExcelSheetErrors(error));
      // yield put (  SetTheExcelSheetRender(1) )
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    } else {
      toast.error(` ${" something went wrong"} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}

///-------___Signature---------lists-------------
function* SignatureCalls() {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: JoiningDateAPI,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(SetSignatureResponses(response.data.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));

    if (error.response.status != 500) {
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(SetSignatureErrorMessage(error));

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    } else {
      toast.error(` ${" something went wrong"} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}

///-----Leave-  Types----LIsts--------------------------
function* getLeaveTypeLists(payloads) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: LeaveTypeListAPi,
      params: {
        search: payloads.payload.search,
        page_size: payloads.payload.page_size,
        page: payloads.payload.page,
        mode: payloads.payload.mode,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(setLeaveTypeResponses(response.data.data));
    yield put(getLoaderAction(false));
    yield put(setLeaveTypeResponseTotalCounts(response.data.total_count));
  } catch (error) {
    yield put(getLoaderAction(false));
    if (error.response.status != 500) {
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(SetLeaveTypeListError(error));
      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    } else {
      toast.error(` ${" something went wrong"} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}

///----------------Leave------------Type------Creates--------
function* LeaveTypeCreate(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: LeaveTypeCreateAPi,
      data: {
        leave_type: payload.payload.Data.LeaveType,
        description: payload.payload.Data.Description,
        unique_value: payload.payload.unique_value,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(SetLeaveTypeCreate(response.data.data));
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    yield put(getLoaderAction(false));
    const Content = {
      search: payload.payload.search,
      page_size: 20,
      page: payload.payload.currentPage,
    };
    yield put(SetLeaveTypeActions(Content));
  } catch (error) {
    yield put(getLoaderAction(false));
    if (error.response.status != 500) {
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
      yield put(SetLeaveTypeError(error));
    } else {
      toast.error(` ${" something went wrong"} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}

///------Leave---Tye-----deletes---------------
function* LeaveTypeDeleteSaga(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "delete",
      url: LeaveTypeDeleteAPi + payload.payload.DeleteId,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(setLeaveTypeResponsesDelete(response.data.data));
    yield put(getLoaderAction(true));
    const Content = {
      search: "",
      page_size: 20,
      page: payload.payload.currentPage,
    };
    yield put(SetLeaveTypeActions(Content));
  } catch (error) {
    yield put(getLoaderAction(false));
    if (error.response.status != 500) {
      yield put(SetLeaveTypeDeleteError(error));
      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    } else {
      toast.error(` ${" something went wrong"} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}

///-----Leave---type------retrive-------
function* getLeaveTypeRetrieve(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: LeaveTypeRetrievAPi + payload.payload.EditID + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setLeaveTypeResponsesRetrieve(response.data.data));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      if (error.response.status != 500) {
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
        yield put(SetLeaveTypeRetrieveError(error));
        if (error.response.data.status.code == 401) {
          console.log("401 erweu", error.response.data.status.code);

          localStorage.clear();
          window.location.href = "/";
        }
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

//-----Leave Type----Edits-----
function* setLeaveTypeEdits(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "put",
      url: LeavetypeEditApi + payload.payload.EditID + "/",
      data: {
        leave_type: payload.payload.Data.LeaveType,
        description: payload.payload.Data.Description,
        unique_value: payload.payload.unique_value,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    const Content = {
      search: payload.payload.search,
      page_size: 20,
      page: payload.payload.currentPage,
    };
    yield put(SetLeaveTypeActions(Content));
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(setLeaveTypeResponsesEdit(response.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));

    if (error.response.status != 500) {
      yield put(SetLeaveTypeEditError(error));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    } else {
      toast.error(` ${" something went wrong"} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}

///-------Leave----Request--------Get_---List
function* getLeavePermissionListCall(payloads) {
  console.log(payloads, "payloads");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: LeavePermissionlistAPi,
        // params: {
        //   search: payloads.payload.search,
        //   page_size: payloads.payload.page_size,
        //   page: payloads.payload.page,
        //   status: payloads.payload.selectVal.status,
        //   white_collar: payloads.payload.white_collar,
        //   // month: payloads.payload.month,
        //   // year: payloads.payload.year,

        //   from_date: payloads.payload.from_date,
        //   to_date: payloads.payload.to_date,

        //   range: true,
        // },
        params: payloads.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(SetTheLeavePermissionlistResponse(response.data.data));
      yield put(getLoaderAction(false));
      yield put(
        SetTheLeavePermissionListTotal_counts(response.data.total_count),
      );
    } catch (error) {
      yield put(getLoaderAction(false));
      if (error.response.status != 500) {
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
        yield put(SetTheLeavePermissionListError(error));

        if (error.response.data.status.code == 401) {
          console.log("401 erweu", error.response.data.status.code);

          localStorage.clear();
          window.location.href = "/";
        }
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

///-------Leave----Request----Search---Lists
function* getLeavePermissionListSearchCall(payloads) {
  if (payloads.payload.client != undefined && payloads.payload.client != []) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: LeavePermissionlistAPi,
        params: {
          search: payloads.payload.search,
          page_size: payloads.payload.page_size,
          page: payloads.payload.page,
          client: JSON.stringify(payloads.payload.client),
          status: payloads.payload.selectVal.status,
          white_collar: payloads.payload.white_collar,
        },
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(SetTheLeavePermissionlistSearchResponse(response.data.data));
      yield put(getLoaderAction(false));
      yield put(
        SetTheLeavePermissionListSearchTotal_counts(response.data.total_count),
      );
    } catch (error) {
      yield put(getLoaderAction(false));
      if (error.response.status != 500) {
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
        yield put(SetTheLeavePermissionListSearchError(error));

        if (error.response.data.status.code == 401) {
          console.log("401 erweu", error.response.data.status.code);

          localStorage.clear();
          window.location.href = "/";
        }
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

/////-------------------------------
///------Leave-Permission----deletes---------------
function* LeavePermissionDelete(payload) {
  console.log(payload.payload.GetlistOptoins, "GetlistOptoins");

  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "delete",
      url: LeavePermissionDeleteAPi + payload.payload.DeleteID,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(SetTheLeavePermissionDeleteResponse(response.data.data));
    yield put(getLoaderAction(true));
    // const Content = {

    //   // search: "",
    //   // page_size: 10,
    //   // page: payload.payload.currentPage,
    //   // selectVal: {
    //   //   status: "",
    //   // },
    //   // white_collar: payload.payload.white_collar,
    // };
    yield put(SetTheLeavePermissionListActions(payload.payload.GetlistOptoins));
  } catch (error) {
    yield put(getLoaderAction(false));
    if (error.response.status != 500) {
      yield put(SetTheLeavePermissionDeleteError(error));

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    } else {
      toast.error(` ${" something went wrong"} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}

///-----Leave---Premissions------retrive-------
function* getLeavePermissionRetrieve(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: LeavePermissionRetrieevApi + payload.payload.EditId + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SettheLeaveRetrievePremissionActions(response.data.data));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(SetTheLeavePermissionErrorRetrieve(error));

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

//-----Leave Premission----Edits-----
function* setLeavePermissionEdits(payload) {
  console.log(payload, "selectVal");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "put",
      url: LeavePermissionEdits + payload.payload.EditId + "/",
      data: {
        status: payload.payload.status,
        reason_for_decline: payload.payload.description,
      },

      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(SetTheLeavePermissionListActions(payload.payload.GetlistOptoins));
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(SettheLeaveEditsPremissionActions(response.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));

    yield put(SetTheLeavePermissionErrorEdits(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}

///-----Leave Status-----LIsts--------------------------
function* getLeaveStatusListClientView(payloads) {
  console.log(payloads, "payloadsasdasdn");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: LeaveStatusApi,
      params: {
        search: payloads.payload.search,
        page_size: payloads.payload.page_size,
        page: payloads.payload.page,
        client: payloads.payload.client_id,
        user: payloads.payload.user,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(setLeaveStatusLisPersonsResponseActions(response.data.data));
    yield put(getLoaderAction(false));
    yield put(SetTheInquriyLeaveStatus(response.data.data.Inquriy));
    yield put(
      SetLeaveStatusLisDataTotal_countPersonsActions(response.data.total_count),
    );
  } catch (error) {
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    yield put(setLeaveStatusLisDataPersonsErrorMessages(error));

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}

///------Shfit-Excel upload---LIsts--------------------------
function* getexcelSheetUploadList(payloads) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: ExcelSheetgetApi,
      params: {
        search: payloads.payload.search,
        page_size: payloads.payload.page_size,
        page: payloads.payload.page,
        client: payloads.payload.client_id,
        user: payloads.payload.user,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(setShiftStatusLisPersonsResponseActions(response.data.data));

    yield put(getLoaderAction(false));
    yield put(SetShiftDataTotal_countPersonsActions(response.data.total_count));
  } catch (error) {
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    yield put(setShiftsDataPersonsErrorMessages(error));

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}

///-------Shift Permission------------Get_---List
function* getShiftPermissionList(payloads) {
  console.log(payloads, "payloads");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: ShiftPermission,
      params: {
        search: payloads.payload.search,
        page_size: payloads.payload.page_size,
        page: payloads.payload.page,
        status: payloads.payload.selectVal.status,
        zone: payloads.payload.data.zone,
        state: payloads.payload.data.state,
        region: payloads.payload.data.region,
        white_collar: payloads.payload.white_collar,
        // month: payloads.payload.month,
        // year: payloads.payload.year,

        from_date: payloads.payload.from_date,
        to_date: payloads.payload.to_date,
        range: true,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(setTheshiftPermissionRespons(response.data.data));
    yield put(getLoaderAction(false));
    yield put(setTheShiftPermissionTotal_counts(response.data.total_count));
  } catch (error) {
    yield put(setShiftPermissionError(error));
    yield put(getLoaderAction(false));

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}

///-----shift---Premissions------retrive-------
function* getShiftPermissionRetrieve(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: ShiftRetrievePermission + payload.payload.EditId + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SettheShiftRetrievePremissionActions(response.data.data));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
      yield put(SetTheShiftermissionErrorRetrieve(error));
    }
  }
}

//-----Shift ----Edits-----
function* setShiftPermissionEdits(payload) {
  console.log(payload, "payload");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "put",
      url: ShiftEditPermission + payload.payload.EditId + "/",
      data: {
        status: payload.payload.status,
        reason_for_decline: payload.payload.description,
      },

      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    const Content = {
      search: payload.payload.search,
      page_size: 20,
      page: payload.payload.currentPage,

      selectVal: {
        status: payload.payload.selectVal.status,
      },
      data: {
        zone: payload.payload.data.zone,
        state: payload.payload.data.state,
        region: payload.payload.data.region,
      },
      white_collar: payload.payload.white_collar,
      // month: payload.payload.month,
      // year: payload.payload.year,
      from_date: payload.payload.from_date,
      to_date: payload.payload.to_date,

      range: true,
    };
    yield put(setShiftPermissionActions(Content));
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(SettheShiftditsPremissionActions(response.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));
    yield put(SetTheShiftPermissionErrorEdits(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}

///------Shift-Permission----deletes---------------
function* SiftPermissionDelete(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "delete",
      url: ShiftDeleteAPiPermission + payload.payload.DeleteID,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(SetTheshiftPermissionDeleteResponse(response.data.data));
    yield put(getLoaderAction(true));
    const Content = {
      search: "",
      page_size: 20,
      page: payload.payload.currentPage,
      selectVal: {
        status: payload.payload.selectVal.status,
      },
      data: {
        zone: payload.payload.data.zone,
        state: payload.payload.data.state,
        region: payload.payload.data.region,
      },
      white_collar: payload.payload.white_collar,
      // month: payload.payload.month,
      // year: payload.payload.year,
      from_date: payload.payload.from_date,
      to_date: payload.payload.to_date,

      range: true,
    };

    yield put(setShiftPermissionActions(Content));
  } catch (error) {
    yield put(getLoaderAction(false));
    yield put(SetTheShiftPermissionDeleteError(error));

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

///-----Appraisal----LIsts--------------------------
function* getAppraisalList(payloads) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: AppraisalApi,
      params: {
        search: payloads.payload.search,
        page_size: payloads.payload.page_size,
        page: payloads.payload.page,
        status: payloads.payload.selectVal.status,
        white_collar: payloads.payload.white_collar,
        // month: payloads.payload.month,
        // year: payloads.payload.year,
        // date: payloads.payload.date,

        from_date: payloads.payload.from_date,
        to_date: payloads.payload.to_date,

        range: true,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(setAppraisaltResponse(response.data.data));
    yield put(getLoaderAction(false));

    yield put(setAppraisalTotal_counts(response.data.total_count));
  } catch (error) {
    console.log(error, "error");
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    yield put(setAppraisalError(error));

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

///-----ReInvestment----LIsts--------------------------
function* getreinvesmentLists(payloads) {
  try {
    yield put(getLoaderAction2(true));
    const response = yield axios({
      method: "get",
      url: ReInvestmentGetApi,
      params: {
        search: payloads.payload.search,
        page_size: payloads.payload.page_size,
        page: payloads.payload.page,
        status: payloads.payload.selectVal.status,
        zone: payloads.payload.data.zone,
        state: payloads.payload.data.state,
        region: payloads.payload.data.region,
        white_collar: payloads.payload.white_collar,
        // month: payloads.payload.month,
        // year: payloads.payload.year,
        // date: payloads.payload.date,
        from_date: payloads.payload.from_date,
        to_date: payloads.payload.to_date,
        range: true,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(setReinvestmentResponse(response.data.data));
    yield put(getLoaderAction2(false));

    yield put(setReinvestmentTotal_counts(response.data.total_count));
  } catch (error) {
    console.log(error, "error");
    yield put(getLoaderAction2(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }

    yield put(setReInvestmentError(error));
  }
}
///---ReInvestment----Retrieve----
function* ReInvestMentRetrieve(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: ReInvestmentretrievetApi + payload.payload.EditId + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SettheReinvestmentRetrieveActions(response.data.data));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(SetReinvestmentErrorRetrieve(error));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

//----- Re---Investment----Edits-----
function* ReInvestmentEdits(payload) {
  console.log(payload, "payload");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "put",
      url: ReInvestmentEditApi + payload.payload.EditId + "/",
      data: {
        status: payload.payload.status,
        reason_for_decline: payload.payload.description,
      },

      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    const Content = {
      search: payload.payload.search,
      page_size: 20,
      page: payload.payload.currentPage,
      selectVal: {
        status: payload.payload.selectVal.status,
      },
      data: {
        zone: payload.payload.data.zone,
        state: payload.payload.data.state,
        region: payload.payload.data.region,
      },
      white_collar: payload.payload.white_collar,
      // month: payload.payload.month,
      // year: payload.payload.year,
      // date: payload.payload.date,

      from_date: payload.payload.from_date,
      to_date: payload.payload.to_date,
      range: true,
    };
    yield put(setReinvestmentAction(Content));
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(SettheReInvestmentResponsesActions(response.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));

    yield put(SetTheReInvestmentErrorEdits(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}
//////----SHift---Excel---Sheet----
function* getExcelShiftSheetRetrieve(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: ExcelSheetgetApi,
        params: {
          user: payload.payload.user,
        },
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTheShiftexcelRetrieveResponse(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(setTheShiftExcelSheetError(error));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

/////----On---Duty-----Get----Lists=====

function* getOnDutySagaActions(payloads) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: OndutyGetlistAPI,
      params: {
        search: payloads.payload.search,
        page_size: payloads.payload.page_size,
        page: payloads.payload.page,
        status: payloads.payload.selectVal.status,
        zone: payloads.payload.data.zone,
        state: payloads.payload.data.state,
        region: payloads.payload.data.region,
        white_collar: payloads.payload.white_collar,
        // month: payloads.payload.month,
        // year: payloads.payload.year,
        from_date: payloads.payload.from_date,
        to_date: payloads.payload.to_date,
        range: true,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(SeTheOndutyRespones(response.data.data));
    yield put(getLoaderAction(false));
    yield put(SetheOndutytatolCounts(response.data.total_count));
  } catch (error) {
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }

    yield put(SetTheIndutyError(error));
  }
}

///-----On--Duty------retrive-------
function* GetOnDutyRetrieve(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: OndutyGetlistAPI + payload.payload.EditId + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SettheOndutyResponeActions(response.data.data));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(SetTheOndutyErrorRetrieve(error));
      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

//-----OnDuty----Edits-----
function* setONDUtyEdits(payload) {
  console.log(payload, "payload");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "put",
      url: OndutyGetlistAPI + payload.payload.EditId + "/",
      data: {
        status: payload.payload.status,
        reason_for_decline: payload.payload.description,
      },

      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    const Content = {
      search: payload.payload.search,
      page_size: 20,
      page: payload.payload.currentPage,
      selectVal: {
        status: payload.payload.selectVal.status,
      },
      data: {
        zone: payload.payload.data.zone,
        state: payload.payload.data.state,
        region: payload.payload.data.region,
      },
      // white_collar: payload.payload.white_collar,
      white_collar: payload.payload.white_collar,
      // month: payload.payload.month,
      // year: payload.payload.year,
      from_date: payload.payload.from_date,
      to_date: payload.payload.to_date,
      range: true,
    };

    yield put(SetTheOndutyActions(Content));
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(SettheOndutyEditReponse(response.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));
    yield put(SetTheOndutyErrorEdits(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}
///-------------------On---Duty---Delete-----
function* OnDutyDelete(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "delete",
      url: OndutyGetlistAPI + payload.payload.DeleteID,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(SetTheOndutyDeleteResponse(response.data.data));
    yield put(getLoaderAction(true));
    const Content = {
      search: "",
      page_size: 20,
      page: payload.payload.currentPage,
      selectVal: {
        status: payload.payload.selectVal.status,
      },
      data: {
        zone: payload.payload.data.zone,
        state: payload.payload.data.state,
        region: payload.payload.data.region,
      },
      // month: payload.payload.month,
      // year: payload.payload.year,

      from_date: payload.payload.from_date,
      to_date: payload.payload.to_date,

      range: true,
    };
    yield put(SetTheOndutyActions(Content));
  } catch (error) {
    yield put(getLoaderAction(false));
    yield put(SetTheOndutyDeleteError(error));

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

/////----Resign-----Get----Lists=====

function* SetTheResignCalls(payloads) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: ResginAPI,
      params: {
        search: payloads.payload.search,
        page_size: payloads.payload.page_size,
        page: payloads.payload.page,
        status: payloads.payload.selectVal.status,
        zone: payloads.payload.data.zone,
        state: payloads.payload.data.state,
        region: payloads.payload.data.region,
        white_collar: payloads.payload.white_collar,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(SeTheResignRespones(response.data.data));
    yield put(getLoaderAction(false));
    yield put(SetheResigntatolCounts(response.data.total_count));
  } catch (error) {
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }

    yield put(SetTheresignError(error));
  }
}

////---------Appraisal----

function* GetAppraisaletrieve(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: AppraisalApi + payload.payload.EditId + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SettheAppraisalRetrieveActions(response.data.data));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(SetAppraisalErrorRetrieve(error));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

//-----Appraisal----Edits-----
function* SetTheAppraisaledit(payload) {
  console.log(payload, "payload");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "put",
      url: AppraisalApi + payload.payload.EditId + "/",
      data: {
        status: payload.payload.status,
        reason_for_decline: payload.payload.description,
      },

      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    const Content = {
      search: payload.payload.search,
      page_size: 20,
      page: payload.payload.currentPage,
      selectVal: {
        status: "",
      },
      white_collar: payload.payload.white_collar,
      // month: payload.payload.month,
      // year: payload.payload.year,
      // date: payload.payload.date,
      from_date: payload.payload.from_date,
      to_date: payload.payload.to_date,
      range: true,
    };
    yield put(setAppraisalAction(Content));
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(SettheAppraisalResponsesActions(response.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));
    yield put(SetTheAppraisalErrorEdits(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

///-----Resign------retrive-------
function* GetResignRetrieve(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: ResginAPI + payload.payload.EditId + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SettheResignResponeActions(response.data.data));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(SetTheResignErrorRetrieve(error));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

//-----Resign----Edits-----
function* setResignEdits(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "put",
      url: ResginAPI + payload.payload.EditId + "/",
      data: {
        status: payload.payload.status,
        reason_for_decline: payload.payload.description,
      },

      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    const Content = {
      search: payload.payload.search_field,
      page_size: 20,
      page: payload.payload.currentPage,
      selectVal: {
        status: payload.payload.selectVal.status,
      },
      data: {
        zone: payload.payload.data.zone,
        state: payload.payload.data.state,
        region: payload.payload.data.region,
      },
      white_collar: payload.payload.white_collar,
    };
    yield put(SetTheResignActions(Content));
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(SettheResignEditReponse(response.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));

    yield put(SetTheResignErrorEdits(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

///----------Resign---Delete-----
function* ResignDelete(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "delete",
      url: ResginAPI + payload.payload.DeleteID,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(SetTheResginDeleteResponse(response.data.data));
    yield put(getLoaderAction(true));
    const Content = {
      search: "",
      page_size: 20,
      page: payload.payload.currentPage,
      selectVal: {
        status: payload.payload.selectVal.status,
      },
      data: {
        zone: payload.payload.data.zone,
        state: payload.payload.data.state,
        region: payload.payload.data.region,
      },
      white_collar: payload.payload.white_collar,
    };
    yield put(SetTheResignActions(Content));
  } catch (error) {
    yield put(getLoaderAction(false));
    yield put(SetTheResignDeleteError(error));

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

/////---Exit-----Get----Lists=====

function* getExitSagaActions(payloads) {
  try {
    yield put(getLoaderAction2(true));
    const response = yield axios({
      method: "get",
      url: ExitApi,
      params: {
        search: payloads.payload.search,
        page_size: payloads.payload.page_size,
        page: payloads.payload.page,
        status: payloads.payload.selectVal.status,
        zone: payloads.payload.data.zone,
        state: payloads.payload.data.state,
        region: payloads.payload.data.region,
        white_collar: payloads.payload.white_collar,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(SeTheExitRespones(response.data.data));
    yield put(getLoaderAction2(false));
    yield put(SetheExittatolCounts(response.data.total_count));
  } catch (error) {
    yield put(getLoaderAction2(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }

    yield put(SetTheExitError(error));
  }
}

///-----EXIT------retrive-------
function* GetExitApprovalRetrieve(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: ExitApi + payload.payload.EditId + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SettheExitResponeActions(response.data.data));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(SetTheExitErrorRetrieve(error));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

//-----EXIT----Edits-----
function* setExitApprovalEdits(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "put",
      url: ExitApi + payload.payload.EditId + "/",
      data: {
        status: payload.payload.status,
        reason_for_decline: payload.payload.description,
      },

      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    const Content = {
      search: payload.payload.search,
      page_size: 20,
      page: payload.payload.currentPage,
      selectVal: {
        status: payload.payload.selectVal.status,
      },
      data: {
        zone: payload.payload.data.zone,
        state: payload.payload.data.state,
        region: payload.payload.data.region,
      },
      white_collar: payload.payload.white_collar,
    };
    yield put(SetTheExitActions(Content));
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(SettheExitEditReponse(response.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));

    yield put(SetTheExitErrorEdits(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}
//-----Update----Edits-----
function* setExitNodueEdits(payload) {
  console.log(payload.payload, "askfhlkasdhkf");
  console.log(payload.payload.data, "askfhlkasdhkf");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: ExitApi + payload.payload.id + "/",
        data: payload.payload.data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetExitNoDueEditResponeActions(response.data.data));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(SetExitNoDueEditErrorRetrieve(error));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///----------Exit---Delete-----
function* ExitDelete(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "delete",
      url: ExitApi + payload.payload.DeleteID,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(SetTheExitDeleteResponse(response.data.data));
    yield put(getLoaderAction(true));
    const Content = {
      search: "",
      page_size: 20,
      page: payload.payload.currentPage,
      selectVal: {
        status: payload.payload.selectVal.status,
      },
      data: {
        zone: payload.payload.data.zone,
        state: payload.payload.data.state,
        region: payload.payload.data.region,
      },
    };
    yield put(SetTheExitActions(Content));
  } catch (error) {
    yield put(getLoaderAction(false));

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }

    yield put(SetTheExitDeleteError(error));
  }
}

///-----PaySlip-----LIsts--------------------------
function* setThePaySlip(payloads) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: paySlipApi,
      params: {
        search: payloads.payload.search,
        page_size: payloads.payload.page_size,
        page: payloads.payload.page,
        // status: payloads.payload.selectVal.status,
        white_collar: payloads.payload.white_collar,
        month: payloads.payload.month,
        year: payloads.payload.year,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(getPaySlipSuccessResponseActions(response.data.data));
    yield put(getLoaderAction(false));
    yield put(getPaySlipTotal_pageCounst(response.data.total_count));
  } catch (error) {
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    yield put(getPaySlipErroResponsen(error));

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

function* setThePayslipCreate(payload) {
  console.log(payload, "payload");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: paySlipApi,
      data: payload.payload.CreatedData,

      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(getPaySlipSuccessCreaetResponseActions(response.data));
    yield put(getLoaderAction(false));
    const Content = {
      search: payload.payload.search,
      page_size: 20,
      page: payload.payload.page,
      // selectVal: {
      //   status: "",
      // },
      white_collar: payload.payload?.values?.white_collar,
      month: payload.payload.values.month,
      year: payload.payload.values.year,
      status: {
        status: payload.payload.values.selectVa,
      },
    };
    yield put(setThePayslipAcrions(payload.payload.values));
  } catch (error) {
    yield put(getPaySlipErroCreateResponsen(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

///-----Pay---Slip=---
function* setThePayslipRetrieve(payload) {
  console.log(payload, "payload");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: paySlipApi + payload.payload.EditId + "/",

      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(getPaySlipSuccessRrtrieveResponseActions(response.data.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getPaySlipErroRetriveResponsen(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}

function* setThePayslipEdit(payload) {
  console.log(payload, "payload");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "put",
      url: paySlipApi + payload.payload.EditId + "/",
      data: payload.payload.formdat,

      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(getPaySlipSuccessEditResponseActions(response.data));
    yield put(getLoaderAction(false));
    const Content = {
      search: payload.payload.search,
      page_size: 20,
      page: payload.payload.currentPage,
      // selectVal: {
      //   status: "",
      // },
      white_collar: payload.payload.white_collar,
      month: payload.payload.month,
      year: payload.payload.year,
    };
    yield put(setThePayslipAcrions(payload.payload.values));
  } catch (error) {
    yield put(getPaySlipErroeditResponsen(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

function* PaySlipDeleteSaga(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "delete",
      url: paySlipApi + payload.payload.DeleteID,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(getPaySlipSuccessDeleteResponseActions(response.data.data));
    yield put(getLoaderAction(false));
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    const Content = {
      search: "",
      page_size: 20,
      page: payload.payload.currentPage,
      // selectVal: {
      //   status: "",
      // },
      white_collar: payload.payload.white_collar,
      month: payload.payload.month,
      year: payload.payload.year,
    };
    yield put(setThePayslipAcrions(payload.payload.values));
  } catch (error) {
    yield put(getLoaderAction(false));
    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }

    yield put(getPaySlipErrodeleteResponsen(error));
  }
}

///----Bank--------CRAEte----___Forms-------------
function* getBankCreateDetails(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: BankDetailAPI,
        data: payload.payload.formdata,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetBankDataResponecreateActions(response.data.data));
      yield put(getLoaderAction(false));
      // toast.success(` ${response.data.status.message} `, {
      // position: toast.POSITION.TOP_RIGHT,
      // });

      const payloadsempyeeprofile = {
        search: "",
        page_size: 10,
        page: 1,
        ids:
          store.getState().BasicFormCreated.user_ID == ""
            ? store.getState().EmployeeProfile.EmployeeProfileList.id
            : store.getState().BasicFormCreated.user_ID,
      };

      yield put(setEmployeeProfileDATASActions(payloadsempyeeprofile));

      // const datas = {
      //   Retieveid: response.data.data.id,
      // };
      // yield put(setBankDataActions(datas));

      yield put(SetActiveTabs(5));
      yield put(setTheBankNameVerification(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(setBankDatacreateError(error));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///----Bank--------EDIT----___Forms-------------
function* getBankEditDetails(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: BankDetailAPI + payload.payload.Retieveid + "/",
        data: payload.payload.formdata,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetBankDataResponeEditActions(response.data.data));
      yield put(getLoaderAction(false));
      // toast.success(` ${response.data.status.message} `, {
      // position: toast.POSITION.TOP_RIGHT,
      // });

      const payloadsempyeeprofile = {
        search: "",
        page_size: 10,
        page: 1,
        ids:
          store.getState().BasicFormCreated.user_ID == ""
            ? store.getState().EmployeeProfile.EmployeeProfileList.id
            : store.getState().BasicFormCreated.user_ID,
      };

      yield put(setEmployeeProfileDATASActions(payloadsempyeeprofile));
      // const datas = {
      //   Retieveid: payload.payload.Retieveid,
      // };
      // yield put(setBankDataActions(datas));
      yield put(SetActiveTabs(5));
      yield put(setTheBankNameVerification(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(setBankDataEditError(error));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///-------------Branches----List
function* getClientBranchFieldBranchList(payloads) {
  console.log(payloads, "payloads");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: branchlistfofieldagentapi,
      params: {
        search: payloads.payload.search,
        page_size: payloads.payload.page_size,
        page: payloads.payload.page,
        // zone: payloads.payload.data.zone,
        // state: payloads.payload.data.state,
        // region: payloads.payload.data.region,
      },

      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(setfieldbranchResponseActions(response.data.data));
    yield put(getLoaderAction(false));
    yield put(SetFieldagentTotalCount(response.data.total_count));
  } catch (error) {
    yield put(setfieldagentErrorMessages(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

//--Employee---Singel----Persons--MNgaer----

function* getEmployeaSingleManagerPersonsList(payloads) {
  console.log(payloads, "payloads");

  if (
    payloads.payload.client != ""
    // && payloads.payload.ids != ""
  ) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: employeeListforFieldAgentApi + payloads.payload.client + "/",
        params: {
          search: payloads.payload.search,
          page_size: payloads.payload.page_size,
          page: payloads.payload.page,
          is_pending: payloads.payload.selectVal.is_pending,
          is_decline: payloads.payload.selectVal.is_decline,
          approved: payloads.payload.selectVal.approved,
          role: payloads.payload.ids,
          client: payloads.payload.client,
        },

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      console.log(response, "response");
      // yield put(
      //   setEmployeeListSPersonsManagerResponseActions(response.data.data)
      // );
      // yield put(SetTheInquriyStatusmanager(response.data.data.inquiry_data));

      if (response.data.data.inquiry_data != undefined) {
        yield put(SetTheInquriyStatusmanager(response.data.data.inquiry_data));
      } else {
        yield put(SetTheInquriyStatusmanager([]));
      }

      yield put(
        SetEmployeeDataTotal_countPersonsManagerActions(
          response.data.total_count,
        ),
      );
      toast.success(` ${response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      yield put(getLoaderAction2(false));
    } catch (error) {
      yield put(getLoaderAction2(false));
      if (error.response.status != 500) {
        yield put(setEmployeeDataPersonsManagerErrorMessages(error));

        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });

        if (error.response.data.status.code == 401) {
          localStorage.clear();
          window.location.href = "/";
        }
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}
////-------------------------------------Previous---Call
function* PreviousDataCalls(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: PreviousDataApi + "/" + payload.payload.userId + "/",
        params: {
          type: payload.payload.type,
        },
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetThePreviousDataResponsesActions(response.data.data));
      yield put(getLoaderAction(false));
      // toast.success(` ${response.data.status.message} `, {
      // position: toast.POSITION.TOP_RIGHT,
      // });
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(setThePreviousErrAction(error));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

////------------------------Data---FETCH_---
function* DataFecthCallForm(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: DataFetchApiForForm + "/" + payload.payload.user_id + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTheDataFetchRESponse(response.data.data));
      yield put(getLoaderAction(false));
      // toast.success(` ${response.data.status.message} `, {
      // position: toast.POSITION.TOP_RIGHT,
      // });
    } catch (error) {
      yield put(getLoaderAction(false));

      if (error.response.status != 500) {
        yield put(setTheDataFETCHerror(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });

        if (error.response.data.status.code == 401) {
          localStorage.clear();
          window.location.href = "/";
        }
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

///---Grievance---Type---

function* GrievanceSagaCAlls(payloads) {
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: grievanceApi,
        params: {
          search: payloads.payload.search,
          page_size: payloads.payload.page_size,
          page: payloads.payload.page,
          // status:payloads.payload.selectVal.status
        },
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setGrievanceResponse(response.data.data));
      yield put(getLoaderAction(false));
      yield put(setgrievanceTotal_counts(response.data.total_count));
    } catch (error) {
      yield put(setgrievanceError(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///---Grievance---Type---Create

function* GrievanceCareteSagaCAlls(payloads) {
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: grievanceApi,
        data: payloads.payload.Data,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTheGrievanceCreateRESponse(response.data.data));
      yield put(getLoaderAction(false));

      const data = {
        search: payloads.payload.search,
        page_size: 20,
        page: payloads.payload.currentPage,
      };
      yield put(setGrievanceAction(data));
    } catch (error) {
      yield put(setTheGrievanceCreateerror(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///---Grievance---Type---retrive------

function* GrievanceRetriveSagaCAlls(payloads) {
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: grievanceApi + payloads.payload.EditID + "/",

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTheGrievanceRetrieveRESponse(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setTheGrievanceREtriveerror(error));
      yield put(getLoaderAction(false));
      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///---Grievance---Type---Edit

function* GrievanceEditSagaCAlls(payloads) {
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: grievanceApi + payloads.payload.EditID + "/",
        data: payloads.payload.Data,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTheGrievanceEditRESponse(response.data.data));
      yield put(getLoaderAction(false));

      const data = {
        search: payloads.payload.search,
        page_size: 20,
        page: payloads.payload.currentPage,
      };
      yield put(setGrievanceAction(data));
    } catch (error) {
      yield put(setTheGrievancediterror(error));
      yield put(getLoaderAction(false));
      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

////--Grievance---Employee----List-----
function* GrievanceEmployeeListSagaCAlls(payloads) {
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: GrievanceEmployeeListApi,
        params: {
          search: payloads.payload.search,
          page_size: payloads.payload.page_size,
          page: payloads.payload.page,
          status: payloads.payload.selectVal.status,
          zone: payloads.payload.data.zone,
          state: payloads.payload.data.state,
          region: payloads.payload.data.region,
          white_collar: payloads.payload.white_collar,
          // month: payloads.payload.month,
          // year: payloads.payload.year,

          from_date: payloads.payload.from_date,
          to_date: payloads.payload.to_date,
          range: true,
        },
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setGrievanceEMpListResponse(response.data.data));
      yield put(getLoaderAction(false));
      yield put(setgrievanceEmpListTotal_counts(response.data.total_count));
    } catch (error) {
      yield put(setgrievanceEmpListError(error));
      yield put(getLoaderAction(false));
      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///--Grievance-----retrieve--

function* GrievanceRetrivApprovedeSagaCAlls(payloads) {
  console.log(payloads, "payloads");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: GrievanceEmployeeListApi + payloads.payload.EditID + "/",

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTheGrievanceApproveEMPretrieveRESponse(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setTheGrievanceApproveEMPretrieveerror(error));
      yield put(getLoaderAction(false));
      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///--Grieveance----delete----actions---------------

function* GrieveanceDeleteActionsSagas(payloads) {
  console.log(payloads, "payloads");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "delete",
        url: grievanceApi + payloads.payload.DeleteId + "/",

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setThegrieveancedeletereponses(response.data.data));

      toast.success(` ${response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      const data = {
        search: "",
        page_size: 20,
        page: 1,
        // from_date:payloads.payload.from_date,
        // to_date:payloads.payload.to_date
      };
      yield put(setGrievanceAction(data));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setThegrieveancedeleteErrors(error));
      yield put(getLoaderAction(false));
      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///--Grievance---Approval---
function* GrievanceApprovalSagaCAlls(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: GrievanceEmployeeListApi + payload.payload.EditId + "/",
        data: {
          status: payload.payload.status,
          reason_for_decline: payload.payload.description,
        },

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      const Content = {
        search: payload.payload.search,
        page_size: 20,
        page: payload.payload.currentPage,
        selectVal: {
          status: payload.payload.selectVal.status,
        },
        data: {
          zone: payload.payload.data.zone,
          state: payload.payload.data.state,
          region: payload.payload.data.region,
        },
        white_collar: payload.payload.white_collar,
        // month: payload.payload.month,
        // year: payload.payload.year,
        from_date: payload.payload.from_date,
        to_date: payload.payload.to_date,
        range: true,
      };
      yield put(setGrievanceEMPListAction(Content));

      yield put(setTheGrievanceApprovalResponse(response.data.data));
      yield put(getLoaderAction(false));

      // const data = {
      //   search: "",
      //   page_size: 10,
      //   page: 1,
      // };
      // yield put(setGrievanceAction(data));
    } catch (error) {
      yield put(setTheGrievanceApprovalErrors(error));
      yield put(getLoaderAction(false));
      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///---Performance---Type---

function* performanceSagaCAlls(payloads) {
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",

        url: performanceApi,
        params: {
          search: payloads.payload.search,
          page_size: payloads.payload.page_size,
          page: payloads.payload.page,
          parent_type: payloads.payload.parent_type,
        },
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setPerformanceResponse(response.data.data));
      yield put(getLoaderAction(false));
      yield put(setPerformanceTotal_counts(response.data.total_count));
    } catch (error) {
      yield put(setPerformanceError(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}
///---Performance---Type Retreve---

function* performanceTypeRetrivalSagaCAlls(payloads) {
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",

        url: performanceApi + payloads.payload.id + "/",

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setPerformanceRetreveResponse(response.data.data));
      yield put(getLoaderAction(false));
      console.log(response.data.data.grading_name, "resposdfsdfsdj");
      yield put(setTheNameFormForm(response.data.data.grading_name));
    } catch (error) {
      yield put(setPerformanceRetreveError(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}
//-------------Performance----Create-------------------
function* performanceTypeCreateSaga(payload) {
  console.log(payload.payload, "skjdf;ajs;djfoajsodjf");
  const payloadStata = {
    search: payload.payload.search,
    page_size: "10",
    page: 1,
    parent_type: payload.payload.parent_,
  };
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: performanceApi,
      data: payload.payload.data,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(setPerformanceCreateResponse(response.data.data));
    yield put(setPerformanceAction(payloadStata));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));

    yield put(setPerformanceCreateError(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}
//-------------Performance----update-------------------
function* performanceTypeUpdateSaga(payload) {
  console.log(payload.payload, "skjdf;ajs;djfoajsodjf");

  const payloadStata = {
    search: payload.payload.search,
    page_size: "10",
    page: 1,
    parent_type: payload.payload.parent_,
  };
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "put",
      url: performanceApi + payload.payload.id + "/",
      data: payload.payload.data,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(setPerformanceUpdateResponse(response.data.data));
    yield put(setPerformanceAction(payloadStata));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));
    yield put(setPerformanceUpdateError(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}
//-------------Performance----Delete-------------------
function* performanceTypeDeleteSaga(payload) {
  // console.log(payload, "84789payload");
  const payloadStata = {
    search: payload.payload.search,
    page_size: "10",
    page: payload.payload.dtpageindex,
    parent_type: payload.payload.parent_type,
  };
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "delete",
      url: performanceApi + payload.payload.DeleteID + "/",
      // data: payload.payload.data,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(setPerformanceDeleteResponse(response.data.data));
    yield put(setPerformanceAction(payloadStata));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));
    yield put(setPerformanceDeleteError(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}
///---Performance---Type---

function* performanceChildSagaCAlls(payloads) {
  console.log(payloads, "payloads");
  if (payloads != undefined && payloads.payload.id != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",

        url: performanceChildApi,
        params: {
          search: payloads.payload.search,
          page_size: payloads.payload.page_size,
          page: payloads.payload.page,
          parent: payloads.payload.id,
        },
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      console.log(response.data, "asfciabsaude");
      yield put(setPerformanceChildResponse(response.data.data));
      yield put(getLoaderAction2(false));
      yield put(setPerformanceChildTotal_counts(response.data.total_count));
    } catch (error) {
      yield put(setPerformanceChildError(error));
      yield put(getLoaderAction2(false));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}
///---Performance---Type Retreve---

function* performanceChildTypeRetrivalSagaCAlls(payloads) {
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",

        url: performanceChildApi,
        params: {
          search: payloads.payload.search,
          page_size: payloads.payload.page_size,
          page: payloads.payload.page,
          parent: payloads.payload.id,
        },
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setPerformanceChildRetreveResponse(response.data.data));
      yield put(getLoaderAction(false));
      yield put(
        setPerformanceChildRetreveTotal_counts(response.data.total_count),
      );
    } catch (error) {
      yield put(setPerformanceChildRetreveError(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}
//-------------Performance----Create-------------------
function* performanceChildTypeCreateSaga(payload) {
  console.log(payload.payload, "skjdf;ajs;djfoajsodjf");
  const payloadStata = {
    search: payload.payload.search,
    page_size: "10",
    page: 1,
    id: payload.payload.data.parent_id,
  };
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: performanceChildApi,
      data: payload.payload.data,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(setPerformanceChildCreateResponse(response.data.data));
    yield put(setPerformanceChildAction(payloadStata));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));

    yield put(setPerformanceChildCreateError(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}
//-------------Performance----update-------------------
function* performanceChildTypeUpdateSaga(payload) {
  // console.log(payload.payload, "skjdf;ajs;djfoajsodjf");

  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "put",
      url: performanceChildApi + payload.payload.id + "/",
      data: payload.payload.data,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(setPerformanceUpdateChildResponse(response.data.data));

    const payloadStata = {
      search: "",
      page_size: "10",
      page: 1,
      id: payload.payload.parent_id,
    };
    console.log(payloadStata, "payloadStata");

    yield put(setPerformanceChildAction(payloadStata));

    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));
    yield put(setPerformanceUpdateChildError(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}
//-------------Performance----Delete-------------------
function* performanceChildTypeDeleteSaga(payload) {
  console.log(payload, "This is coolldfklsdkf");
  const payloadStata = {
    search: "",
    page_size: 20,
    page: payload.payload.page,
    id: payload.payload.id,
  };
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "delete",
      url: performanceChildApi + payload.payload.DeleteID + "/",
      // data: payload.payload.data,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(setPerformanceChildDeleteResponse(response.data.data));
    yield put(setPerformanceChildAction(payloadStata));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));
    yield put(setPerformanceChildDeleteError(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

///----EDUCATIONS-------reate-----Details-------------
function* getEDUCATIONcreateDetails(payload) {
  console.log(payload.payload, "alskjdfljasldkfjkajsldflajsdjfalsjfl");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: EducationDetailsAPI,
        data: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetEducationDataResponecrateActions(response.data));
      yield put(getLoaderAction(false));

      yield put(SetEducationDetails(response.data.data.id));

      const payloadsempyeeprofile = {
        search: "",
        page_size: 10,
        page: 1,
        ids:
          store.getState().BasicFormCreated.user_ID == ""
            ? store.getState().EmployeeProfile.EmployeeProfileList.id
            : store.getState().BasicFormCreated.user_ID,
      };

      yield put(setEmployeeProfileDATASActions(payloadsempyeeprofile));
      // const test = {
      //   Retieveid: response.data.data.id,
      // };
      // yield put(setEducationDataActions(test));
      yield put(SetActiveTabs(6));
      // state.FormsIDList.EducationID

      // toast.success(` ${response.data.status.message} `, {
      // position: toast.POSITION.TOP_RIGHT,
      // });
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(setEducationDatacreateError(error));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}
///----EDUCATIONS-------Edit-----Details-------------
function* geteducationUpdateDetails(payload) {
  console.log(payload.payload, "daadaaasas");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: EducationDetailsAPI + payload.payload.id + "/",
        data: payload.payload.data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetEducationDataPutResponeActions(response.data));
      yield put(getLoaderAction(false));
      yield put(SetEducationDetails(response.data.data.id));

      const payloadsempyeeprofile = {
        search: "",
        page_size: 10,
        page: 1,
        ids:
          store.getState().BasicFormCreated.user_ID == ""
            ? store.getState().EmployeeProfile.EmployeeProfileList.id
            : store.getState().BasicFormCreated.user_ID,
      };

      yield put(setEmployeeProfileDATASActions(payloadsempyeeprofile));
      // const test = {
      //   Retieveid: response.data.data.id,
      // };
      // yield put(setEducationDataActions(test));

      yield put(SetActiveTabs(6));
      // state.FormsIDList.EducationID

      // toast.success(` ${response.data.status.message} `, {
      // position: toast.POSITION.TOP_RIGHT,
      // });
    } catch (error) {
      yield put(getLoaderAction(false));
      yield put(setEducationDataPutError(error));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///---Sheet----uploads----
function* FileSheetUploadCalls(payload) {
  console.log(payload, "payload");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: sheetuploadsApi,
      data: payload.payload.formdatas,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(setTheExcelSheetuploadERROES(response.data.data));
    yield put(getLoaderAction(false));

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
  } catch (error) {
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    yield put(setTheExcelSheetuploadERROES(error));
  }
}

////---Create---EMployee------with--sign
function* createEmployeeCreaeSign(payload) {
  console.log(payload, "payload");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: createEmplosignApi + payload.payload.id + "/",
      data: payload.payload.formdatas,

      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    // yield put(SetSignaturePops(false));
    yield put(settheCreateEmployeeResponse(response.data));
    yield put(getLoaderAction(false));
    yield put(Files(""));
    yield SetSignaturePops(false);

    if (typeof payload.payload.Funcations === "function") {
      payload.payload.Funcations();
    }

    // window.location.href = "/fieldagent";
  } catch (error) {
    yield put(getLoaderAction(false));

    if (error.response.status != 500) {
      yield put(settheCreareEmployeErr(error));

      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    } else {
      toast.error(` ${" something went wrong"} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}

///--Attendance-----------------Request----
function* setTheAttendanceRequestList(payloads) {
  console.log(payloads, "23749283798");
  try {
    yield put(getLoaderAction2(true));
    const response = yield axios({
      method: "get",
      url: AttendanceRequestAPi,
      params: {
        search: payloads.payload.search,
        page_size: payloads.payload.page_size,
        page: payloads.payload.page,
        // month: payloads.payload.month,
        //year: payloads.payload.year,
        from_date: payloads.payload.from_date,
        to_date: payloads.payload.to_date,
        range: true,

        request_type: "request",
        status: payloads.payload.selectVal.status,
        zone: payloads.payload.data.zone,
        state: payloads.payload.data.state,
        region: payloads.payload.data.region,
        white_collar: payloads.payload.white_collar,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(SetTheAttendanceResponseActions(response.data.data));
    yield put(getLoaderAction2(false));
    yield put(setTeAttendanceTotal_counts(response.data.total_count));
  } catch (error) {
    yield put(getLoaderAction2(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    yield put(setTheAttendanceListError(error));

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

function* settheOverTimeSAGA(payloads) {
  console.log(payloads, "23749283798");
  try {
    yield put(getLoaderAction2(true));
    const response = yield axios({
      method: "get",
      url: overtimeapi,
      params: payloads.payload,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(setheOvertimeResponse(response.data.data));
    yield put(getLoaderAction2(false));
    yield put(setTotal_count_OvertimeEmployeeList(response.data.total_count));
  } catch (error) {
    yield put(getLoaderAction2(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    yield put(settheOvertimeErrorMessage(error));

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

function* setTheoverTImeREquestAppriveforApp(payload) {
  console.log(payload, "payload");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "put",
      url: AttendanceRequestAPi + payload.payload.EditId + "/",
      data: {
        status: payload.payload.status,
        reason_for_decline: payload.payload.description,
      },

      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    // const Content = {
    //   search: payload.payload.search,
    //   page_size: 20,
    //   page: payload.payload.currentPage,
    //   selectVal: {
    //     status: payload.payload.selectVal.status,
    //   },
    //   data: {
    //     zone: payload.payload.data.zone,
    //     state: payload.payload.data.state,
    //     region: payload.payload.data.region,
    //   },
    //   from_date: payload.payload.from_date,
    //   to_date: payload.payload.to_date,

    //   white_collar: payload.payload.white_collar,
    // };
    yield put(setTheOvertimeAction(payload.payload.getlist));
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(SetOvertimeResponseApproveActions(response.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));
    yield put(SetOvertimeListApproveError(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

///-----Region------retrive-------
function* getTheAttendanceRetrieveSaga(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: AttendanceRequestAPi + payload.payload.EditID + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SetTheAttendanceResponseRetriveActions(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setTheAttendanceListRetrieveError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///---attendance----Approve---

function* setTheAttendanceREquestAppriveforApp(payload) {
  console.log(payload, "payload");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "put",
      url: AttendanceRequestAPi + payload.payload.EditId + "/",
      data: {
        status: payload.payload.status,
        reason_for_decline: payload.payload.description,
      },

      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    const Content = {
      search: payload.payload.search,
      page_size: 20,
      page: payload.payload.currentPage,
      month: payload.payload.month,
      year: payload.payload.year,
      selectVal: {
        status: payload.payload.selectVal.status,
      },
      data: {
        zone: payload.payload.data.zone,
        state: payload.payload.data.state,
        region: payload.payload.data.region,
      },
      from_date: payload.payload.from_date,
      to_date: payload.payload.to_date,

      white_collar: payload.payload.white_collar,

      // white_collar: payload.payload.white_collar,
      // white_collar: payload.payload.white_collar,
    };
    yield put(StetheAttendanceActions(Content));
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(SetTheAttendanceResponsepproveActions(response.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));
    yield put(setTheAttendanceListApproveError(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

// ///-----Performs--------Fieldagent-----LIsts--------------------------
function* getPerformsFieldAgentCall(payloads) {
  console.log(payloads, "payloads");
  try {
    yield put(getLoaderAction(true));

    const response = yield axios({
      method: "get",
      url: performFieldAgentAPi,
      // params: {
      //   search: payloads.payload.search,
      //   page_size: payloads.payload.page_size,
      //   page: payloads.payload.page,
      //   month: payloads.payload.month,
      //   year: payloads.payload.year,
      //   is_completed: payloads.payload.is_complete.completed,
      //   status: payloads.payload.selectVal.status,
      //   zone: payloads.payload.data.zone,
      //   state: payloads.payload.data.state,
      //   region: payloads.payload.data.region,
      //   role: payloads.payload.role,
      //   client: payloads.payload.client_id,
      // },
      params: payloads.payload,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(setThePerformsFieldResponse(response.data.data));
    yield put(getLoaderAction(false));
    yield put(setPerformanceFieldTotal_counts(response.data.total_count));
  } catch (error) {
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    yield put(setPerformanceFieldError(error));
    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

///-----------retrive-------
function* getPerformsFieldAgentRetrieveCAll(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: performfieldagentRetrievespi + payload.payload.EditId + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setPerformanceRetrieveFieldResponse(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setPerformanceRetrieveFielError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///-----Man--power-performances------edit-------
function* getPerformsFieldAgentEDITCAll(payload) {
  console.log(payload, "payloadwes");
  if (payload != undefined && payload.payload.EditId != "") {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: manpowerperformsApi + payload.payload.EditId + "/",
        data: payload.payload.innerdata,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setPerformanceEditFieldResponse(response.data.data));

      // const payloads = {
      //   question_id: payload.payload.question_id,
      //   userid: payload.payload.userid, ///----useoooid
      //   year: payload.payload.year,
      //   month: payload.payload.month,
      // };

      // yield put (setThePerformsAgentRetrieveseparatestandACtion(payloads))

      yield put(getLoaderAction(false));

      if (payload.payload.count == 2) {
        toast.success(` ${response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
        window.location.href = "/manpower";
      }
    } catch (error) {
      yield put(setPerformanceEditFielError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///-----performance---separate---call------retrive-------
function* getPerformsFieldAgentRetrieveSeparateCAllSaga(payload) {
  console.log(
    payload,
    "payload",
    payload.payload.id,
    manpowerperformsretrieveStandApi,
  );
  if (payload != undefined && payload.payload.id != "") {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: manpowerperformsretrieveStandApi + payload.payload.userid + "/",
        params: {
          question_id: payload.payload.question_id,
          year: payload.payload.year,
          month: payload.payload.month,
        },
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(
        setPerformanceRetrieveFieldseparateResponse(response.data.data),
      );
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setPerformanceRetrieveFielseparateError(error));
      yield put(getLoaderAction(false));
      // toast.error(` ${error.response.data.status.message} `, {
      //   position: toast.POSITION.TOP_RIGHT,
      // });
      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///-----Man--power-performances------create-------
function* getPerformsFieldAgentCREATECAll(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: manpowerperformsApi,
        data: payload.payload.innerdata,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setPerformanceCreateFieldResponse(response.data.data));

      // const payloads = {
      //   question_id: payload.payload.question_id,
      //   userid: payload.payload.userid, ///----useoooid
      //   year: payload.payload.year,
      //   month: payload.payload.month,
      // };

      // yield put (setThePerformsAgentRetrieveseparatestandACtion(payloads))

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setPerformanceCreateFielError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* setTheattendanceexport(payload) {
  console.log(payload, "payload", payload.payload.Dob);
  // // if (payload != undefined) {
  //   try {
  //     yield put(getLoaderAction(true));
  //     const response = yield axios({
  //       // method: "post",
  //       method: "get",

  //       url: Attendanceexportapi,
  //       // data: payload.payload.data,
  //       params: {
  //         export_type: `${payload.payload.export_type}`,
  //         client_id: ${payload.payload.client_id},
  //         user_id: payload.payload.user_id,
  //         base_type: payload.payload.data.base_type,
  //         from_date: payload.payload.data.from_date,
  //         to_date: payload.payload.data.to_date,
  //         range: true,
  //       },

  //       // headers: {
  //       //   Authorization:
  //       //     "Bearer " + store.getState().users.UserData.session.token,
  //       // },
  //     });

  //     yield put(SetTheAttendanceResponseExportActions(response.data.data));

  //     const getFileExtension = (filename) => {
  //       console.log(filename, "dsada");
  //       return filename.split(".").pop();
  //     };

  //     // window.open(response.data.data); // old
  //     // console.log(response.data, "sdfcweufb");
  //     // // window.open(response.data) ///new flow
  //     //  window.open(URL.createObjectURL(response.data), "_blank");

  //     try {
  //       const file = new File([response.data],"sdfaasd", {
  //         type: response.headers["content-type"],
  //       });

  //        console.log(file ,"fsdasdasdile");
  //       // Check the file extension to determine the file type
  //       const fileExtension = getFileExtension(file.name);
  //       console.log(fileExtension, "fileExtension");
  //       // if (fileExtension === "pdf") {
  //         // Open PDF file
  //         window.open(URL.createObjectURL(file), "_blank");
  //       // } else if (fileExtension === "xlsx" || fileExtension === "xls") {
  //         // Open Excel file
  //         // alert("This is an Excel file");
  //       // } else {
  //         // Unsupported file type
  //         // alert("Unsupported file type");
  //       // }
  //     } catch (error) {
  //       console.error("Error downloading file:", error);
  //     }

  //     yield put(getLoaderAction(false));
  //   } catch (error) {
  //     yield put(setTheAttendanceListExportError(error));
  //     ///  console.log(error, "error");
  //     yield put(getLoaderAction(false));
  //     // toast.error(` ${error.response.data.status.message} `, {
  //     // position: toast.POSITION.TOP_RIGHT,
  //     // });
  //     if (error.response.data.status.code == 401) {
  //
  //       localStorage.clear();
  //       window.location.href = "/";
  //     }
  //   }
  // }

  window.open(
    `${baseurlforexport}/adminapp/attendance/export/?export_type=${payload.payload.export_type}&client_id=${payload.payload.client_id}&user_id=${payload.payload.user_id}&base_type=${payload.payload.data.base_type}&from_date=${payload.payload.data.from_date}&to_date=${payload.payload.data.to_date}&range=true&given_header=${payload.payload.Dob}`,
    "_blank",
  );
}

////--Black---list--------------

function* getBlackListCall(payloads) {
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: blacklistapi,
        params: {
          search: payloads.payload.search,
          page_size: payloads.payload.page_size,
          page: payloads.payload.page,
          status: payloads.payload.selectVal.status,
          zone: payloads.payload.data.zone,
          state: payloads.payload.data.state,
          region: payloads.payload.data.region,
          // client: payloads.payload.client,
          // user: payloads.payload.user,
          white_collar: payloads.payload.white_collar,
          // month: payloads.payload.month,
          // year: payloads.payload.year,
          // date: payloads.payload.date,
          from_date: payloads.payload.from_date,
          to_date: payloads.payload.to_date,
          range: true,
        },
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(SetTheBlackllistResponse(response.data.data));
      yield put(getLoaderAction2(false));
      yield put(SetTheBlackistTotal_counts(response.data.total_count));
    } catch (error) {
      yield put(getLoaderAction2(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(SetTheBlacklistError(error));
      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///---black----Retrieve----
function* BlackiListRetrieve(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: blacklistapi + payload.payload.EditId + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SettheBlacklistresponseRetrieveActions(response.data.data));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(SetBlacklistErrorRetrieve(error));
      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

//----- black----list----Edits-----
function* BlackListEdits(payload) {
  console.log(payload, "payasdasdload");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "put",
      url: blacklistapi + payload.payload.EditId + "/",
      // data: {
      // status: payload.payload.status,
      // reason_for_decline: payload.payload.description,
      // },

      data: payload.payload.form_data,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    // const Content = {
    //   search: payload.payload.search,
    //   page_size: 20,
    //   page: payload.payload.currentPage,
    //   selectVal: {
    //     status: payload.payload.selectVal.status,
    //   },
    //   data: {
    //     zone: payload.payload.data.zone,
    //     state: payload.payload.data.state,
    //     region: payload.payload.data.region,
    //   },

    //   white_collar: payload.payload.white_collar,
    //   // client: payload.payload.client,
    //   // user: payload.payload.user,
    //   // month: payload.payload.month,
    //   // year: payload.payload.year,
    //   // date: payload.payload.date,
    //   from_date: payload.payload.from_dates,
    //   to_date: payload.payload.to_dates,
    //   range: true,
    // };

    if (payload.payload.count == 1) {
      const Content = {
        search: payload.payload.search,
        page_size: 20,
        page: payload.payload.currentPage,
        selectVal: {
          status: payload.payload.selectVal.status,
        },
        data: {
          zone: payload.payload.data.zone,
          state: payload.payload.data.state,
          region: payload.payload.data.region,
        },

        white_collar: payload.payload.white_collar,
        // client: payload.payload.client,
        // user: payload.payload.user,
        // month: payload.payload.month,
        // year: payload.payload.year,
        // date: payload.payload.date,
        from_date: payload.payload.from_dates,
        to_date: payload.payload.to_dates,
        range: true,
      };
      yield put(SetTheBlacklistActions(Content));
    }
    if (payload.payload.count == 3) {
      const Content_approved = {
        search: payload.payload.searchemp,
        page_size: 20,
        page: payload.payload.page_size_approved,
        old_employee: payload.payload.Emp_old,
        client_id: payload.payload.client_id_sfrom,
      };

      console.log(Content_approved, "Content");

      yield put(SetVerifiedUserActions(Content_approved));
    }

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(SettheBlacklistResponsesActions(response.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));

    yield put(SetTheBlacklistErrorEdits(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

//----- black----list----Edits-----
function* blackilistCreate(payload) {
  console.log(payload, "payload");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: blacklistapi,

      data: payload.payload.form_data,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    const Content = {
      search: "",
      page_size: 20,
      page: payload.payload.currentPage,
      selectVal: {
        status: payload.payload.selectVal.status,
      },
      data: {
        zone: payload.payload.data.zone,
        state: payload.payload.data.state,
        region: payload.payload.data.region,
      },
      white_collar: false,
      // client: payload.payload.client,
      // user: payload.payload.user,
      // month: payload.payload.month,
      // year: payload.payload.year,
      // date: payload.payload.date,
    };
    if (payload.payload.count == 1) {
      yield put(SetTheBlacklistActions(Content));
    }
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    const approveform = new FormData();
    approveform.append(
      "data",
      JSON.stringify({
        status: "approved",
      }),
    );
    const approvecall = {
      EditId: response.data.data.id,

      form_data: {
        status: "approved",
      },
      selectVal: {
        status: payload.payload.selectVal.status,
      },
      count: payload.payload?.Count_of_block,
      search: "",
      white_collar: payload.payload.white_collar,
      Emp_old: payload.payload.Emp_old,
      searchemp: payload.payload.searchemp,
      page_size_approved: payload.payload.page_size_approved,
      client_id_sfrom: payload.payload.client_id_sfrom,
      black_list: payload?.payload?.black_list,
      page: payload.payload.currentPage,
    };

    yield put(SetTheBlacklistEditsActions(approvecall));

    yield put(SettheBlacklistresponseCreateActions(response.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));

    yield put(SetBlacklistErrorCreate(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

///=====================Site---Transfer-----
function* SiteTransferCall(payloads) {
  console.log(payloads, "payloads");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: siteTransferapi,
        params: {
          search: payloads.payload.search,
          page_size: payloads.payload.page_size,
          page: payloads.payload.page,
          status: payloads.payload.selectVal.status,
          zone: payloads.payload.data.zone,
          state: payloads.payload.data.state,
          region: payloads.payload.data.region,
          // from_client: payloads.payload.from_client,
          // user: payloads.payload.user,
          white_collar: payloads.payload.white_collar,
          // month: payloads.payload.month,
          // year: payloads.payload.year,
          // date: payloads.payload.date,
          from_date: payloads.payload.from_date,
          to_date: payloads.payload.to_date,
          range: true,
        },
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(SetThesiteTramsferResponse(response.data.data));
      yield put(getLoaderAction2(false));
      yield put(SetThesiteTramfersTotal_counts(response.data.total_count));
    } catch (error) {
      console.log(error, "error");
      yield put(getLoaderAction2(false));
      // toast.error(` ${error.response.data.status.message} `, {
      //   position: toast.POSITION.TOP_RIGHT,
      // });
      yield put(SetTheSiteTranferError(error));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///---SiteTransfer----Retrieve----
function* SietTransferRetrieve(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: siteTransferapi + payload.payload.EditId + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(SettheSiteTransferRetrieveResponsesActions(response.data.data));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(SetSiteTransferErrorRetrieve(error));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

//----- SiteTransferEdits----Edits-----
function* SiteTransferEdits(payload) {
  console.log(payload, "payloadasdasd");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "put",
      url: siteTransferapi + payload.payload.EditId + "/",
      data: payload.payload.form_data,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    if (payload.payload.count == 1) {
      const Content = {
        search: payload.payload.search,
        page_size: 20,
        page: payload.payload.currentPage,
        selectVal: {
          status: payload.payload.selectVal.status,
        },
        data: {
          zone: payload.payload.data.zone,
          state: payload.payload.data.state,
          region: payload.payload.data.region,
        },
        // from_client: payload.payload.from_client,
        // user: payload.payload.user,
        white_collar: payload.payload.white_collar,
        // month: payload.payload.month,
        // year: payload.payload.year,
        // date: payload.payload.date,

        from_date: payload.payload.from_date,
        to_date: payload.payload.to_date,
        range: true,
      };

      console.log(Content, "Content");

      yield put(SetTheSiteTransferActions(Content));
    }
    if (payload.payload.count == 3) {
      const Content_approved = {
        search: payload.payload.searchemp,
        page_size: 20,
        page: payload.payload.page_size_approved,
        old_employee: payload.payload.Emp_old,
        client_id: payload.payload.client_id_sfrom,
      };

      console.log(Content_approved, "Content");

      yield put(SetVerifiedUserActions(Content_approved));
    }

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(SettheSiteTranfserResponsesActions(response.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));

    yield put(SetTheSiteTramsferErrorEdits(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

function* SiteTransferCreateSaga(payload) {
  console.log(payload, "payload");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: siteTransferapi,
      data: payload.payload.form_data,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    // const Content = {
    //   search: "",
    //   page_size: 10,
    //   page: 1,
    //   selectVal: {
    //     status: payload.payload.selectVal.status,
    //   },
    //   // data: {
    //   //   zone: payload.payload.data.zone,
    //   //   state: payload.payload.data.state,
    //   //   region: payload.payload.data.region,
    //   // },
    //   from_client: payload.payload.from_client,
    //   user: payload.payload.user,
    // };
    // yield put(SetTheSiteTransferActions(Content));
    // console.log(response.data, "resfisdpofsdnf", response.data.data.id);

    const approveform = new FormData();
    approveform.append(
      "data",
      JSON.stringify({
        status: "approved",
      }),
    );
    const approvecall = {
      EditId: response.data.data.id,

      form_data: {
        status: "approved",
      },
      selectVal: {
        // status: payload.payload.selectVal.status,
        status: "",
      },
      // count: 1,
      // count: 2,
      // month: payload.payload.month,
      // year: payload.payload.year,
      // date: payload.payload.date,
      // search: "",
      count: payload.payload?.Count_of_block, // month: payload.payload.month,
      // year: payload.payload.year,
      // date: payload.payload.date,
      search: "",
      Emp_old: payload.payload.Emp_old,
      client_id_sfrom: payload.payload.client_id_sfrom,
      searchemp: payload.payload.searchemp,
      page_size_approved: payload.payload.page_size_approved,
      client_id_sfrom: payload.payload.client_id_sfrom,
      page: payload.payload?.currentPage,
    };

    yield put(SetTheSiteTransferEditsActions(approvecall));

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(SettheSiteTranfserResponsesCreateActions(response.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));

    yield put(SetTheSiteTramsferErrorCreate(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

function* sendTheNotificationsSaga(payload) {
  console.log(payload, "payload");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: setnotificationsapi,
      data: {
        send_type: payload.payload.send_type,
        client_id: payload.payload.data.client_id,
        title: payload.payload.data.title,
        body: payload.payload.data.body,
        user:
          payload.payload.data.user_id == []
            ? ""
            : payload.payload.data.user_id,
        state: payload.payload.filters.state,
        region: payload.payload.filters.region,
        zone: payload.payload.filters.zone,
        parent: payload.payload.data.parent,
        white_collar: payload.payload.white_collar,
        is_oldemployee: payload.payload.is_oldemployee,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(setTheNotificationcreateResponse(response.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));

    yield put(SetTheSendnotificationErrorCreate(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

function* setThepdfdownloadsagas(payload) {
  console.log(payload, "payload");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: pdfgetlistapi + payload.payload.id + "/",

      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    // toast.success(` ${response.data.status.message} `, {
    //   position: toast.POSITION.TOP_RIGHT,
    // });
    yield put(getLoaderAction(false));

    //  console.log(response.data.data ,"responsesdcca");
    if (payload.payload.count == 1) {
      window.open(response.data.data);
    }
    yield put(setHtlformatpdfdownloadreponse(response.data.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));
    if (error.response.status != 500) {
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(setHtlformatpdfdownloadreponse(error));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    } else {
      // toast.error(` ${error.response.data} `, {
      //   position: toast.POSITION.TOP_RIGHT,
      // });
      toast.error(` ${" something went wrong"} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}

function* getAppraisalHtmlFormatPost(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: manpowerperformsApi,
        data: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      console.log(response.data.data, "response.data.data");

      yield put(settheAppraisalHtmlFormatsPostsResponse(response.data.data.id));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setTheAppraisalErrorReponseshtmlForm(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///==============Attendance0----export---get---list====API
function* settheAttendanceExportGetSaga(payloads) {
  console.log(payloads, "payloads");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: AttendanceExportForUserProfilesGetApi,
        params: {
          user: payloads.payload.user,
          month: payloads.payload.month,
          year: payloads.payload.year,
        },
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setTheAttendanceExportgetListReponse(response.data.data));
      yield put(getLoaderAction(false));
      yield put(setTheAttendanceExportTotal_counts(response.data.total_count));
    } catch (error) {
      console.log(error, "error");
      yield put(getLoaderAction(false));
      // toast.error(` ${error.response.data.status.message} `, {
      //   position: toast.POSITION.TOP_RIGHT,
      // });
      yield put(setTheAttendanceExportGetListError(error));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

//admin0---user--list access---get---list====API
function* calladminuseraccesslistsaga(payloads) {
  console.log(payloads, "payloads");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: adminuseraccesslist,
        params: {
          search: payloads.payload.search,
          page_size: payloads.payload.page_size,
          page: payloads.payload.page,
        },
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(
        setTheAdminuseraccesslistDatasgetListReponse(response.data.data),
      );
      yield put(getLoaderAction(false));
      yield put(
        setTheAdminuseraccesslistDatasTotal_counts(response.data.total_count),
      );
    } catch (error) {
      console.log(error, "error");
      yield put(getLoaderAction(false));
      // toast.error(` ${error.response.data.status.message} `, {
      //   position: toast.POSITION.TOP_RIGHT,
      // });
      yield put(setTheAdminuseraccesslistDatasGetListError(error));
      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///---post for admin access
function* getadinaccesslistpotsaga(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: adminuseraccesslist,
        data: payload.payload.data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(settheadminuseraccesscratePostsResponse(response.data.data));

      const Content = {
        search: payload.payload.search,
        page_size: 20,
        page: payload.payload.currentPage,
      };
      yield put(setAdminuseraccesslistDatasgetlistActions(Content));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setTheadminuseraccesscrateReponsesError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///-----admin---user---acces------retrive-------
function* getAdminuserlitretrieve(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: adminuseraccesslist + payload.payload.EditID + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(settheadminuseraccessRetrievePostsResponse(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(setTheadminuseraccessRetrieveReponsesError(error));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

//-----admin----Edits-----
function* settheadminiserputsaga(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "put",
      url: adminuseraccesslist + payload.payload.EditId + "/",
      data: payload.payload.data,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    const Content = {
      search: payload.payload.search,
      page_size: 20,
      page: payload.payload.currentPage,
    };
    yield put(setAdminuseraccesslistDatasgetlistActions(Content));

    yield put(settheadminuseraccessEDITPutResponse(response.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(setTheadminuseraccessEDITReponsesError(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

function* AdminuserlistDeleteActionsSagas(payloads) {
  console.log(payloads, "payloads");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "delete",
        url: adminuseraccesslist + payloads.payload.DeleteID + "/",

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(settheadminuseraccesdeleteResponse(response.data.data));

      toast.success(` ${response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      const Content = {
        search: "",
        page_size: 20,
        page: 1,
      };
      yield put(setAdminuseraccesslistDatasgetlistActions(Content));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setTheadminuseraccessdeleteReponsesError(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* gettheexcelSheetFormatSaga(payload) {
  console.log(payload, "payload");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: ExcelSheetGetList,
      params: {
        user_id: payload.payload.user_id,
        client_id: payload.payload.client_id,
        return_type: payload.payload.return_type,
        family_type: payload.payload.family_type,
        previous_type: payload.payload.previous_type,
        form_name: payload.payload.form_name,
      },

      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    //  console.log(response.data.data ,"responsesdcca");

    window.open(response.data.data);
    yield put(setTheExcelSheetDataforEMpANdclientResponses(response.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));
    console.log(error, "error2");
    yield put(setExcelSheetgetEmpANdClientReponsesError(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

///==============Attendance  request====API
function* setTheAttendanceEmployeeRequestSaga(payloads) {
  console.log(payloads, "payloads");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: AttendaceRequestList,
        params: {
          // user: payloads.payload.user,
          month: payloads.payload.month,
          year: payloads.payload.year,
        },
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(
        setTheAttendancesaccesslistDatasgetListReponse(response.data.data),
      );
      yield put(getLoaderAction(false));
      yield put(
        setTheAttendanceslistDatasTotal_counts(response.data.total_count),
      );
    } catch (error) {
      console.log(error, "error");
      yield put(getLoaderAction(false));
      // toast.error(` ${error.response.data.status.message} `, {
      //   position: toast.POSITION.TOP_RIGHT,
      // });
      yield put(setTheAdttendanceslistDatasGetListError(error));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* setVerifyForEMployeeOnboardOtp(payload) {
  console.log(payload, "payloasd");
  // console.log(store.getState().ForgotP.email, "emails");

  try {
    const response = yield axios({
      method: "post",
      url: SignOtpUrl,
      data: payload.payload,
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    console.log(response.status, "sldasodoiawhdo");

    yield put(
      setTheEsignatureCodes(
        response.status != null && response.status != undefined
          ? response.status
          : 502,
      ),
    );

    yield put(setThePhoneNumberOtpREsponses(payload.payload));
  } catch (error) {
    yield put(setThePhoneNumberOfOtpVerified_Error(error));
    console.log(error.response.data.status.code, "error");

    yield put(
      setTheEsignatureCodes(
        error.response != null ? error.response.data.status.code : 502,
      ),
    );
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

function* setVerifyForEMployeeOnboardOtpASRESENTOTP(payload) {
  console.log(payload, "payloasd");
  // console.log(store.getState().ForgotP.email, "emails");

  try {
    const response = yield axios({
      method: "post",
      url: SignOtpUrl,
      data: payload.payload,
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    // console.log(response.status, "sldasodoiawhdo");

    // yield put(
    //   setTheEsignatureCodes(
    //     response.status != null && response.status != undefined
    //       ? response.status
    //       : 502
    //   )
    // );

    yield put(setTheResentPhoneNumberOtpREsponses(payload.payload));
  } catch (error) {
    yield put(setThePhoneNumberResentOfOtpVerified_Error(error));

    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

function* setTheOtpVerificationWithNumberAndOtpOnboards(payload) {
  console.log(payload, "paysasloasd", store.getState());

  try {
    const response = yield axios({
      method: "post",
      url: SignOtpVerified,
      data: payload.payload.otp,
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(setThePhoneNumberwithOtpREsponses(response.data));

    if (typeof payload.payload.Funcations === "function") {
      payload.payload.Funcations();
    }

    yield put(setTheEsignatureCodes(502)); //for close the otp

    yield put(SetSignaturePops(true)); ///-----signaturepad made as true
  } catch (error) {
    yield put(setThePhoneNumberOfwithOtpVerified_Error(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

function* ActiveEmployeeListSaga(payloads) {
  try {
    yield put(getLoaderAction2(true));
    const response = yield axios({
      method: "get",
      url: ActiveBasedEmployees,
      params: {
        search: payloads.payload.search,
        page_size: payloads.payload.page_size,
        page: payloads.payload.page,

        status: payloads.payload.selectVal.status,
        zone: payloads.payload.data.zone,
        state: payloads.payload.data.state,
        region: payloads.payload.data.region,
        white_collar: payloads.payload.white_collar,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(setTheActiveEmployeeListActionsResponses(response.data.data));
    yield put(getLoaderAction2(false));
    yield put(setTheActiveEmployeeTotal_counts(response.data.total_count));
  } catch (error) {
    yield put(setTheActiveEmployeeListErrorReponses(error));
    yield put(getLoaderAction2(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

///-----------retrive-------
function* setTheRetrieveEmployeeActiveBased(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: ActiveBasedEmployees + payload.payload.EditId + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(
        setTheRetrievForApproveEmployeeTOleftResponses(response.data.data),
      );

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(setTheRetieveFroApproveApproveEmployeeTOleftError(error));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* InActiveEmployeeForLeftSaga(payload) {
  console.log(payload, "payload");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "put",
      url: ActiveBasedEmployees + payload.payload.EditId + "/",
      data: {
        status: payload.payload.status,
        reason_for_decline: payload.payload.description,
      },

      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    const Content = {
      search: "",
      page_size: 20,
      page: payload.payload.currentPage,
      selectVal: {
        status: payload.payload.selectVal.status,
      },
      data: {
        zone: payload.payload.data.zone,
        state: payload.payload.data.state,
        region: payload.payload.data.region,
      },
      white_collar: payload.payload.white_collar,
      white_collar: payload.payload.white_collar,
    };
    yield put(SetTheActiveEmployeeListACtions(Content));
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(setTheApproveEmployeeTOleftResponses(response.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));
    yield put(setTheApproveEmployeeTOleftError(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

/////------inactive create
function* setTheActiveBasedEmployeeForPOstSaga(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: ActiveBasedEmployees,
        data: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTheActiveEmployeeActionResponses(response.data.data));
      toast.success(` ${response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setTheActiveEmployeesResponseInErrorMessage(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* setThePerformanceExportSheetSaga(payloads) {
  console.log(payloads, "payloads");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: `${baseurlforexport}/adminapp/perform/excelexport/?client=${payloads.payload.client}&role=${payloads.payload.role}&user_id=${payloads.payload.user_id}`,
        // params: payloads.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setThePerformanceExportSheetDatasReponses(response.data.data));
      yield put(getLoaderAction(false));
      console.log(response.data?.data, "response.data oiudoiausd");
      window.open(response.data.data);
    } catch (error) {
      console.log(error, "error");
      yield put(getLoaderAction(false));
      // toast.error(` ${error.response.data.status.message} `, {
      //   position: toast.POSITION.TOP_RIGHT,
      // });
      yield put(setThPerformanceExportSheetDatasErrorReponses(error));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }

  // http://192.168.5.52:8888/adminapp/perform/excelexport/?user_id=&role_id=1a2bdefa-e1ca-467b-9310-43c8588816bd&client_id=0fd93bfe-57d3-42ae-a716-2bf8b1ac9d1b

  // window.open(
  //   `${baseurlforexport}/adminapp/perform/excelexport/?client_id=${payloads.payload.client}&role_id=${payloads.payload.role}&user_id=${payloads.payload.user_id}`,
  //   "_blank"
  // );
}
//---APPRAISAL-----
function* ApraisalGetListSaga(payloads) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: manpowerperformsApi,
      params: {
        search: payloads.payload.search,
        page_size: payloads.payload.page_size,
        page: payloads.payload.page,
        user: payloads.payload.user,
        month: payloads.payload.month,
        year: payloads.payload.year,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(setTheAppraisalListedreponses(response.data.data));
    yield put(getLoaderAction(false));
    yield put(setTheAppraisalListCountsTotal_counts(response.data.total_count));
  } catch (error) {
    yield put(setTheAAppraiisalEroorerrorReponses(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

///---APRRAISAL---retrieve---
///-----------retrive-------
function* getTheAppraisalRetrieveSagas(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: manpowerperformsApi + payload.payload.EditId + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTheAppraisalRetrieveDatasReponses(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setTheAppaisalRetrieveSlicesErrorReponses(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* setTheSuperviorseSagas(payloads) {
  // console.log(payloads, "payloads");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: SuperviorsListPutorRemove,
        data: payloads.payload.data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setThesuperViorsResponseActionss(response.data.data));
      yield put(getLoaderAction(false));
      const CallSupervisoractions = {
        client_id: payloads.payload.client_id,
        type: "remove",
        search: payloads.payload.search,
        page_size: 20,
        page: payloads.payload.page,
      };
      yield put(SetTheSuperviorsListACtions(CallSupervisoractions));

      toast.success(` ${response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    } catch (error) {
      yield put(getLoaderAction(false));

      yield put(setTheSuperviorseErrorResponses(error));

      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* SuperviorsgetLists(payloads) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: SuperviorsListPutorRemove,
      params: {
        search: payloads.payload.search,
        page_size: payloads.payload.page_size,
        page: payloads.payload.page,
        client_id: payloads.payload.client_id,
        type: payloads.payload.type,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(setTheSuperviorsListActionsResponses(response.data.data));
    yield put(getLoaderAction(false));
    yield put(setTheSuperviorsTotal_counts(response.data.total_count));
  } catch (error) {
    yield put(setTheSuperviorsListErrorReponses(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

function* setTheAttendanceREquestMulitipleSelcetdsforApp(payload) {
  // console.log(payload, "payload");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "put",
      url: attendanceRequestAPIPutwithmuil,
      data: {
        status: payload.payload.status,
        reason_for_decline: payload.payload.reason_for_decline,
        attendance_id: payload.payload.attendance_id,
      },

      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    const Content = {
      search: payload.payload.search,
      page_size: 20,
      page: payload.payload.currentPage,
      month: payload.payload.month,
      year: payload.payload.year,
      selectVal: {
        status: payload.payload.selectVal.status,
      },
      data: {
        zone: payload.payload.data.zone,
        state: payload.payload.data.state,
        region: payload.payload.data.region,
      },
      from_date: payload.payload.from_date,
      to_date: payload.payload.to_date,
      range: true,

      white_collar: payload.payload.white_collar,

      // white_collar: payload.payload.white_collar,
      // white_collar: payload.payload.white_collar,
    };
    yield put(StetheAttendanceActions(Content));
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(setTheAttedanceListMulitipleResponses(response.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));
    yield put(setTheAttedanceListErrorMulitiples(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

///dashboard------for employees - --------------
function* DashboardFroEmployeesSaga(payloads) {
  console.log(payloads, "payloadasdasdasds", employeedashboard);

  try {
    yield put(getLoaderAction2(true));
    const response = yield axios({
      method: "get",
      url: employeedashboard,
      params: payloads.payload,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(SettheEmployeeAttendanceResponseDatas(response.data.data));
    console.log(response.data.data, "response.data.data");
    if (response.data.data != undefined) {
      yield put(getLoaderAction2(false));
    }
  } catch (error) {
    yield put(getLoaderAction2(false));
    if (error.response.status != 500) {
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(setTheEmployeeDashboardAttedanceResults(error));
      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    } else {
      toast.error(` ${"something went wrong"} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}

function* setTheUserDetailsExportsSaga(payloads) {
  console.log(payloads, "payloads");
  // console.log(
  //   "sdoiudio",
  //   `{$baseurlforexport}/adminapp/userdetails/export/?&role_id=${payloads.payload.role_id}&export_type=${payloads.payload.export_type}`
  // );

  window.open(
    `${baseurlforexport}/adminapp/userdetails/export/?&role=${payloads.payload.role_id}&export_type=${payloads.payload.export_type}&user_id=${payloads.payload.user_id}`,
    "_blank",
  );
}

function* getTheQueryQuestionsData(payloads) {
  console.log(payloads, "payloajeyuiwyeuywds");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: QuesyQuestionsApi,
        params: {
          search: payloads.payload.search,
          page_size: payloads.payload.page_size,
          page: payloads.payload.page,
        },
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setTheQueryQuestionsResponses(response.data.data));
      yield put(getLoaderAction(false));
      yield put(setTheQueryQuestionTotalCounts(response.data.total_count));
    } catch (error) {
      yield put(setTheQueryQuestionsError(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* setTheQueryQuestionsDeleteSaga(payloads) {
  console.log(payloads, "payloads");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "delete",
        url: QuesyQuestionsApi + payloads.payload.DeleteId + "/",

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTheQueryQuestionsdeleteResponsive(response.data.data));

      toast.success(` ${response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      const content = {
        search: "",
        page_size: 20,
        page: payloads.payload.currentPage,
      };
      yield put(settheQueryQuestionActions(content));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheQueryQuestionsDeletError(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

/////------Query create
function* settheQueryCreatetionsSaga(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: QuesyQuestionsApi,
        data: payload.payload.Data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTheQueryQuestionsCreateResponsive(response.data.data));
      const content = {
        search: payload.payload.search,
        page_size: 20,
        page: payload.payload.currentPage,
      };
      yield put(settheQueryQuestionActions(content));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheQueryQuestionsCreateError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}

function* settheQueryActionRetrieve(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: QuesyQuestionsApi + payload.payload.EditID + "/",

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTheQueryQuestionsRetrieveResponsive(response.data.data));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheQueryQuestionsRetrieveError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* settheQueryActionEdit(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: QuesyQuestionsApi + payload.payload.EditID + "/",
        data: payload.payload.Data,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTheQueryQuestionsEditResponsive(response.data.data));

      const content = {
        search: payload.payload.search,
        page_size: 20,
        page: payload.payload.currentPage,
      };
      yield put(settheQueryQuestionActions(content));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheQueryQuestionsEditError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* getTheQuerySubQuestionsData(payloads) {
  console.log(payloads, "payloajeyuiwyeuywds");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: QuerySubQuestionsApi,
        params: {
          search: payloads.payload.search,
          page_size: payloads.payload.page_size,
          page: payloads.payload.page,
          parent: payloads.payload.parent,
        },
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setTheQuerySubQuestionsResponses(response.data.data));
      yield put(getLoaderAction(false));
      yield put(setTheQuerySubQuestionTotalCounts(response.data.total_count));
    } catch (error) {
      yield put(setTheQuerySubQuestionsError(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* settheSubQueryCreatetionsSaga(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: QuerySubQuestionsApi,
        data: payload.payload.Data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTheQuerySubQuestionsCreateResponsive(response.data.data));
      const content = {
        search: payload.payload.search,
        page_size: 20,
        page: payload.payload.currentPage,
        parent: payload.payload.parent_id,
      };
      yield put(settheQuerySubQuestionActions(content));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheQuerySubQuestionsCreateError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}

function* settheSubQueryActionEdit(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: QuerySubQuestionsApi + payload.payload.EditID + "/",
        // data: payload.payload.Data,
        data: {
          name: payload.payload.Data.name,
          description: payload.payload.Data.description,
          parent_id: payload.payload.parent_id,
          expire_time: payload.payload.Data.expire_time,
        },

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTheQuerySubQuestionsEditionsResponsive(response.data.data));
      const content = {
        search: payload.payload.search,
        page_size: 20,
        page: payload.payload.currentPage,
        parent: payload.payload.parent_id,
      };
      yield put(settheQuerySubQuestionActions(content));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheQuerySubQuestionsEditionError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* settheSUBQueryActionRetrieve(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: QuerySubQuestionsApi + payload.payload.EditID + "/",

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTheQuerySubQuestionsRetrieveResponsive(response.data.data));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheQuerySubQuestionsRetrieveError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* setTheQuerySUBQuestionsDeleteSaga(payloads) {
  console.log(payloads, "payloads");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "delete",
        url: QuerySubQuestionsApi + payloads.payload.DeleteId + "/",

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTheQuerySUbQuestionsdeleteResponsive(response.data.data));

      toast.success(` ${response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      const content = {
        search: "",
        page_size: 20,
        page: payloads.payload.currentPage,
        parent: payloads.payload.parent_id,
      };
      yield put(settheQuerySubQuestionActions(content));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheQuerySUbQuestionsDeletError(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///----GET-----THE----TRACKING---DATAS---------------

function* setTheTrackingDatasListSaga(payloads) {
  console.log(payloads, "payloajeyuiwyeuywds");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: TrackingrecordAPi,
        params: {
          search: payloads.payload.search,
          page_size: payloads.payload.page_size,
          page: payloads.payload.page,
          // day: payloads.payload.day,
          status: payloads.payload.selectVal.status,

          // year: payloads.payload.year,
          // month: payloads.payload.month,
          from_date: payloads.payload.from_date,
          to_date: payloads.payload.to_date,
          range: true,
        },

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(
        setTheTrackingrecordgetListDataResponses(response.data.data.data),
      );
      yield put(setTrackignRecordListDashboardReport(response.data.data));
      console.log(response.data.data.data, "23864928374983");
      yield put(getLoaderAction2(false));
      yield put(
        setTheTrackingrecordgetListDataTotalCounts(response.data.total_count),
      );
    } catch (error) {
      yield put(setTheQTrackingrecordgetListDatasError(error));
      yield put(getLoaderAction2(false));

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* getMyticketsListsaga(payloads) {
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: myTicketApi,
        params: payloads.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setTheMyticketsgetListDataResponses(response.data.data.data));
      yield put(setTheMyticketsinChartList(response.data.data));

      yield put(getLoaderAction2(false));
      yield put(setTheMyTicketsListDataTotalCounts(response.data.total_count));
    } catch (error) {
      yield put(setTheQMyTicketsListDatasError(error));
      yield put(getLoaderAction2(false));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}
///---tracking----retrieve----saga
function* setTheTrackingRetrieveSaga(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: TrackingrecordAPi + payload.payload.EditID + "/",

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(
        setTheQueryTrackingrecordgetListRetrieveResponsive(response.data.data),
      );

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheTrackingrecordgetListRetrieveError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///--tracking---editions--------------
function* setTheTrackingEdtionsSaga(payload) {
  console.log(payload, "selectVal");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "put",
      url: TrackingrecordAPi + payload.payload.EditID + "/",
      // data: {
      //   status: payload.payload.status,
      //   reason_for_decline: payload.payload.description,
      // },
      data: payload.payload.formDatas,

      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    const Content = {
      search: payload.payload.search,
      page_size: 20,
      page: payload.payload.currentPage,
      // day: payload.payload.day,
      selectVal: {
        status: payload.payload.selectVal.status,
      },
      // year: payload.payload.year,
      // month: payload.payload.month,
      to_date: payload.payload.to_date,
      from_date: payload.payload.from_date,

      range: true,

      // white_collar: payload.payload.white_collar,
    };
    yield put(settheTrackingrecordgetListDataActions(Content));
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(setTheTrackingEditionsResponsive(response.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));

    yield put(SettheTrackingEditionError(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}

///---tracking====delete saga
function* setTheTrackingDeleteSaga(payloads) {
  console.log(payloads, "payloads");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "delete",
        url: TrackingrecordAPi + payloads.payload.DeleteID + "/",

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTheTrackingdeleteResponsive(response.data.data));

      toast.success(` ${response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      const Content = {
        search: "",
        page_size: 20,
        page: payloads.payload.currentPage,
        // day: payloads.payload.day,
        selectVal: {
          status: payloads.payload.selectVal.status,
        },
        // year: payloads.payload.year,
        // month: payloads.payload.month,

        to_date: payloads.payload.to_date,
        from_date: payloads.payload.from_date,

        range: true,
      };

      if (payloads.payload.Mytickets != 1) {
        yield put(settheTrackingrecordgetListDataActions(Content));
      } else {
        const Content2 = {
          search: payloads.payload.search,
          page_size: 20,
          page: payloads.payload.currentPage,
          status: payloads.payload.selectVal.status,
          to_date: payloads.payload.to_date,
          from_date: payloads.payload.from_date,
          range: true,
        };

        yield put(settheMyTicketsDataActions(Content2));
      }
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheTrackingDeletError(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///--tracking---Apply--------------
function* setTheTrackingApplySaga(payload) {
  console.log(payload, "selectVal");
  try {
    yield put(getLoaderAction2(true));
    const response = yield axios({
      method: "post",
      url: TrackingrecordAPi,

      data: payload.payload.formDatas,

      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    // const Content = {
    //   search: payload.payload.search,
    //   page_size: 20,
    //   page: payload.payload.currentPage,
    //   status:payload.payload.selectVal.status,
    //   to_date: payload.payload.to_date,
    //   from_date: payload.payload.from_date,
    //   range: true,
    // };

    // // yield put(settheTrackingrecordgetListDataActions(Content));
    // yield put(settheMyTicketsDataActions(Content))
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(setTheTrackingEditionsResponsive(response.data));
    yield put(getLoaderAction2(false));
  } catch (error) {
    yield put(getLoaderAction2(false));

    yield put(setTheTrackingCreateError(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

//-Finance-----Calll

function* getFinanceDatas(payloads) {
  console.log(payloads, "payloajeyuiwyeuywds");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: FinancegetApi,
        params: payloads.payload.Params,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      // yield put(setThefinanceResponsiveDatas(response.data.data));
      if (payloads.payload.export_type == 1) {
        yield put(setThefinanceResponsiveDatas(response.data.data.data));
        yield put(setTheFinanceCountsDatas(response.data.data));
        yield put(setTheFinancetableTotal_Count(response.data.total_count));
      } else if (payloads.payload.export_type == 2) {
        yield put(setThefinanceResponsivePancardDatas(response.data.data.data));
        yield put(setTheFinanceCountsDatas(response.data.data));
        yield put(setTheFinancetableTotal_CountPan(response.data.total_count));
      } else if (payloads.payload.export_type == 3) {
        yield put(
          setThefinanceResponsiveWhatsapppDatas(response.data.data.data),
        );
        yield put(setTheFinanceCountsDatas(response.data.data));
        yield put(
          setTheFinancetableTotal_CountwhatsApp(response.data.total_count),
        );
      } else if (payloads.payload.export_type == 4) {
        yield put(setThefinanceResponsiveBankDatas(response.data.data.data));
        yield put(setTheFinanceCountsDatas(response.data.data));
        yield put(setTheFinancetableTotal_CountBank(response.data.total_count));
      }

      yield put(getLoaderAction2(false));
    } catch (error) {
      yield put(getLoaderAction2(false));
      if (error.response.status != 500) {
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
        yield put(setTheFinanceErrorResponse(error));
        if (error.response.data.status.code == 401) {
          localStorage.clear();
          window.location.href = "/";
        }
      } else {
        toast.error(` ${"something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

// function* getFinanceFOREXPORTDatas(payloads) {
//   if (payloads != undefined) {
//     try {
//       yield put(getLoaderAction(true));
//       const response = yield axios({
//         method: "get",
//         url: FinancegetApi,
//         params: payloads.payload,
//         headers: {
//           Authorization:
//             "Bearer " + store.getState().users.UserData.session.token,
//         },
//       });
//        console.log(response.data.data , "data" );
//       yield put(setThefinanceResponsiveExportDatas(response.data.data));
//       yield put(getLoaderAction(false));
//     } catch (error) {
//       yield put(setTheFinanceErrorExportResponse(error));
//       yield put(getLoaderAction(false));

//       if (error.response.data.status.code == 401) {
//         console.log("401 erweu", error.response.data.status.code);

//
//         localStorage.clear();
//         window.location.href = "/";
//       }
//     }
//   }
// }

function* getFinanceFOREXPORTDatas(payloads) {
  window.open(
    `${FinancegetApi}?&return_type=${payloads.payload.return_type}&export_type=${payloads.payload.export_type}`,
    "_blank",
  );
}

function* gettheDahboardAttendanceData(payloads) {
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: AttendaceReportApi,
        params: payloads.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      // yield put(setThefinanceResponsiveDatas(response.data.data));
      yield put(setTheAttendanceReportResponsiveDatas(response.data.data));

      yield put(getLoaderAction2(false));
      yield put(setTheAttendanceReportTotal_Count(response.data.total_count));
    } catch (error) {
      yield put(setTheAttendanceReportErrorResponse(error));
      yield put(getLoaderAction2(false));

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* OnboaderDetailsLsit(payloads) {
  //  console.log(payloads , "payloads9821");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: Userlist,
      params: payloads.payload,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(setTheOnboarderDetailsResponsiveDatas(response.data.data));
    yield put(setTheAuthrorzedToatalCounts(response.data.total_count));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(setTheOnboaderdetailsReportErrorResponse(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

////---other----party---apis

///--id---verifycation another api implementations

function* getidverificationanotherAPIsagaCall(payload) {
  // console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: idverificationanotherApi,
        // data: {
        //   doc_type: payload.payload.doc_type,
        //   req_id: payload.payload.req_id,
        //   doc_base64: payload.payload.doc_base64,
        // },
        data: payload.payload.fromdata,
        // headers: {
        //   token: "9a74f6c4f1673b90f52fedb74bd0af4c",
        // },
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      console.log(response, "response98237", response.data.data);
      // if (response.data.image_quality == "NA") {
      //   toast.error(` ${"Poor Image Quality"} `, {
      //     position: toast.POSITION.TOP_RIGHT,
      //   });

      if (response.data.data.image_quality == "NA") {
        toast.error(` ${"Poor Image Quality"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });

        toast.error(` ${response.data.data.error_message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });

        yield put(setIDverifycationanotherapidatasReponsesError("NA"));
      }

      if (response.data.data.error_message == "") {
        // toast.success(` ${response.data.status.message} `, {
        //   position: toast.POSITION.TOP_RIGHT,
        // });

        if (payload.payload.Imagetype == 1) {
          if (response.data.data.image_quality != "NA") {
            yield put(
              setTheAadharFristNumbers(
                response.data.data.extracted_data.aadhar_id.replace(/\s/g, ""),
              ),
            ); /// first image in aadhar number
            // yield put(
            //   setTHnUMBERSRESPONSES(
            //     response.data.data.extracted_data.aadhar_id.replace(/\s/g, "")
            //   )
            // ); // second page in aadhar number

            yield put(
              setTheAadharFrontImageDatas(response.data.data.extracted_data),
            ); /// first image
          }
        }

        if (payload.payload.Imagetype == 2) {
          if (response.data.data.image_quality != "NA") {
            yield put(
              setTHnUMBERSRESPONSES(
                response.data.data.extracted_data.aadhar_id.replace(/\s/g, ""),
              ),
            ); // second page in aadhar number

            yield put(
              setTheAadharBackSideImageDatas(response.data.data.extracted_data),
            ); ///second
          }
        }

        // yield put(
        //   settheIDverifycationanotherapidatasResponse(
        //     response.data.extracted_data
        //   )
        // );
      } else if (response.data.error_message != "") {
        toast.error(` ${response.data.error_message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      // console.log(
      //   response.data,
      //   "sadasdasdas",
      //   response.data.error_message,
      //   response.data.error_message == "" ? true : false
      // );

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      if (error.response.status != 500) {
        yield put(setIDverifycationanotherapidatasReponsesError(error));

        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });

        if (error.response.data.status.code == 401) {
          localStorage.clear();
          window.location.href = "/";
        }
      } else {
        toast.error(` ${"something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* settheOtherpartyAPIforPanCardsSAGA(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: idverificationanotherApi,
        // data: {
        //   doc_type: payload.payload.doc_type,
        //   req_id: payload.payload.req_id,
        //   doc_base64: payload.payload.doc_base64,
        // },
        data: payload.payload.fromdata,
        // headers: {
        //   token: "9a74f6c4f1673b90f52fedb74bd0af4c",
        // },
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      // console.log(response.data.data.extracted_data , "extracted_data", response.data.data.extracted_data , "data.data.extracted_data");

      if (response.data.data.extracted_data.pan_no) {
        toast.success(` ${"successfully Pan Card Image is Scaned"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });

        yield put(
          setTheOtherPartyApiResponsesActions(
            response.data.data.extracted_data,
          ),
        );
      } else if (!response.data.data.extracted_data.pan_no) {
        toast.error(` ${"Please upload valid pan card"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      yield put(getLoaderAction(false));

      if (response.data.data.image_quality == "NA") {
        toast.error(` ${"Poor Image Quality"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
        toast.error(` ${response.data.data.error_message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      //        if (response.data.data.extracted_data.pan_no &&response.data.data.image_quality != "NA") {
      //         const aadhartop = {
      //           data: response.data.data.extracted_data.pan_no,
      //         };

      //          yield put(setThePANCARDeportActions(aadhartop))
      // yield put(setThPanVerifyCounts(payload.payload.count +1))
      //       }

      // console.log(response.data, "sadasdasdas");
    } catch (error) {
      yield put(setTheotherAPtyApiInErrorMsg(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///----PassBook---Or----Checque-Leaf-000verified---

function* getPassbookorChequesSagas(payload) {
  console.log(payload, "asdasdasSASsdas");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const names = payload.payload.cheque ? "cheque" : "passbook";

      const response = yield axios({
        method: "post",
        url: passbookDatatretrieve,
        data: payload.payload.passBookFormdata,
        params: {
          file_type: names,
        },
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
          "content-type": "multipart/form-data",
        },
      });

      console.log(response.data.data, "sadasdasdas", response);
      // toast.success(`Bank verified successfully `, {
      //   position: toast.POSITION.TOP_RIGHT,
      // });

      // yield put(setTheDataAsEncodedDataResponses(innerParsedJson));
      yield put(setTheDataAsEncodedDataResponses(response.data.data));

      yield put(getLoaderAction(false));
      yield put(setThePassBookActionsErrorrs(""));
    } catch (error) {
      yield put(getLoaderAction(false));
      if (error.response.status != 500) {
        yield put(setThePassBookActionsErrorrs(error));

        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });

        if (error.response.data.status.code == 401) {
          window.location.href = "/";
          localStorage.clear();
        }
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

///---send---otp----for the approve---aadhar--phone number
function* CallOtherPartyaadharsendOtpApi(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: aadharsendOtpToNumberApi,
        data: {
          aadhaarNumber: payload.payload.data,
        },

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
          "content-type": "multipart/form-data",
        },
      });
      yield put(setTheOtherPartyApiAADharReponse(response.data.data));
      if (response.data.data) {
        yield put(setTheClient_id(response.data.data.data?.reference_id));
        toast.success(` ${response.data?.status?.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      console.log(response, "response");
      if (response.data.data.code == 500) {
        if (response.data.data.message) {
          toast.error(` ${response.data.data.message} `, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      }

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      if (error.response.status != 500) {
        yield put(settheAAdharPhoneNumberOtpSend(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });

        if (error.response.data.status.code == 401) {
          window.location.href = "/";
          localStorage.clear();
        }
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* CallOtherpartysubmitACtions(payload) {
  console.log(payload, "payload");
  const formdata = new FormData();
  const counts = 0;
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: SubmitOTPAADHARVERIFIEDApi,
      data: payload.payload.datas,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
        "content-type": "multipart/form-data",
      },
    });
    yield put(setTheAadharsendthesubmitotpResponsiveDatas(response.data.data));
    console.log("response.data", response, payload.payload.basisdata);
    if (typeof payload.payload.Funcations === "function") {
      payload.payload.Funcations();
    }
    const formatDOB = (dob) => {
      if (!dob) return null;

      // If format is DD-MM-YYYY
      const parts = dob.split("-");
      if (parts.length === 3) {
        const [dd, mm, yyyy] = parts;
        return `${yyyy}-${mm}-${dd}`; // convert to YYYY-MM-DD
      }

      return null;
    };

    let normalData = {
      first_name: response.data.data?.data?.name
        ? response.data.data?.data?.name
        : null,
      date_of_birth: response.data.data?.data?.date_of_birth
        ? formatDOB(response.data.data?.data?.date_of_birth)
        : null,
      gender: payload.payload.basisdata.gender,
      aadhar_number: payload.payload.basisdata.aadhar_number,
      client_id: payload.payload.basisdata.client_id,
      role_id: payload.payload.basisdata.role_id,
      aadhar_count: payload.payload.basisdata.aadhar_count,
      aadhar_front_count: payload.payload.basisdata.aadhar_front_count,
      aadhar_transaction_id: payload.payload.basisdata.aadhar_transaction_id,
      email_id: payload.payload.basisdata.email_id,
      blood_group: payload.payload.basisdata.blood_group,
      place_of_birth: payload.payload.basisdata.place_of_birth,
      emergency_contact_number:
        payload.payload.basisdata.emergency_contact_number,
      religion: payload.payload.basisdata.religion,
      personal_identification_mark:
        payload.payload.basisdata.personal_identification_mark,
      aadhar_front: payload.payload.aadhar_front,
      user_image: payload.payload.user_image,
    };
    const responseDatas = {
      form_data: normalData,
      Retieveid: payload.payload.Retieveid,
    };
    // console.log(responseDatas, "responseDatas874");
    toast.success(` ${response.data?.status?.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    yield put(setTheSumbitOtpFormsAadhar_verified(true));
    if (payload.payload.Id == "") {
      yield put(SetActionsBasicFormscreateDetails(responseDatas));
    } else if (payload.payload.Id != "") {
      const responseEdit = {
        form_data: normalData,
        Retieveid: payload.payload.Id,
        Movedno: "2",
      };

      yield put(SetActionsBasicFormsEditDetails(responseEdit));
    }
    // yield put(setTheAadhar_front_count(counts + 1));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(setTheaadharsubmitotpErrReportErrorResponse(error));
    yield put(setTheSumbitOtpFormsAadhar_verified(false));

    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

///--pan---card

function* CallOtherPartyPANCARDsendOtpApi(payload) {
  console.log(payload, "payload");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: Pancardsendotpapi,
      data: {
        panNumber: payload.payload.data,
      },
      //   headers: {
      //     "Content-Type": "application/json",
      //     // secretKey:
      //     //   "OGen9DgGlg3FIo56kacmNqqtkt7urmF2z8MubtyUjKYe79DcPSztNFFQ75WeEdqF6",
      //     // clientId:
      //     //   "13c06fc10d67e5cbfcbc632e78c84da2:59b602c2756ff95e57396c0d373d335b",
      //    // new keys
      //    secretKey:
      //    "OGen9DgGlg3FIo56kacmNqqtkt7urmF2z8MubtyUjKYe79DcPSztNFFQ75WeEdqF6",
      //  clientId:
      //    "13c06fc10d67e5cbfcbc632e78c84da2:59b602c2756ff95e57396c0d373d335b",

      //     ///-----live
      //     // clientId:
      //     //   "60526ee281de4f01a95920aa0251895c:f60b22d4988d0466dfccdbda6f4578af",
      //     // secretKey:
      //     //   "ac2QVpXhJk9KX6Og1BrUkETpZU7xFCn7aS7I84O8MWeBYBtiooRgEWoYerrgo6dpd",
      //   },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    console.log(response.data.data, "123response");
    if (response.data.data.code == 200) {
      yield put(setThePANCARDotpResponsiveDatas(true));
      yield put(setThePANCARDVerifyDatas(response.data.data));
      toast.success(`Pan card verified successfully `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else if (response.data.data.code != 200) {
      yield put(setThePANCARDotpResponsiveDatas(false));

      // yield put(setThePANCARDotpResponsiveDatas(true));
      if (response.data.data.message) {
        toast.error(` ${response.data.data.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
    yield put(setThPanVerifyCounts(payload.payload.count + 1));

    console.log(response, "response");
    // if (response.code == 200) {
    // yield put(setTheCLientID(response.data.result.data.client_id));

    // }

    if (
      response.data.data.code == 400 ||
      response.data.data.code == 500 ||
      response.data.data.code == 502
    ) {
      toast.error(` ${response.data.data.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }

    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(setThePANCARDrrReportErrorResponse(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}

function* PANCARDSUBMITOTPVeried(payload) {
  // console.log(payload, "payload");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: Pancardsendotpapi,
      data: payload.payload.datas,
      headers: {
        "Content-Type": "application/json",
        secretKey:
          "OGen9DgGlg3FIo56kacmNqqtkt7urmF2z8MubtyUjKYe79DcPSztNFFQ75WeEdqF6",
        clientId:
          "13c06fc10d67e5cbfcbc632e78c84da2:59b602c2756ff95e57396c0d373d335b",
      },
    });
    yield put(setThePANCARDotpSUBMITResponsiveDatas(response.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(setThePANCARDSUBMITOTPResponse(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}

///--create--token---for--penny drop

function* CreateTokenPennydrop(payload) {
  // console.log(payload, "payload");
  const bankverifyeddatas = {
    data: payload.payload.data,
    phone_number: payload.payload.phone_number,
  };

  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: createTokenPennyapi,
      // data: payload.payload.datas,
      headers: {
        accept: "application/json",
        "x-api-key": "key_test_T7pKWzgSuP4EqWdMxBoFvoWWDV5DDZPD",
        "x-api-secret": "secret_test_iBOaz6zsBLo0NdW1hA0IcaWtkkrALyXb",
        // "x-api-version":"3"
      },
    });
    yield put(Createtoken_store(response.data.access_token));
    yield put(getLoaderAction(false));

    // yield put(BankVerifyActions(bankverifyeddatas));
  } catch (error) {
    yield put(createToken_store_erro_reposen(error));
    yield put(getLoaderAction(false));
    // toast.error(` ${error.response.data.status.message} `, {
    //   position: toast.POSITION.TOP_RIGHT,
    // });
  }
}

///----bank---verified----drop

function* BanlVerifiyedPennydrop(payload) {
  console.log(payload, "payload");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: bankPennyDropapi,
      //   +
      //   "/bank/" +
      //   payload.payload.data.ifsc_code +
      //   "/accounts" +
      //   payload.payload.data.account_number +
      //   "/",
      // params: {
      //   verify: payload.payload.data.account_holder_name,
      //   mobile: payload.payload.phone_number,
      // },
      data: {
        ifsc_code: payload.payload.data.ifsc_code,
        account_number: payload.payload.data.account_number,
        account_holder_name: payload.payload.data.account_holder_name,
        phone_number: payload.payload.phone_number,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    console.log(response, "93028408response");

    console.log(
      response,
      response.data.data.transaction_id,
      "setTheTransactionID",
      response.data.data.code == 200,

      response.data.data.data,
      response.data.data.code != 200,
      response.data.data.data,
    );

    if (response.data.data.code == 200) {
      toast.success(` ${response.data.data.data.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (response.data) {
        if (response.data.data) {
          if (response.data.data.data.account_exists == true) {
            yield put(CreateResponse_store(true));
            yield put(setbankCounts(payload.payload.count + 1));
          } else if (response.data.data.data.account_exists == false) {
            yield put(CreateResponse_store(false));
            yield put(setbankCounts(payload.payload.count + 1));
          }
        }
      }

      if (response.data.data.transaction_id) {
        yield put(setTheTransactionID(response.data.data.transaction_id));
      }

      if (response.data.data) {
        if (response.data.data.data) {
          yield put(setTheAccountExit(response.data.data.data.account_exists));

          if (response.data.data.data.name_at_bank) {
            yield put(
              settheBankHolderName(
                response.data.data.data.name_at_bank.toUpperCase(),
              ),
            );
          }
        }
      }
    }

    // if (response.data.data.data) {
    //   toast.error(` ${response.data.data.data.status.message} `, {
    //     position: toast.POSITION.TOP_RIGHT,
    //   });
    // }

    if (response.data.data.code != 200) {
      toast.error(` ${response.data.data.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(CreateResponse_store(false));
      if (response.data.data) {
        if (response.data.data.data) {
          toast.error(` ${response.data.data.data.message} `, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      }
    }

    //  if(response.data.data.data){

    //   toast.error(` ${response.data.data.data.message} `, {
    //     position: toast.POSITION.TOP_RIGHT,
    //   });

    //  }

    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));
    if (error.response.status != 500) {
      yield put(createBankverifyed_store_error_reposen(error));
      yield put(CreateResponse_store(false));
    } else {
      yield put(CreateResponse_store(false));

      toast.error(` ${" something went wrong"} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}

function* SuperviorsgetEmployeeeLists(payloads) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: SuperviorsListPutorRemove,
      params: {
        search: payloads.payload.search,
        client_id: payloads.payload.client_id,
        type: payloads.payload.type,
        page_size: 20,
        page: 1,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(
      setTheSuperviorsListEmploeyeeActionsResponses(response.data.data),
    );
    yield put(getLoaderAction(false));
    yield put(setTheSuperviorsTotal_counts(response.data.total_count));
  } catch (error) {
    yield put(setTheSuperviorsListErrorEmployeeeReponses(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

//---report----datas-

function* gettheReportdatassagaSheetexport(payloads) {
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: reportgetdatasapi,
        params: payloads.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(getRoportdatsListSuccessResponseActions(response.data.data));
      yield put(getLoaderAction(false));
      yield put(getRoportsTotal_pageCounst(response.data.total_count));
      //  console.log(response.data.total_count , "238472387");
    } catch (error) {
      yield put(getRoportDatsListErroResponsen(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

//--report---post
function* getreportSheetexportPOst(payloads) {
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: reportgetdatasapi,
        data: payloads.payload.data,
        // params: payloads.payload.params,
        params: payloads.payload.paramsdata.params,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(getRoportpostListSuccessResponseActions(response.data.data));
      yield put(getRoportDatasActions(payloads.payload.callactions));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));

      if (error.response.status != 500) {
        yield put(getRoportPostListErroResponsen(error));
        // some report APIs return a flat { message } instead of { status: { message } }
        toast.error(
          ` ${error.response.data?.status?.message || error.response.data?.message} `,
          {
            position: toast.POSITION.TOP_RIGHT,
          },
        );

        if (
          (error.response.data?.status?.code || error.response.status) == 401
        ) {
          console.log("401 erweu", error.response.data.status.code);

          localStorage.clear();
          window.location.href = "/";
        }
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

///---Custom---UDs---Employe-----role----login

///----------------Login----Call
function* getTheUDSEmployeeLogin(payload) {
  // console.log(
  //   payload,
  //   "payload39809284",
  //   payload.payload.valid == 2 ? udsLoginAPI : UDSEmployeeSentoptapi
  // );
  console.log(payload, "ASASASAS jgjh ");

  try {
    yield put(getLoaderAction(true));

    const response = yield axios({
      method: "post",
      url: payload.payload.api == 1 ? udsLoginAPI : UDSEmployeeSentoptapi,
      data: payload.payload.logindata,
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    console.log(response.data, "ioaudaiasd response.data");
    if (payload.payload.dashboard != 2) {
      yield put(settheCustomerUDSemployeeloginresponse(response.data));
      if (response.data != undefined && response.data.session) {
        localStorage.setItem("tokenUDS", response.data.session.token);
        yield put(setTheUDSAttendanceTOKEN(response.data.session.token));
        localStorage.setItem("token", response.data.session.token);
        localStorage.setItem("websiteversion", requiredVersion);

        //  console.log(response.data.session.token , "027340289374guresponse.data");
      }
      if (response.data.data.data.user_image != null) {
        yield put(
          setTheudsEmployeeImage(response.data.data.data.user_image.media_url),
        );
      }

      // yield put(setTheIdOne(2));
    }
    if (payload.payload.dashboard == 1) {
      localStorage.setItem("loginUdsEmployee", "false");
      // localStorage.setItem("loginUds", "true");
      yield put(getUserSuccessAction([]));
      // window.location.href = "/customudsdashboard";
      yield put(getSideBarfilesActions("HOME"));
    } else {
      yield put(setTheUdsLoginPagechange(2));
    }

    yield put(getLoaderAction(false));
  } catch (error) {
    localStorage.setItem("loginUdsEmployee", "true");

    // localStorage.setItem("loginUds", "false");
    localStorage.clear();
    yield put(getLoaderAction(false));

    yield put(settheCustomerUDSEmployeeErroMsg(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}

function* getTheOtpUDSEmployee(payload) {
  try {
    yield put(getLoaderAction(true));

    const response = yield axios({
      method: "post",
      url: UDSEmployeeSentoptapi,
      data: payload.payload,
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(settheCustomerUDSemployeeSendOTPresponse(response.data));

    localStorage.setItem("loginUdsEmployee", "false");

    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(settheCustomerUDSEmployeeErroMsgSendOtp(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    yield put(getLoaderAction(false));
  }
}

////------AttenDance---Datas----------------------------
function* RequestCheckInOutSaga(payload) {
  console.log(payload, "laksjdfkjasjdfjasljdfljkasldjkf123123123");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      // method: "post",
      method: "post",
      url: requestCheckInOut,
      data: payload.payload.form_data,
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });
    yield put(SetCheckInOutSuccessResponse(response.data.data));
    yield put(SetTheShiftDatasActions());
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    yield put(getLoaderAction(false));

    setTimeout(() => {
      if (payload.payload.Navigatedto == 1) {
        window.location.href = "/customudsdashboard";
      }
      if (payload.payload.Navigatedto == 2) {
        if (typeof payload.payload.Funcations === "function") {
          payload.payload.Funcations();
        }
      }
    }, 1000);
  } catch (error) {
    yield put(SetCheckInOutError(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
  }
}

function* RequestCheckInpUTmETHOSOutSaga(payload) {
  console.log(payload, "laksjdfkjasjdfjasljdfljkasldjkf123123123");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      // method: "post",
      method: "put",
      url: requestCheckInOut + payload.payload.id + "/",
      data: payload.payload.form_data,
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });
    yield put(SetCheckInOutSuccessputmethodResponse(response.data.data));
    yield put(SetTheShiftDatasActions());
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(getLoaderAction(false));

    setTimeout(() => {
      if (payload.payload.Navigatedto == 1) {
        window.location.href = "/customudsdashboard";
      }
      if (payload.payload.Navigatedto == 2) {
        if (typeof payload.payload.Funcations === "function") {
          payload.payload.Funcations();
        }
      }
    }, 1000);
  } catch (error) {
    yield put(SetCheckInOutErrorputmethod(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
  }
}

////-------Reimbursement--Datas----------------------------
function* GetReimbursementPermission(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: Reimbursement,
      params: {
        page_size: payload.payload.page_size,
        page: payload.payload.page,
        status: payload.payload.status,
        search: payload.payload.search,
        user: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
          .id,
      },
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });
    yield put(SetFetchReimbursementEMPSuccessResponse(response.data.data));
    yield put(SetFetchReimbursementEMPResponse(response.data.data.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(SetFetchReimbursementEMPError(error));
    yield put(getLoaderAction(false));

    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
  }
}

function* reimbursementEmpSaga(payload) {
  console.log(payload, "laksjdfkjasjdfjasljdfljkasldjkf123123123");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: Reimbursement,
      data: payload.payload.formdatas,
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });

    yield put(
      SetFetchReimbursementEMPCreateSuccessResponse(response.data.data),
    );
    toast.success("Apply Successfully.", {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(getLoaderAction(false));
    yield put(SetFetchReimbursementEMPAction(payload.payload.GetFilter));
    // window.location.href = "/employment";
  } catch (error) {
    yield put(SetFetchReimbursementCreateEMPError(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}

////------Shify---Datas----------------------------
function* LeaveTypeDataSaga(payloads) {
  console.log(payloads, "payloads.payloadpayloads.payloadpayloads.payload");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: leaveType,
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });
    yield put(getLoaderAction(false));
    yield put(SetLeaveTypeDataresponse(response.data.data));
  } catch (error) {
    yield put(setLeaveTypeDataError(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
  }
}

///--Employee onduty
function* getTheEmployeeOnduty(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: onDuty,
      params: {
        page_size: payload.payload.page_size,
        page: payload.payload.page,
        status: payload.payload.status,
        search: payload.payload.search,
        user: payload.payload.user,
      },
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });
    // SetOndutyEmployeetotalcountDataresponse
    console.log(response, "we908rnresponse");

    yield put(SetOndutyEmployeeDataresponse(response.data.data.data));
    yield put(
      SetOndutyEmployeetotalcountDataresponse(response.data.total_count),
    );
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(setOndutyEmployeeDataError(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
  }
}
////------Create On Duty---Data----------------------------
function* CreateOnDutySagaEmp(payload) {
  console.log(payload, "laksjdfkjasjdfjasljdfljkasldjkf123123123");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: onDuty,
      data: payload.payload.data,
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });

    yield put(SetOndutyEmployeeDataCreateresponse(response.data.data));
    toast.success("OnDuty apply Successfully.", {
      position: toast.POSITION.TOP_RIGHT,
    });
    yield put(SetTheOnDutyDatasActions(payload.payload.GetFilters));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(setOndutyEmployeeDataCreateError(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}

///--Employee permission get list
function* getTheEmployeePermissionGetlist(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: AttendanceAvailablePermission,
      params: {
        page_size: payload.payload.page_size,
        page: payload.payload.page,
        status: payload.payload.status,
        search: payload.payload.search,
        user: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
          .id,
      },
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });
    // SetOndutyEmployeetotalcountDataresponse
    console.log(response, "we908rnresponse", response.data.data.data.data);

    yield put(
      SetAttendancePermissiongetlistempResponse(response.data.data.data.data),
    );
    yield put(
      setTheAttendancePermissiongetListempTotal_counts(
        response.data.data.data.data.length + 1,
      ),
    );
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(setTheAttendancePermissiongetlistempDatasError(error));
    yield put(getLoaderAction(false));

    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
  }
}

///----employeee premissison---create
function* PermissionCreateForEmployeee(payload) {
  console.log(payload, "laksjdfkjasjdfjasljdfljkasldjkf123123123");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: AttendanceAvailablePermission,
      data: payload.payload.data,
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });

    yield put(SetCreatePermissionEmpSuccessResponse(response.data.data));
    toast.success("Permisssion apply Successfully.", {
      position: toast.POSITION.TOP_RIGHT,
    });
    yield put(
      SetTheAttendancegetlistempPermissionDatasActions(
        payload.payload.GetFilters,
      ),
    );
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(SetCreatePermissionEmpError(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}

//---Regularization
function* getTheEmployeeRegularizationGetlist(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: RegularizationApis,
      params: {
        page_size: payload.payload.page_size,
        page: payload.payload.page,
        status: payload.payload.status,
        search: payload.payload.search,
        user: payload.payload.user,
        request_type: payload.payload.request_type,
      },
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });
    // SetOndutyEmployeetotalcountDataresponse
    console.log(response, "diouasd oiasudisad", response.data.data);

    yield put(SetAttendanceRegularizationlistempResponse(response.data.data));
    yield put(
      setTheAttendanceRegularizationListempTotal_counts(
        response.data.total_count,
      ),
    );
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(setTheAttendanceRegularizationlistempDatasError(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
  }
}

function* gettheprofiledataslist(payloads) {
  console.log(payloads, "payloads.payloadpayloads.payloadpayloads.payload");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url:
        EmpProfileapi +
        store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data.id +
        "/",
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });
    yield put(getLoaderAction(false));
    console.log(response, "asdsdresponse");

    yield put(setTheEmpProfileGetAttendanceProfileResponse(response.data.data));
  } catch (error) {
    yield put(settheprofileErrorEmpAttendancemethod(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
  }
}

function* updatedEmpProfileImagesSaga(payload) {
  console.log(payload, "lkaslfjjasfk");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "put",
      url: EmpProfileapi + payload.payload.id + "/",
      data: payload.payload.form_data,
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });

    yield put(
      setTheEmpProfileGetAttendanceupdateProfileResponse(response.data.data),
    );
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(settheprofileErrorEmpUpdateAttendancemethod(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
  }
}

////------AttenDance---Datas----------------------------
function* AttendanceRegularizationcreates(payload) {
  console.log(payload, "lkaslfjjasfk");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: RegularizationApis,
      data: payload.payload.formData,
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });

    yield put(
      SetCreateAttendanceRegularizationEmpSuccessResponse(response.data.data),
    );
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(getLoaderAction(false));
    if (payload.payload.Requesttype == 1) {
      yield put(settheOvertimeRegulrizationActions(payload.payload.GetFilters));
    } else if (payload.payload.Requesttype == 2) {
      yield put(
        SetTheAttendancegetlistempRegularizationDatasActions(
          payload.payload.GetFilters,
        ),
      );
    }
  } catch (error) {
    yield put(SetCreateAttendanceRegularizationEmpError(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
  }
}

////----Face Verifications
function* FaceVerificationStatusSaga(payload) {
  console.log(payload, "lkaslfjjasfk");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: FaceVerificationApi,
      data: payload.payload.formData,
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });

    console.log(response, "osa98sd asudaisd response");

    yield put(
      SetCheckInOutSuccessFaceVerificationmethodResponse(response.data.data),
    );
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(getLoaderAction(false));
    if (payload.payload.Methods == true) {
      const payloadput = {
        form_data: payload.payload.DATAS,
        Post: payload.payload.form_data.Post,
        id: payload.payload.form_data.id,
        Navigatedto: payload.payload.Navigatedto,
        Funcations:
          payload.payload.Navigatedto == 2 ? payload.payload.Funcations : 1,
      };

      // dispatch(SetCheckInOutAction(payload));
      yield put(SetCheckInOutputMethosAction(payloadput));
    } else if (!payload.payload.Methods) {
      const payloadpost = {
        form_data: payload.payload.DATAS,
        Post: payload.payload.form_data.Post,
        Navigatedto: payload.payload.Navigatedto,
        Funcations:
          payload.payload.Navigatedto == 2 ? payload.payload.Funcations : 1,
      };
      yield put(SetCheckInOutAction(payloadpost));
    }
  } catch (error) {
    yield put(SetCheckInOutFaceVerificationErrorputmethod(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
  }
}

//---Regularization
function* getheemployeeOvertimeRegularizations(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: RegularizationApis,
      params: {
        page_size: payload.payload.page_size,
        page: payload.payload.page,
        status: payload.payload.status,
        search: payload.payload.search,
        user: payload.payload.user,
        request_type: payload.payload.request_type,
      },
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });
    // SetOndutyEmployeetotalcountDataresponse
    console.log(response, "diouasd oiasudisad", response.data.data);

    yield put(settheOvertimeRegularizationsResponseStore(response.data.data));
    yield put(
      setTheOvertimeRegularizationListempTotal_counts(
        response.data.total_count,
      ),
    );
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(settheOvertimRegularizationErrorMsg(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
  }
}

//--hELP= desk
function* gettheHelpDeskEmpSAGA(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: helpdeskGet,
      params: {
        page_size: payload.payload.page_size,
        page: payload.payload.page,
        status: payload.payload.status,
        search: payload.payload.search,
        user: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
          .id,
      },
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });
    // SetOndutyEmployeetotalcountDataresponse
    console.log(response, "we908rnresponse");

    yield put(SetHelpEmployeeDataresponse(response.data.data));
    yield put(SetHelpEmployeetotalcountDataresponse(response.data.total_count));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(setHelpEmployeeDataError(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
  }
}

///----BlockEmployyye
function* GettheBlockEmployeegetListSaga(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: getBlockListApi,
      params: {
        page_size: payload.payload.page_size,
        page: payload.payload.page,
        status: payload.payload.status,
        search: payload.payload.search,
        type: payload.payload.type,
      },
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });
    // SetOndutyEmployeetotalcountDataresponse

    if (payload.payload.Popup == 0) {
      yield put(SetEmployeeEmpGetListEmpDataresponse(response.data.data));
    } else {
      yield put(setTheBlockEmployeelistDatasForPopup(response.data.data));
    }

    yield put(
      SetEmpEmpGetBlockEMPtotalcountDataresponse(response.data.total_count),
    );
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(setEmpBlockEmpGetEMPDataError(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
  }
}

function* gettheUnblockedEmployeesList(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: getUnBlockListApi,
      params: {
        page_size: payload.payload.page_size,
        page: payload.payload.page,
        status: payload.payload.status,
        search: payload.payload.search,
        type: payload.payload.type,
      },
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });
    // SetOndutyEmployeetotalcountDataresponse

    yield put(SetUnbloackedEmployeesEmpDataresponse(response.data.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(setEmpUnbloackedEmployeesEMPDataError(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
  }
}

///---create block
function* CreateTheBlockSagaEm(payload) {
  console.log(payload, "lkaslfjjasfk");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: getBlockListApi,
      data: payload.payload.data,
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });

    yield put(SetEmployeeEmppostListEmpDataresponse(response.data.data));
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    yield put(getLoaderAction(false));
    window.location.reload();
  } catch (error) {
    console.log(error, "Block list error");

    yield put(setEmpBlockEmppostEMPDataError(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
  }
}

///--SITE TRANSFER
function* getTheSiteTransferEmpSlice(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: sitetransferapi,
      params: {
        page_size: payload.payload.page_size,
        page: payload.payload.page,
        status: payload.payload.status,
        search: payload.payload.search,
      },
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });
    // SetOndutyEmployeetotalcountDataresponse
    console.log(response, "we908rnresponse");

    yield put(SetEmployeesitetransferListEmpDataresponse(response.data.data));
    yield put(
      SetEmpEmpGesiteTransferEMPtotalcountDataresponse(
        response.data.total_count,
      ),
    );
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(setEmpsiteTransferEmpGetEMPDataError(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
  }
}

function* GETTHECLIENTBRANCHforsitetransfersaga(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: ToclientBranchApi,
      params: {
        page_size: payload.payload.page_size,
        page: payload.payload.page,
        status: payload.payload.status,
        search: payload.payload.search,
      },
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });
    yield put(SetEmployeeClientBrancheListEmpDataresponse(response.data.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(setEmpClientBranchForEmpDataError(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
  }
}

function* gettheSiteTransferSagaCreate(payload) {
  console.log(payload, "lkaslfjjasfk");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: sitetransferapi,
      data: payload.payload.data,
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });

    console.log(response, "osa98sd asudaisd response");

    yield put(
      SetEmployeesitetransferListCreateEmpDataresponse(response.data.data),
    );
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(getLoaderAction(false));
    const payloadsstieget = {
      page: payload.payload.PageIndex,
      search: payload.payload.search,
      page_size: 20,
    };

    yield put(setEmpsiteTransferGetlistEmpEmpAction(payloadsstieget));
  } catch (error) {
    yield put(setEmpsiteTransferEmpCreateMPDataError(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
  }
}

function* settheReginationSaga(payload) {
  console.log(payload, "lkaslfjjasfk");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: empResign,
      data: payload.payload.formData,
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });

    console.log(response, "osa98sd asudaisd response");

    yield put(setTheResignationsForEmp(response.data.data));
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(getLoaderAction(false));

    window.location.href = "/resignemp";
  } catch (error) {
    yield put(setTheResignationForEMpError(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
  }
}

///--parent
function* settheParenthelpdeskSagaEmp(payload) {
  console.log(payload, "lkaslfjjasfk");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: ParentForHelpApi,
      params: payload.payload,
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });

    console.log(response, "osa98sd asudaisd response");

    yield put(SettrackingparentEmployeeDataresponse(response.data.data));

    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(setTrackingparentEmployeeDataError(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
  }
}

function* settheSubCateoryListthelpdeskSagaEmp(payload) {
  console.log(payload, "lkaslfjjasfk");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: CateoryForHelpApi,
      params: payload.payload,
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });

    console.log(response, "osa98sd asudaisd response");

    yield put(
      SettrackingSubCategoryEmpEmployeeDataresponse(response.data.data),
    );

    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(setTrackingSubCategoryEmpEmployeeDataError(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
  }
}
/// help---desk--post

function* settheHelpDeskPostsagaForEmp(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: helpdeskGet,
        data: payload.payload.data,
        headers: {
          Authorization:
            "Bearer " +
            store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session
              .token,
        },
      });

      yield put(SetHelpDeskApplyEmpEmployeeDataresponse(response.data.data));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(setHelpDeskApplyEmpEmployeeDataError(error));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/customudsemployee";
      }
    }
  }
}

function* settheReginationSagaretrieve(payload) {
  console.log(payload, "lkaslfjjasfk");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: empResign,
      params: payload.payload,
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });

    console.log(response, "osa98sd asudaisd response");

    yield put(setTheResignationsRetrieveForEmp(response.data.data));
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(setTheResignationForEMpretrieveError(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
  }
}

function* setExitNodueEditsEMPrecords(payload) {
  if (payload != undefined) {
    try {
      // yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: NoDueFormEmpAPi + payload.payload.id + "/",
        data: payload.payload.data,
        headers: {
          Authorization:
            "Bearer " +
            store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session
              .token,
        },
      });
      // yield put(getLoaderAction(false));

      yield put(settheNoDueFormResponsesDataEditEmployeee(response.data.data));

      window.location.href = "/employment";
    } catch (error) {
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(settheNodueFormForEmpErrorEditCall(error));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* settheExitFormForEmployeeDAtaRetireve(payload) {
  console.log(payload, "asuaisoud oaisudo payload");

  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: NoDueFormEmpAPi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " +
            store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session
              .token,
        },
      });

      yield put(
        settheNoDueFormResponsesDataretrieveEmployeee(response.data.data),
      );

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(settheNodueFormForEmpErrorretrirve(error));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* settheNodueFormInpostMethod(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: NoDueFormEmpAPi,
        data: payload.payload.data,
        headers: {
          Authorization:
            "Bearer " +
            store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session
              .token,
        },
      });
      yield put(getLoaderAction(false));

      yield put(settheNoDueFormResponsesDataEmployeee(response.data.data));

      window.location.href = "/employment";
    } catch (error) {
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(settheNodueFormForEmpError(error));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* getthePaySlipSagaForEmployee(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: payslip,
      params: {
        page_size: payload.payload.page_size,
        page: payload.payload.page,
        search: payload.payload.search,
        user: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
          .id,
        year: payload.payload.year,
      },
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });
    // SetOndutyEmployeetotalcountDataresponse
    console.log(response, "diouasd oiasudisad", response.data.data);

    yield put(setthePayslipDataforEmp(response.data.data.data));
    yield put(setThePayslipToatal_countForEmp(response.data.total_count));
    yield put(setTheJoiningDateForPayslipEmp(response.data.data.joining_year));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(setTheErrorofPayslipemp(error));
    yield put(getLoaderAction(false));
  }
}

////------Shify---Datas----------------------------
function* getTheShiftDatas(payloads) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: ShiftDatas,
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });
    yield put(getLoaderAction(false));
    yield put(SetTheShiftDataresponse(response.data.data));
  } catch (error) {
    yield put(getLoaderAction(false));
    if (error.response.status != 500) {
      yield put(setTheShiftDatasError(error));

      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/customudsemployee";
      }
    } else {
      toast.error(` ${" something went wrong"} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}

////------AttenDance---Datas----------------------------
function* CreateLeaveSaga(payload) {
  console.log(payload, "lkaslfjjasfk");
  const postUrl = AttendanceAvaliableLeav;
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: postUrl,
      data: payload.payload.formData,
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });

    yield put(SetCreateLeaveSuccessResponse(response.data.data));
    toast.success("Leave Created Successfully.", {
      position: toast.POSITION.TOP_RIGHT,
    });
    yield put(
      SetTheAttendanceDatasActions({
        page_size: 20,
        page: 1,
        status: "",
      }),
    );
    window.location.href = "/leave";

    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(SetCreateLeaveError(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
  }
}

////------Calendar--Fetch---Datas----------------------------
function* CalendarFetchSaga(payloads) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: requestCheckInOut,
      params: {
        year: payloads.payload.year,
        month: payloads.payload.month,
      },
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });
    yield put(SetCalendarSuccessResponse(response.data.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(setCalendarError(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
  }
}
////------AttenDance---Datas----------------------------
function* GetTheAttendanceDatas(payloads) {
  //  console.log(payloads , "347287payloads");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: AttendanceAvaliableLeav,
      params: {
        page_size: payloads.payload.page_size,
        page: payloads.payload.page,
        status: payloads.payload.status,
        user: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
          .id,
        search: payloads.payload.search,
      },
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });
    yield put(getLoaderAction(false));
    yield put(SetTheAttendanceDataresponse(response.data.data));
    yield put(setTheAttendanceLeaveResponses(response.data.data.data.data));
    yield put(setTheAttendanceTotal_counts(response.data.total_count));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(setTheAttendanceDatasError(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
  }
}

//----got the employee list ---
function* gettheprofilesignaturegetlist(payload) {
  console.log(payload, "payload");

  if (payload != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: employeeelistAPi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      // yield put(setTheProfileSignatureGetActionsResponse(response.data.data.inquiry_data));

      if (response.data.data.inquiry_data != undefined) {
        yield put(
          setTheProfileSignatureGetActionsResponse(
            response.data.data.inquiry_data,
          ),
        );
      } else {
        yield put(setTheProfileSignatureGetActionsResponse([]));
      }
      yield put(setTheTotal_counts(response.data.total_count));
      yield put(getLoaderAction2(false));
    } catch (error) {
      yield put(getLoaderAction2(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(settheprofileSignatureGetLIStErrorputmethod(error));
      // if (error.response.data.status.code == 401) {

      //   localStorage.clear();
      //   window.location.href = "/";
      // }
    }
  }
}

function* getthesonyemployeegetlist(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: sonyEmployeeLetterCountApi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      if (response.data?.data?.inquiry_data != undefined) {
        yield put(
          setTheSonyEmployeeGetActionsResponse(
            response.data.data.inquiry_data,
          ),
        );
      } else if (response.data?.inquiry_data != undefined) {
        yield put(
          setTheSonyEmployeeGetActionsResponse(
            response.data.inquiry_data,
          ),
        );
      } else if (Array.isArray(response.data?.data)) {
        yield put(setTheSonyEmployeeGetActionsResponse(response.data.data));
      } else if (Array.isArray(response.data)) {
        yield put(setTheSonyEmployeeGetActionsResponse(response.data));
      } else {
        yield put(setTheSonyEmployeeGetActionsResponse([]));
      }
      yield put(
        setTheSonyEmployeeTotal_counts(
          response.data?.total_count || response.data?.data?.total_count || 0
        )
      );
      yield put(getLoaderAction2(false));
    } catch (error) {
      yield put(getLoaderAction2(false));
      toast.error(` ${error?.response?.data?.status?.message || "Error fetching Sony Employee List"} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(settheSonyEmployeeGetLIStErrorputmethod(error));
    }
  }
}

function* gettheOverallreport(payloads) {
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: overAllReportget,

        params: payloads.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      // yield put(setOverReportSuccessResponse(response.data.data.total_recharges));
      yield put(setOverReportSuccessResponse(response.data.data.total_balance));

      yield put(setTheOverAllReportDatas(response.data.data.data));
      yield put(setThekycapproximatedvalue(response.data.data.kyc_value));
      yield put(settheapproximated_values(response.data.data.except_api_hits));
      console.log(response.data.data, "1270391279jj");
      yield put(getLoaderAction(false));
      yield put(setTotal_count_OverReport(response.data.total_count));
    } catch (error) {
      yield put(getLoaderAction(false));

      if (error.response.status != 500) {
        yield put(setOverReportErrorsMessage(error));
        console.log(error.response.status, "error");

        if (error.response.data.status.code == 401) {
          localStorage.clear();
          window.location.href = "/";
        }
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* gettheOverallreportEmployeeList(payloads) {
  console.log(payloads, "2304-8payloads");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: overallemployeelisteAPI,

        params: payloads.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(
        setOverReportSuccessResponseEmployeeList(response.data.data.data),
      );

      console.log(response.data, "1270391279jj");
      yield put(getLoaderAction(false));
      yield put(
        setTotal_count_OverReportEmployeeList(response.data.total_count),
      );
    } catch (error) {
      yield put(setOverReportErrorsMessageEmployee(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* gettheOverallreportEXPORTEmployeeList(payloads) {
  console.log(payloads, "2304-8payloads");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: overAllEmployeeListAPI,

        params: payloads.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(
        setOverReportSuccessResponseExportEmployeeList(response.data.data.data),
      );

      console.log(response.data, "wuer8237", response.data.data);
      yield put(getLoaderAction(false));
      window.open(response.data.data);
    } catch (error) {
      yield put(setOverReportErrorsMessageExportEmployee(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* setOverallvalidations(payload) {
  console.log(payload, "1728oupayload");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: overAllReportget,
      data: payload.payload.data,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(setOverReportSuccessCreateResponse(response.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));

    yield put(setOverReportErrorsCreateMessage(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    console.log(error, "error");

    // console.log(error, "9837832error");
    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

function* setOverallexcelSheetuploadSaga(payload) {
  console.log(payload, "02930payload");

  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: overallexportapi,
      params: payload.payload,

      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(setOverReportSuccessRetrieveResponse(response.data));
    yield put(getLoaderAction(false));
    console.log(response.data.data, "9839821response.data");
    window.open(response.data.data);
  } catch (error) {
    yield put(setOverReportErrorsRetrieveMessage(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    // console.log(error, "9837832error");
    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

function* settheSendemailUpdatesd(payload) {
  console.log(payload, "90728payload", sendEmailUpdateApi + payload.payload.id);
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "put",
      url: sendEmailUpdateApi + payload.payload.id + "/",
      data: payload.payload.sendEmail,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(setthesendEmailActionsResponse(response.data.data));

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    yield put(getLoaderAction(false));
  } catch (error) {
    if (error) {
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(setthesendEmailActionsEditError(error));
    }
    yield put(getLoaderAction(false));

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

function* getThesendEmailGetList(payloads) {
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: sendEmailUpdateApi,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setthesendEmailActionsgetListResponse(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setthesendEmailActionsGetListError(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* getGeoOverallState(payloads) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: OverallStateAPi,
      params: payloads.payload,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(settheStatesgetListResponse(response.data.data));
    yield put(getLoaderAction(false));
    // yield put(SetGeoListTotalCount(response.data.total_count));
  } catch (error) {
    yield put(settheStateGetListError(error));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    yield put(getLoaderAction(false));

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}

function* gettheattendanceLocationInApiGetListSaga(payloads) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: AttendancelocationApi,
      params: payloads.payload,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(setheAttendanceLocationResponse(response.data.data));
    yield put(
      setTotal_count_AttedanceLocationEmployeeList(response.data.total_count),
    );

    console.log(response.data, "wuer8237", response.data.data);
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(settheAttendanceLocationErrorMessage(error));
    yield put(getLoaderAction(false));

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

function* AttendanceLocaitonDeletePlace(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "delete",
      url: AttendancelocationApi + payload.payload.DeleteId,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(setheAttendanceLocationDeleteResponse(response.data.data));
    yield put(getLoaderAction(true));
    const Content = {
      search: "",
      page_size: 20,
      page: payload.payload.currentPage,
    };
    yield put(setTheAttendanceLocationAction(Content));
  } catch (error) {
    yield put(getLoaderAction(false));
    if (error.response.status != 500) {
      yield put(settheAttendanceLocationDeletesErrorMessage(error));
      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    } else {
      toast.error(` ${"something went wrong"} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}

function* AttendanceLocationCreattionSaga(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: AttendancelocationApi,
      data: payload.payload.data,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(setheAttendanceLocationCreateResponse(response.data.data));
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    yield put(getLoaderAction(false));

    yield put(setTheAttendanceLocationAction(payload.payload.GetList));
  } catch (error) {
    yield put(getLoaderAction(false));
    if (error.response.status != 500) {
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
      yield put(settheAttendanceLocationCreateErrorMessage(error));
    } else {
      toast.error(` ${" something went wrong"} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}

function* gettheRetrieveofattendanceLocaitonsaga(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: AttendancelocationApi + payload.payload.EditID + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(
        setheAttendanceLocationRetrievemethodResponse(response.data.data),
      );

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      if (error.response.status != 500) {
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
        yield put(settheAttendanceLocationRetrieveMethodErrorMessage(error));
        if (error.response.data.status.code == 401) {
          console.log("401 erweu", error.response.data.status.code);

          localStorage.clear();
          window.location.href = "/";
        }
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* CallTheAttendanceLocaitonEditionsaga(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "put",
      url: AttendancelocationApi + payload.payload.EditID + "/",
      data: payload.payload.data,

      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(setheAttendanceLocationEditionsResponse(response.data));
    yield put(setTheAttendanceLocationAction(payload.payload.GetList));

    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));

    if (error.response.status != 500) {
      yield put(settheAttendanceLocationEditionsErrorMessage(error));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    } else {
      toast.error(` ${" something went wrong"} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}

function* callSupportDocumentEditSaga(payload) {
  try {
    yield put(getLoaderAction(true));

    const response = yield axios({
      method: "put",
      url: Supportdocumentapi + payload.payload.EditID + "/",
      data: payload.payload.removeformdata,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(getLoaderAction(false));

    toast.success(`${response.data.status.message}`, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(setEditedSupportDocument(response.data));
    const getlist = {
      EditID: payload.payload.EditID,
      Reload: 1,
    };
    yield put(startFetchingSupportDocuments(getlist));
  } catch (error) {
    yield put(getLoaderAction(false));

    if (error.response && error.response.status !== 500) {
      yield put(setEditSupportDocumentError(error));
      toast.error(`${error.response.data.status.message}`, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code === 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    } else {
      toast.error("Something went wrong", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}
function* callSupportDocumentFetchSaga(payload) {
  try {
    yield put(getLoaderAction(true));
    yield put(setSupportDocuments([]));

    const response = yield axios({
      method: "get",
      url: `${Supportdocumentapi}${payload.payload.EditID}`,
      headers: {
        Authorization: `Bearer ${store.getState().users.UserData.session.token}`,
      },
    });
    yield put(getLoaderAction(false));

    toast.success(`${response.data.status.message}`, {
      position: toast.POSITION.TOP_RIGHT,
    });

    yield put(setSupportDocuments(response.data.data));
    // if(payload.payload.Reload == 1){
    // window.location.reload();
    // }
  } catch (error) {
    yield put(getLoaderAction(false));

    if (error.response && error.response.status !== 500) {
      yield put(setSupportDocumentsError(error));
      toast.error(`${error.response.data.status.message}`, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code === 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    } else {
      toast.error("Something went wrong", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}

function* getMyonboardingList(payloads) {
  try {
    yield put(getLoaderAction2(true));
    const response = yield axios({
      method: "get",
      url: MyonoardignApi,
      params: payloads.payload,

      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(getthemyonboardingreponsesdatas(response.data.data));
    yield put(settheMyonardingTotal_counts(response.data.total_count));
    yield put(getLoaderAction2(false));
  } catch (error) {
    yield put(settheMyonboardinggetlisterror(error));
    yield put(getLoaderAction2(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}
function* getHRonboardingList(payloads) {
  try {
    yield put(getLoaderAction2(true));
    const response = yield axios({
      method: "get",
      url: HRonoardignApi,
      params: payloads.payload,

      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(gettheHRonboardingreponsesdatas(response.data.data));
    yield put(settheHRonardingTotal_counts(response.data.total_count));
    yield put(getLoaderAction2(false));
  } catch (error) {
    yield put(settheHRonboardinggetlisterror(error));
    yield put(getLoaderAction2(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}

function* gettheregeneratorPdfSaga(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: pdfgetlistapi + payload.payload.id + "/",
      params: payload.payload.overwritedatas,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(getLoaderAction(false));
    yield put(getLoaderAction(false));

    yield put(gettheRegeneratePdfResponse(response.data.data));

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    console.log(
      response,
      "sdpoipoasdi asdresponse",
      store.getState().Loader.isLoading,
    );

    // if(store.getState().Loader.isLoading == false){
    //       window.location.reload();
    // }

    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));

    if (error.response.status != 500) {
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      yield put(settheRegeneratorlisterror(error));

      // if (error.response.data.status.code == 401) {

      //   localStorage.clear();
      //   window.location.href = "/";
      // }
    } else {
      toast.error(` ${" something went wrong"} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  } finally {
    // Stop loader first
    yield put(getLoaderAction(false));

    // Wait a moment so UI updates, then reload
    yield delay(500); // 👈 redux-saga effect
    window.location.reload();
  }
}

function* gettheApproverequestmanagerlisted(payloads) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: Manager_list_get,
      params: payloads.payload,

      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(gettheapproveRequestManagerResponse(response.data.data));
    yield put(settheMyonardingTotal_counts(response.data.total_count));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(gettheApproveRequestManagerListError(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}

function* ReportDeleteOption(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "delete",
      url: reportgetdatasapi + payload.payload.DeleteID,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(getRoportdatsListdeletedResponseActions(response.data.data));
    yield put(getLoaderAction(false));
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    const reportpayload = payload.payload.reportpayloads;
    yield put(getRoportDatasActions(reportpayload));
  } catch (error) {
    yield put(getLoaderAction(false));
    yield put(getRoportDatsListErrodeleteResponsen(error));
    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

function* gettheOverallOnboarderList(payloads) {
  try {
    yield put(getLoaderAction2(true));
    const response = yield axios({
      method: "get",
      url: Onboardergetlist,
      params: payloads.payload,

      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(getthestoretheoverallOnboaderData(response.data.data));
    yield put(gettheoverallonboarderTotalCounts(response.data.total_count));
    yield put(getLoaderAction2(false));
  } catch (error) {
    yield put(getheOverallonboarderErrorMessage(error));
    yield put(getLoaderAction2(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}

function* RejoiningSaga(payload) {
  console.log(payload, "payload");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: payload.payload.API == 2 ? RejoningAPi : KysRejectionapi,
      data: payload.payload.formdatas,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(gettheRejoiningActionResponse(response.data.data));
    yield put(setTheAllFormPdf(false));
    yield put(getLoaderAction(false));
    if (typeof payload.payload.Funcations === "function") {
      payload.payload.Funcations();
    }
    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    // window.location.href = "/employeeprofile"
  } catch (error) {
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    yield put(gettheRejoingError(error));
  }
}

function* gettheboththeUser(payloads) {
  try {
    yield put(getLoaderAction2(true));
    const response = yield axios({
      method: "get",
      url: BothuserandEmpAPIs,
      params: payloads.payload,

      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(settheActionsreponsesforboththeUDSANDEMP(response.data.data));
    yield put(setBoththeUsersTotal_counts(response.data.total_count));
    yield put(getLoaderAction2(false));
  } catch (error) {
    yield put(setBoththeUserError(error));
    yield put(getLoaderAction2(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      console.log("401 erweu", error.response.data.status.code);

      localStorage.clear();
      window.location.href = "/";
    }
  }
}

function* gettheemployeeGrievenceSagaList(payload) {
  console.log(payload, "apSUPOAS paispA Spayload");

  try {
    yield put(getLoaderAction2(true));
    const response = yield axios({
      method: "get",
      url: GrievanceEmpApi,
      params: {
        page_size: payload.payload.page_size,
        page: payload.payload.page,
        status: payload.payload.status,
        search: payload.payload.search,
        user: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
          .id,
      },
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });
    // SetOndutyEmployeetotalcountDataresponse
    console.log(response, "diouasd oiasudisad", response.data.data);

    yield put(settheActionsreponsesforGrievencegetlistEmp(response.data.data));
    yield put(setgrievencegetlistEmpTotal_counts(response.data.total_count));
    yield put(getLoaderAction2(false));
  } catch (error) {
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
    yield put(setGrievencegetlistEmpError(error));
    yield put(getLoaderAction2(false));
  }
}

function* getgrievanceApplySagaEMp(payload) {
  console.log(payload, "suAPOS AIS payload");

  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: GrievanceEmpApi,
      data: payload.payload.data,
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });
    const Content = {
      page: payload.payload.page,
      page_size: 20,
      search: payload.payload.search,
      status: payload.payload.status,
    };
    yield put(settheGrievenceGetListForEMpActions(Content));

    // SetOndutyEmployeetotalcountDataresponse
    console.log(response, "diouasd oiasudisad");
    yield put(SetCreateGrievanceApplyEmpSuccessResponse(response));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(SetCreateGrievanceApplyEmpError(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
  }
}

function* gettheemployeeGrievenceTYPESagaList(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: grievenceEmptypegetapi,
      params: {
        page_size: payload.payload.page_size,
        page: payload.payload.page,
        status: payload.payload.status,
        search: payload.payload.search,
        user: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
          .id,
        request_type: payload.payload.request_type,
      },
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });
    // SetOndutyEmployeetotalcountDataresponse
    console.log(response, "diouasd oiasudisad", response.data.data);

    yield put(
      settheActionsreponsesforGrievenceTYPEgetlistEmp(response.data.data),
    );
    yield put(getLoaderAction(false));
  } catch (error) {
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
    yield put(setGrievencegetlistEmpTYPEError(error));
    yield put(getLoaderAction(false));
  }
}

function* gettheEmployeeAttendanceSagaForEmpList(payload) {
  try {
    yield put(getLoaderAction2(true));
    const response = yield axios({
      method: "get",
      url: EmpAttendanceApi,
      params: payload.payload,
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });
    // SetOndutyEmployeetotalcountDataresponse
    console.log(response, "diouasd oiasudisad", response.data.data);

    yield put(SetEmployeeAttendanceEmpDataresponse(response.data.data));
    yield put(
      SetEmpAttendanceEMPtotalcountDataresponse(response.data.total_count),
    );
    yield put(getLoaderAction2(false));
  } catch (error) {
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }

    yield put(setEmpAttendanceEMPDataError(error));
    yield put(getLoaderAction2(false));
  }
}

function* getfetchtheNodueFormdatasEmpUDS(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: EmpNoDueFormFetchapi + payload.payload.user + "/",
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });
    yield put(
      SetEmployenoduformfetchdatasempempteamListEmpDataresponse(
        response.data.data,
      ),
    );
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(setEmpnoduformfetchdatasempgetMPDataError(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
  }
}

function* gettheEmployeesitetransferEmployeeListSagaForEmpList(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: employeesiteempAPi,
      params: payload.payload,
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });
    // SetOndutyEmployeetotalcountDataresponse
    console.log(response, "diouasd oiasudisad", response.data.data);

    yield put(
      SetEmployeeSitetransferresponseEmpDataresponse(response.data.data),
    );
    yield put(getLoaderAction(false));
  } catch (error) {
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }

    yield put(setEmpsiteEMPDataError(error));
    yield put(getLoaderAction(false));
  }
}

function* gettheemployeeskillassessmentsempgetlistSagaList(payload) {
  console.log(payload, "apSUPOAS paispA Spayload");

  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: skillassEmplist,
      params: payload.payload,
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });
    // SetOndutyEmployeetotalcountDataresponse
    console.log(response, "diouasd oiasudisad", response.data.data);

    yield put(setSkillAssessmentEmpDataResponse(response.data.data));
    yield put(
      setSkillAssessmentotal_countEmpDataResponse(response.data.total_count),
    );
    yield put(getLoaderAction(false));
  } catch (error) {
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }

    yield put(setSkillAssessmentEmpDataError(error));
    yield put(getLoaderAction(false));
  }
}

function* getthestateactionsforEmplist(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: empstateapi,
      params: payload.payload,
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });
    console.log(response, "diouasd oiasudisad", response.data.data);

    yield put(setStateDataResponse(response.data.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(setStateDataError(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
  }
}

function* gettheregionactionsforEmplist(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: empregionapi,
      params: payload.payload,
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });
    console.log(response, "diouasd oiasudisad", response.data.data);

    yield put(setRegionDataResponse(response.data.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(setRegionDataError(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
  }
}

function* getZoneSagaactionsforEmplist(payload) {
  console.log(payload, "sduousad oi payload");

  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: empzonelistapi,
      params: payload.payload,
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });

    yield put(setZoneDataResponse(response.data.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(setZoneDataError(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
  }
}

function* getdesignationemplistactionsforEmplist(payload) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: emprolelistapi,
      params: payload.payload,
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });

    yield put(setDesignationDataResponse(response.data.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(setDesignationDataError(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
  }
}

function* getbranchempsitesactionsforEmplist(payload) {
  console.log(payload, "sduousad oi payload");

  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: branchliststrezoapi,
      params: payload.payload,
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    });
    console.log(response, "diouasd oiasudisad", response.data.data);

    yield put(setBranchDataResponse(response.data.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(setBranchDataError(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/customudsemployee";
    }
  }
}

function* gettheskillassessmentsagaEmpretrievedatas(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: skillassessmentretrieveapi + payload.payload.EditId + "/",
        headers: {
          Authorization:
            "Bearer " +
            store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session
              .token,
        },
      });

      yield put(gettheSkillassessmentretirvetheActionofemp(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));
      if (error.response.status != 500) {
        yield put(gettheskillAssessmentEmpretirveemp(error));

        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
        if (error.response.data.status.code == 401) {
          localStorage.clear();
          window.location.href = "/customudsemployee";
        }
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}
function* gettheskilassessmentquestionformlist(payload) {
  console.log(payload, "aSOPAOS Spayload");

  if (payload != undefined && payload.payload.id != "") {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: empquestiongetskillsform + payload.payload.userid + "/",
        params: {
          question_id: payload.payload.question_id,
          year: payload.payload.year,
          month: payload.payload.month,
        },
        headers: {
          Authorization:
            "Bearer " +
            store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session
              .token,
        },
      });

      yield put(setEmployeeDataquestionslist(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setErrorquestionslist(error));
      yield put(getLoaderAction(false));
      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/custonudsemployee";
      }
    }
  }
}

function* skillassessmentsagachildinneerqetions(payloads) {
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: innerquestionapi + payloads.payload.id + "/",
        headers: {
          Authorization:
            "Bearer " +
            store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session
              .token,
        },
      });

      console.log(response, "asiudyiasdu  response");

      // yield put(setQuestionData(response.data.data));
      yield put(getLoaderAction(false));
      // yield put(
      //   setPerformanceChildRetreveTotal_counts(response.data.total_count)
      // );
    } catch (error) {
      yield put(setErrorinnerquestions(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/custonudsemployee";
      }
    }
  }
}

function* gethequestionpapertypqskillassessment(payloads) {
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",

        url: innerquestionapi + payloads.payload.id + "/",
        headers: {
          Authorization:
            "Bearer " +
            store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session
              .token,
        },
      });
      yield put(setQuestionTypeData(response.data.data));
      yield put(getLoaderAction(false));
      yield put(setTheNameFormForm(response.data.data.grading_name));
    } catch (error) {
      yield put(setErrorQuestionType(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* gettheEMpSkillassessmentPostmethods(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: skillassessmenrcrud,
        data: payload.payload.innerdata,
        headers: {
          Authorization:
            "Bearer " +
            store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session
              .token,
        },
      });

      yield put(
        gettheSkillassessmentEmppostmethodstheActionofemp(response.data.data),
      );

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(gettheskillAssessmentEmpPostmethodemp(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///skill assessment put mehtods
function* gettheskillassessmentputmethods(payload) {
  console.log(payload, "payloadwes");
  if (payload != undefined && payload.payload.EditId != "") {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: skillassessmenrcrud + payload.payload.EditId + "/",
        data: payload.payload.innerdata,
        headers: {
          Authorization:
            "Bearer " +
            store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session
              .token,
        },
      });

      yield put(
        gettheSkillassessmentEmpputmethodstheActionofemp(response.data.data),
      );

      yield put(getLoaderAction(false));

      if (payload.payload.count == 2) {
        toast.success(` ${response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
        window.location.href = "/assessments_apply";
      }
    } catch (error) {
      yield put(gettheskillAssessmentEmpPuttmethodemp(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* getTheTicketingQuestionsDatagetlist(payloads) {
  console.log(payloads, "payloajeyuiwyeuywds");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: ticketcategoryapi,
        params: {
          search: payloads.payload.search,
          page_size: payloads.payload.page_size,
          page: payloads.payload.page,
        },
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setTheticketQuestionsResponses(response.data.data));
      yield put(getLoaderAction(false));
      yield put(setTheticketQuestionTotalCounts(response.data.total_count));
    } catch (error) {
      yield put(setTheticketeQuestionsError(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* setTheTickeing_QuestionsDeleteSaga(payloads) {
  console.log(payloads, "payloads");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "delete",
        url: ticketcategoryapi + payloads.payload.DeleteId + "/",

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTheTicketingQuestionsdeleteResponsive(response.data.data));

      toast.success(` ${response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      const content = {
        search: "",
        page_size: 20,
        page: payloads.payload.currentPage,
      };
      yield put(getTheTicketingQuestionsData(content));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheTicketingQuestionsDeletError(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* settheTicketingActionRetrieve(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: ticketcategoryapi + payload.payload.EditID + "/",

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTheTicketQuestionsretrieveResponsive(response.data.data));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheTicketQuestionsretrieveError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* settheTicketCategoryCreatetionsSaga(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: ticketcategoryapi,
        data: payload.payload.Data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTheTicketQuestionsCreateResponsive(response.data.data));
      const content = {
        search: payload.payload.search,
        page_size: 20,
        page: payload.payload.currentPage,
      };
      yield put(getTheTicketingQuestionsData(content));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheTicketQuestionsCreateError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}

function* settheTicketActionEdit(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: ticketcategoryapi + payload.payload.EditID + "/",
        data: payload.payload.Data,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTheTicketQuestionsEditResponsive(response.data.data));

      const content = {
        search: payload.payload.search,
        page_size: 20,
        page: payload.payload.currentPage,
      };
      yield put(getTheTicketingQuestionsData(content));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheTicketQuestionsEditError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* getTheTicketSubQuestionsData(payloads) {
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: ticketsubcategoryapi,
        params: payloads.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setTheTicketSubQuestionsResponses(response.data.data));
      yield put(getLoaderAction(false));
      yield put(setTheTicketSubQuestionTotalCounts(response.data.total_count));
    } catch (error) {
      yield put(setTheTicketSubQuestionsError(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* settheTicketingSubQueryCreatetionsSaga(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: ticketsubcategoryapi,
        data: payload.payload.Data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTheTicketSubQuestionsCreateResponsive(response.data.data));
      const content = {
        search: payload.payload.search,
        page_size: 20,
        page: payload.payload.currentPage,
        category: payload.payload.category,
      };
      yield put(settheTicketSubQuestionActions(content));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheTicketSubQuestionsCreateError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}

function* settheTicketingSubQueryActionEdit(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: ticketsubcategoryapi + payload.payload.EditID + "/",
        data: payload.payload.Rawdata,
        // data: {
        //   name: payload.payload.Data.name,
        //   description: payload.payload.Data.description,
        //   issue_category_id: payload.payload.category,
        //   expire_time: payload.payload.Data.expire_time,
        // },

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTheTicketSubQuestionsEditionsResponsive(response.data.data));
      const content = {
        search: payload.payload.search,
        page_size: 20,
        page: payload.payload.currentPage,
        category: payload.payload.category,
      };
      yield put(settheTicketSubQuestionActions(content));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheTicketSubQuestionsEditionError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* settheTicketingSUBQueryActionRetrieve(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: ticketsubcategoryapi + payload.payload.EditID + "/",

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTheTicketSubQuestionsRetrieveResponsive(response.data.data));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheTicketSubQuestionsRetrieveError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* setTheTicketingSUBQuestionsDeleteSaga(payloads) {
  console.log(payloads, "payloads");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "delete",
        url: ticketsubcategoryapi + payloads.payload.DeleteId + "/",

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTheTicketSUbQuestionsdeleteResponsive(response.data.data));

      toast.success(` ${response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      const content = {
        search: "",
        page_size: 20,
        page: payloads.payload.currentPage,
        category: payloads.payload.category,
      };
      yield put(settheTicketSubQuestionActions(content));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheTicketSUbQuestionsDeletError(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* setTheTicketinglistDatasListSaga(payloads) {
  console.log(payloads, "payloajeyuiwyeuywds");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: udsticketlistapi,
        params: payloads.payload,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(
        setTheTicketsystemrecordgetListDataResponses(response.data.data),
      );
      yield put(setTicketsystemRecordListDashboardReport(response.data.data));
      console.log(
        response.data.data,
        "qiudkjashdkjasd",
        response.data.total_count,
      );
      yield put(getLoaderAction(false));
      yield put(
        setTheTicketsystemrecordgetListDataTotalCounts(
          response.data.total_count,
        ),
      );
    } catch (error) {
      yield put(setTheQTicketsystemrecordgetListDatasError(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* settheTicketingSystemIndashboardSaga(payloads) {
  console.log(payloads, "payloajeyuiwyeuywds");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: ticketdashboardapi,
        params: payloads.payload,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(settheTicketingDashboardActiondataStores(response.data.data));
      yield put(getLoaderAction2(false));
    } catch (error) {
      yield put(SettheTicketingDashboardErrDeletError(error));
      yield put(getLoaderAction2(false));

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* getetheticketingretrievedatassaga(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: ticketlistapi + payload.payload.id + "/",

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(
        setTheTrackingrecordgetListRetrieveResponsive(response.data.data),
      );

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheTicketingrecordgetListRetrieveError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* gettheRemarkRetrieveActionsSaga(payloads) {
  console.log(payloads, "payloajeyuiwyeuywds");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: ticketremarks,
        params: payloads.payload,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(
        setTheTrackingrecordgetList_remarksRetrieveResponsive(
          response.data.data,
        ),
      );
      yield put(getLoaderAction2(false));
      yield put(
        setTheTicketsystemrecordgetListDataTotalCounts(
          response.data.total_count,
        ),
      );
    } catch (error) {
      yield put(SettheTicketingrecordgetListRetrieve_remarkError(error));
      yield put(getLoaderAction2(false));

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* gettheCommentsRetrieveActionsSaga(payloads) {
  console.log(payloads, "payloajeyuiwyeuywds");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: ticketcomment,
        params: payloads.payload,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(settheCommentRetieveDataList(response.data.data));
      yield put(getLoaderAction(false));
      yield put(
        setTheTicketsystemrecordgetListDataTotalCounts(
          response.data.total_count,
        ),
      );
    } catch (error) {
      yield put(settheCommentRetieveErorActions(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* gettheFeedbacksRetrieveActionsSaga(payloads) {
  console.log(payloads, "payloajeyuiwyeuywds");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: ticketfeedback,
        params: payloads.payload,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setthefeedbackRetieveDataList(response.data.data));
      yield put(getLoaderAction(false));
      yield put(
        setTheTicketsystemrecordgetListDataTotalCounts(
          response.data.total_count,
        ),
      );
    } catch (error) {
      yield put(settheFeedbackRetieveErorActions(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* settheremarksorCommentSaga(payload) {
  console.log(payload, "asdoasd poiuasd payload");

  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: payload.payload.remarks == 1 ? ticketremarks : ticketcomment,
        data: payload.payload.data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(settheticketcreateRetieveDataList(response.data.data));
      if (payload.payload.remarks == 2) {
        //  const contents ={
        //   ticket_id:payload.payload.data.ticket_id
        //  }
        //   yield put(settheticketTimelineretieveDatasActions(contents))

        const contentscomments = {
          ticket: payload.payload.data.ticket_id,
        };
        yield put(setthecommentRetieveDatasActions(contentscomments));
      } else if (payload.payload.remarks == 3) {
        const conetentonlyCom = {
          ticket: payload.payload.data.ticket_id,
        };
        yield put(setthecommentRetieveDatasActions(conetentonlyCom));
      } else {
        const contents = {
          ticket: payload.payload.data.ticket_id,
        };
        yield put(setTheTrackingrecordgetList_remarksRetrieveActions(contents));
      }

      if (payload.payload.ticketcall != undefined) {
        const ticketingpayload = {
          Rawdata: {
            status: payload.payload.ticketcall,
          },
          EditID: payload.payload.data.ticket_id,
        };
        yield put(settehTicketStatusChanges(ticketingpayload));

        const contents = {
          ticket_id: payload.payload.data.ticket_id,
        };
        yield put(settheticketTimelineretieveDatasActions(contents));
      }

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(settheticketcreateRetieveErorActions(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}

function* settheremarksoSagapost(payload) {
  console.log(payload, "asdoasd poiuasd payload");

  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: ticketremarks,
      data: payload.payload.data,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(settheticketcreateRetieveDataList(response.data.data));

    yield put(getLoaderAction(false));
    if (payload.payload.Assinged && payload.payload.Assinged == 1) {
      //  window.location.href="/ticketviews";

      if (typeof payload.payload.Funcations === "function") {
        payload.payload.Funcations();
      }
    } else {
      const remarksapicall = {
        ticket: payload.payload.data.ticket_id,
      };
      yield put(
        setTheTrackingrecordgetList_remarksRetrieveActions(remarksapicall),
      );
    }
  } catch (error) {
    yield put(settheticketcreateRetieveErorActions(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}

function* settheTicketChangess(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "put",
        url: ticketlistapi + payload.payload.EditID + "/",
        data: payload.payload.Rawdata,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(settheTicketStatusChangesrespons(response.data.data));

      console.log(response.data, "testing purposeresponse.data");

      const ticketpayloads = {
        id: payload.payload.EditID,
      };
      yield put(setTheTrackingrecordgetListRetrieveActions(ticketpayloads));

      const contents = {
        ticket_id: payload.payload.data.EditID,
      };
      yield put(settheticketTimelineretieveDatasActions(contents));

      yield put(getLoaderAction2(false));
    } catch (error) {
      yield put(settheTickeStatusErr(error));
      yield put(getLoaderAction2(false));
      if (error.response) {
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });

        if (error.response.data.status.code == 401) {
          localStorage.clear();
          window.location.href = "/";
        }
      }
    }
  }
}

function* gettheTicketLineSaga(payloads) {
  console.log(payloads, "payloajeyuiwyeuywds");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: ticketlineapi,
        params: payloads.payload,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(settheticketTiemlineRetieveDataList(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(settheticketTimeLineRetieveErorActions(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* SETTHEticketexxportssaga(payloads) {
  console.log(payloads, "payloads");
  // console.log(
  //   "sdoiudio",
  //   `{$baseurlforexport}/adminapp/userdetails/export/?&role_id=${payloads.payload.role_id}&export_type=${payloads.payload.export_type}`
  // );

  console.log(payloads, "payloajeyuiwyeuywds");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url:
          payloads.payload.ticketapis == 1
            ? ticketexports
            : ticketinernalexport,
        params: payloads.payload.parasnadata,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      console.log(response, "response");

      yield put(setTheTicketsDetailsResponsiveExport(response.data.data));
      yield put(getLoaderAction(false));
      window.open(response.data.data);
      // window.open(
      //   `${baseurlforexport}/ticketapp/udsexcelexport/?&state=${payloads.payload.state}&zone=${payloads.payload.zone}&region=${payloads.payload.region}&client=${payloads.payload.client}&priority=${payloads.payload.priority}&status=${payloads.payload.status}`,
      //   "_blank"
      // );
    } catch (error) {
      yield put(SettheTicketsDetailsErrorExport(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

//// SCOPE LIST

function* gettheScopeListDatassaga(payloads) {
  console.log(payloads, "payloajeyuiwyeuywds");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: scopeapi,
        params: payloads.payload,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTheScopeDetailsResponsiveExport(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheScopeDetailsErrorExport(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

/// contact edit

function* seteditthecontactpersons(payload) {
  if (payload.payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: payload.payload.Post == 2 ? "put" : "post",
        url:
          payload.payload.Post == 2
            ? contacteditapi + payload.payload.EditId + "/"
            : contacteditapi,

        data: payload.payload.data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      toast.success(` ${response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      yield put(setTheContactEditDetailsResponsiveExport(response.data));
      yield put(getLoaderAction(false));
      if (payload.payload.Post == 1) {
        const Ticketingretrieveingbranch = {
          EditId: payload.payload.data.client_id,
        };

        yield put(setClientBranchesRetrieveActions(Ticketingretrieveingbranch));
      }
    } catch (error) {
      yield put(SettheContactEditDetailsErrorExport(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* settheSubcategoryeditSliceandcreate(payload) {
  if (payload.payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: payload.payload.Apifunc == 1 ? "put" : "post",
        url:
          payload.payload.Apifunc == 1
            ? ClientCatecreateapi + payload.payload.EditId + "/"
            : ClientCatecreateapi,
        data: payload.payload.data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      toast.success(` ${response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      yield put(
        setTheSubCategoryEditandcreateDetailsResponsiveExport(response.data),
      );
      // const clientuserlist={
      //   Scopeid: 1,
      //   paramslist: {
      //     client: payload.payload.EditId,

      //   }
      //  }

      //  yield put (setTheSubCategorydataDetailsExportActions(clientuserlist));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheSubCategoryEditandcreateDetailsErrorExport(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

///-- categoryscope

function* gettheScopeCategoryListDatassaga(payloads) {
  console.log(payloads, "payloajeyuiwyeuywds");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: categoryscope,
        params: payloads.payload,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTheCategoryEditDetailsResponsiveExport(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheCategoryEditDetailsErrorExport(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

/// sub category
function* gettheScopeSubCategoryListDatassaga(payloads) {
  console.log(payloads, "payloajeyuiwyeuywds");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url:
          payloads.payload.Scopeid == 1
            ? ClientCatecreateapi
            : subcategoryscope,
        params: payloads.payload.paramslist,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(
        setTheSubCategoryEditDetailsResponsiveExport(response.data.data),
      );
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheSubCategoryEditDetailsErrorExport(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

/// sub category
function* gettheScopeSubCategoryListDatasOnlyEditsaga(payloads) {
  console.log(payloads, "payloajeyuiwyeuywdspayloajeyuiwyeuywds");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: subcategoryscope,
        params: payloads.payload.paramslist,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setthesubcategorybranchResponses(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setthesubcategorybranchErrors(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* gettheNeardueSagas(payloads) {
  console.log(payloads, "payloajeyuiwyeuywds");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: neardueapi,
        params: payloads.payload,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(settheeardueresponsestore(response.data.data));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(settheNeardueCallingErrors(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

/// internal

function* getTheInternalQuestionsDatagetlist(payloads) {
  console.log(payloads, "payloajeyuiwyeuywds");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: departmentissuesapi,
        params: payloads.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setTheUDSQuestionsResponses(response.data.data));
      yield put(getLoaderAction(false));
      yield put(setTheUDsQuestionTotalCounts(response.data.total_count));
    } catch (error) {
      yield put(setTheUdsQuestionsError(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* settheInternalTicketingActionRetrieve(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: departmentissuesapi + payload.payload.EditID + "/",

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(
        setTheInternalcategoryQuestionsretrieveResponsive(response.data.data),
      );

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheinternalcategoryQuestionsretrieveError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* gettheqrforbranchsaga(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: branchqrapi + payload.payload.EditID + "/",

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      //  console.log(response.data.data ,"response.data.data");
      window.open(response.data.data, "_blank");

      yield put(settheqrexportedresponse(response.data.data));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(settheQrcodeexports(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* settheinternalCategoryCreatetionsSaga(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: departmentissuesapi,
        data: payload.payload.Data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTheInternalQuestionsCreateResponsive(response.data.data));
      const content = {
        search: payload.payload.search,
        page_size: 20,
        page: payload.payload.currentPage,
      };
      yield put(getTheUDSQuestionsData(content));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheTicketQuestionsCreateError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}

function* settheinternalcategoryActionEdit(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: departmentissuesapi + payload.payload.EditID + "/",
        data: payload.payload.Data,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(
        setTheinternalCategoryQuestionsEditResponsive(response.data.data),
      );

      const content = {
        search: payload.payload.search,
        page_size: 20,
        page: payload.payload.currentPage,
      };
      yield put(getTheUDSQuestionsData(content));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheinternalcategoryQuestionsEditError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* setTheInternalDeleteSaga(payloads) {
  console.log(payloads, "payloads");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "delete",
        url: departmentissuesapi + payloads.payload.DeleteId + "/",

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setThInternalQuestionsdeleteResponsive(response.data.data));

      toast.success(` ${response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      const content = {
        search: "",
        page_size: 20,
        page: payloads.payload.currentPage,
      };
      yield put(getTheUDSQuestionsData(content));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheInternalQuestionsDeletError(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* getTheInternalSubQuestionsData(payloads) {
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: departmentsubissuesapi,
        params: payloads.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setTheInternalSubQuestionsResponses(response.data.data));
      yield put(getLoaderAction(false));
      yield put(
        setTheInternalSubQuestionTotalCounts(response.data.total_count),
      );
    } catch (error) {
      yield put(setTheunternalSubQuestionsError(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* settheInternalSubQueryCreatetionsSaga(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: departmentsubissuesapi,
        data: payload.payload.Data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTheInternalSubQuestionsCreateResponsive(response.data.data));
      const content = {
        search: payload.payload.search,
        page_size: 20,
        page: payload.payload.currentPage,
        category: payload.payload.category,
        active: payload.payload.Activeget,
      };
      yield put(settheInternalSubQuestionActions(content));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheInternalSubQuestionsCreateError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}

function* settheInternalSubQueryActionEdit(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: departmentsubissuesapi + payload.payload.EditID + "/",
        data: payload.payload.Rawdata,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(
        setTheinternalSubQuestionsEditionsResponsive(response.data.data),
      );
      const content = {
        search: payload.payload.search,
        page_size: 20,
        page: payload.payload.currentPage,
        category: payload.payload.category,
        active: payload.payload.Activeget,
      };
      yield put(settheInternalSubQuestionActions(content));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheinternalSubQuestionsEditionError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* settheInternalSUBQueryActionRetrieve(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: departmentsubissuesapi + payload.payload.EditID + "/",

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(
        setTheinternalSubQuestionsRetrieveResponsive(response.data.data),
      );

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheInternalSubQuestionsRetrieveError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* setTheInternalSUBQuestionsDeleteSaga(payloads) {
  console.log(payloads, "payloads");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "delete",
        url: departmentsubissuesapi + payloads.payload.DeleteId + "/",

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTheInternalSUbQuestionsdeleteResponsive(response.data.data));

      toast.success(` ${response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      const content = {
        search: "",
        page_size: 10,
        page: payloads.payload.currentPage,
        category: payloads.payload.category,
      };
      yield put(settheInternalSubQuestionActions(content));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheInternalSUbQuestionsDeletError(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* setTheTicketingforUnregisterlistDatasListSaga(payloads) {
  console.log(payloads, "payloajeyuiwyeuywds");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: unregisertapi,
        params: payloads.payload,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(
        setTheTicketsystem_unregisterrecordgetListDataResponses(
          response.data.data.ticket_data,
        ),
      );
      yield put(
        setTicketsystem_unregisterRecordListDashboardReport(response.data.data),
      );
      console.log(
        response.data.data,
        "qiudkjashdkjasd",
        response.data.total_count,
      );
      yield put(getLoaderAction(false));
      yield put(
        setTheTicketsystem_unregisterrecordgetListDataTotalCounts(
          response.data.total_count,
        ),
      );
    } catch (error) {
      yield put(setTheQTicketsystem_unregisterrecordgetListDatasError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* gettheDepartmentGetListsaga(payloads) {
  console.log(payloads, "payloajeyuiwyeuywds");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: departmentapi,
        params: payloads.payload,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setTheInternalDepartmentsResponses(response.data.data));
      // yield put(setTicketsystem_unregisterRecordListDashboardReport(response.data.data));
      console.log(
        response.data.data,
        "qiudkjashdkjasd",
        response.data.total_count,
      );
      yield put(getLoaderAction(false));
      yield put(
        setTheInternalDepartmentsTotalCounts(response.data.total_count),
      );
    } catch (error) {
      yield put(setTheinternalDepartmentsError(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* settheInternalDepartmentsCreatetionsSaga(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: departmentapi,
        data: payload.payload.data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTheInternalDepartmentsCreateResponsive(response.data.data));
      const content = {
        search: payload.payload.search,
        page_size: 20,
        page: payload.payload.currentPage,
      };
      yield put(settheInternalDepartmentsctions(content));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheInternalDepartmentsCreateError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}

function* settheInternalDepartmentslevelusersCreatetionsSaga(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: leveluserapi,
        data: payload.payload.data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(
        setTheInternalDepartmentsLevelUsersCreateResponsive(response.data.data),
      );

      yield put(getLoaderAction(false));

      const content = {
        search: payload.payload.search,
        page_size: 20,
        page: payload.payload.currentPage,
        department_id: store.getState().NeededdatasListed.SubQueryIDs,
        user_type: payload.payload.user_type,
      };
      yield put(getTheLevelUsersListData(content));
    } catch (error) {
      yield put(SettheInternalDepartmentsLevelUserCreateError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}

function* gettheDepartmentGetLevelusersListsaga(payloads) {
  console.log(payloads, "payloajeyuiwyeuywds");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: DepartmentUsersapi,
        params: payloads.payload,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      // yield put(
      //   setTheInternalDepartmentsResponses(response.data.data)
      // );
      yield put(setTheLevelUsersListResponses(response.data.data));
      yield put(getLoaderAction(false));
      yield put(setTheLevelUserListedTotalCounts(response.data.total_count));
    } catch (error) {
      yield put(setTheLevelUserslistError(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* gettheinternaldepartmentretrievesaga(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: departmentapi + payload.payload.EditId + "/",

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(
        setTheInternalDepartmentsRetrieveResponsive(response.data.data),
      );

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheInternalDepartmentsRetrieveError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* settheInternalDepartmentActionEdit(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: departmentapi + payload.payload.EditId + "/",
        data: payload.payload.data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTheInternalDepartmentsEditResponsive(response.data.data));
      const content = {
        search: payload.payload.search,
        page_size: 20,
        page: payload.payload.currentPage,
      };
      yield put(settheInternalDepartmentsctions(content));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheInternalDepartmentsEditError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* settehInternalDepartmentDeletedSaga(payloads) {
  console.log(payloads, "payloads");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "delete",
        url: departmentapi + payloads.payload.DeleteId + "/",

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTheInternalDepartmentsdeleteResponsive(response.data.data));

      toast.success(` ${response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      const content = {
        search: "",
        page_size: 20,
        page: payloads.payload.currentPage,
      };
      yield put(settheInternalDepartmentsctions(content));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheInternalDepartmentsDeletError(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* gettheinternaldepartmentLevelUsersretrievesaga(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: leveluserapi + payload.payload.EditId + "/",

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(
        setTheInternalDepartmentsRetrieve_usersResponsive(response.data.data),
      );

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheInternalDepartmentsRetrieve_usersError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* settheInternalDepartmentLevelUsersActionEdit(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: leveluserapi + payload.payload.EditId + "/",
        data: payload.payload.data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(
        setTheInternalDepartmentsEdtions_usersResponsive(response.data.data),
      );
      const content = {
        search: payload.payload.search,
        page_size: 20,
        page: payload.payload.currentPage,
        department_id: store.getState().NeededdatasListed.SubQueryIDs,
        user_type: payload.payload.user_type,
      };
      yield put(getTheLevelUsersListData(content));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheInternalDepartmentsEdtions_usersError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* settehInternalDepartmentLevelUsersDeletedSaga(payloads) {
  console.log(payloads, "payloads");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "delete",
        url: leveluserapi + payloads.payload.DeleteId + "/",

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(
        setTheInternalDepartmentsdelete_usersResponsive(response.data.data),
      );

      toast.success(` ${response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
      const content = {
        search: "",
        page_size: 10,
        page: payloads.payload.currentPage,
        department_id: store.getState().NeededdatasListed.SubQueryIDs,
        user_type: payloads.payload.user_type,
      };
      yield put(getTheLevelUsersListData(content));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheInternalDepartmentsDelete_usersError(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* setTheTicketinglistInternalDepartmentsDatasListSaga(payloads) {
  console.log(payloads, "payloajeyuiwyeuywds");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: internalTicketsget,
        params: payloads.payload,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(
        setTheTicketsystemrecordgetListDataInternalDepartmentResponses(
          response.data.data,
        ),
      );
      yield put(
        setTicketsystemRecordListDashboardInternalDepartmentReport(
          response.data.data,
        ),
      );
      console.log(
        response.data.data,
        "qiudkjashdkjasd",
        response.data.total_count,
      );
      yield put(getLoaderAction(false));
      yield put(
        setTheTicketsystemrecordgetListDataInternalDepartmentTotalCounts(
          response.data.total_count,
        ),
      );
    } catch (error) {
      yield put(
        setTheQTicketsystemrecordgetListDatasInternalDepartmentError(error),
      );
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* settheticketCreationforiNternalTeams(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: internalTickets,
        data: payload.payload.data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(settheCreateInternalTicketsResponse(response.data.data));

      yield put(getLoaderAction(false));
      yield put(settheTicketSuccesspopuos(true));
      // const content = payload.payload.getpayloads
      // yield put(settheInternalTicketsystemrecordgetListInternalDepartmentsDataActions(content));
      // if(state.NeededdatasListed.RoutesDefinedof == 0){
      //   window.location.href="/internaldashboard"
      // }
      //  else if(state.NeededdatasListed.RoutesDefinedof == 1{
      //   {
      //   window.location.href="/internalTicket"

      //  }
    } catch (error) {
      yield put(getLoaderAction(false));

      if (error.response.status != 500) {
        yield put(SettheInternalInternalTicketCreations(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* gettheticketviewretrivesaga(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: internalTickets + payload.payload.EditId + "/",

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      console.log(response.data.data, "asdy8aosydiousad comments datas ");

      yield put(
        setTheInternalDepartmentsRetrieve_TicketViewsResponsive(
          response.data.data.ticket_data,
        ),
      );

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheInternalDepartmentsRetrieve_TicketViewsError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* gettheinternalticketingRemarks(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: internalTicketremarks,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(
        setTheInternalDepartmentsRetrieve_TicketRemarksResponsive(
          response.data.data,
        ),
      );

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheInternalDepartmentsRetrieve_TickeRemarkError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* gettheTicketingTimelineinternal(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: internalTickettimeline,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(
        setTheInternalDepartmentsRetrieve_TicketTimelineResponsive(
          response.data.data,
        ),
      );

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheInternalDepartmentsRetrieve_TickeTimelineError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* setthefeedbackpostsagalistedDATA(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: internalfeedbackapi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(
        setTheInternalDepartmentsRetrieve_TicketFeedbackResponsive(
          response.data.data,
        ),
      );

      yield put(getLoaderAction(false));

      // const content = payload.payload.getpayloads
      // yield put(settheInternalTicketsystemrecordgetListInternalDepartmentsDataActions(content));
    } catch (error) {
      yield put(getLoaderAction(false));

      if (error.response.status != 500) {
        yield put(SettheInternalDepartmentsRetrieve_TicketFeedbackError(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* setthefeedbackinernalpostsagalisted(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: internalfeedbackapi,
        data: payload.payload.data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(
        setTheInternalDepartments_TicketFeedbackPostResponsive(
          response.data.data,
        ),
      );
      const payloadupdateds = {
        data: {
          status: "3",
        },
        EditId: store.getState().NeededdatasListed.InternalTicketIds,
      };
      console.log(payloadupdateds, "payloadupdateds");

      yield put(
        setTheInternalDepartmentRetreve_TicketTicketChangesActions(
          payloadupdateds,
        ),
      );

      yield put(getLoaderAction(false));
      // const content = payload.payload.getpayloads
      // yield put(settheInternalTicketsystemrecordgetListInternalDepartmentsDataActions(content));
    } catch (error) {
      yield put(getLoaderAction(false));

      if (error.response.status != 500) {
        yield put(SettheInternalDepartments_TicketFeedbackPostError(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}
function* getthetickeChangesSaga(payload) {
  console.log(
    payload,
    "payload oiuoiewqueoiwqe",
    store.getState().NeededdatasListed.RoutesDefinedof,
  );
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: internalTickets + payload.payload.EditId + "/",
        data: payload.payload.data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(
        setTheInternalDepartmentsRetrieve_TicketChangesResponsive(
          response.data.data,
        ),
      );
      const content = {
        EditId: payload.payload.EditId,
      };
      // yield put(getTheLevelUsersListData(content));

      yield put(setTheInternalDepartmentRetreve_TicketViewsActions(content));

      const contentstimeline = {
        ticket_id: payload.payload.EditId,
      };
      yield put(
        setTheInternalDepartmentRetreve_TicketTImelinesActions(
          contentstimeline,
        ),
      );
      const ticketjourneypayload = {
        root_ticket: payload.payload.EditId,
      };
      yield put(settheTicketTicketJourneyActions(ticketjourneypayload));

      if (!payload.payload.Internals) {
        if (payload.payload.data?.status != 4) {
          yield put(settehTicketthankspopup(true));
        }

        if (payload.payload.data?.status == 4) {
          if (store.getState().NeededdatasListed.RoutesDefinedof == 0) {
            window.location.href = "/internaldashboard";
          }
          // else if(store.getState().NeededdatasListed.RoutesDefinedof ==  9){
          //   // window.location.href="/sub_ticket_internal_view"
          // }
          else if (store.getState().NeededdatasListed.RoutesDefinedof == 8) {
            window.location.href = "/ticketviews";
          } else {
            window.location.href = "/internalTicket";
          }
        }
      }

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheInternalDepartmentsRetrieve_TicketChangesError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* setthecommandsinernalpostsagalisted(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: internalcommandapi,
        data: payload.payload.data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(
        settheinternaldepartmentcommandpostresponse(response.data.data),
      );
      if (payload.payload.reopen == 1) {
        const payloadupdateds = {
          data: {
            status: "4",
          },
          EditId: store.getState().NeededdatasListed.InternalTicketIds,
        };

        yield put(
          setTheInternalDepartmentRetreve_TicketTicketChangesActions(
            payloadupdateds,
          ),
        );
      }
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));

      if (error.response.status != 500) {
        yield put(settheinternaldepartmentcommandpostError(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* gettheinternalcommanlisted(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: internalcommandapi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      console.log(response.data, "response.data");

      yield put(
        settheinternaldepartmentcommandgetdataresponse(response.data.data),
      );

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));

      if (error.response.status != 500) {
        yield put(settheinternaldepartmentcommangetdataError(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* setTheTicketinglistInternalDepartmentsUsersDatasListSaga(payloads) {
  console.log(payloads, "payloajeyuiwyeuywds");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: internalTicketsget,
        params: payloads.payload,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(
        setTheTicketsystemInernalDepaertmentrecordgetListDataResponses(
          response.data.data,
        ),
      );
      yield put(
        setTicketsystemRecord_departmentListDashboardReport(response.data.data),
      );
      console.log(
        response.data.data,
        "qiudkjashdkjasd",
        response.data.total_count,
      );
      yield put(getLoaderAction(false));
      yield put(
        setTheTicketsystemrecordgetDepartmentListDataTotalCounts(
          response.data.total_count,
        ),
      );
    } catch (error) {
      yield put(setTheQTicketsystemrecordDepartmentgetListDatasError(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* settehCrudOfinternalTicketings(payload) {
  console.log(payload, "asdoasd poiuasd payload");

  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url:
          payload.payload.remarks == 1
            ? internalTicketremarks
            : internalcommandapi,
        data: payload.payload.data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(
        setTheInternalDepartmentsRetrieve_TicketRemarksCURDResponsive(
          response.data.data,
        ),
      );
      if (payload.payload.remarks == 2) {
        const contentscomments = {
          ticket: payload.payload.data.ticket_id,
        };
        yield put(
          settheinternaldepartmentcommanddatagetaction(contentscomments),
        );
      } else if (payload.payload.remarks == 3) {
        const conetentonlyCom = {
          ticket: payload.payload.data.ticket_id,
        };
        yield put(
          settheinternaldepartmentcommanddatagetaction(conetentonlyCom),
        );
      } else {
        const contents = {
          ticket: payload.payload.data.ticket_id,
        };
        yield put(
          setTheInternalDepartmentRetreve_TicketRemarksActions(contents),
        );
      }

      if (payload.payload.ticketcall != undefined) {
        const ticketingpayload = {
          data:
            payload.payload.ticketcall == 2
              ? {
                status: payload.payload.ticketcall,
                duration: payload.payload?.duration,
              }
              : {
                status: payload.payload.ticketcall,
              },
          EditId: payload.payload.data.ticket_id,
          Internals: 2,
        };
        yield put(
          setTheInternalDepartmentRetreve_TicketTicketChangesActions(
            ticketingpayload,
          ),
        );

        const contents = {
          ticket_id: payload.payload.data.ticket_id,
        };
        yield put(
          setTheInternalDepartmentRetreve_TicketTImelinesActions(contents),
        );
      }

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(SettheInternalDepartmentsRetrieve_TickeRemarkCRUDError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
}

function* settheremarksInternal_usersSagapost(payload) {
  console.log(payload, "asdoasd poiuasd payload");

  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "post",
      url: internalTicketremarks,
      data: payload.payload.data,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(settheinternaldepartmeentremarksdataresponse(response.data.data));
    yield put(getLoaderAction(false));
    if (payload.payload.Assinged == 1) {
      // window.location.href="/internal_ticketview"
      if (typeof payload.payload.Funcations === "function") {
        payload.payload.Funcations();
      }
    } else if (payload.payload.Rejected) {
      const remarksapicall = {
        ticket: payload.payload.data.ticket_id,
      };
      yield put(
        setTheInternalDepartmentRetreve_TicketRemarksActions(remarksapicall),
      );
    } else {
      const remarksapicall = {
        ticket: payload.payload.data.ticket_id,
      };
      yield put(
        setTheInternalDepartmentRetreve_TicketRemarksActions(remarksapicall),
      );
    }
  } catch (error) {
    yield put(settheinternaldepartmentremarkdsdataError(error));
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}

function* settheInternalDashboardTicketSaga(payloads) {
  console.log(payloads, "payloajeyuiwyeuywds");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: InternalDashbaordApi,
        params: payloads.payload,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      console.log(response, "siodoiasud response", response.data.data);

      yield put(
        setTheTicketsystemrecordgetListInternalDataResponses(
          response.data.data,
        ),
      );
      yield put(
        setTicketsystemRecordListInternalDashboardReport(response.data.data),
      );
      console.log(
        response.data.data,
        "qiudkjashdkjasd",
        response.data.total_count,
      );
      yield put(getLoaderAction(false));
      yield put(
        setTheTicketsystemrecordgetListInternalDataTotalCounts(
          response.data.total_count,
        ),
      );
    } catch (error) {
      yield put(setTheQTicketsystemrecordgetListInternalDatasError(error));
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* settheinternalNearDueSagaListed(payloads) {
  console.log(payloads, "payloajeyuiwyeuywds");
  if (payloads != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: InternalNearDueApi,
        params: payloads.payload,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(
        setTheTicketsystemrecordgetListInternalNearDueDataResponses(
          response.data.data,
        ),
      );
      yield put(
        setTheTicketsystemrecordgetListInternalNearDueDataResponses(
          response.data.data,
        ),
      );
      console.log(
        response.data.data,
        "qiudkjashdkjasd",
        response.data.total_count,
      );
      yield put(getLoaderAction(false));
      yield put(
        setTheTicketsystemrecordgetListInternaNearDuelDataTotalCounts(
          response.data.total_count,
        ),
      );
    } catch (error) {
      yield put(
        setTheQTicketsystemrecordgetListInternalNearDueDatasError(error),
      );
      yield put(getLoaderAction(false));

      if (error.response.data.status.code == 401) {
        console.log("401 erweu", error.response.data.status.code);

        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* settheReassignandAssignAndRejectSAGACalls(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: rejectassignReassignapi + payload.payload.EditId + "/",
        data: payload.payload.data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setthereassignandAssignRejectDataResponse(response.data.data));

      yield put(getLoaderAction(false));
      if (store.getState().StateManagementOverallCall.AssignandReassign == 1) {
        if (typeof payload.payload.Funcations === "function") {
          payload.payload.Funcations();
        }
        //   const payloadAssin = {
        //     data: {
        //         name: `'${"The Internal Ticket Has Been Created"} '`,
        //         description: `'${"The Internal Ticket Has Been Created"} '`,
        //         documents: [],
        //         // uds_user_id: "",
        //         ticket_id: store.getState().StateManagementOverallCall.TicketIDS,
        //         // status: "1",
        //         uds_user_id: store.getState().SideBarFiles.LoginIDs,
        //     },
        //     remarks: 1,
        //     Assinged:1,
        //     Funcations: payload.payload.Funcations(),

        // }
        // yield put (settheRemarkspostActions(payloadAssin))
      } else if (
        store.getState().StateManagementOverallCall.AssignandReassign == 2
      ) {
        if (payload.payload.ticket_assign_mode == "Reassign") {
          yield put(settheReassignTicketpopups(true));
          // if (typeof payload.payload.Funcations === "function") {
          //   payload.payload.Funcations();
          // }

          //   const payloadReassign = {
          //     data: {
          //         name: `' ${"The Internal Ticket Has Been Reassigned"} '`,
          //         description: `' ${"The Internal Ticket Has Been Reassigned"} '`,
          //         documents: [],
          //         // uds_user_id: "",
          //         ticket_id: store.getState().StateManagementOverallCall.TicketIDS,
          //         // status: "1",
          //         uds_user_id: store.getState().SideBarFiles.LoginIDs,
          //     },
          //     remarks: 1,
          //     Assinged:1,
          //     Funcations: payload.payload.Funcations(),

          // }
          // yield put (settheinternaldepartmentRemarksgetaction(payloadReassign))
        } else if (payload.payload.data.ticket_assign_mode == "reject") {
          if (typeof payload.payload.Funcations === "function") {
            payload.payload.Funcations();
          }

          const payloadtimeline = {
            ticket_id: store.getState().StateManagementOverallCall.TicketIDS,
          };
          yield put(
            setTheInternalDepartmentRetreve_TicketTImelinesActions(
              payloadtimeline,
            ),
          );

          //   const payloadReassign = {
          //     data: {
          //         name: `' ${"The Internal Ticket Has Been Rejected"} '`,
          //         description: `' ${"The Internal Ticket Has Been Rejected"} '`,
          //         documents: [],
          //         // uds_user_id: "",
          //         ticket_id: store.getState().StateManagementOverallCall.TicketIDS,
          //         // status: "1",
          //         uds_user_id: store.getState().SideBarFiles.LoginIDs,
          //     },
          //     remarks: 1,
          //     Assinged:2,
          //     // Funcations: payload.payload.Funcations(),
          //     Rejected:1

          // }
          // yield put (settheinternaldepartmentRemarksgetaction(payloadReassign))
        }

        // window.location.href="/internalTicketuserlist"
      }
    } catch (error) {
      yield put(setthereassignandAssignRejectDataError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* gettheClientTicketDetailslistedforinternal(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: clientticketview + payload.payload.EditId + "/",

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(settheClientTicketDetailsDataResponse(response.data.data));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(settheClientTciketDetailsDataError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* gettheUnregisterAssignOrRejectSagaActions(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: UnregisterAssign + payload.payload.EditId + "/",
        data: payload.payload.data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(settheTicketUnregisterAssignResponse(response.data.data));
      toast.success(` ${response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      yield put(getLoaderAction(false));
      const contents = {
        search: payload.payload.search,
        page_size: payload.payload.page_size,
        page: payload.payload.page,
      };
      yield put(
        settheTicketsystem_unregisterrecordgetListDataActions(contents),
      );
    } catch (error) {
      yield put(settheTicketUnregisterAssignError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* gettheexcalationgetsagalisted(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: escalationlevelapi + payload.payload.EditId + "/",
        params: payload.payload.paramsdata,

        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(settheTicketEscalationResponse([response.data.data]));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(settheTicketEscalationError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* gettheTicketJourneyDatasSaglisted_internal(payload) {
  console.log(payload, "ticketjourney lieted");

  if (payload.payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: tickethourneyapi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      console.log(response.data.data, "saduas9dusaud oisdu ");

      yield put(settheTicketJourneyResponse(response.data.data));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(settheTicketJourneyError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}
function* gettheTicketJourneyDatasSaglisted_client(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: tickethourneyapi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(settheTicketJourneyResponseclientside(response.data.data));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(settheTicketJourneyErrorclient(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

/// sub ticket

function* gettheSubticketSagas(payload) {
  console.log(payload, "ticketjourney lieted");

  if (payload.payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: subticketapi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      console.log(response.data.data, "saduas9dusaud oisdu ");

      yield put(settheSubticketgetActionsResponses(response.data.data));
      //  settheSubticketgetActionsTotal_counts
      yield put(
        settheSubticketgetActionsTotal_counts(response.data.total_count),
      );

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(settheSubticketgetActionsErrors(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* gettheClientTicketsagalisted(payload) {
  console.log(payload, "ticketjourney lieted");

  if (payload.payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: clientticketsapi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      console.log(response.data.data, "saduas9dusaud oisdu ");

      yield put(settheclientloneticketresponseActions(response.data.data));
      //  settheSubticketgetActionsTotal_counts
      yield put(
        settheclientloneticketAction_total_counts(response.data.total_count),
      );

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(settheclientloneticketActionsErrors(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* getheClientloneticketraisedsagacatgeory(payload) {
  console.log(payload, "ticketjourney lieted");

  if (payload.payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: clientticketcategoryapi + payload.payload.client_id + "/",
        params: payload.payload.passing,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      console.log(response.data.data, "saduas9dusaud saduas9dusaud oisdu ");

      yield put(settheClientCategoryDataResponses(response.data.data));
      //  settheSubticketgetActionsTotal_counts
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(settheClientCategoryDataError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* GETTHEclientSubcategoryActionsaga(payload) {
  console.log(payload, "ticketjourney lieted");

  if (payload.payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: cliensubcategoryapi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      console.log(response.data.data, "saduas9dusaud saduas9dusaud oisdu ");

      yield put(settheClientSubcategorylistedresponses(response.data.data));
      //  settheSubticketgetActionsTotal_counts
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(settheClientSubcategorylistedError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* SETTEHClient_ticketAs_raised(payload) {
  console.log(payload, "payload");
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: clientticketcreateapi,
        data: payload.payload.data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(settheClientCategoryDataLonesResponses(response.data.data));

      yield put(getLoaderAction(false));
      yield put(settheTicketSuccesspopuos(true));
    } catch (error) {
      yield put(getLoaderAction(false));

      if (error.response.status != 500) {
        yield put(settheClientCategoryDataLonesError(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* getthenotificationlistoutsagacalls(payload) {
  console.log(payload, "ticketjourney lieted");

  if (payload.payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: notifiapilist,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      console.log(response.data, "saduas9dusaud saduas9dusaud oisdu ");

      yield put(setthenotificationactionsResponses(response.data.data));
      //  settheSubticketgetActionsTotal_counts
      yield put(settheNotificationToatalcounts(response.data.total_count));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setthenotificationactionsErrors(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* getthenotificationDeletesagacalls(payload) {
  console.log(payload, "ticketjourney lieted");

  if (payload.payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "Delete",
        url: notifiapilist + payload.payload.Deleteid + "/",
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      console.log(response.data.data, "saduas9dusaud saduas9dusaud oisdu ");

      yield put(
        setthenotificationactionsDeletelistResponses(response.data.data),
      );
      //  settheSubticketgetActionsTotal_counts
      const payloadgetilist = {
        user: store.getState().SideBarFiles.LoginIDs,
      };

      yield put(setthenotificationactionsgetlist(payloadgetilist));
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setthenotificationactionsDeletelistErrors(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* gettheNewDashboardRecordOflisted(payload) {
  console.log(payload, "ticketjourney lieted");

  if (payload.payload != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: dhashboardgraphapi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(settheNewDashboardRecordsResponse(response.data.data));

      yield put(getLoaderAction2(false));
    } catch (error) {
      yield put(settheNewDashboardErrors(error));
      yield put(getLoaderAction2(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* gettheSubassignedTicketDashboardSaga(payload) {
  if (payload.payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: subassigneddashboardapi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(settheSubAssignDashboardRecordsResponse(response.data.data));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(settheSubAssignDashboardErrors(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* gettheAdvanceAttendance_state_Saga(payload) {
  if (payload.payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: advanceattendanceState,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(settheAdvanceStateResponsHold(response.data.data));

      yield put(getLoaderAction(false));
      const advanceDashboard = payload.payload;
      yield put(settheAdvancDatas_SecondStateHold(advanceDashboard));
    } catch (error) {
      yield put(setTheAdvanceStateErrorHold(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* gettheAdvanceAttendance_Employee_list_Saga(payload) {
  if (payload.payload != undefined) {
    try {
      yield put(settheadvance_attendanceloader(true));
      const response = yield axios({
        method: "get",
        url: advanceattendancetable,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      console.log(response.data, "response.data");

      yield put(settheAdvanceEmployeeResponsHold(response.data.data));
      yield put(settheadvanceEmployeetotal_counts(response.data.total_count));
      yield put(settheadvance_attendanceloader(false));
    } catch (error) {
      yield put(setTheAdvanceEmployeeErrorHold(error));
      yield put(settheadvance_attendanceloader(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* gettheAdvanceAttendance_Employee_listSummary_reportsSaga(payload) {
  if (payload.payload != undefined) {
    try {
      yield put(settheadvance_attendanceloader_summary(true));
      const response = yield axios({
        method: "get",
        url: attendance_summary_countapi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      console.log(response.data, "response.data");

      yield put(settheAdvanceEmployeeRespons_summaryHold(response.data.data));
      yield put(
        settheadvanceEmployeetotal_counts_summary(response.data.total_count),
      );
      yield put(settheadvance_attendanceloader_summary(false));
    } catch (error) {
      yield put(setTheAdvanceEmployeeErrorHold_summary(error));
      yield put(settheadvance_attendanceloader_summary(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.status != 500) {
        yield put(settheRegionalManagerErrors(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
        if (error.response.data.status.code == 401) {
          localStorage.clear();
          window.location.href = "/";
        }
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* gettheAdvanceAttendance_Employee_Count_Saga(payload) {
  if (payload.payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: advanceattendancecount,
        params: payload.payload.Counts,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(settheAdvanceEmployeeRespons_countHold(response.data.data));

      yield put(getLoaderAction(false));
      const EmployeePayload = payload.payload.EmployeePayload;
      yield put(settheAdvanceEmployeeDatasHold(EmployeePayload));
    } catch (error) {
      yield put(setTheAdvanceEmployeeError_countsHold(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* gettheAdvanceAttendance_Second_state_Saga(payload) {
  if (payload.payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: advanceSecondstateapi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(settheAdvanceRespons_SecondStatHold(response.data.data));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setTheAdvanceError_SecondStatHold(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* setthermOnboarderDetailsPOsted(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "post",
        url: RmOnboardapi,
        data: payload.payload.data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(settheRegionalMangerdata_ResponseHolder(response.data.data));

      yield put(getLoaderAction(false));
      yield put(setRmOnboarderdatas(true));
    } catch (error) {
      yield put(getLoaderAction(false));

      if (error.response.status != 500) {
        yield put(settheRegionalManagerErrors(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* setthe_internal_data_tablewithcategory(payload) {
  if (payload != undefined) {
    try {
      yield put(settheinternalDashboardloadBool(true));
      const response = yield axios({
        method: "get",
        url: internalcategory_dashboardapi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(settheInternal_dashboard_ResponseHolder(response.data.data));
      yield put(
        settheinternal_dashboard_total_counts(response.data.total_count),
      );

      yield put(settheinternalDashboardloadBool(false));
    } catch (error) {
      yield put(settheinternalDashboardloadBool(false));

      if (error.response.status != 500) {
        yield put(settheInterna_dashboard_table_Errors(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* setthe_customer_support_tablewithdepartments(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: Customer_department_dashboardapi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(settheCustomer_dashboard_ResponseHolder(response.data.data));
      yield put(
        settheCustomer_dashboard_total_counts(response.data.total_count),
      );

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));

      if (error.response.status != 500) {
        yield put(settheCustomer_dashboard_table_Errors(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* getthestatebasedinternalticketstatus(payload) {
  if (payload != undefined) {
    try {
      yield put(settheinternalDashboardloadBool(true));
      const response = yield axios({
        method: "get",
        url: InternalStatebasedapi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setstatebasedInternalTableData(response.data.data));
      yield put(setstatebasedInternalTotalCount(response.data.total_count));

      yield put(settheinternalDashboardloadBool(false));
    } catch (error) {
      yield put(settheinternalDashboardloadBool(false));

      if (error.response.status != 500) {
        yield put(setstatebasedInternalError(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* getthestatebasedCustomner_ticketstatus(payload) {
  if (payload != undefined) {
    try {
      yield put(settheinternalDashboardloadBool(true));
      const response = yield axios({
        method: "get",
        url: CustomerSupport_stateApi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(
        settheState_basedCustomer_dashboard_ResponseHolder(response.data.data),
      );
      yield put(
        settheStateBasedCustomer_dashboard_total_counts(
          response.data.total_count,
        ),
      );

      yield put(settheinternalDashboardloadBool(false));
    } catch (error) {
      yield put(settheinternalDashboardloadBool(false));

      if (error.response.status != 500) {
        yield put(settheStateBased_Customer_dashboard_table_Errors(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* gettheEscalationlevelfor_internalsupport(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: escalation_internal,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(settheEscalationResponsehold(response.data.data));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(getLoaderAction(false));

      if (error.response.status != 500) {
        yield put(settheEscalationErrormessgae(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* gettheEscalationlevelfor_Externalsupport(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: escalation_External,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(settheExternalEscalationResponsehold(response.data.data));

      yield put(getLoaderAction2(false));
    } catch (error) {
      yield put(getLoaderAction2(false));

      if (error.response.status != 500) {
        yield put(settheExternalEscalationErrormessgae(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* gettheCustomer_support_trendingtickets(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: trendingtickets,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setTicketTrendData(response.data.data));

      yield put(getLoaderAction2(false));
    } catch (error) {
      yield put(getLoaderAction2(false));

      if (error.response.status != 500) {
        yield put(setTicketTrendError(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* getthePerformance_MatrixdatasSagas(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: trendingtickets,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setPerformance_matrix_Data(response.data.data));

      yield put(getLoaderAction2(false));
    } catch (error) {
      yield put(getLoaderAction2(false));

      if (error.response.status != 500) {
        yield put(setPerformance_Matrix_Error(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* gettheCustom_categoryListed_saga(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: categorytopfiveapi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setCategoryList_Data(response.data.data));

      yield put(getLoaderAction2(false));
    } catch (error) {
      yield put(getLoaderAction2(false));

      if (error.response.status != 500) {
        yield put(setCategoryList_Error(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* getthecategoryfivechartrecordssaga(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: categorytopfiveapi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setCategoryChart_Data(response.data.data));

      yield put(getLoaderAction2(false));
    } catch (error) {
      yield put(getLoaderAction2(false));

      if (error.response.status != 500) {
        yield put(setCategoryChart_Error(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* getthecustom_support_RegionalTabcard(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: custom_card_regionapi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setCustomerSupportCard_StateData(response.data.data));

      yield put(getLoaderAction2(false));
    } catch (error) {
      yield put(getLoaderAction2(false));

      if (error.response.status != 500) {
        yield put(setCustomerSupportCard_StateError(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* gettheCustom_state_listed_sagas(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: custom_statechart,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setCustomerSupportStateListData(response.data.data));

      yield put(getLoaderAction2(false));
    } catch (error) {
      yield put(getLoaderAction2(false));

      if (error.response.status != 500) {
        yield put(setCustomerSupportStateListError(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* gettheState_chart_customSaga(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: custom_statechart,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setCustomerSupportStateChartData(response.data.data));

      yield put(getLoaderAction2(false));
    } catch (error) {
      yield put(getLoaderAction2(false));

      if (error.response.status != 500) {
        yield put(setCustomerSupportStateChartError(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* gettheRegional_listed_customSaga(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: custom_rgionlist,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setCustomerSupportRegionalListData(response.data.data));

      yield put(getLoaderAction2(false));
    } catch (error) {
      yield put(getLoaderAction2(false));

      if (error.response.status != 500) {
        yield put(setCustomerSupportRegionalListError(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* getRegional_chart_saga(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: custom_rgionlist,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setCustomerSupportRegionalChartData(response.data.data));

      yield put(getLoaderAction2(false));
    } catch (error) {
      yield put(getLoaderAction2(false));

      if (error.response.status != 500) {
        yield put(setCustomerSupportRegionalChartError(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* gettheZone_chartSaga(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: custom_zoneApi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setCustomerSupportZoneChartData(response.data.data));

      yield put(getLoaderAction2(false));
    } catch (error) {
      yield put(getLoaderAction2(false));

      if (error.response.status != 500) {
        yield put(setCustomerSupportZoneChartError(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* gettheZone_ListedSaga(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: custom_zoneApi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setCustomerSupportZoneListData(response.data.data));

      yield put(getLoaderAction2(false));
    } catch (error) {
      yield put(getLoaderAction2(false));

      if (error.response.status != 500) {
        yield put(setCustomerSupportZoneListError(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* gettheClientCustom_ListedSaga(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: cusstom_clientapi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setCustomerSupportClientListData(response.data.data));

      yield put(getLoaderAction2(false));
    } catch (error) {
      yield put(getLoaderAction2(false));

      if (error.response.status != 500) {
        yield put(setCustomerSupportClientListError(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* gettheClientCustom_ChartedSaga(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: cusstom_clientapi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setCustomerSupportClientChartData(response.data.data));

      yield put(getLoaderAction2(false));
    } catch (error) {
      yield put(getLoaderAction2(false));

      if (error.response.status != 500) {
        yield put(setCustomerSupportClientChartError(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* getthe_performance_matrix_sagas(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: custom_performancematrix,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setCustomPerformanceMatrixData(response.data.data));

      yield put(getLoaderAction2(false));
    } catch (error) {
      yield put(getLoaderAction2(false));

      if (error.response.status != 500) {
        yield put(setCustomPerformanceMatrixError(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

/// internal support
function* gettheInternalSupportTrendTickets(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: internal_trendgraphapi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setInternalSupportTrendResponseData(response.data.data));

      yield put(getLoaderAction2(false));
    } catch (error) {
      yield put(getLoaderAction2(false));

      if (error.response.status != 500) {
        yield put(setInternalSupportTrendsActionsError(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* get_internal_support_performanceMarix(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: internal_performancematrix,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setInternalPerformanceData(response.data.data));

      yield put(getLoaderAction2(false));
    } catch (error) {
      yield put(getLoaderAction2(false));

      if (error.response.status != 500) {
        yield put(setInternalPerformanceError(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* get_InternalSupportStateList(payload) {
  if (payload !== undefined) {
    try {
      yield put(getLoaderAction2(true));

      const response = yield axios({
        method: "get",
        url: internal_supportstate,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setInternalSupportStateListData(response.data.data));
    } catch (error) {
      yield put(setInternalSupportStateListError(error));
      if (error.response?.status !== 500) {
        toast.error(`${error.response.data.status.message}`, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error("Something went wrong", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } finally {
      yield put(getLoaderAction2(false));
    }
  }
}

function* get_internal_issue_category_topfive(payload) {
  if (payload !== undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: percentangecategoryapi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setInternalCategoryTopFive(response.data.data));
    } catch (error) {
      yield put(setInternalCategoryTopFiveError(error));
      if (error.response?.status !== 500) {
        toast.error(`${error.response.data.status.message}`, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error("Something went wrong", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } finally {
      yield put(getLoaderAction2(false));
    }
  }
}

function* get_internal_issue_category_list(payload) {
  if (payload !== undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: internal_categoryDataapi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setInternalCategoryList(response.data.data));
    } catch (error) {
      yield put(setInternalCategoryListError(error));
      if (error.response?.status !== 500) {
        toast.error(`${error.response.data.status.message}`, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error("Something went wrong", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } finally {
      yield put(getLoaderAction2(false));
    }
  }
}

function* get_internal_support_state_chart(payload) {
  if (payload !== undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: internal_supportstate,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setInternalSupportChartStateData(response.data.data));
    } catch (error) {
      yield put(setInternalSupportChartStateError(error));
      if (error.response?.status !== 500) {
        toast.error(`${error.response.data.status.message}`, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error("Something went wrong", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } finally {
      yield put(getLoaderAction2(false));
    }
  }
}

function* get_internal_support_regional_chart(payload) {
  if (payload !== undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: internal_supportregion,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setInternalSupportRegionalChartData(response.data.data));
    } catch (error) {
      yield put(setInternalSupportRegionalChartError(error));
      if (error.response?.status !== 500) {
        toast.error(`${error.response.data.status.message}`, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error("Something went wrong", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } finally {
      yield put(getLoaderAction2(false));
    }
  }
}

function* get_internal_support_regional_list(payload) {
  if (payload !== undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: internal_supportregion,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setInternalSupportRegionalListData(response.data.data));
    } catch (error) {
      yield put(setInternalSupportRegionalListError(error));
      if (error.response?.status !== 500) {
        toast.error(`${error.response.data.status.message}`, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error("Something went wrong", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } finally {
      yield put(getLoaderAction2(false));
    }
  }
}

function* get_internal_support_zone_chart(payload) {
  if (payload !== undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: internal_supportzone,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setInternalSupportZoneChartData(response.data.data));
    } catch (error) {
      yield put(setInternalSupportZoneChartError(error));
      if (error.response?.status !== 500) {
        toast.error(`${error.response.data.status.message}`, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error("Something went wrong", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } finally {
      yield put(getLoaderAction2(false));
    }
  }
}
function* get_internal_support_zone_list(payload) {
  if (payload !== undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: internal_supportzone,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setInternalSupportZoneListData(response.data.data));
    } catch (error) {
      yield put(setInternalSupportZoneListError(error));
      if (error.response?.status !== 500) {
        toast.error(`${error.response.data.status.message}`, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error("Something went wrong", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } finally {
      yield put(getLoaderAction2(false));
    }
  }
}

function* get_internal_support_client_chart(payload) {
  if (payload !== undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: internal_supportclient,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setInternalSupportClientChartData(response.data.data));
    } catch (error) {
      yield put(setInternalSupportClientChartError(error));
      if (error.response?.status !== 500) {
        toast.error(`${error.response.data.status.message}`, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error("Something went wrong", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } finally {
      yield put(getLoaderAction2(false));
    }
  }
}
function* get_internal_support_client_list(payload) {
  if (payload !== undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: internal_supportclient,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setInternalSupportClientListData(response.data.data));
    } catch (error) {
      yield put(setInternalSupportClientListError(error));
      if (error.response?.status !== 500) {
        toast.error(`${error.response.data.status.message}`, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error("Something went wrong", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } finally {
      yield put(getLoaderAction2(false));
    }
  }
}

function* get_internal_custom_performance_matrix(payload) {
  if (payload !== undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: internla_ticketHihestapi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setInternalCustomPerformanceMatrixData(response.data.data));
    } catch (error) {
      yield put(setInternalCustomPerformanceMatrixError(error));
      if (error.response?.status !== 500) {
        toast.error(`${error.response.data.status.message}`, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error("Something went wrong", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } finally {
      yield put(getLoaderAction2(false));
    }
  }
}

function* getthecustomer_state_listed_regionalTab(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: custom_statechart,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setStateTableData(response.data.data));

      yield put(getLoaderAction2(false));
    } catch (error) {
      yield put(getLoaderAction2(false));

      if (error.response.status != 500) {
        yield put(setStateError(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* getthe_customer_regional_popupResponse(payload) {
  console.log(payload, "asdiui custom payload");

  if (payload != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: custom_rgionlist,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setRegionalTableData(response.data.data));

      yield put(getLoaderAction2(false));
    } catch (error) {
      yield put(getLoaderAction2(false));

      if (error.response.status != 500) {
        yield put(setRegionalError(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* getthe_customer_zone_Saga_listed(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: custom_zoneApi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setZoneTableData(response.data.data));

      yield put(getLoaderAction2(false));
    } catch (error) {
      yield put(getLoaderAction2(false));

      if (error.response.status != 500) {
        yield put(setZoneError(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* getthe_client_listed_sagaListedFun(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: cusstom_clientapi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setClientTableData(response.data.data));

      yield put(getLoaderAction2(false));
    } catch (error) {
      yield put(getLoaderAction2(false));

      if (error.response.status != 500) {
        yield put(setClientError(error));
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${" something went wrong"} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  }
}

function* get_the_regional_internal_listedTabs(payload) {
  if (payload !== undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: internal_supportregion,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setInternalRegionTableData(response.data.data));
    } catch (error) {
      yield put(setInternalRegionError(error));
      if (error.response?.status !== 500) {
        toast.error(`${error.response.data.status.message}`, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error("Something went wrong", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } finally {
      yield put(getLoaderAction2(false));
    }
  }
}

function* getthe_internal_zone_listed_tabs(payload) {
  if (payload !== undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: internal_supportzone,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setZoneTableData_internal(response.data.data));
    } catch (error) {
      yield put(setZoneError_internal(error));
      if (error.response?.status !== 500) {
        toast.error(`${error.response.data.status.message}`, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error("Something went wrong", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } finally {
      yield put(getLoaderAction2(false));
    }
  }
}

function* get_internalsupport_client_listTabs(payload) {
  if (payload !== undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: internal_supportclient,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(setClientTableData_internal(response.data.data));
    } catch (error) {
      yield put(setClientError_internal(error));
      if (error.response?.status !== 500) {
        toast.error(`${error.response.data.status.message}`, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error("Something went wrong", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } finally {
      yield put(getLoaderAction2(false));
    }
  }
}

function* Updatedthe_Employee_exitingEdit_actionsSaga(payload) {
  console.log(payload, "asoiudo payload");

  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: employee_Editapi + payload.payload.EditId + "/",
        data: payload.payload.data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(settheExitignEmp_editActionsresponse(response.data.data));
      toast.success(` ${response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      const contents = {
        search: payload.payload.payload_pass.search,
        page_size: payload.payload.payload_pass.page_size,
        page: payload.payload.payload_pass.page,
        old_employee: payload.payload.payload_pass.old_employee,
        region: payload.payload.payload_pass.region,
        state: payload.payload.payload_pass.state,
        zone: payload.payload.payload_pass.zone,
        client: payload.payload.payload_pass.client,
      };
      yield put(setTheProfileSignatureActions(contents));

      if (typeof payload.payload.Funcations === "function") {
        payload.payload.Funcations();
      }
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setEmployeeEditActionsError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

/// Master _dashboard

function* get_masterDashbpard_record_lists(payload) {
  if (payload !== undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: master_dashboard_api,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setMasterdashTableData_internal(response.data.data));
      yield put(setMasterdashTotalCount_internal(response.data.total_count));
    } catch (error) {
      yield put(setMasterdashError_internal(error));
      if (error.response?.status !== 500) {
        toast.error(`${error.response.data.status.message}`, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error("Something went wrong", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } finally {
      yield put(getLoaderAction2(false));
    }
  }
}

function* masterDashboardCrudSaga({ payload }) {
  console.log(payload, "payload asdasd");

  const { method, data, id } = payload?.payload;
  // method: "create" | "edit" | "delete"

  try {
    yield put(getLoaderAction2(true));

    let response;
    if (method == "create") {
      response = yield axios({
        method: "post",
        url: master_dashboard_api,
        data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      toast.success("Record created successfully ✅", {
        position: toast.POSITION.TOP_RIGHT,
      });
      if (typeof payload.payload.Funcations === "function") {
        payload.payload.Funcations();
        yield put(resetMasterdashData_internal(payload.payload.listParams));
      }
    } else if (method == "edit") {
      response = yield axios({
        method: "put",
        url: `${master_dashboard_api}${id}`,
        data,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      toast.success("Record updated successfully ✏️", {
        position: toast.POSITION.TOP_RIGHT,
      });
      if (typeof payload.payload.Funcations === "function") {
        payload.payload.Funcations();
        yield put(resetMasterdashData_internal(payload.payload.listParams));
      }
    } else if (method == "delete") {
      response = yield axios({
        method: "delete",
        url: `${master_dashboard_api}${id}`,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      if (typeof payload.payload.Funcations === "function") {
        payload.payload.Funcations();
        yield put(resetMasterdashData_internal(payload.payload.listParams));
      }

      toast.success("Record deleted successfully 🗑️", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }

    // ✅ Store response (optional, you can decide what you want to keep)
    yield put(setMasterdashTableData_CrudOperation(response));
  } catch (error) {
    console.log(error, "aoisduiosa derror");

    yield put(setMasterdashError_Crud_opreation(error));
    if (error.response?.status !== 500) {
      toast.error(`${error.response?.data?.status?.message}`, {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else {
      toast.error("Something went wrong", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  } finally {
    yield put(getLoaderAction2(false));
  }
}

function* gettheOrganization_filterListed(payload) {
  if (payload !== undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: organization_listapi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setOrganizationFilterlistData(response.data.data));
    } catch (error) {
      yield put(setOrganizationFilterlistError(error));
      if (error.response?.status !== 500) {
        toast.error(`${error.response.data.status.message}`, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error("Something went wrong", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } finally {
      yield put(getLoaderAction2(false));
    }
  }
}
function* gettheClientDivisionLevel_dropdown() {
  try {
    const response = yield axios({
      method: "get",
      url: clientDivisionLevelDropdownApi,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(
      setClientDivisionLevelDropdownData(
        response.data.data?.client_division_level || [],
      ),
    );
  } catch (error) {
    yield put(setClientDivisionLevelDropdownError(error));
    toast.error(
      error.response?.data?.status?.message || "Something went wrong",
      {
        position: toast.POSITION.TOP_RIGHT,
      },
    );
  }
}
function* gettheOrganizationRm_filterListed(payload) {
  if (payload !== undefined) {
    try {
      yield put(getLoaderAction2(true));
      const response = yield axios({
        method: "get",
        url: organizationRm_listapi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setOrganizationRmFilterlistData(response.data.data));
    } catch (error) {
      yield put(setOrganizationRmFilterlistError(error));
      if (error.response?.status !== 500) {
        toast.error(`${error.response.data.status.message}`, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error("Something went wrong", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } finally {
      yield put(getLoaderAction2(false));
    }
  }
}
function* getthe_grievance_listedexports(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: grievanceApi_export,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      window.open(response.data.data?.aws_url, "_blank");

      yield put(setGrievanceEMpExporttResponse(response.data.data));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setgrievanceEmpExportError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* getthe_salary_export_annualexports(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: LetterSalaryRevisionApi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      window.open(response.data.data, "_blank");

      yield put(setSalaryEMpExporttResponse(response.data.data));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setSalaryEmpExportError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* getthe_Appointment_export_annualexports(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: LetterAppointmentApi,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      window.open(response.data.data, "_blank");

      yield put(setAppointmentEMpExporttResponse(response.data.data));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setAppointmentEmpExportError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* getthe_salary_export_Revisionexports(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: salary_revision_letter,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      window.open(response.data.data, "_blank");

      yield put(setSalaryrevisionExporttResponse(response.data.data));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setSalaryrevisionExportError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* getthe_Contract_export_exports(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: contract_renewel_letter,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      window.open(response.data.data, "_blank");

      yield put(setContractRenewalResponse(response.data.data));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setContractRenewalError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* getthe_salary_revision_letter_export(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: salary_revision_letter_change_letter,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      window.open(response.data.data, "_blank");

      yield put(setSalaryRevisionChangeResponse(response.data.data));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setSalaryRevisionChangeError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* get_waringin_letter_poor_performances(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: warning_poor_perfomance_api,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      window.open(response.data.data, "_blank");

      yield put(setWarningPoorPerformanceResponse(response.data.data));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setWarningPoorPerformanceError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* get_showcause_letter_performances(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: showcause_abconding,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      window.open(response.data.data, "_blank");

      yield put(setShowCauseAbscondingResponse(response.data.data));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setShowCauseAbscondingError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* get_Genated_letter_performances(action) {
  console.log(action, "asdopuaposd action");

  if (!action?.payload) return;

  try {
    yield put(getLoaderAction(true));

    const { type, ...params } = action.payload;
    console.log(type, params, "adspoudpaosdi psaodua sd");

    let apiUrl = "";

    switch (type) {
      case "relinquishment":
        apiUrl = Relinquishment_api;
        break;

      case "designation_change":
        apiUrl = Designation_api;
        break;

      case "role_change":
        apiUrl = Role_Change_api;
        break;

      case "transfer":
        apiUrl = transfer_letter_api;
        break;

      case "relieving":
        apiUrl = relieving_letter_api;
        break;

      case "experience":
        apiUrl = experience_letter_api;
        break;

      default:
        throw new Error("Invalid letter type");
    }

    const response = yield call(axios, {
      method: "get",
      url: apiUrl,
      params,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    window.open(response.data.data, "_blank");

    yield put(setGenerated_lettersResponse(response.data.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(setGeneratedError(error));
    yield put(getLoaderAction(false));

    toast.error(`${error.response?.data?.status?.message}`, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error.response?.data?.status?.code === 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

// for the particular users

function* gettheAdvanceAttendance_Employee_Count_Saga_particular_client(
  payload,
) {
  if (payload.payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: advanceattendancecount_particular,
        params: payload.payload.Counts,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(
        settheAdvanceEmployeeparticular_Respons_countHold(response.data.data),
      );

      yield put(getLoaderAction(false));
      const EmployeePayload = payload.payload.EmployeePayload;
      yield put(settheAdvanceEmployeeDatas_particularHold(EmployeePayload));
    } catch (error) {
      yield put(setTheAdvanceEmployee_particularError_countsHold(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* gettheAdvanceAttendance_state_Saga_particular(payload) {
  if (payload.payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: advanceattendanceState_particular,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(settheAdvanceState_particularResponsHold(response.data.data));

      yield put(getLoaderAction(false));
      const advanceDashboard = payload.payload;
      yield put(settheAdvancDatas_Second_particularStateHold(advanceDashboard));
    } catch (error) {
      yield put(setTheAdvanceState_particularErrorHold(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* gettheAdvanceAttendance_Second_state_Saga_particular(payload) {
  if (payload.payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: advanceSecondstateapi_particular,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      yield put(
        settheAdvanceRespons_Second_particularStatHold(response.data.data),
      );

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setTheAdvanceError_Second_particularStatHold(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

//
function* gettheAdvanceAttendance_Employee_list_Saga_particular(payload) {
  if (payload.payload != undefined) {
    try {
      yield put(settheadvance_attendanceloader(true));
      const response = yield axios({
        method: "get",
        url: advanceattendancetable_particular,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      console.log(response.data, "response.data");

      yield put(
        settheAdvanceEmployeeRespons_particularHold(response.data.data),
      );
      yield put(
        settheadvanceEmployeetotal_counts_particular(response.data.total_count),
      );
      yield put(settheadvance_attendanceloader(false));
    } catch (error) {
      yield put(setTheAdvanceEmployeeErrorHold_particular(error));
      yield put(settheadvance_attendanceloader(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* gettheAdvanceAttendance_Employee_listSummary_reportsSaga_particular(
  payload,
) {
  if (payload.payload != undefined) {
    try {
      yield put(settheadvance_attendanceloader_summary(true));
      const response = yield axios({
        method: "get",
        url: attendance_summary_countapi_particular,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      console.log(response.data, "response.data");

      yield put(
        settheAdvanceEmployeeRespons_summary_particularHold(response.data.data),
      );
      yield put(
        settheadvanceEmployeetotal_counts_summary_particular(
          response.data.total_count,
        ),
      );
      yield put(settheadvance_attendanceloader_summary(false));
    } catch (error) {
      yield put(setTheAdvanceEmployeeErrorHold_summary(error));
      yield put(settheadvance_attendanceloader_summary(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

// 🔹 Get pre-signed URL
function* getPresignedUrlSaga(action) {
  console.log("getPresignedUrlSaga action", action);

  try {
    yield put(getLoaderAction(true));

    const { file, awsFilePostApi, data, editedId } = action.payload;

    // ✅ get token like your existing saga
    // const token = yield select(
    //   (state) => state.users.UserData.session.token
    // );

    const response = yield axios({
      method: "post",
      url: awsFilePostApi,
      data: {
        multiple_files: [
          {
            filename: `onboarding/user_sign/${file.name}`,
            file_type: file.type,
          },
        ],
      },
      // headers: {
      //   Authorization: "Bearer " + token,
      // },
    });
    console.log("response?.data?.data?.data", response?.data?.data, file);

    const presignedData = response?.data?.data?.[0];

    yield put(getPresignedUrlSuccess(presignedData));

    // 🔥 trigger PUT upload
    yield put(uploadSignatureRequest({ presignedData, file, data, editedId }));

    yield put(getLoaderAction(false));
  } catch (error) {
    console.log(error, "asdspodi asderror");

    yield put(getPresignedUrlFailure(error));
    yield put(getLoaderAction(false));

    responsiveToast("Failed to get presigned URL", "error");

    // ✅ 401 handling (same as your pattern)
    if (error?.response?.data?.status?.code === 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

function* uploadSignatureSaga(action) {
  try {
    yield put(getLoaderAction(true));

    const { presignedData, file, data, editedId, Funcations } = action.payload;
    console.log(presignedData, file, "presignedData, file", data, editedId);

    yield axios({
      method: "put",
      url: presignedData,
      data: file,
      headers: {
        "Content-Type": file.type,
        "x-amz-acl": "public-read",
      },
    });
    yield put(getLoaderAction(false));

    const finalUrl = presignedData.split("?")[0];
    const contents = {
      data: { ...data, user_sign_image: finalUrl },
      EditId: editedId,
    };
    console.log(contents, "asiduapsd  contents");

    yield put(setSignatureEmployeeUpdatedAction(contents));

    yield put(uploadSignatureSuccess(finalUrl));

    responsiveToast("Signature uploaded successfully", "success");
  } catch (error) {
    yield put(uploadSignatureFailure(error));
    yield put(getLoaderAction(false));

    // toast.error("Signature upload failed", {
    //   position: toast.POSITION.TOP_RIGHT,
    // });
  }
}

function* getPresignedUrlEmployeeEsignSaga(action) {
  try {
    yield put(getLoaderAction(true));
    const { file, awsFilePostApi, editedId } = action.payload;

    const response = yield axios({
      method: "post",
      url: awsFilePostApi,
      data: {
        multiple_files: [
          {
            filename: `onboarding/user_sign/${file.name}`,
            file_type: file.type,
          },
        ],
      },
    });

    const presignedData = response?.data?.data?.[0];
    yield put(getPresignedUrlEmployeeEsignSuccess(presignedData));

    yield put(
      uploadSignatureEmployeeEsignRequest({ presignedData, file, editedId })
    );
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getPresignedUrlEmployeeEsignFailure(error));
    yield put(getLoaderAction(false));
    responsiveToast("Failed to get presigned URL", "error");
  }
}

function* uploadSignatureEmployeeEsignSaga(action) {
  try {
    yield put(getLoaderAction(true));
    const { presignedData, file, editedId } = action.payload;

    yield axios({
      method: "put",
      url: presignedData,
      data: file,
      headers: {
        "Content-Type": file.type,
        "x-amz-acl": "public-read",
      },
    });
    yield put(getLoaderAction(false));

    const finalUrl = presignedData.split("?")[0];
    const contents = {
      data: { employee_sign_url: finalUrl },
      EditId: editedId,
    };

    yield put(updateEmployeeEsignRequest(contents));
    responsiveToast("Signature uploaded successfully", "success");
  } catch (error) {
    yield put(getLoaderAction(false));
    responsiveToast("Signature upload failed", "error");
  }
}

function* getthe_selfonboarding_retrieve(payloads) {
  console.log(payloads.payload, "selfonboard retrieve payload");

  try {
    yield put(getLoaderAction2(true));
    const response = yield axios({
      method: "get",
      url: selfonboardRetriveApi + payloads.payload.retrieveId + "/",
    });
    console.log(response.data, "selfonboard retrieve response");
    const retrievedData = response.data?.data || response.data;
    yield put(setSelfonboardingRetrieveResponse(retrievedData)); yield put(getLoaderAction2(false));
  } catch (error) {
    yield put(setSelfonboardingRetrieveError(error));
    responsiveToast(` ${"Something went wrong"} `, "error");
  } finally {
    yield put(getLoaderAction2(false));
  }
}

function* getthe_retrirve_of_employee_details(payloads) {
  console.log(payloads.payload, "paipdoasdj");

  try {
    yield put(getLoaderAction2(true));
    const response = yield axios({
      method: "get",
      url: user_retrieve_api,
      params: payloads.payload,
    });
    console.log(response.data, "401");
    const retrievedData = response.data?.data || response.data;
    yield put(setSignatureEmployeeRetrieveResponse(retrievedData));
  } catch (error) {
    yield put(setSignatureEmployeeRetrieveError(error));
    responsiveToast(` ${"Something went wrong"} `, "error");
  } finally {
    yield put(getLoaderAction2(false));
  }
}

function* Update_the_employee_esignature_forms(payload) {
  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: user_update_api + payload.payload.EditId + "/",
        data: payload.payload.data,
      });

      yield put(setSignatureEmployeeUpdatedResponse(response.data.data));
      console.log(response.data.status.message, "response.data.status.message");

      responsiveToast(`${response.data.status.message} `, "success");

      const contents = {
        timeline_id: payload.payload.EditId,
      };
      yield put(setSignatureEmployeeRetrieveAction(contents));

      //      if (typeof payload.payload.Funcations === "function") {
      //   payload.payload.Funcations();
      // }
      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setSignatureEmployeeUpdatedError(error));
      yield put(getLoaderAction(false));
      responsiveToast(` ${"Something went wrong"} `, "error");
    }
  }
}

function* getEmployeeEsignRetrieveSaga(action) {
  try {
    yield put(getLoaderAction2(true));
    const response = yield axios({
      method: "get",
      url: employeeEsignRetriveApi + action?.payload?.timeline_id + "/",
      // params: action.payload,
    });
    const retrievedData = response.data?.data || response.data;
    yield put(getEmployeeEsignRetrieveSuccess(retrievedData));
  } catch (error) {
    yield put(getEmployeeEsignRetrieveFailure(error));
    responsiveToast("Something went wrong", "error");
  } finally {
    yield put(getLoaderAction2(false));
  }
}

function* updateEmployeeEsignSaga(action) {
  if (action?.payload) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: employeeEsignUpdateApi + action.payload.EditId + "/",
        data: action.payload.data,
      });

      yield put(updateEmployeeEsignSuccess(response.data?.data));
      if (response.data?.status?.message) {
        responsiveToast(`${response.data.status.message}`, "success");
      }

      const contents = {
        timeline_id: action.payload.EditId,
      };
      yield put(getEmployeeEsignRetrieveRequest(contents));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(updateEmployeeEsignFailure(error));
      yield put(getLoaderAction(false));
      responsiveToast("Something went wrong", "error");
    }
  }
}

function* user_retrieve_saga_forthe_form_exports(payload) {
  console.log(payload, "asoiudo payload");

  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: employee_retrieve_apo,
        params: payload.payload.params,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });
      console.log(response.data, "response response.data.");

      yield put(setFormExportsUsersRetrieveResponse(response.data.data));
      toast.success(` ${response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setFormExportsUsersRetrieveError(error));
      yield put(getLoaderAction(false));
      toast.error(` ${error.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* user_Updations_saga_forthe_form_exports(payload) {
  console.log(payload, "asoiudo payload");

  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "put",
        url: employee_retrieve_apo + payload.payload.EditId + "/",
        data: payload.payload.data,
        params: payload.payload.params,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setFormReportsUpdatedResponse(response.data.data));
      toast.success(` ${response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
      });

      const context_ = {
        params: {
          user_id: payload.payload.data?.user_id,
          is_form_requested: true,
        },
      };
      yield put(setFormExportsUsersRetrieveAction(context_));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setFormReportsUpdatedError(error));
      yield put(getLoaderAction(false));
      if (error.response) {
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error("Something went wrong", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}
//----------------___Sheet Bulkupload--------
function* SheetBulkuploadSaga(payload) {
  console.log(payload?.payload?.file instanceof File, "fdasfsdfsdfsfs");
  try {
    yield put(getLoaderAction(true));
    const formData = new FormData();
    formData.append("report_type", payload?.payload?.report_type);
    formData.append("file", payload?.payload?.file); // 👈 important

    const response = yield axios({
      method: "post",
      url: SheetBulkUploadApi,
      data: formData,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    payload?.payload?.setPopup(false);
    yield put(
      GetSheetBulkUploadDataRequest({
        search: "",
        page_size: 20,
        page: 1,
      }),
    );
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));

    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}
//----------------___Employee Bulkupload--------
function* EmployeeBulkuploadSaga(payload) {
  console.log(payload?.payload?.file instanceof File, "fdasfsdfsdfsfs");
  try {
    yield put(getLoaderAction(true));
    const formData = new FormData();
    formData.append("file", payload?.payload?.file); // 👈 important

    const response = yield axios({
      method: "post",
      url: EmployeeBulkUploadApi,
      data: formData,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    payload?.payload?.setPopup(false);
    yield put(
      GetEmployeeBulkUploadDataRequest({
        search: "",
        page_size: 20,
        page: 1,
      }),
    );
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));

    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}

//----------------___Denave Bulk Upload New--------
function* DenaveBulkUploadNewSaga(payload) {
  try {
    yield put(getLoaderAction(true));
    const formData = new FormData();
    formData.append("file", payload?.payload?.file);

    const response = yield axios({
      method: "post",
      url: denaveBulkUploadNewApi,
      data: formData,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    toast.success(` ${response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    payload?.payload?.setPopup(false);
    yield put(
      GetDenaveBulkUploadNewDataRequest({
        search: "",
        page_size: 20,
        page: 1,
      }),
    );
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));

    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}


// sHEET BULK UPLOAD GET

function* getBulkUploadDataListSaga(payloads) {
  console.log(payloads, "paylasdasdoads");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: SheetBulkUploadApi,
      params: payloads.payload,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(getLoaderAction(false));
    yield put(GetSheetBulkUploadDataSuccess(response?.data));
  } catch (error) {
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}
// Denave State GET

function* getDenaveStateDataListSaga(payloads) {
  console.log(payloads, "paylasdasdoads");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: denaveStateGetApi,
      params: payloads.payload,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(getLoaderAction(false));
    yield put(getDenaveStateDataSuccess(response));
  } catch (error) {
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}
// EMPLOYEE BULK UPLOAD GET

function* getEmployeeBulkUploadDataListSaga(payloads) {
  console.log(payloads, "paylasdasdoads");
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: EmployeeBulkUploadApi,
      params: {
        search: payloads.payload.search,
        page_size: payloads.payload.page_size,
        page: payloads.payload.page,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(getLoaderAction(false));
    yield put(GetEmployeeBulkUploadDataSuccess(response?.data));
  } catch (error) {
    yield put(getLoaderAction(false));
    toast.error(` ${error.response.data.status.message} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    if (error.response.data.status.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

//----------------___Denave Bulk Upload New List--------
function* getDenaveBulkUploadNewDataListSaga(payloads) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: denaveBulkUploadNewListApi,
      params: {
        search: payloads.payload.search,
        page_size: payloads.payload.page_size,
        page: payloads.payload.page,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(getLoaderAction(false));
    yield put(GetDenaveBulkUploadNewDataSuccess(response?.data));
  } catch (error) {
    yield put(getLoaderAction(false));
    // backend may return { status: { message } } or a flat { message }
    toast.error(
      ` ${error.response?.data?.status?.message || error.response?.data?.message || "something went wrong"} `,
      {
        position: toast.POSITION.TOP_RIGHT,
      },
    );
    if (error.response?.data?.status?.code == 401 || error.response?.status == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

//----------------___Sony Bulk Upload--------
function* SonyBulkuploadSaga(payload) {
  try {
    yield put(getLoaderAction(true));
    const formData = new FormData();
    formData.append("file", payload?.payload?.file);

    const response = yield axios({
      method: "post",
      url: sonyBulkUploadPostApi,
      data: formData,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    toast.success(
      ` ${response.data?.message || response.data?.status?.message || "Upload Started"} `,
      {
        position: toast.POSITION.TOP_RIGHT,
      },
    );
    payload?.payload?.setPopup(false);
    yield put(
      GetSonyBulkUploadDataRequest({
        search: "",
        page_size: 20,
        page: 1,
      }),
    );
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));

    const errData = error.response?.data;
    const errMessage =
      errData?.message || errData?.status?.message || "Upload failed";
    const isMissingColumns = /missing required columns/i.test(errMessage);

    toast.error(
      isMissingColumns
        ? `${errMessage}. Please download the latest sample sheet.`
        : ` ${errMessage} `,
      {
        position: toast.POSITION.TOP_RIGHT,
      },
    );
  }
}

//----------------___Letter Onboarding Bulk Upload--------
function* LetterOnboardingBulkUploadSaga(payload) {
  try {
    yield put(getLoaderAction(true));
    const actualFile = payload?.payload?.file?.File || payload?.payload?.file;
    const formData = new FormData();
    if (actualFile) {
      formData.append("file", actualFile);
    }


    console.log(actualFile, "LetterOnboardingBulkUpload file payload", payload);
    const response = yield axios({
      method: "post",
      url: LetterOnboardingApi,
      params: {
        report_type: payload?.payload?.report_type,
      },
      data: formData,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    toast.success(` ${response?.data?.status?.message || "File uploaded successfully"} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    payload?.payload?.setPopup?.(false);
    yield put(
      GetSheetBulkUploadDataRequest({
        search: "",
        page_size: 20,
        page: 1,
        report_type: "6",
      }),
    );
    yield put(
      getLetterOnboardingEmployeeListRequest({
        search: "",
        page_size: 20,
        page: 1,

      }),
    );
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));

    toast.error(` ${error.response?.data?.status?.message || "Upload failed"} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}

//----------------___Letter Onboarding Employee List GET--------
function* getLetterOnboardingEmployeeListSaga(payloads) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: LetterOnboardingEmployeeListApi,
      params: payloads.payload,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(getLoaderAction(false));
    yield put(getLetterOnboardingEmployeeListSuccess(response?.data));
  } catch (error) {
    yield put(getLoaderAction(false));
    yield put(getLetterOnboardingEmployeeListFail(error?.response?.data));
    toast.error(` ${error?.response?.data?.status?.message || "Failed to fetch letter onboarding list"} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}

//----------------___Sony Bulk Upload List--------
function* getSonyBulkUploadDataListSaga(payloads) {
  try {
    yield put(getLoaderAction(true));
    const response = yield axios({
      method: "get",
      url: sonyBulkUploadListApi,
      params: {
        search: payloads.payload.search,
        page_size: payloads.payload.page_size,
        page: payloads.payload.page,
        status: payloads.payload.status,
      },
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(getLoaderAction(false));
    yield put(GetSonyBulkUploadDataSuccess(response?.data));
  } catch (error) {
    yield put(getLoaderAction(false));
    toast.error(` ${error.response?.data?.status?.message || "Failed to fetch data"} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    if (error.response?.data?.status?.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}


function* Skill_assessments_dashbpoard_countss_sagas(payload) {
  console.log(payload, "asoiudo payload");

  if (payload != undefined) {
    try {
      yield put(getLoaderAction(true));
      const response = yield axios({
        method: "get",
        url: skill_assessments_dashboard_api,
        params: payload.payload,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      yield put(setSkillAssessmentDashboardCountResponse(response.data.data));

      yield put(getLoaderAction(false));
    } catch (error) {
      yield put(setSkillAssessmentDashboardCountError(error));
      yield put(getLoaderAction(false));
      if (error.response) {
        toast.error(` ${error.response.data.status.message} `, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error("Something went wrong", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      if (error.response.data.status.code == 401) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
}

function* getHrmsConnectivityListSaga(payloads) {
  try {
    yield put(getLoaderAction2(true));
    const response = yield axios({
      method: "get",
      url: hrmsConnectivityListApi,
      params: payloads.payload,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(getHrmsConnectivityListResponse(response.data.data));
    yield put(setHrmsConnectivityListTotalCount(response.data.total_count));
    yield put(getLoaderAction2(false));
  } catch (error) {
    yield put(setHrmsConnectivityListError(error));
    yield put(getLoaderAction2(false));
    toast.error(` ${error?.response?.data?.status?.message || "Something went wrong"} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error?.response?.data?.status?.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

function* getIdCardListSaga(payloads) {
  try {
    yield put(getLoaderAction2(true));
    const response = yield axios({
      method: "get",
      url: IdCardListApi,
      params: payloads.payload,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(getIdCardListResponse(response.data.data));
    yield put(setIdCardListTotalCount(response.data.total_count));
    yield put(getLoaderAction2(false));
  } catch (error) {
    yield put(setIdCardListError(error));
    yield put(getLoaderAction2(false));
    toast.error(` ${error?.response?.data?.status?.message || "Something went wrong"} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error?.response?.data?.status?.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

function* hrmsConnectivityUpdateSaga(payloads) {
  try {
    yield put(getLoaderAction2(true));
    const id =
      payloads?.payload?.id ||
      "";
    const updateUrl = id
      ? `${hrmsConnectivityJobInfoUpdateApi.replace(/\/+$/, "")}/${id}/`
      : hrmsConnectivityJobInfoUpdateApi;

    const response = yield axios({
      method: "put",
      url: updateUrl,
      data: payloads.payload,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(setHrmsConnectivityUpdateResponse(response.data.data));
    yield put(getLoaderAction2(false));
    toast.success(` ${response?.data?.status?.message || "Updated successfully"} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    // if (typeof payloads?.payload?.navigate === "function") {
    //   payloads.payload.navigate("/hrmsconnectivity");
    // }
  } catch (error) {
    yield put(setHrmsConnectivityUpdateError(error));
    yield put(getLoaderAction2(false));
    toast.error(` ${error?.response?.data?.status?.message || "Something went wrong"} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error?.response?.data?.status?.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

function* hrmsConnectivityStatusUpdateSaga(payloads) {
  try {
    yield put(getLoaderAction2(true));
    const id =
      payloads?.payload?.id ||
      "";
    const updateUrl = id
      ? `${(hrmsConnectivityStatusUpdateApi || hrmsConnectivityUpdateApi).replace(/\/+$/, "")}/${id}/`
      : (hrmsConnectivityStatusUpdateApi || hrmsConnectivityUpdateApi);

    const dataToSend = {
      is_hrms_pushed: payloads?.payload?.is_hrms_pushed !== undefined ? payloads?.payload?.is_hrms_pushed : true,
    };

    const response = yield axios({
      method: "put",
      url: updateUrl,
      data: dataToSend,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });
    yield put(setHrmsConnectivityStatusUpdateResponse(response.data.data));
    yield put(getLoaderAction2(false));
    toast.success(` ${response?.data?.status?.message || "HRMS status updated successfully"} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    if (typeof payloads?.payload?.navigate === "function") {
      payloads.payload.navigate("/hrmsconnectivity");
    }
  } catch (error) {
    yield put(setHrmsConnectivityStatusUpdateError(error));
    yield put(getLoaderAction2(false));
    toast.error(` ${error?.response?.data?.status?.message || "Something went wrong"} `, {
      position: toast.POSITION.TOP_RIGHT,
    });

    if (error?.response?.data?.status?.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

//----------------___Smart Connect Employee List GET Saga--------
function* getSmartConnectEmployeeListSaga(payloads) {
  try {
    yield put(getLoaderAction(true));
    const params = {
      record_type: payloads?.payload?.record_type || "",
      search: payloads?.payload?.search || "",
      page_size: payloads?.payload?.page_size || 20,
      page: payloads?.payload?.page || 1,
    };

    const response = yield axios({
      method: "get",
      url: smartCoonectEmployeeListApi,
      params: params,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(getLoaderAction(false));
    yield put(getSmartConnectEmployeeListSuccess(response?.data));
  } catch (error) {
    yield put(getLoaderAction(false));
    yield put(getSmartConnectEmployeeListFail(error?.response?.data));
    toast.error(` ${error?.response?.data?.status?.message || "Failed to fetch Smart Connect employee list"} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    if (error?.response?.data?.status?.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}

//----------------___Smart Connect Hiring List GET Saga--------
function* getSmartConnectHiringListSaga(payloads) {
  try {
    yield put(getLoaderAction(true));
    const params = {
      search: payloads?.payload?.search || "",
      page_size: payloads?.payload?.page_size || 20,
      page: payloads?.payload?.page || 1,
    };
    if (payloads?.payload?.record_type) {
      params.record_type = payloads?.payload?.record_type;
    }

    const response = yield axios({
      method: "get",
      url: smartConnectHiringListApi,
      params: params,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    yield put(getLoaderAction(false));
    yield put(getSmartConnectHiringListSuccess(response?.data));
  } catch (error) {
    yield put(getLoaderAction(false));
    yield put(getSmartConnectHiringListFail(error?.response?.data));
    toast.error(` ${error?.response?.data?.status?.message || "Failed to fetch Smart Connect hiring list"} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    if (error?.response?.data?.status?.code == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
  }
}


//----------------___Smart Connect Bulk Upload POST Saga--------
function* smartConnectBulkUploadSaga(payload) {
  try {
    yield put(getLoaderAction(true));
    const formData = new FormData();
    formData.append("record_type", payload?.payload?.record_type);
    formData.append("file", payload?.payload?.file);

    const response = yield axios({
      method: "post",
      url: smartCoonectEmployeePostApi,
      data: formData,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    });

    toast.success(` ${response?.data?.status?.message || "File uploaded successfully"} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
    payload?.payload?.setPopup?.(false);
    yield put(
      GetSheetBulkUploadDataRequest({
        search: "",
        page_size: 20,
        page: 1,
        report_type: "4",
      }),
    );
    yield put(smartConnectBulkUploadSuccess(response?.data));
    yield put(getLoaderAction(false));
  } catch (error) {
    yield put(getLoaderAction(false));
    yield put(smartConnectBulkUploadFail(error?.response?.data));
    toast.error(` ${error?.response?.data?.status?.message || error?.response?.data?.message || "Bulk upload failed"} `, {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}

//-------Generator--Funtion
function* watchGetUser() {
  yield takeLatest(sagaActions.FETCH_DATA_SAGA + "/getUserAction", getUserSaga);
  yield takeLatest(
    sagaActions.FETCH_FOTGOT_PASSWORD_PERSON + "/getForgotPasswordPerson",
    getForgotperson,
  );
  yield takeLatest(
    sagaActions.FETCH_SHEET_BULKUPLOAD + "/SheetBulkUploadSucess",
    SheetBulkuploadSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_EMPLOYEE_BULKUPLOAD + "/EmployeeBulkUploadSucess",
    EmployeeBulkuploadSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_SHEET_BULKUPLOAD_GETDATA +
    "/GetSheetBulkUploadDataRequest",
    getBulkUploadDataListSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_DENAVE_STATE_GETDATA + "/getDenaveStateDataRequest",
    getDenaveStateDataListSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_EMPLOYEE_BULKUPLOAD_GETDATA +
    "/GetEmployeeBulkUploadDataRequest",
    getEmployeeBulkUploadDataListSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_DENAVE_BULKUPLOAD_NEW + "/DenaveBulkUploadNewSuccess",
    DenaveBulkUploadNewSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_DENAVE_BULKUPLOAD_NEW_GETDATA +
    "/GetDenaveBulkUploadNewDataRequest",
    getDenaveBulkUploadNewDataListSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_SONY_BULKUPLOAD + "/SonyBulkUploadSuccess",
    SonyBulkuploadSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_SONY_BULKUPLOAD_GETDATA +
    "/GetSonyBulkUploadDataRequest",
    getSonyBulkUploadDataListSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_LETTER_ONBOARDING_BULK_UPLOAD +
    "/LetterOnboardingBulkUploadSuccess",
    LetterOnboardingBulkUploadSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_LETTER_ONBOARDING_EMPLOYEE_LIST +
    "/getLetterOnboardingEmployeeListRequest",
    getLetterOnboardingEmployeeListSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_VERIFY_OTP + "/getOtpVerifyActions",
    setVerifyOtp,
  );
  yield takeLatest(
    sagaActions.FETCH_RESEND_OTP + "/GetResendPerson",
    ResendOtpSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_UPDATE_PASSWORD_ + "/getUpdatedPasswordActions",
    setUpdatePassword,
  );

  yield takeLatest(
    sagaActions.FETCH_ROLE_LIST_TABLE + "/getRoleListActions",
    getRoleLists,
  );
  yield takeLatest(
    sagaActions.FETCH_ROLE_CREAT_LIST + "/getRoleCreateActions",
    setRoleCreate,
  );
  yield takeLatest(
    sagaActions.FETCH_ROLE_DELTE_CALLS_ + "/SetRoleDeleteCalActions",
    RoleDelete,
  );
  yield takeLatest(
    sagaActions.FECTH_ROLE_RETRIRVE_CALL + "/setRoleRetrieveActions",
    getRoleretrieve,
  );
  yield takeLatest(
    sagaActions.FECTH_ROLE_EDIT_CALLS + "/setRoleEditActions",
    setRoleEdits,
  );
  yield takeLatest(
    sagaActions.FETCH_USER_GET_LIST + "/setUserActions",
    getUserList,
  );
  yield takeLatest(
    sagaActions.FETCH_USER_DELETECALL + "/setUserDeleteActions",
    UserDeletes,
  );
  yield takeLatest(
    sagaActions.FETCH_USER_CREATE_DATA + "/setUserCreateActions",
    setUserCreate,
  );
  yield takeLatest(
    sagaActions.FETCH_USER_RETRIEVE_DATA + "/SetUserREtrieveActions",
    getUserRetrieve,
  );
  yield takeLatest(
    sagaActions.FETCH_USER_EDIT_DATA + "/SetUserEditActions",
    SetUserEdits,
  );
  yield takeLatest(
    sagaActions.FETCH_GEO_LOCATIONS + "/setGeoLoactionStateAction",
    getGeoState,
  );
  yield takeLatest(
    sagaActions.FECTH_STATE_CREATE_ACTIONS + "/getStateCreateActions",
    setStateCreate,
  );
  yield takeLatest(
    sagaActions.FETCH_STATE_DELETE_ACTIONS + "/setStateDeleteActions",
    StateDelete,
  );
  yield takeLatest(
    sagaActions.FETCH_STATE_EDIT_ACIONS + "/setStateEditActions",
    setStateEDITS,
  );
  yield takeLatest(
    sagaActions.FETCH_STATE_RETRIEVE_ACTIONS + "/setStateetrieveAction",
    getStateRetrieve,
  );
  yield takeLatest(
    sagaActions.FETCH_REGION_LIST_ACTIONS + "/setRegionActions",
    getRegions,
  );
  yield takeLatest(
    sagaActions.FETCH_REGION_CREATE_LIST + "/getRegionCreateActions",
    setRegionCreate,
  );
  yield takeLatest(
    sagaActions.FETCH_REGION_DELETE_CALL + "/setRegionDeleteActions",
    RegionDelete,
  );
  yield takeLatest(
    sagaActions.FETCH_REGION_RETRIRVE_ALL + "/setRegionetrieveAction",
    getRegionRetrieve,
  );
  yield takeLatest(
    sagaActions.FETCH_REGION_EDIT_CALL + "/setRegionEditActions",
    setReigonEditCall,
  );
  yield takeLatest(
    sagaActions.FETCH_ZONE_LISTS + "/setZoneActions",
    getZONELISt,
  );
  yield takeLatest(
    sagaActions.FETCH_ZONE_CREATE + "/getZoneCreateActions",
    setzoneCreate,
  );
  yield takeLatest(
    sagaActions.FETCH_ZONE_DELETE_CALL + "/setZoneDeleteActions",
    ZoneDeleteCall,
  );
  yield takeLatest(
    sagaActions.FETCH_ZONE_EEDIT_CALL + "/setZoneEditActions",
    setZoneEdiyCall,
  );
  yield takeLatest(
    sagaActions.FETCH_ZONE_RETRIEVE_CALL + "/setZoneetrieveAction",
    getZoneRetrieve,
  );
  yield takeLatest(
    sagaActions.FETCH_CLIENT_GET_LISTS + "/SetClientActions",
    getCLientLIsts,
  );
  yield takeLatest(
    sagaActions.FETCH_CLIENT_CREATE_POST + "/getClientCreateActions",
    ClientCreateCall,
  );
  yield takeLatest(
    sagaActions.FETCH_CLIENT_DELETE_DEL + "/setCLientDeleteActions",
    ClientDleteCall,
  );
  yield takeLatest(
    sagaActions.FETCH_CLIENT_RETRIEVE_LIST + "/setCLientetrieveAction",
    getClientRetrieve,
  );
  yield takeLatest(
    sagaActions.FECTCH_CLIENT_EDIT_LIST + "/setClientEditActions",
    setClientEditCall,
  );
  yield takeLatest(
    sagaActions.FETCH_CLIENT_BRANCHES_LIST_ + "/setClientBranchActions",
    getClientBranchList,
  );
  yield takeLatest(
    sagaActions.FETCH_CLIENT_BRANCHES_CREATE_ + "/setClientBranchCreateActions",
    setBranchCreate,
  );
  yield takeLatest(
    sagaActions.FETCH_CLIENT_BRANCHES_DELETE_CALLS +
    "/setClientBranchDeleteActions",
    setBranchDelete,
  );
  yield takeLatest(
    sagaActions.FETCH_BRANCHES_RETRIEVE_DATA +
    "/setClientBranchesRetrieveActions",
    getBranchRetrieve,
  );
  yield takeLatest(
    sagaActions.FETCH_BRANCHES_EDIT_CALL + "/SetBranchEditActions",
    setBranchEdits,
  );
  yield takeLatest(
    sagaActions.FETCH_BRANCHSEARCH_LIST + "/setClientBranchSearchAction",
    getClientBranchSearchList,
  );
  yield takeLatest(
    sagaActions.FETCH_SHIFT_CALL_TABLE + "/setShiftListsActions",
    getShiftListCal,
  );
  yield takeLatest(
    sagaActions.FETCH_SHIOFT_CREATE_CALL + "/setShiftCreateActions",
    SetShiftCreateCall,
  );
  yield takeLatest(
    sagaActions.FETCH_SHIFT_CALL_DELETE + "/setShiftDeletCall",
    ShiftDeleteSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_SHIFT_RETRIEVE_CALL + "/setShiftRetrieveActions",
    getShiftRetrieveCall,
  );
  yield takeLatest(
    sagaActions.FETCH_SHIFT_EDIT_CALL + "/SetShiftEditActions",
    setShiftEdits,
  );
  yield takeLatest(
    sagaActions.FETCH_SHIFT_SEARCH_CALL_TABLE + "/SetShiftSearchActions",
    getShiftSearch,
  );
  yield takeLatest(
    sagaActions.FETCH_EMPLOYEE_LIST_CALL + "/setEmployeetListsActions",
    getEmployeeList,
  );
  yield takeLatest(
    sagaActions.FETCH_EMPLOYEE_CREATE_CALL + "/SetEmployeeActions",
    EmployeeCreate,
  );
  yield takeLatest(
    sagaActions.FETCH_EMPLOYEE_DELETE_CALL + "/SetEmployeeDeleteActions",
    EmployeeDelete,
  );
  yield takeLatest(
    sagaActions.FETCH_EMPLOYEE_EDIT_CALL + "/SetEmployeeEditcallActions",
    EmployeeEditCall,
  );
  yield takeLatest(
    sagaActions.FETCH_EMPLOYEE_RETRIEVE_CALL + "/SetEmployeeRetrieveActions",
    getRetriveEmp,
  );
  yield takeLatest(
    sagaActions.FETCH_EMPLOYEE_DATA_LIST_CALL + "/setEmployeeListsDATASActions",
    getEmployeaDatasList,
  );
  yield takeLatest(
    sagaActions.FETCH_EMPLOYEE_DATA_PERSONS_LISTED_CALLS +
    "/getEmployeeListPersonsListed",
    getEmployeaSinglePersonsList,
  );
  yield takeLatest(
    sagaActions.FETCH_EMPLOYEE_DETAIL_PROFILE_LIST +
    "/setEmployeeProfileDATASActions",
    getEmployeaSingleFormPersonsList,
  );
  yield takeLatest(
    sagaActions.FETCH_FORMS_DETAILS_BASIC_FORM + "/SetActionsBasicFormsDetails",
    getFormBasicDetails,
  );
  yield takeLatest(
    sagaActions.FETCH_FORMS_DETAILS_ADDRESS_FORM + "/SetAddressForm",
    getAddressFormDetails,
  );
  yield takeLatest(
    sagaActions.FETCH_IDVERIFICATION_DETAILS_FORMS +
    "/setIdVerificationActions",
    getIdverificationdetails,
  );

  yield takeLatest(
    sagaActions.FETCH_BANKDETIAL_DATA_FORM + "/setBankDataActions",
    getBankDetails,
  );
  yield takeLatest(
    sagaActions.FETCH_EDUCATION_DATA_FORMS + "/setEducationDataActions",
    getEDUCATIONDetails,
  );
  yield takeLatest(
    sagaActions.FETCH_PREVIOUS_EMPLOYEE_DETAILS + "/setPreviousEmpDataActions",
    PreviousEmployeeCall,
  );
  yield takeLatest(
    sagaActions.FETCH_FAMILY_DETAILS_EMPLOYEEE + "/setFamilyEmpDataActions",
    FamilyDetailsCall,
  );

  yield takeLatest(
    sagaActions.FETCH_DECALARATION_FORM_DATAS + "/SetDeclarationAction",
    DecalarationDetails,
  );

  yield takeLatest(
    sagaActions.FETCH_DETAILS_FROM_ESI_FORM + "/SetESICALLAction",
    ESICall,
  );

  yield takeLatest(
    sagaActions.FETCH_DAETAILS_FORM_JOB_OFFERDETAILS + "/SetJObofferCall",
    JobofferCall,
  );
  yield takeLatest(
    sagaActions.FETCH_ID_VERIFICATION_EDIT_CALLS +
    "/SetTheIdVerifycationActions",
    GetIdVerificationEditCalls,
  );
  yield takeLatest(
    sagaActions.FETCH_FORMS_APPROVAL_DATAS + "/SetApprovalCallsActions",
    FormApproval,
  );
  yield takeLatest(
    sagaActions.FETCh_COMPLETED_AND_VEIRIFED_USERS + "/SetVerifiedUserActions",
    VerifiedUsersCall,
  );
  yield takeLatest(
    sagaActions.FETCH_JONING_DATE_GENERAT_CALL + "/SetTheJoiningDateCall",
    JoiningDateCall,
  );
  yield takeLatest(
    sagaActions.FETCH_SIGNATURE_CALL_RESPONSE_LIST + "/SetSignatureActions",
    SignatureCalls,
  );
  yield takeLatest(
    sagaActions.FETCH_USER_FILTER_RESPONSE_CALL + "/SettheUserFilterActions",
    getUserListFilter,
  );
  yield takeLatest(
    sagaActions.FETCH_EMPLOYEE_LIST_FLITER_PEN_COMP_DEC_APP +
    "/getEmployeeListFilterPersonsListed",
    getEmployeaSingleLIST_FILTER_PersonsList,
  );
  yield takeEvery(
    sagaActions.FETC_SHIFT_EMPLOYEE_SHEET_EXCEL_UPLOADS +
    "/SettheExcelSheeetUpaloads",
    ExcelSheetUploads,
  );
  yield takeEvery(
    sagaActions.FETCH_LEAVE_TYPE_CREATE + "/SetActionForLeaveTypes",
    LeaveTypeCreate,
  );
  yield takeEvery(
    sagaActions.FETCH_LEAVE_TYPE_LIST_OUTS + "/SetLeaveTypeActions",
    getLeaveTypeLists,
  );
  yield takeEvery(
    sagaActions.FETCH_LEAVE_TYPE_DELETE_CALL + "/SetLeaveTypeDeleteActions",
    LeaveTypeDeleteSaga,
  );
  yield takeEvery(
    sagaActions.FETCH_LEAVE_TYPE_RETRIEVE_CALL + "/SetLeaveTypeRetrieveActions",
    getLeaveTypeRetrieve,
  );
  yield takeEvery(
    sagaActions.FETCH_LEAVE_TYPE_EDITS_CALLS + "/SetLeaveTypeEditActions",
    setLeaveTypeEdits,
  );
  yield takeLatest(
    sagaActions.FETCH_LEAVE_PERMISSION_CALL +
    "/SetTheLeavePermissionListActions",
    getLeavePermissionListCall,
  );
  yield takeLatest(
    sagaActions.FETCH_LEAVE_PERMISSION_SEARCH_CALL +
    "/SetTheLeavePermissionListSearchActions",
    getLeavePermissionListSearchCall,
  );
  yield takeLatest(
    sagaActions.FETCH_LEAVE_PERMISSION_DELETE_CALL +
    "/SetTheLeavePermissionDelete",
    LeavePermissionDelete,
  );
  yield takeLatest(
    sagaActions.FETCH_LEAVE_PERMISSION_RETRIEVE_CALLS +
    "/SetTheLeavePremissionRetrieveActions",
    getLeavePermissionRetrieve,
  );
  yield takeLatest(
    sagaActions.FETCH_LEAVE_PERMISSION_EDIT_CALLS +
    "/SetTheLeavePremissionEditsActions",
    setLeavePermissionEdits,
  );
  yield takeLatest(
    sagaActions.FETCH_DASHBOARD_COUNT_LIST + "/setTheDashboardactions",
    SetTheDashboards,
  );
  yield takeLatest(
    sagaActions.FETCH_CLIENT_SIDE_LEAVE_STATUS__LIST +
    "/getLeaveStatusPersonsListed",
    getLeaveStatusListClientView,
  );
  yield takeLatest(
    sagaActions.FETCH_SHIFT_EXCEL_SHEET_UPLOAD_GET_LIST +
    "/getShiftStatusPersonsListed",
    getexcelSheetUploadList,
  );
  yield takeLatest(
    sagaActions.FETCH_SHIFT_PERMISSION_LISTS + "/setShiftPermissionActions",
    getShiftPermissionList,
  );
  yield takeLatest(
    sagaActions.FETCH_SHIFT_PERMISSION_RETRIEVE +
    "/SetTheShiftPremissionRetrieveActions",
    getShiftPermissionRetrieve,
  );
  yield takeLatest(
    sagaActions.FETCH_SHIFT_PERMISSION_EDITS +
    "/SetTheShiftPremissionEditsActions",
    setShiftPermissionEdits,
  );
  yield takeLatest(
    sagaActions.FETCH_SHIFT_PERMISSION_DELETE + "/SetTheShiftPermissionDelete",
    SiftPermissionDelete,
  );
  yield takeLatest(
    sagaActions.FETCH_RE_INVESTMENT_GET_LIST + "/setReinvestmentAction",
    getreinvesmentLists,
  );
  yield takeLatest(
    sagaActions.FETCH_RE_INVESTMENT_RETRIVE_LIST +
    "/SetTheReinvestmentRetrieveActions",
    ReInvestMentRetrieve,
  );
  yield takeLatest(
    sagaActions.FETCH_RE_INVESTMENT_EDIT_LIST +
    "/SetTheReInvestmentEditsActions",
    ReInvestmentEdits,
  );
  yield takeLatest(
    sagaActions.FETCH_SHIFT_EXCEL_RETRIEVE_LIST +
    "/setTheShiftexcelSheetRetrieveAction",
    getExcelShiftSheetRetrieve,
  );
  yield takeLatest(
    sagaActions.FETCH_ON_DUTY_GET_LIST_RESPONSER + "/SetTheOndutyActions",
    getOnDutySagaActions,
  );
  yield takeLatest(
    sagaActions.FETCH_ON_DUTY_GET_LIST_RETRIEVE +
    "/SetTheonDutyRetrieveActions",
    GetOnDutyRetrieve,
  );
  yield takeLatest(
    sagaActions.FETCH_ON_DUTY_EDIT_REPONSES + "/setTheOndutyEditAction",
    setONDUtyEdits,
  );
  yield takeLatest(
    sagaActions.FETCH_ON_DUTY_DELETED + "/SetTheOndutynDelete",
    OnDutyDelete,
  );
  yield takeLatest(
    sagaActions.FETCH_RESIGN_GET_LIST + "/SetTheResignActions",
    SetTheResignCalls,
  );
  yield takeLatest(
    sagaActions.FETCH_RESIGN_RETRIEVE_LIST + "/SetTheResignRetrieveActions",
    GetResignRetrieve,
  );
  yield takeLatest(
    sagaActions.FETCH_RESIGN_EDIT_LISTS + "/setTheResignEditAction",
    setResignEdits,
  );
  yield takeLatest(
    sagaActions.FETCH_RESIGN_DELETE_CALL + "/SetTheResignDelete",
    ResignDelete,
  );
  yield takeLatest(
    sagaActions.FETCH_EXIT_ALL_DATA + "/SetTheExitActions",
    getExitSagaActions,
  );
  yield takeLatest(
    sagaActions.FETCH_EXIT_RETIEVE_LIST_DATAS + "/SetTheExitRetrieveActions",
    GetExitApprovalRetrieve,
  );

  yield takeLatest(
    sagaActions.FETCH_EXIT_EXIT_LIST_DATAS + "/setTheExitEditAction",
    setExitApprovalEdits,
  );
  yield takeLatest(
    sagaActions.FETCH_EXIT_DELETE_DATAS + "/SetTheExitDelete",
    ExitDelete,
  );
  yield takeLatest(
    sagaActions.FETCH_APPAISAL_DATA + "/setAppraisalAction",
    getAppraisalList,
  );
  yield takeLatest(
    sagaActions.FETCH_APPRAISAL_RETRIEVE_DATA +
    "/SetTheAppraisalRetrieveActions",
    GetAppraisaletrieve,
  );
  yield takeLatest(
    sagaActions.FETCH_APPRAISAL_EDITS + "/SetTheAppraisalditsActions",
    SetTheAppraisaledit,
  );
  yield takeLatest(
    sagaActions.FETCH_PAY_SLIP_DATA + "/setThePayslipAcrions",
    setThePaySlip,
  );
  yield takeLatest(
    sagaActions.FETCH_PAY_SLIP_CREATE + "/setThePayslipCreateAcrions",
    setThePayslipCreate,
  );
  yield takeLatest(
    sagaActions.FETCH_BASIC_FORM_CREATE + "/SetActionsBasicFormscreateDetails",
    getFormBasicDetailsCreate,
  );
  yield takeLatest(
    sagaActions.FETCH_ADDRESS_CREATE + "/SetAddressCreateForm",
    getAddressCreateFormDetails,
  );
  yield takeLatest(
    sagaActions.FETCH_JOB_OFFER_CREATE_FOMR + "/SetJObofferCallAction",
    JoboffercreateCall,
  );

  yield takeLatest(
    sagaActions.FETCH_JOB_OFFER_PREVIEW + "/SetJObofferPreviewCallAction",
    JobofferPreviewCall,
  );
  yield takeLatest(
    sagaActions.FETCH_REMAINDER_EMAIL + "/SetRemainderMailCallAction",
    RemainderMailCall,
  );
  yield takeLatest(
    sagaActions.FETCH_FORM_ACTIONIONCALL_BANK_DETAILS +
    "/setBankDataCreateActions",
    getBankCreateDetails,
  );
  yield takeLatest(
    sagaActions.FETCH_FORM_ACTIONCALL_EDUCATION +
    "/setEducationDatacreateActions",
    getEDUCATIONcreateDetails,
  );
  yield takeLatest(
    sagaActions.FETCH_FIELD_AGENT_BRANC_LIST_OUT +
    "/setThefieldAgentbranchactions",
    getClientBranchFieldBranchList,
  );
  yield takeLatest(
    sagaActions.FTCH_EMPLOYEE_LIST_FOR__MANGER +
    "/getEmployeeListcreatePersonsListed",
    getEmployeaSingleManagerPersonsList,
  );
  yield takeLatest(
    sagaActions.FETCH_BASIC_FORM_EDITS + "/SetActionsBasicFormsEditDetails",
    getFormBasicDetailsEdit,
  );
  yield takeLatest(
    sagaActions.FETCH_ADDRESS_EDITS + "/SetAddressEditForm",
    getAddresseditFormDetails,
  );
  yield takeLatest(
    sagaActions.FETCH_JOB_OFFER_LETTER_EDIT + "/SetJObofferDITCallAction",
    JobofferEDITCall,
  );
  yield takeLatest(
    sagaActions.HR_APPROVAL_OFFER_LETTER_EDIT + "/setHrApprovalCallAction",
    HrApprovalEDITCall,
  );
  yield takeLatest(
    sagaActions.FETCH_ID_VERIFYING_CREATE + "/setIdVerificationActionsCreate",
    getIdverificationCreatedetails,
  );
  yield takeLatest(
    sagaActions.FETCH_BANK_DETAILS_EDIT + "/setBankDataEditActions",
    getBankEditDetails,
  );
  yield takeLatest(
    sagaActions.FETCH_DECLARATION_FORM_CREATE + "/SetDeclarationcreateAction",
    DecalarationCraeteDetails,
  );
  yield takeLatest(
    sagaActions.FETCH_DECLARATION_FORM_EDIT + "/SetDeclarationEditAction",
    DecalarationEditDetails,
  );
  yield takeLatest(
    sagaActions.FETCH_FORM_ESI_FORM_EDIT + "/SetESIEditCALLAction",
    ESIEditCallSaga,
  );

  // yield takeLatest(
  //   sagaActions.FETCH_FORM_ESI_FORM_CREATE + "/SetESICraeteCALLAction",
  //   ESICreateCallSaga
  // );
  yield takeLatest(
    sagaActions.FETCH_UPDATE_NODUE_FORM + "/SetExitNoDueEditActions",
    setExitNodueEdits,
  );

  yield takeLatest(
    sagaActions.FETCH_FORM_ESI_FORM_CREATE + "/SetESICraeteCALLAction",
    ESICreateCallSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_FORM_DATA_LIKE_PRIVIOUS_DATA +
    "/setPreviousDataFetchActions",
    PreviousDataCalls,
  );

  yield takeLatest(
    sagaActions.FETCH_FORM_DATA_LIKE_DATA_FETCH_ + "/settheDataFetchActions",
    DataFecthCallForm,
  );
  yield takeLatest(
    sagaActions.FETCH_FORM_DATA_IN_VERIFYCATION +
    "/setIdVerificationActionsEdit",
    getIdverificationEditdetails,
  );
  yield takeLatest(
    sagaActions.FETCH_FORM_DATAS_PREVIOUS_CALL_CREATE +
    "/setPreviousEmpDataCreateActions",
    PreviousEmployeeCreateCall,
  );

  yield takeLatest(
    sagaActions.FETCH_FORM_DATAS_PREVIOUS_CALL_EDIT +
    "/setPreviousEmpDataeditActions",
    PreviousEmployeeEditCall,
  );

  yield takeLatest(
    sagaActions.FETCH_PAY_SLIP_RETRIEV + "/setThePayslipRtrievecrions",
    setThePayslipRetrieve,
  );
  yield takeLatest(
    sagaActions.FETCH_PAY_SLIP_EDIT + "/setThePayslipEditActions",
    setThePayslipEdit,
  );
  yield takeLatest(
    sagaActions.FETCH_GRIVANCE_TYPE + "/setGrievanceAction",
    GrievanceSagaCAlls,
  );
  yield takeLatest(
    sagaActions.FECTH_GRIEVEANCE_TYPE_FIELD_CREATE +
    "/settheGrievanceCreateActions",
    GrievanceCareteSagaCAlls,
  );
  yield takeLatest(
    sagaActions.FECTH_GRIEVEANCE_TYPE_FIELD_RETRIVE +
    "/settheGrievanceRetrieveActions",
    GrievanceRetriveSagaCAlls,
  );
  yield takeLatest(
    sagaActions.FECTH_GRIEVEANCE_TYPE_FIELD_EDIT +
    "/settheGrievanceEditActions",
    GrievanceEditSagaCAlls,
  );
  yield takeLatest(
    sagaActions.FECTCH_FAMLIY_FORM_FOR_FEILD_AGENT_CREATE +
    "/setFamilyEmpDatacreateActions",
    FamilyDetailsCreateCall,
  );

  yield takeLatest(
    sagaActions.FECTCH_FAMLIY_FORM_FOR_FEILD_AGENT_EDIT +
    "/setFamilyEmpDataEditActions",
    FamilyDetailsEditCall,
  );

  yield takeLatest(
    sagaActions.FETCH_PERFORMANCE_TYPE + "/setPerformanceAction",
    performanceSagaCAlls,
  );
  yield takeLatest(
    sagaActions.FETCH_PERFORMANCE_RETRIEVE_TYPE +
    "/setPerformanceRetreveAction",
    performanceTypeRetrivalSagaCAlls,
  );
  yield takeLatest(
    sagaActions.FETCH_PERFORMANCE_UPDATE_TYPE + "/setPerformanceUpdateAction",
    performanceTypeUpdateSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_PERFORMANCE_CREATE_TYPE + "/setPerformanceCreateAction",
    performanceTypeCreateSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_PERFORMANCE_DELETE_TYPE + "/setPerformanceDeleteAction",
    performanceTypeDeleteSaga,
  );

  yield takeLatest(
    sagaActions.FETCH_PERFORMANCE_CHILD_TYPE + "/setPerformanceChildAction",
    performanceChildSagaCAlls,
  );
  yield takeLatest(
    sagaActions.FETCH_PERFORMANCE_CHILD_RETRIEVE_TYPE +
    "/setPerformanceChildRetreveAction",
    performanceChildTypeRetrivalSagaCAlls,
  );
  yield takeLatest(
    sagaActions.FETCH_PERFORMANCE_CHILD_UPDATE_TYPE +
    "/setPerformanceUpdateChildAction",
    performanceChildTypeUpdateSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_PERFORMANCE_CHILD_CREATE_TYPE +
    "/setPerformanceChildCreateAction",
    performanceChildTypeCreateSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_PERFORMANCE_CHILD_DELETE_TYPE +
    "/setPerformanceChildDeleteAction",
    performanceChildTypeDeleteSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_FORM_PUT_CALL_EDUCATION + "/setEducationDataPutActions",
    geteducationUpdateDetails,
  );
  yield takeLatest(
    sagaActions.FETCH_PERFORM_FIELD_DATA + "/setThePerformFieldAGentGet",
    getPerformsFieldAgentCall,
  );
  yield takeLatest(
    sagaActions.FETCH_PERFORMS_FIELD_AGENT_RETRIEVE_DATAS +
    "/setThePerformsAgentRetrieveACtion",
    getPerformsFieldAgentRetrieveCAll,
  );
  yield takeLatest(
    sagaActions.FETCH_SHEET_UPLOAD_FOR__STATE_CLI_BRANCH +
    "/setTheSHeetuploaAction",
    FileSheetUploadCalls,
  );
  yield takeLatest(
    sagaActions.FETCH_CREATE_EMPLOYEE_SIGNS + "/setThecreateEmploSigAction",
    createEmployeeCreaeSign,
  );
  yield takeLatest(
    sagaActions.FETCH_GRIEVANCE_APPROVAL_ + "/SetTheGrievaceApprovalActions",
    GrievanceApprovalSagaCAlls,
  );
  yield takeLatest(
    sagaActions.FECTCH_GRIEVANCE_EMPLOYEE_LIST_DATA_ACTIONS +
    "/setGrievanceEMPListAction",
    GrievanceEmployeeListSagaCAlls,
  );
  yield takeLatest(
    sagaActions.FECTCH_GRIEVANCE_EMPLOYEE_LIST_DATA_APPROVE +
    "/settheGrievanceEMPApproveretrieveActions",
    GrievanceRetrivApprovedeSagaCAlls,
  );
  yield takeLatest(
    sagaActions.FETCH_ATTENDANCE_REQUEST_LIST_ACTIONS_LIST +
    "/StetheAttendanceActions",
    setTheAttendanceRequestList,
  );
  yield takeLatest(
    sagaActions.FETCH_ATTENDANCE_REQUEST_LIST_ACTIONS_RETRIVE +
    "/StetheAttendanceRetrievActions",
    getTheAttendanceRetrieveSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_PERFORMS_FIELD_AGENT_EDIT_DATAS +
    "/setThePerformsAgentEditACtion",
    getPerformsFieldAgentEDITCAll,
  );
  yield takeLatest(
    sagaActions.FETCH_PERFORMS_FIELD_AGENT_CREATE_DATAS +
    "/setThePerformsAgentCreateACtion",
    getPerformsFieldAgentCREATECAll,
  );
  yield takeLatest(
    sagaActions.FETCH_PERFORMANCE_FIELD_BY_STAND_SEPARATE_API_CALL +
    "/setThePerformsAgentRetrieveseparatestandACtion",
    getPerformsFieldAgentRetrieveSeparateCAllSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_ATTENDANCE___EXPORT + "/StetheAttendanceExportActions",
    setTheattendanceexport,
  );
  yield takeLatest(
    sagaActions.FETCH_BLACKILIST_PERSONA + "/SetTheBlacklistActions",
    getBlackListCall,
  );

  yield takeLatest(
    sagaActions.FETCH_BLACKLIST_DATAS_RETRIEV +
    "/SetTheBlacklistRetrieveActions",
    BlackiListRetrieve,
  );

  yield takeLatest(
    sagaActions.FETCH_BLACKLIST_DATAS_EDIT + "/SetTheBlacklistEditsActions",
    BlackListEdits,
  );
  yield takeLatest(
    sagaActions.FECTCH_SITE_TRANFER_GET_LIST + "/SetTheSiteTransferActions",
    SiteTransferCall,
  );
  yield takeLatest(
    sagaActions.FETCH_SITE_TRANSFER_ACTIONS_FOR_SITE_RETRIEVE_ +
    "/SetTheSiteTransferRetrieveActions",
    SietTransferRetrieve,
  );
  yield takeLatest(
    sagaActions.FETCH_SITE_TRANSFER_ACTIONS_FOR_SITE_APPROVE_CALL +
    "/SetTheSiteTransferEditsActions",
    SiteTransferEdits,
  );
  yield takeLatest(
    sagaActions.FETCH_SITE_TRANSFER_ACTIONS_FOR_CREATE +
    "/SetTheSiteTransferCreateActions",
    SiteTransferCreateSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_BLACK_LIST_ACTIONS_FOR_CREATE +
    "/SetTheBlacklistCreateActions",
    blackilistCreate,
  );
  yield takeLatest(
    sagaActions.FETCH_SEND_NOTIFICATIONS +
    "/SetThesendNotificationCreateActions",
    sendTheNotificationsSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_PDF_FORMAT_DOWNLOADS + "/sethtmlformatpdfdownoadActions",
    setThepdfdownloadsagas,
  );
  yield takeLatest(
    sagaActions.FETCH_GRIEVEANCE_DELTE + "/setThegrieveacncedeleteActions",
    GrieveanceDeleteActionsSagas,
  );
  yield takeLatest(
    sagaActions.FETCH_APPRAISAL_HTML_FORMAT_DATAS_POST +
    "/setAppraisalHtmlPostActions",
    getAppraisalHtmlFormatPost,
  );
  yield takeLatest(
    sagaActions.FETCH_ATTENDANCES_EXPORT_GET_LIST_CALL +
    "/setAttendanceExportgetlistActions",
    settheAttendanceExportGetSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_ADMIN_USER_LIST_ACCESS_LIST +
    "/setAdminuseraccesslistDatasgetlistActions",
    calladminuseraccesslistsaga,
  );

  yield takeLatest(
    sagaActions.FETCH_ADMIN_USER_ACCES_LIST_ACTIONS_POST +
    "/setadminuseraccessceateActions",
    getadinaccesslistpotsaga,
  );
  yield takeLatest(
    sagaActions.FETCH_ADMIN_USER_ACCES_LIST_ACTIONS_RETRIEVE +
    "/setadminuseraccessRetrieveActions",
    getAdminuserlitretrieve,
  );

  yield takeLatest(
    sagaActions.FETCH_ADMIN_USER_ACCES_LIST_ACTIONS_PUT +
    "/setadminuseraccessEDITActions",
    settheadminiserputsaga,
  );
  yield takeLatest(
    sagaActions.FETCH_ADMIN_USER_LIST_ACTION_DELETE +
    "/setadminuseraccessdeleteActions",
    AdminuserlistDeleteActionsSagas,
  );
  yield takeLatest(
    sagaActions.FETCH_ID_VERIFICATION_ANOTHER_KYC_EMPLOYEE_API_AS_POST +
    "/setIDverifycationanotherapidatasActions",
    getidverificationanotherAPIsagaCall,
  );
  yield takeLatest(
    sagaActions.FETCH_EXPORT_EXCEL_SHEET_FOR_EMPLOYEE_CLINET_ +
    "/setTheExcelsheetUploadDataForEmpCIlent",
    gettheexcelSheetFormatSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_PAYSLIP_DELETE_ACTIONS + "/setThePayslipDeleteActions",
    PaySlipDeleteSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_BANKPASSBOOK_VERIFIED_AND_DATA_RETRIEVE +
    "/setTheActionsFroTheBankPassbooks",
    getPassbookorChequesSagas,
  );

  yield takeLatest(
    sagaActions.FETCH_ATTENDANCE_REQUEST_GET_LIST +
    "/setAttedancelistDatasgetlistActions",
    setTheAttendanceEmployeeRequestSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_ATTENDANCE_REQUEST_LIST_ACTIONS_APPROVE +
    "/StetheAttendanceApproveActions",
    setTheAttendanceREquestAppriveforApp,
  );
  yield takeLatest(
    sagaActions.FETCH_ONBOARING_OTP_NUMBER_GET_DATAS +
    "/setTheActionForOtpPhoneNumbers",
    setVerifyForEMployeeOnboardOtp,
  );
  yield takeLatest(
    sagaActions.FETCH_ONBOARDING_OTP_SEND_DATAS_WITH_oTPS +
    "/setTheActionForOtpwithPhoneNumbers",
    setTheOtpVerificationWithNumberAndOtpOnboards,
  );
  yield takeLatest(
    sagaActions.FETCH_OTHER_PARTY_API_FOR_PAN_CARDS +
    "/setTheOtherpARTYaPIaCTIONS",
    settheOtherpartyAPIforPanCardsSAGA,
  );
  yield takeLatest(
    sagaActions.FETCH_ACTIVE_EMPLOYEES_LIST_OUT +
    "/SetTheActiveEmployeeListACtions",
    ActiveEmployeeListSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_EMPLOYEE_MAKE_ACTIVE_EMPLOYEES +
    "/setTheApproveEmployeeTOLeftAOffice",
    InActiveEmployeeForLeftSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_EMPLOYEE_FOR_APPROVE_EMPLOYEES_RETRIVE +
    "/setTheRetrieveForApproveEmployeeTOLeftAOffice",
    setTheRetrieveEmployeeActiveBased,
  );
  yield takeLatest(
    sagaActions.FETCH_EMPLOYEE_ACTIVE_BASED_CREATEED_ACTIONS +
    "/setTheActiveEmployeeCreatesList",
    setTheActiveBasedEmployeeForPOstSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_PERFORMANCE_SHEET_EXPORT_ACTIONS +
    "/SetThePerformanceExportSheetDatasActions",
    setThePerformanceExportSheetSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_APPRAISAL_EXPORTS_PRINTED_YEARdATAS +
    "/SetTheAppraisalListActions",
    ApraisalGetListSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_APPRAISAL_RETRIEVE_LIST_DATAS +
    "/SetTheAppraisalRetrieveDatasActions",
    getTheAppraisalRetrieveSagas,
  );
  yield takeLatest(
    sagaActions.FETCH_SUPERVIORS_LIST_RESPONSES_ +
    "/setTheSuperviorsgeteListActions",
    setTheSuperviorseSagas,
  );
  yield takeLatest(
    sagaActions.FETCH_SUPERVISOR_LISTED_DATASS_GET_LIST +
    "/SetTheSuperviorsListACtions",
    SuperviorsgetLists,
  );
  yield takeLatest(
    sagaActions.FETCH_ATTEDANCES_LIST_MULIPLESSELECTED +
    "/settheAttedanceListMulitipleActions",
    setTheAttendanceREquestMulitipleSelcetdsforApp,
  );

  yield takeLatest(
    sagaActions.FETCH_EMPLOYEE_ATTEDANCE_RESULTS_DASHOBOARD +
    "/SettheEmployeeAttedanceResults",
    DashboardFroEmployeesSaga,
  );

  yield takeLatest(
    sagaActions.FETCH_USERDETAILS_EXPORT_DETAILS_LISTED +
    "/setTheUserDetailsExportActions",
    setTheUserDetailsExportsSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_QUERYS_QUESTIONS_LISTED_DATAS +
    "/settheQueryQuestionActions",
    getTheQueryQuestionsData,
  );
  yield takeLatest(
    sagaActions.FETCH_QUERY_ACTIONS_CRAETE_ +
    "/setTheQueryQuestionsCreateActions",
    settheQueryCreatetionsSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_QUERY_QUESTION_RETRIEVE +
    "/setTheQueryQuestionsRetrieveActions",
    settheQueryActionRetrieve,
  );
  yield takeLatest(
    sagaActions.FETCH_QUERY_QUESTIONS_EDIT + "/setTheQueryQuestionsEditActions",
    settheQueryActionEdit,
  );
  yield takeLatest(
    sagaActions.FETCH_QUERY_SUBQUERY_QUESTIONS +
    "/settheQuerySubQuestionActions",
    getTheQuerySubQuestionsData,
  );
  yield takeLatest(
    sagaActions.FETCH_SUB_QUERY_CREATED +
    "/setTheQuerySubQuestionsCreateActions",
    settheSubQueryCreatetionsSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_QUERY_SUB_QUESTION_RETRIEVE +
    "/setTheQuerySubQuestionsRetrieveActions",
    settheSUBQueryActionRetrieve,
  );

  yield takeLatest(
    sagaActions.FETCH_QUERY_SUB_QUESTIONS_EDIT +
    "/setTheQuerySubQuestionsEditionsActions",
    settheSubQueryActionEdit,
  );
  yield takeLatest(
    sagaActions.FETCH_QUERY_QUESTIONS_DELETE +
    "/setTheQueryQuestionsDeleteActions",
    setTheQueryQuestionsDeleteSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_QUERY_SUB_QUESTIONS_DELETE +
    "/setTheQuerySUbQuestionsDeleteActions",
    setTheQuerySUBQuestionsDeleteSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_TRACKING_RECORDS_DATAS_LIST +
    "/settheTrackingrecordgetListDataActions",
    setTheTrackingDatasListSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_TRACKING_SYSTEM_DATAS_RETRIEVE +
    "/setTheQueryTrackingrecordgetListRetrieveActions",
    setTheTrackingRetrieveSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_TRACKING_SYSTEM_DATAS_EDITIONS +
    "/setTheTrackingEditionsActions",
    setTheTrackingEdtionsSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_TRACING_DELETE_ACTIONS + "/setTheTrackingDeleteActions",
    setTheTrackingDeleteSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_TRACKING_CREATE_ACTIONS + "/setTheTrackingCreateActions",
    setTheTrackingApplySaga,
  );
  yield takeLatest(
    sagaActions.FECTH_FINANCE_RESPONSIVE_DATAS + "/setThefinanceDataActions",
    getFinanceDatas,
  );
  yield takeLatest(
    sagaActions.FETCH_FINANCE_EXPORT + "/setThefinanceDataExportActions",
    getFinanceFOREXPORTDatas,
  );
  yield takeLatest(
    sagaActions.FETCH_ATTENDANCE_REPORT_DASHBOARD_ACTIONS +
    "/setTheAttendanceReportActions",
    gettheDahboardAttendanceData,
  );
  yield takeLatest(
    sagaActions.FETCH_ONBOADER_DETAILS_DATA +
    "/setTheOnboarderdetailsReportActions",
    OnboaderDetailsLsit,
  );
  yield takeLatest(
    sagaActions.FETCH_OTHERPARTY_AADHAR_PHONE_NUMBER_VERIFIED +
    "/setTheOtherAAdhaarOtpPhoneNuberAction",
    CallOtherPartyaadharsendOtpApi,
  );
  yield takeLatest(
    sagaActions.FETCH_OTHER_PARY_OTP_SUBMIT_FOR_AADHAR +
    "/setTheaadharsentOtpReportActions",
    CallOtherpartysubmitACtions,
  );
  yield takeLatest(
    sagaActions.FETCH_PANCACRD_SEND_OTP + "/setThePANCARDeportActions",
    CallOtherPartyPANCARDsendOtpApi,
  );
  yield takeLatest(
    sagaActions.FETCH_PANCARD_SUBMIT_OTP + "/setThePANCARDSUBMITeportActions",
    PANCARDSUBMITOTPVeried,
  );
  yield takeLatest(
    sagaActions.FETCH_SUPERVIRSOE_EMPLOYEE_LIST +
    "/SetTheSuperviorsLisEmployeeeetACtions",
    SuperviorsgetEmployeeeLists,
  );
  yield takeLatest(
    sagaActions.FETCH_USER_SELECT_OPTIONS_PAYLOASD_ +
    "/setUserOptionDatasActions",
    getUserSelectoptionsList,
  );
  yield takeLatest(
    sagaActions.FETCH_OTHER_PARTY_API_BANK_VERIFICATION + "/BankVerifyActions",
    BanlVerifiyedPennydrop,
  );
  yield takeLatest(
    sagaActions.FETCH_PENNY_DROP_CREATE_TOKEN_ +
    "/CreateTokenForBankVerifyActions",
    CreateTokenPennydrop,
  );

  ///----UDs---empployee----Role---
  yield takeLatest(
    sagaActions.FECTH_UDS_EMPLOYEEE_LOGIN_ + "/SetTheCustomerUDSEmployeeLogin",
    getTheUDSEmployeeLogin,
  );
  yield takeLatest(
    sagaActions.FETCH_UDS_SEND_OTP_FOR_UDS_EMPLOYEES +
    "/SetTheCustomerUDSEmployeeSendOtp",
    getTheOtpUDSEmployee,
  );

  ///----need---uds---employees

  // yield takeLatest(
  //   sagaActions.FETCH_CREATE_ON_DUTY_DATA + "/SetCreateOnDutyAction",
  //   CreateOnDutySaga
  // );

  yield takeLatest(
    sagaActions.FETCH_CALENDAR_DATA + "/SetCalendarActions",
    CalendarFetchSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_CREATE_CHECKINOUT + "/SetCheckInOutAction",
    RequestCheckInOutSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_LEAVE_TYPES + "/SetLeaveTypeDataActions",
    LeaveTypeDataSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_EMPLOYEE_ATTENDANCE_GET_LIST_DATAS +
    "/SetTheAttendanceDatasActions",
    GetTheAttendanceDatas,
  );
  yield takeLatest(
    sagaActions.FETCH_CREATE_LEAVE + "/SetCreateLeaveAction",
    CreateLeaveSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_EMPLOYEE_SHIFT_DATAS + "/SetTheShiftDatasActions",
    getTheShiftDatas,
  );

  yield takeLatest(
    sagaActions.FETCH_EMPLOYEEE_CHECKOUT_PUT_METHOD_CALL +
    "/SetCheckInOutputMethosAction",
    RequestCheckInpUTmETHOSOutSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_ATTENDANCE_DASHBOARD_EMPLOYEE_LIST +
    "/setUserOptionDashboardEmployeesActions",
    getUserSelectAttendanceDashboardListList,
  );

  yield takeLatest(
    sagaActions.FETCH_REPORT_DATAS_POST_METHOD + "/getRoportpostActions",
    getreportSheetexportPOst,
  );
  yield takeLatest(
    sagaActions.FETCH_REPORT_DATAS_GET_DATAS + "/getRoportDatasActions",
    gettheReportdatassagaSheetexport,
  );
  yield takeLatest(
    sagaActions.FETCH_SIGNATURE_GET_PROFILE + "/setTheProfileSignatureActions",
    gettheprofilesignaturegetlist,
  );
  yield takeLatest(
    sagaActions.FETCH_SONY_EMPLOYEE_GET_LIST + "/setTheSonyEmployeeActions",
    getthesonyemployeegetlist,
  );
  yield takeLatest(
    sagaActions.FETCH_SIGNATURE_PUT_PROFILE +
    "/setTheProfileSignatureEDITActions",
    settheProfileUpdate,
  );

  yield takeLatest(
    sagaActions.FETCH_OVER_ALL_REPORT_GET + "/setOverReportActions",
    gettheOverallreport,
  );
  yield takeLatest(
    sagaActions.FETCH_OVER_ALL_REPORT_CREATE + "/setOverReportCreateActions",
    setOverallvalidations,
  );
  yield takeLatest(
    sagaActions.FETCH_OVER_ALL_REPORT_RETRIEVE +
    "/setOverReportRetrieveActions",
    setOverallexcelSheetuploadSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_OVER_ALL_REPORT_EMPLOYEE_LISTED +
    "/setOverReportActionsEmployeeList",
    gettheOverallreportEmployeeList,
  );
  yield takeLatest(
    sagaActions.FETCH_OVER_ALL_REPORT_EMPLOYEE_EXPORT +
    "/setOverReportActionsExportEmployeeList",
    gettheOverallreportEXPORTEmployeeList,
  );
  yield takeLatest(
    sagaActions.FETCH_SEND_EMAIL_EDIT_ACCESS + "/setthesendEmailActions",
    settheSendemailUpdatesd,
  );
  yield takeLatest(
    sagaActions.FETCH_SEND_EMAIL_RETRIEVE_GET_LIST +
    "/setthesendEmailGetListActions",
    getThesendEmailGetList,
  );
  yield takeLatest(
    sagaActions.FETCH_ONBOARD_OVER_VIEW_DASHBOARD_DATAS +
    "/setTheDashboardonboadOverviewactions",
    SetTheDashboardsOnboardOverViewCall,
  );
  yield takeLatest(
    sagaActions.FETCH_STATE_OVERALL_STATE_LIST + "/SetTheStateGetListActions",
    getGeoOverallState,
  );
  yield takeLatest(
    sagaActions.FETCH_ONBOARDING_RESEND_OTP_CALL +
    "/setTheActionResentForOtpPhoneNumbers",
    setVerifyForEMployeeOnboardOtpASRESENTOTP,
  );
  yield takeLatest(
    sagaActions.FETCH_ATTENDANCE_LOCATION_DETAIL_GET_LIST +
    "/setTheAttendanceLocationAction",
    gettheattendanceLocationInApiGetListSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_ATTENDANCE_LOCATION_DETAIL_DELETE_ACTION +
    "/setTheAttendanceLocationDeleteAction",
    AttendanceLocaitonDeletePlace,
  );
  yield takeLatest(
    sagaActions.FETCH_ATTENDANCE_LOCATION_DETAIL_CREATE_ACTION +
    "/setTheAttendanceLocationCreateAction",
    AttendanceLocationCreattionSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_ATTENDANCE_LOCAITON_DETAILS_RETRIEV_METHOD +
    "/setTheAttendanceLocationRetrieveMetyhodAction",
    gettheRetrieveofattendanceLocaitonsaga,
  );
  yield takeLatest(
    sagaActions.FETCH_ATTENDANCE_LOCATION_DETAIL_EDIT_ACTION +
    "/setTheAttendanceLocationEditionsAction",
    CallTheAttendanceLocaitonEditionsaga,
  );
  yield takeLatest(
    sagaActions.FETCH_SUPPORT_DOCUMENTS_EDIT + "/startEditingSupportDocument",
    callSupportDocumentEditSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_SUPPORT_DOCUMENTS_FETCH +
    "/startFetchingSupportDocuments",
    callSupportDocumentFetchSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_MY_ONBOARDING_DATAS_GET_LISTED +
    "/gettheMyonboardignlisteddatas",
    getMyonboardingList,
  );
  yield takeLatest(
    sagaActions.FETCH_HR_ONBOARDING_DATAS_GET_LISTED +
    "/gettheHRonboardignlisteddatas",
    getHRonboardingList,
  );
  yield takeLatest(
    sagaActions.FETCH_IN_THE_APPROVE_REQUEST_LIST +
    "/getApproveRequestActionListed",
    gettheApproveRequestEmployeelist,
  );
  yield takeLatest(
    sagaActions.FETCH_REGENERATOR_THE_PDF + "/gettheRegeneratePdfAction",
    gettheregeneratorPdfSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_APPROVE_REQUEST_MANAGER_LIST_ +
    "/gettheApproveRequestInmnagaerList",
    gettheApproverequestmanagerlisted,
  );
  yield takeLatest(
    sagaActions.FETCH_REPORT_DELETED_REPORT + "/getRoportDeletedActions",
    ReportDeleteOption,
  );
  yield takeLatest(
    sagaActions.FETCH_OVERTIME_REPORT_DATAS + "/setTheOvertimeAction",
    settheOverTimeSAGA,
  );
  yield takeLatest(
    sagaActions.FETCH_OVERTIME_APPROVE_REQEST + "/SetOvertimeApproveActions",
    setTheoverTImeREquestAppriveforApp,
  );
  yield takeLatest(
    sagaActions.FECTCH_OVERALL_ONBOARDER_DATA + "/gettheoverallOnboaderDatas",
    gettheOverallOnboarderList,
  );
  yield takeLatest(
    sagaActions.FETCH_REJOINING_FLOW_FROM_EMP +
    "/gettheStoretheRejoiningActions",
    RejoiningSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_mY_TICKET_LIST_IN_HELP_DESK +
    "/settheMyTicketsDataActions",
    getMyticketsListsaga,
  );
  yield takeLatest(
    sagaActions.FETCH_BOTH_THE_USER_FOR_AS + "/setTheActionsBoth_theusers",
    gettheboththeUser,
  );

  yield takeLatest(
    sagaActions.FETCH_REIMBURSEMENT + "/SetFetchReimbursementEMPAction",
    GetReimbursementPermission,
  );
  yield takeLatest(
    sagaActions.FECTH_ONDUTY_EMPLOYEE + "/setOndutyDatasEmpAction",
    getTheEmployeeOnduty,
  );
  yield takeLatest(
    sagaActions.FETCH_ONDUTY_EMPLOYEEE_CREATE +
    "/setOndutyDatasEmpCreateAction",
    CreateOnDutySagaEmp,
  );
  yield takeLatest(
    sagaActions.FETCH_PERMISSION_GET_LIST_FOR_EMPLOYEEE +
    "/SetTheAttendancegetlistempPermissionDatasActions",
    getTheEmployeePermissionGetlist,
  );
  yield takeLatest(
    sagaActions.FETC_CREATE_PERMISSION_FOR_EMPLOYEEE_ +
    "/SetCreatePermissionEmpAction",
    PermissionCreateForEmployeee,
  );
  yield takeLatest(
    sagaActions.FETCH_REGULARIZAATION_GET_LIST_FOR_EMPLOYEEE +
    "/SetTheAttendancegetlistempRegularizationDatasActions",
    getTheEmployeeRegularizationGetlist,
  );
  yield takeLatest(
    sagaActions.FETC_CREATE_REGULARIZATIONS_FOR_EMPLOYEEE_ +
    "/SetCreateAttendanceRegularizationEmpAction",
    AttendanceRegularizationcreates,
  );
  yield takeLatest(
    sagaActions.FETCH_OVERTIME_REGUKARIZATIONS_FOR_THE_EMPLOYEEE +
    "/settheOvertimeRegulrizationActions",
    getheemployeeOvertimeRegularizations,
  );
  yield takeLatest(
    sagaActions.FETCH_PAYSLIP_FOR_EMPLOYEEE_ + "/setThePayslipDataactionforemp",
    getthePaySlipSagaForEmployee,
  );
  yield takeLatest(
    sagaActions.FETCH_FACE_VERIFICATION_STATUS + "/SetFaceVerificationAction",
    FaceVerificationStatusSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_RESIGNATION_STATUS_FOR_EMP + "/setTheresignationForEmp",
    settheReginationSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_RESIGNATION_RETIEVE_ING_DATAS +
    "/setTheresignationRetrieveForEmp",
    settheReginationSagaretrieve,
  );
  yield takeLatest(
    sagaActions.FETCH_NODUE_FORM_EDIT_FOR_EMP +
    "/settheNodueFormEmpEditActionDatas",
    setExitNodueEditsEMPrecords,
  );
  yield takeLatest(
    sagaActions.FETCH_NODUE_FORM_POST_DATAS_EMP +
    "/settheNodueFormEmpActionDatas",
    settheNodueFormInpostMethod,
  );
  yield takeLatest(
    sagaActions.FETCH_NODUE_FORM_RETRIEVE_FORM_POST +
    "/settheNodueFormEmpretrieveActionDatas",
    settheExitFormForEmployeeDAtaRetireve,
  );
  yield takeLatest(
    sagaActions.FETCH_REIMBURSEMENT_CREATE_FOR_THE_EMPLOYEE +
    "/setTheCreateOfEmployeeReimbursementActions",
    reimbursementEmpSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_GRIEVENE_GET_LIST_FOR_EMPLOYEE_ +
    "/settheGrievenceGetListForEMpActions",
    gettheemployeeGrievenceSagaList,
  );

  yield takeLatest(
    sagaActions.FETCH_GRIVENECE_TYPE_GET_LIST_FOR_EMP +
    "/settheGrievenceGetListForTYPEEMpActions",
    gettheemployeeGrievenceTYPESagaList,
  );
  yield takeLatest(
    sagaActions.FECTH_GRIEVANCE_CREATE_FOR_EMPLOYEE +
    "/SetCreateGrievanceApplyEmpAction",
    getgrievanceApplySagaEMp,
  );
  yield takeLatest(
    sagaActions.FETCH_HELPDESK_FOR_EMPLOYEEE_ + "/setHelpDatasEmpAction",
    gettheHelpDeskEmpSAGA,
  );

  yield takeLatest(
    sagaActions.FETCH_TRACKING_PARENT_CALL_FOREMP +
    "/setTrackingParentDatasEmpAction",
    settheParenthelpdeskSagaEmp,
  );

  yield takeLatest(
    sagaActions.FETCH_TRCKING_CATEGORY_CALL_FOR_THE_EMP +
    "/setTrackingSubCategoryEmpDatasEmpAction",
    settheSubCateoryListthelpdeskSagaEmp,
  );

  yield takeLatest(
    sagaActions.FETCH_TRACKING_HELP_DESK_FOR_THE_EMP +
    "/setHelpDeskEmpApplyEmpDatasEmpAction",
    settheHelpDeskPostsagaForEmp,
  );
  yield takeLatest(
    sagaActions.FETCH_EMP_ATTENDANCE_EMPLOYEE_GET_LIST +
    "/setEmpAttendanceEmpEmpAction",
    gettheEmployeeAttendanceSagaForEmpList,
  );
  yield takeLatest(
    sagaActions.FETCH_BLOCK_EMPLOYEEE_GET_LIST +
    "/setEmpBlockGetlistEmpEmpAction",
    GettheBlockEmployeegetListSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_BLOCK_EMPLOYEEE_CREATE_DATA_EMP +
    "/setEmpBlockpostistEmpEmpAction",
    CreateTheBlockSagaEm,
  );
  yield takeLatest(
    sagaActions.FETCH_SITE_TRANSFER_GET_LIST_FOR_EMP +
    "/setEmpsiteTransferGetlistEmpEmpAction",
    getTheSiteTransferEmpSlice,
  );
  yield takeLatest(
    sagaActions.FETCH_UNBLOCKED_EMPLOYEE_GET_LISTED_EMPLOYEES +
    "/gettheUnboackedEmpActions",
    gettheUnblockedEmployeesList,
  );
  yield takeLatest(
    sagaActions.FETCH_CLIENT_BRANCH_LIST_API_FOR_EMP_SITE +
    "/setEmpClientBranchListEmpEmpAction",
    GETTHECLIENTBRANCHforsitetransfersaga,
  );
  yield takeLatest(
    sagaActions.FETCH_CREATE_SITE_TRANSFER_FOR_THE_EMPLOYEE +
    "/setEmpsiteTransferGetlistCreateEmpEmpAction",
    gettheSiteTransferSagaCreate,
  );
  yield takeLatest(
    sagaActions.FETCH_EMP_ATTENDANCE_WEB_POFILE_GET_DATAS +
    "/setTheEMployeeAttendanceProfileActions",
    gettheprofiledataslist,
  );
  yield takeLatest(
    sagaActions.FETCH_EMP_ATTENDANCE_WEB_PROFILE_POST_PROFILES +
    "/setTheEMployeeAttendanceupdateProfileActions",
    updatedEmpProfileImagesSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_EMPLOYEE_UDS_WEBSITE_NO_DUE_FORM +
    "/setEmpnoduformfetchdatasempEmpTeamlistEmpEmpAction",
    getfetchtheNodueFormdatasEmpUDS,
  );
  yield takeLatest(
    sagaActions.FETCH_EMPLOYEEE_LIST_FOR_SITE_TRANSFER_ +
    "/setEmsiteTransferEmployeedatasEmpEmpAction",
    gettheEmployeesitetransferEmployeeListSagaForEmpList,
  );
  yield takeLatest(
    sagaActions.FETCH_EMPLPYEE_SKILL_ASSESSMENT_DATAS +
    "/resetSkillAssessmentEmpData",
    gettheemployeeskillassessmentsempgetlistSagaList,
  );
  yield takeLatest(
    sagaActions.FETCH_STATE_EMP_LIST + "/stateresetStateData",
    getthestateactionsforEmplist,
  );
  yield takeLatest(
    sagaActions.FETCH_REGIONS_EMP_LIST_DATAS + "/stateresetRegionData",
    gettheregionactionsforEmplist,
  );
  yield takeLatest(
    sagaActions.FETCH_ZONE_EMP_DATAS_LIST + "/stateresetZoneData",
    getZoneSagaactionsforEmplist,
  );
  yield takeLatest(
    sagaActions.FETCH_DESIGNATION_DATA_LIST_FOR_EMP +
    "/stateresetDesignationData",
    getdesignationemplistactionsforEmplist,
  );
  yield takeLatest(
    sagaActions.FETCH_BRANCH_LIST_EMP_SITE_ + "/stateresetBranchData",
    getbranchempsitesactionsforEmplist,
  );
  yield takeLatest(
    sagaActions.FETCH_EMP_SKILL_ASSESSMENTS_EMP_SITE_APPLY +
    "/gettheSkillassessmentRetireveEmpactions",
    gettheskillassessmentsagaEmpretrievedatas,
  );
  yield takeLatest(
    sagaActions.FETCH_EMP_SKILL_ASSESSMENT_LISTED_DETAILS_FORM_QUESTIONPAPER +
    "/resetEmployeeDataquestionslist",
    gettheskilassessmentquestionformlist,
  );
  yield takeLatest(
    sagaActions.FETCH_EMP_INNERQUESTION_SKILL_ASSESSMENT_DATAS +
    "/resetQuestionData",
    skillassessmentsagachildinneerqetions,
  );
  yield takeLatest(
    sagaActions.FETCH_EMP_SKILL_ASSESSMENT_QUESTION_TYPES +
    "/resetQuestionTypeData",
    gethequestionpapertypqskillassessment,
  );
  yield takeLatest(
    sagaActions.FETCH_SKILL_ASSESSMENT_EMP_POST +
    "/gettheSkillassessmentpostmethodEmpactions",
    gettheEMpSkillassessmentPostmethods,
  );
  yield takeLatest(
    sagaActions.FETCH_SKILL_ASSESSMENT_EMP_PUT_METHODS +
    "/gettheSkillassessmentputtmethodEmpactions",
    gettheskillassessmentputmethods,
  );

  yield takeLatest(
    sagaActions.FETCH_TICKETING_SYSTEM_CATEGORY_QUESTIONS_LIST +
    "/getTheTicketingQuestionsData",
    getTheTicketingQuestionsDatagetlist,
  );
  yield takeLatest(
    sagaActions.FETCH_TICKING_SYSTEM_CATEGORY_QUESTION_DELETE +
    "/setTheTickeitingtionsDeleteActions",
    setTheTickeing_QuestionsDeleteSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_TICKETING_SYSTEM_CATEGORY_QUESTIONS_RETRIEVE +
    "/setTheTicketQuestionsretrieveActions",
    settheTicketingActionRetrieve,
  );

  yield takeLatest(
    sagaActions.FETCH_TICKING_SYSTEM_CATEGORY_QUESTION_EDITIONS +
    "/setTheTicketQuestionsEdtionctions",
    settheTicketActionEdit,
  );
  yield takeLatest(
    sagaActions.FETCH_TICKETING_SYSTEM_CATEGORY_QUESTIONS_CREATE +
    "/setTheTicketQuestionsCreateActions",
    settheTicketCategoryCreatetionsSaga,
  );

  yield takeLatest(
    sagaActions.FETC_TICKETING_SYSTEM_SUB_CATEGORY_ACTION_LIST +
    "/settheTicketSubQuestionActions",
    getTheTicketSubQuestionsData,
  );
  yield takeLatest(
    sagaActions.FETC_TICKETING_SYSTEM_SUB_CATEGORY_ACTION_CREATIONS +
    "/setTheTicketSubQuestionsCreateActions",
    settheTicketingSubQueryCreatetionsSaga,
  );

  yield takeLatest(
    sagaActions.FETC_TICKETING_SYSTEM_SUB_CATEGORY_ACTION_EDTION +
    "/setTheTicketSubQuestionsEditionsActions",
    settheTicketingSubQueryActionEdit,
  );

  yield takeLatest(
    sagaActions.FETC_TICKETING_SYSTEM_SUB_CATEGORY_ACTION_RETRIEVE +
    "/setTheTicketSubQuestionsRetrieveActions",
    settheTicketingSUBQueryActionRetrieve,
  );

  yield takeLatest(
    sagaActions.FETC_TICKETING_SYSTEM_SUB_CATEGORY_ACTION_DELETE +
    "/setTheTicketSUbQuestionsDeleteActions",
    setTheTicketingSUBQuestionsDeleteSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_TICKETING_SYSTEM_RAISED_LIST +
    "/settheTicketsystemrecordgetListDataActions",
    setTheTicketinglistDatasListSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_TICKETING_SYSTEMiN_DASHBOARDS +
    "/settheTicketingDashboardActions",
    settheTicketingSystemIndashboardSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_TICKETING_SYSTEM_TICKET_DETAILS +
    "/setTheTrackingrecordgetListRetrieveActions",
    getetheticketingretrievedatassaga,
  );
  yield takeLatest(
    sagaActions.FETCH_TICKETING_SYSTEM_RETRIVE_REMARKS_RETRIEVE +
    "/setTheTrackingrecordgetList_remarksRetrieveActions",
    gettheRemarkRetrieveActionsSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_TICKETING_SYSTEM_RETRIVE_COMMENTS +
    "/setthecommentRetieveDatasActions",
    gettheCommentsRetrieveActionsSaga,
  );

  yield takeLatest(
    sagaActions.FETCH_TICKETING_SYSTEM_COMMENT_CREATEOR_REMARKS_CREATE +
    "/settheticketcreateRetieveDatasActions",
    settheremarksorCommentSaga,
  );

  yield takeLatest(
    sagaActions.FETCH_TICKETING_SYSTEM_STATUS_CHANGES +
    "/settehTicketStatusChanges",
    settheTicketChangess,
  );

  yield takeLatest(
    sagaActions.FETCH_TICKETtIME_LINE +
    "/settheticketTimelineretieveDatasActions",
    gettheTicketLineSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_TICKETING_SYSTEM_EXPORTS +
    "/setTheticketetailsExportActions",
    SETTHEticketexxportssaga,
  );

  yield takeLatest(
    sagaActions.FETCH_TICKETING_FEEDBACKS +
    "/setthefeedbackRetieveDatasActions",
    gettheFeedbacksRetrieveActionsSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_CLIENT_CREATION_SCOPE_LIST +
    "/setTheScopeDetailsExportActions",
    gettheScopeListDatassaga,
  );

  yield takeLatest(
    sagaActions.FETCH_CONTACT_EDIT_PERSONS +
    "/setTheContacteitDetailsExportActions",
    seteditthecontactpersons,
  );
  yield takeLatest(
    sagaActions.FETCH_LIST_OF_SCOEP_OF_SUBCATEGORY_DATAS +
    "/setTheSubCategorydataDetailsExportActions",
    gettheScopeSubCategoryListDatassaga,
  );
  yield takeLatest(
    sagaActions.FETCH_LIST_OF_SCOPE_OF_CATEGORY_lISTED +
    "/setTheCategorydataDetailsExportActions",
    gettheScopeCategoryListDatassaga,
  );

  yield takeLatest(
    sagaActions.FETCH_SUB_CATEGORY_EDIT_AND_CREATED +
    "/setTheSubCategorydataEditandcreateDetailsExportActions",
    settheSubcategoryeditSliceandcreate,
  );

  yield takeLatest(
    sagaActions.FETCH_DASHBOARD_TICKETING_NEARDUEDATAS +
    "/settheNeardueActions",
    gettheNeardueSagas,
  );

  yield takeLatest(
    sagaActions.FETCH_UDS_USERS_LISTED_REAMRKS + "/settheRemarkspostActions",
    settheremarksoSagapost,
  );

  yield takeLatest(
    sagaActions.FETCH_UDS_SUB_CATEGORY_LISTED_BRANCH_CREATIONS +
    "/setthesubcategorybranchActionListed",
    gettheScopeSubCategoryListDatasOnlyEditsaga,
  );

  yield takeLatest(
    sagaActions.FETCH_INTERAL_CATEGORYLIST + "/getTheUDSQuestionsData",
    getTheInternalQuestionsDatagetlist,
  );

  yield takeLatest(
    sagaActions.FETCH_INTERAL_CATEGORYCRUD +
    "/setTheInternalQuestionsCreateActions",
    settheinternalCategoryCreatetionsSaga,
  );

  yield takeLatest(
    sagaActions.FETCH_INTERAL_CATEGORYEDITION +
    "/setTheInternalCategoryQuestionsEdtionctions",
    settheinternalcategoryActionEdit,
  );

  yield takeLatest(
    sagaActions.FETCH_INTERAL_CATEGORYRETRIEVE +
    "/setTheInteralcategoryQuestionsretrieveActions",
    settheInternalTicketingActionRetrieve,
  );

  yield takeLatest(
    sagaActions.FETCH_INTERNAL_DELET_ACTIONS + "/setTheInternalDeleteActions",
    setTheInternalDeleteSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_BRANCH_QR_CODE_EXPORTS + "/settheqrcodelisted",
    gettheqrforbranchsaga,
  );

  yield takeLatest(
    sagaActions.FETCH_SUB_INTERNAL_GET_LIST +
    "/settheInternalSubQuestionActions",
    getTheInternalSubQuestionsData,
  );
  yield takeLatest(
    sagaActions.FETCH_SUB_INTERNAL_GET_CRUDCREATE +
    "/setTheInternalSubQuestionsCreateActions",
    settheInternalSubQueryCreatetionsSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_SUB_INTERNAL_GET_CRUD +
    "/setTheInternalSubQuestionsEditionsActions",
    settheInternalSubQueryActionEdit,
  );
  yield takeLatest(
    sagaActions.FETCH_SUB_INTERNAL_GET_CRUDRETRIEVE +
    "/setTheinternalSubQuestionsRetrieveActions",
    settheInternalSUBQueryActionRetrieve,
  );
  yield takeLatest(
    sagaActions.FETCH_SUB_INTERNAL_GET_CRUDDELETE +
    "/setTheInternalSUbQuestionsDeleteActions",
    setTheInternalSUBQuestionsDeleteSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_UNREGISTER_TICKET_LIST +
    "/settheTicketsystem_unregisterrecordgetListDataActions",
    setTheTicketingforUnregisterlistDatasListSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_DEPARTMENT_LISTED_ + "/settheInternalDepartmentsctions",
    gettheDepartmentGetListsaga,
  );
  yield takeLatest(
    sagaActions.FETCH_INTERNAL_DEPARTMENTS +
    "/setTheInternalDepartmentCreatedActions",
    settheInternalDepartmentsCreatetionsSaga,
  );

  yield takeLatest(
    sagaActions.FETCH_DEPARTMENT_RETRIEVE_ACTIONS +
    "/setTheInternalDepartmentRetrieveActions",
    gettheinternaldepartmentretrievesaga,
  );
  yield takeLatest(
    sagaActions.FETCH_DEPARTMENT_EDIIT_ACTIONS +
    "/setTheInternalDepartmentEditActions",
    settheInternalDepartmentActionEdit,
  );
  yield takeLatest(
    sagaActions.FETCH_INTERNAL_DEPARTMENT_DELETE +
    "/setTheInternalDepartmentDeleteActions",
    settehInternalDepartmentDeletedSaga,
  );

  yield takeLatest(
    sagaActions.FETCH_LEVEL_USER_DEPARTMENT_LISTED +
    "/setTheInternalDepartmentlevelusersCreatedActions",
    settheInternalDepartmentslevelusersCreatetionsSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_DEPARTMENT_LEVEL_USERS_LISTED +
    "/getTheLevelUsersListData",
    gettheDepartmentGetLevelusersListsaga,
  );

  yield takeLatest(
    sagaActions.FETCH_DEPARTMENT_LEVEL_USERS_RETRIVEE +
    "/setTheInternalDepartmentRetreve_usersActions",
    gettheinternaldepartmentLevelUsersretrievesaga,
  );

  yield takeLatest(
    sagaActions.FETCH_DEPARTMENT_LEVEL_USERS_EDITION +
    "/setTheInternalDepartmentEdtions_usersActions",
    settheInternalDepartmentLevelUsersActionEdit,
  );
  yield takeLatest(
    sagaActions.FETCH_DEPARTMENT_LEVEL_USERS_USERDELETE +
    "/setTheInternalDepartmentDelete_usersActions",
    settehInternalDepartmentLevelUsersDeletedSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_TICKET_LISTED_THE_INTERNAL_DEPARTMENTS +
    "/settheInternalTicketsystemrecordgetListInternalDepartmentsDataActions",
    setTheTicketinglistInternalDepartmentsDatasListSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_TCIKET_CREATION_OF_LISTED_CRUD +
    "/settheCreateInternalTickets",
    settheticketCreationforiNternalTeams,
  );

  yield takeLatest(
    sagaActions.FETCH_TICKET_TICKET_VIEW_LISTED +
    "/setTheInternalDepartmentRetreve_TicketViewsActions",
    gettheticketviewretrivesaga,
  );
  yield takeLatest(
    sagaActions.FETCH_TICKET_FEEDBACKGETED +
    "/setTheInternalDepartmentRetreve_TicketFeedbackActions",
    setthefeedbackpostsagalistedDATA,
  );
  yield takeLatest(
    sagaActions.FETCH_TICKET_LISTED_CHANGES +
    "/setTheInternalDepartmentRetreve_TicketTicketChangesActions",
    getthetickeChangesSaga,
  );

  yield takeLatest(
    sagaActions.FETCH_TCIKETING_INTERNAL_REMARKTGET_ +
    "/setTheInternalDepartmentRetreve_TicketRemarksActions",
    gettheinternalticketingRemarks,
  );

  yield takeLatest(
    sagaActions.FETCH_TICKETING_INTERNAL_TIME_LINE +
    "/setTheInternalDepartmentRetreve_TicketTImelinesActions",
    gettheTicketingTimelineinternal,
  );

  yield takeLatest(
    sagaActions.FETCH_TICKETIGN_FEEDBACKPOST_LIEDD +
    "/setTheInternalDepartment_TicketFeedbackPostActions",
    setthefeedbackinernalpostsagalisted,
  );

  yield takeLatest(
    sagaActions.FETC_INTERNAL_TICKETING_COMMANDPOST +
    "/settheinternaldepartmentcommandpostaction",
    setthecommandsinernalpostsagalisted,
  );

  yield takeLatest(
    sagaActions.FETCH_INTERNAL_TICKET_LISTED_DETPARTMENT_TICKETLISTE +
    "/settheTicketsystemInternalrecordgetListDataActions",
    setTheTicketinglistInternalDepartmentsUsersDatasListSaga,
  );

  yield takeLatest(
    sagaActions.FETCH_INTERNAL_TICKETING_COMMANDGET +
    "/settheinternaldepartmentcommanddatagetaction",
    gettheinternalcommanlisted,
  );

  yield takeLatest(
    sagaActions.FETCH_INTERNAL_TICKETING_CRUDS +
    "/setTheInternalDepartmentRetreve_TicketRemarksCRUDActions",
    settehCrudOfinternalTicketings,
  );

  yield takeLatest(
    sagaActions.FETCH_REMARKS_POSTFOR_INTERNALS +
    "/settheinternaldepartmentRemarksgetaction",
    settheremarksInternal_usersSagapost,
  );

  yield takeLatest(
    sagaActions.FETCH_TCIKETING_INTERNAL_DASHBOARD +
    "/settheTicketsystemrecordgetListInternalDataActions",
    settheInternalDashboardTicketSaga,
  );

  yield takeLatest(
    sagaActions.FETCH_TCIKETING_INTERNAL_DASHBOARD_NEARDUE +
    "/settheTicketsystemrecordgetListInternalNearDueDataActions",
    settheinternalNearDueSagaListed,
  );
  yield takeLatest(
    sagaActions.FETCH_INTERNAL_TICKETING_REJECT_REASSIGN_ASSIGN +
    "/setthereassignandAssignRejectDataActions",
    settheReassignandAssignAndRejectSAGACalls,
  );
  yield takeLatest(
    sagaActions.FETCH_CLIENT_TICKET_DETAILS_FOR_THE_INTERNAL +
    "/settheClientTicketDeatilsDataActions",
    gettheClientTicketDetailslistedforinternal,
  );
  yield takeLatest(
    sagaActions.FETCH_UNREGISTER_ASSIGNS_ACTIONS +
    "/settheTicketUnregisterAssignActions",
    gettheUnregisterAssignOrRejectSagaActions,
  );
  yield takeLatest(
    sagaActions.FETCH_TICKET_DETAILS_IN_ESCALATION_DETAILS +
    "/settheTicketescalationActions",
    gettheexcalationgetsagalisted,
  );

  yield takeLatest(
    sagaActions.FETCH_TICKET_JOUREY_ACTIONS_FOR_THE_CLIENT_TICKETS +
    "/settheTicketTicketJourneyClientsideActions",
    gettheTicketJourneyDatasSaglisted_client,
  );

  yield takeLatest(
    sagaActions.FETCH_TICKET_JOURNEY_FOR_INTERNAL +
    "/settheTicketTicketJourneyActions",
    gettheTicketJourneyDatasSaglisted_internal,
  );

  yield takeLatest(
    sagaActions.FETCH_TICKET_SUB_TICKET_LISTED_DATAS +
    "/settheSubticketgetActions",
    gettheSubticketSagas,
  );

  yield takeLatest(
    sagaActions.FETCH_CLIENT_TICKET_HAS_BEEN_RAISED_TO +
    "/settheclientloneticketactions",
    gettheClientTicketsagalisted,
  );

  yield takeLatest(
    sagaActions.FETCH_CLIENT_CATEGORY_DATA_ACTIONS +
    "/settheClientCategoryDataActions",
    getheClientloneticketraisedsagacatgeory,
  );

  yield takeLatest(
    sagaActions.FETCH_CLIENT_L_ONE_TICKET_IS_RAISING_ONE +
    "/settheClientCategoryDataLonesActions",
    SETTEHClient_ticketAs_raised,
  );

  yield takeLatest(
    sagaActions.FETCH_CLIENT_SUB_CATEGORY_LISTED_API +
    "/settheClientSubcategorylistedActions",
    GETTHEclientSubcategoryActionsaga,
  );

  yield takeLatest(
    sagaActions.FETCH_NOTIFICATION_GET_LISTED_ +
    "/setthenotificationactionsgetlist",
    getthenotificationlistoutsagacalls,
  );

  yield takeLatest(
    sagaActions.FETCH_NOTIFICATION_GET_THE_DELETE_THE_LIST +
    "/setthenotificationactionDeletelist",
    getthenotificationDeletesagacalls,
  );

  yield takeLatest(
    sagaActions.FETCH_NEW_DASHBOARD_RECORDS_OF_DATAS_LISTED +
    "/settheNewDashboardRecordsActions",
    gettheNewDashboardRecordOflisted,
  );

  yield takeLatest(
    sagaActions.FETCH_SUB_ASSIGNED_TICKET_LISTED_DASBOARDS +
    "/settheSubAssignDashboardRecordsActions",
    gettheSubassignedTicketDashboardSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_ADVANCE_ATTENDANCE_DASHBOARD_OF_STATE_DATAS +
    "/settheAdvanceStateDatasHold",
    gettheAdvanceAttendance_state_Saga,
  );
  yield takeLatest(
    sagaActions.FETCH_ADVANCE_ATTENDANCE_DASHBOARD_OF_TABLE_RECORDS +
    "/settheAdvanceEmployeeDatasHold",
    gettheAdvanceAttendance_Employee_list_Saga,
  );
  yield takeLatest(
    sagaActions.FETCH_ADVANCE_ATTENDANCE_DASHBOARD_OF_EMPLOYEE_COUNTS +
    "/settheAdvanceEmployeeDatas_countsHold",
    gettheAdvanceAttendance_Employee_Count_Saga,
  );

  yield takeLatest(
    sagaActions.FETCH_SECOND_STATE_OF_ADVANCE_ATTENDANCE_RECORDS +
    "/settheAdvancDatas_SecondStateHold",
    gettheAdvanceAttendance_Second_state_Saga,
  );

  yield takeLatest(
    sagaActions.FETCH_REGIONAL_MANAGER_ONBOARDDER_DATE_RECORDS +
    "/settheOnboarderdatalistedactions",
    setthermOnboarderDetailsPOsted,
  );

  yield takeLatest(
    sagaActions.FETCH_CUSTOMER_SUPPORTS_DASHBOARD_DEPARTMENTDATAS +
    "/setCustomer_table_dashboard",
    setthe_customer_support_tablewithdepartments,
  );

  yield takeLatest(
    sagaActions.FETCH_INTERNAL_DASHBOARD_CATEGORYDATAS +
    "/setinternaltable_dashboard",
    setthe_internal_data_tablewithcategory,
  );

  yield takeLatest(
    sagaActions.FETCH_CUSTOMER_SUPPORTS_DASHBOARD_STATEBASED +
    "/setState_based_customerdashboard",
    getthestatebasedCustomner_ticketstatus,
  );

  yield takeLatest(
    sagaActions.FETCH_INTERNAL_DASHBOARD_STATE_BASED +
    "/setStatebasedInternalTable",
    getthestatebasedinternalticketstatus,
  );

  yield takeLatest(
    sagaActions.FETCH_INTERNAL_DASHBOARD_ESCALATION_BASED +
    "/settheInternalescalationActions",
    gettheEscalationlevelfor_internalsupport,
  );

  yield takeLatest(
    sagaActions.FETCH_CUSTOMER_SUPPORTS_DASHBOARD_ESCALATIONSBASED +
    "/settheexternalescalation_dashboardsactions",
    gettheEscalationlevelfor_Externalsupport,
  );

  yield takeLatest(
    sagaActions.FETCH_CUSTOMER_SUPPORT_TRENDING_TICKETS +
    "/clearTicketTrendState",
    gettheCustomer_support_trendingtickets,
  );
  yield takeLatest(
    sagaActions.FETCH_PERFORMANCE_MATRIX_DATAS +
    "/clearPerformance_MatrixState",
    getthePerformance_MatrixdatasSagas,
  );

  yield takeLatest(
    sagaActions.FETCH_ISSUESCATEGORY_TOP_FIVE_DATAS +
    "/clearChartCategory_State",
    getthecategoryfivechartrecordssaga,
  );
  yield takeLatest(
    sagaActions.FETCH_HIGHESTCOUNT_OFCARDS + "/clearCustomerSupportCardState",
    getthecustom_support_RegionalTabcard,
  );

  yield takeLatest(
    sagaActions.FETCH_STATE_CHART_RESPONSE_ACTIONS +
    "/clearCustomerSupportStateChart",
    gettheState_chart_customSaga,
  );
  yield takeLatest(
    sagaActions.FETCH_REGIONAL_LIST_RESPONSE_ACTIONS +
    "/clearCustomerSupportRegionalList",
    gettheRegional_listed_customSaga,
  );

  yield takeLatest(
    sagaActions.FETCH_REGION_CHART_RESPONSE_ACTIONS +
    "/clearCustomerSupportRegionalChart",
    getRegional_chart_saga,
  );
  yield takeLatest(
    sagaActions.FETCH_ZONE_CHART_RESPONSE_ACTIONS +
    "/clearCustomerSupportZoneChart",
    gettheZone_chartSaga,
  );

  yield takeLatest(
    sagaActions.FETCH_ZONE_LIST_RESPONSE_ACTIONS +
    "/clearCustomerSupportZoneList",
    gettheZone_ListedSaga,
  );

  yield takeLatest(
    sagaActions.FETCH_CLIENT_LIST_RESPONSE_ACTIONS +
    "/clearCustomerSupportClientList",
    gettheClientCustom_ListedSaga,
  );

  yield takeLatest(
    sagaActions.FETCH_CLIENT_CHART_RESPONSE_ACTIONS +
    "/clearCustomerSupportClientChart",
    gettheClientCustom_ChartedSaga,
  );

  yield takeLatest(
    sagaActions.FETCH_CUSTOM_STATE_LISTEDACTIONS +
    "/clearCustomerSupportStateList",
    gettheCustom_state_listed_sagas,
  );

  yield takeLatest(
    sagaActions.FETCH_CATEGORY_LISTED_CUSTOM_API_CALLS +
    "/clearCategoryList_State",
    gettheCustom_categoryListed_saga,
  );

  yield takeLatest(
    sagaActions.FETCH_PERFORMANCE_MATRIX_API_CALLS +
    "/clearCustomPerformanceMatrixState",
    getthe_performance_matrix_sagas,
  );

  // internal
  yield takeLatest(
    sagaActions.FETCH_INTERNAL_PERFORMANCE_MATRIX_API_CALLS +
    "/clearInternalCustomPerformanceMatrix",
    get_internal_custom_performance_matrix,
  );

  yield takeLatest(
    sagaActions.FETCH_INTERNAL_CATEGORY_TOP_FIVE +
    "/clearInternalCategoryTopFive",
    get_internal_issue_category_topfive,
  );

  yield takeLatest(
    sagaActions.FETCH_INTERNAL_CATEGORY_LIST + "/clearInternalCategoryList",
    get_internal_issue_category_list,
  );

  yield takeLatest(
    sagaActions.FETCH_INTERNAL_STATE_CHART_DATA +
    "/clearInternalSupportChartState",
    get_internal_support_state_chart,
  );

  yield takeLatest(
    sagaActions.FETCH_INTERNAL_REGION_CHART_DATA +
    "/clearInternalSupportRegionalChart",
    get_internal_support_regional_chart,
  );

  yield takeLatest(
    sagaActions.FETCH_INTERNAL_REGION_LIST_DATA +
    "/clearInternalSupportRegionalList",
    get_internal_support_regional_list,
  );

  yield takeLatest(
    sagaActions.FETCH_INTERNAL_ZONE_CHART_DATA +
    "/clearInternalSupportZoneChart",
    get_internal_support_zone_chart,
  );

  yield takeLatest(
    sagaActions.FETCH_INTERNAL_ZONE_LIST_DATA + "/clearInternalSupportZoneList",
    get_internal_support_zone_list,
  );

  yield takeLatest(
    sagaActions.FETCH_INTERNAL_CLIENT_CHART_DATA +
    "/clearInternalSupportClientChart",
    get_internal_support_client_chart,
  );

  yield takeLatest(
    sagaActions.FETCH_INTERNAL_CLIENT_LIST_DATA +
    "/clearInternalSupportClientList",
    get_internal_support_client_list,
  );

  yield takeLatest(
    sagaActions.FETCH_INTERNAL_SUPPORT_STATE_LIST +
    "/clearInternalSupportStateList",
    get_InternalSupportStateList,
  );
  yield takeLatest(
    sagaActions.FETCH_INTERNAL_PERFORMANCE_DATA +
    "/clearInternalPerformanceState",
    get_internal_support_performanceMarix,
  );
  yield takeLatest(
    sagaActions.FETCH_INTERNAL_SUPPORT_TRENDS_TICKETS +
    "/clearInternalSupportGraph_TrendActions",
    gettheInternalSupportTrendTickets,
  );

  yield takeLatest(
    sagaActions.FETCH_CUSTOMER_STATE_LISTED + "/resetStateData",
    getthecustomer_state_listed_regionalTab,
  );

  yield takeLatest(
    sagaActions.FETCH_CUSTOMER_REGION_LISTED + "/resetRegionalData",
    getthe_customer_regional_popupResponse,
  );

  yield takeLatest(
    sagaActions.FETCH_CUSYOMER_ZONE_LISTED + "/resetZoneData",
    getthe_customer_zone_Saga_listed,
  );

  yield takeLatest(
    sagaActions.FETCH_CUSTOMER_CLIENT_LISTEDS + "/resetClientData",
    getthe_client_listed_sagaListedFun,
  );

  yield takeLatest(
    sagaActions.FETCH_INTERN_SUPPORT_LSITED_REGIONS +
    "/resetInternalRegionData",
    get_the_regional_internal_listedTabs,
  );

  yield takeLatest(
    sagaActions.FETCH_INTERNAL_SUPPORT_LISTED_ZONES + "/resetZoneData_internal",
    getthe_internal_zone_listed_tabs,
  );

  yield takeLatest(
    sagaActions.FETCH_INTERNAL_SUPPORTS_LISTED_CLIENT +
    "/resetClientData_internal",
    get_internalsupport_client_listTabs,
  );

  yield takeLatest(
    sagaActions.FETCH_EMPLOYEE_EXITING_EDIT_ACTIONS +
    "/resetEmployeeEditActionsdata",
    Updatedthe_Employee_exitingEdit_actionsSaga,
  );

  yield takeLatest(
    sagaActions.FETCH_MASTER_DASHBOARD_LISTEDRECORDS +
    "/resetMasterdashData_internal",
    get_masterDashbpard_record_lists,
  );

  yield takeLatest(
    sagaActions.FETCH_MASTER_DASHBOARDCURDS_DETAILS +
    "/resetMasterdashData_Crud_opretions",
    masterDashboardCrudSaga,
  );

  yield takeLatest(
    sagaActions.FETCH_ORGANIZATION_LISTED_FILTERS +
    "/resetOrganizationFilterlist",
    gettheOrganization_filterListed,
  );
  yield takeLatest(
    sagaActions.FETCH_ORGANIZATION_RM_LISTED_FILTERS +
    "/resetOrganizationRmFilterlist",
    gettheOrganizationRm_filterListed,
  );
  yield takeLatest(
    sagaActions.FETCH_CLIENT_DIVISION_LEVEL_DROPDOWN +
    "/resetClientDivisionLevelDropdown",
    gettheClientDivisionLevel_dropdown,
  );

  yield takeLatest(
    sagaActions.FETCCH_ATTENDANCE_SUMMARY_REPORTED_DATAS +
    "/settheAdvanceEmployeeDatas_summaryHold",
    gettheAdvanceAttendance_Employee_listSummary_reportsSaga,
  );

  yield takeLatest(
    sagaActions.FETCH_GRIVANCE_LISTEXPORT_OPTIONS +
    "/setGrievanceEMPexportAction",
    getthe_grievance_listedexports,
  );

  yield takeLatest(
    sagaActions.FECTCH_EXPORT_APPOINTMENT_LETTER_EXPORTACTIONS +
    "/setAppointmentEMPexportAction",
    getthe_Appointment_export_annualexports,
  );

  yield takeLatest(
    sagaActions.FEETCH_EXPORT_SALARY_ANNUAL_EXPORTACTIONS +
    "/setSalaryEMPexportAction",
    getthe_salary_export_annualexports,
  );

  yield takeLatest(
    sagaActions.FECTCH_SALARY_EXPORT_REVISION_ACTIONS +
    "/setSalaryexport_revision_Action",
    getthe_salary_export_Revisionexports,
  );

  yield takeLatest(
    sagaActions.FECTCH_CONTRACT_RENEWAL_LETTER_ACTIONS +
    "/setContractRenewalAction",
    getthe_Contract_export_exports,
  );

  yield takeLatest(
    sagaActions.FECTCH_SALARY_REVISION_LETTER_CHANGE_ACTIONS +
    "/setSalaryRevisionChangeAction",
    getthe_salary_revision_letter_export,
  );

  yield takeLatest(
    sagaActions.FETCH_WARNING_LETTER_POOR_PERFORMANCE_ACTIONS +
    "/setWarningPoorPerformanceAction",
    get_waringin_letter_poor_performances,
  );

  yield takeLatest(
    sagaActions.FETCH_SHOW_CAUSE_ABSCONDING_ACTIONS +
    "/setShowCauseAbscondingAction",
    get_showcause_letter_performances,
  );

  yield takeLatest(
    sagaActions.FETCH_GENERATED_LETTER_ACTIONS + "/setGenerated_letterAction",
    get_Genated_letter_performances,
  );

  yield takeLatest(
    sagaActions.FETCH_ADVANCEATTENDANCE_PARTICULAR_COUNTS +
    "/settheAdvanceEmployeeDatasparticular_countsHold",
    gettheAdvanceAttendance_Employee_Count_Saga_particular_client,
  );
  yield takeLatest(
    sagaActions.FETCH_ADVANCEATTENDANCE_STATE_PARTICULAR +
    "/settheAdvanceState_particularDatasHold",
    gettheAdvanceAttendance_state_Saga_particular,
  );

  yield takeLatest(
    sagaActions.FETCH_ADVANCEATTENDANCE_SECONDSTATE_PARTICULAR +
    "/settheAdvancDatas_Second_particularStateHold",
    gettheAdvanceAttendance_Second_state_Saga_particular,
  );

  yield takeLatest(
    sagaActions.FETCH_ADVANCEATTENDANCE_EMPLOYEE_PARTICULAR +
    "/settheAdvanceEmployeeDatas_particularHold",
    gettheAdvanceAttendance_Employee_list_Saga_particular,
  );

  yield takeLatest(
    sagaActions.FETCH_ADVANCEATTENDANCE_SUMMARY_PARTICULAR +
    "/settheAdvanceEmployeeDatas_summary_particularHold",
    gettheAdvanceAttendance_Employee_listSummary_reportsSaga_particular,
  );
  yield takeLatest(getPresignedUrlRequest.type, getPresignedUrlSaga);
  yield takeLatest(uploadSignatureRequest.type, uploadSignatureSaga);
  yield takeLatest(getEmployeeEsignRetrieveRequest.type, getEmployeeEsignRetrieveSaga);
  yield takeLatest(updateEmployeeEsignRequest.type, updateEmployeeEsignSaga);
  yield takeLatest(getPresignedUrlEmployeeEsignRequest.type, getPresignedUrlEmployeeEsignSaga);
  yield takeLatest(uploadSignatureEmployeeEsignRequest.type, uploadSignatureEmployeeEsignSaga);

  yield takeLatest(
    sagaActions.FETCH_EMPLOYEEE_RETRIEVER_URL_API_CALLS +
    "/setSignatureEmployeeRetrieveAction",
    getthe_retrirve_of_employee_details,
  );
  yield takeLatest(
    sagaActions.FETCH_SELFONBOARDING_RETRIEVE +
    "/setSelfonboardingRetrieveAction",
    getthe_selfonboarding_retrieve,
  );
  yield takeLatest(
    sagaActions.FETCH_EMPLOYEE_E_SIGNATURE_UPDATIONS_ACTION_TRIGGER +
    "/setSignatureEmployeeUpdatedAction",
    Update_the_employee_esignature_forms,
  );
  yield takeLatest(
    sagaActions.FETCH_USER_FORM_EXPORTS_CALLING_HERE_FORM_REQUESTED +
    "/setFormExportsUsersRetrieveAction",
    user_retrieve_saga_forthe_form_exports,
  );

  yield takeLatest(
    sagaActions.FETCH_USER_FORM_APPORVE_REQUESTED_LISED +
    "/setFormReportsUpdatedAction",
    user_Updations_saga_forthe_form_exports,
  );

  yield takeLatest(
    sagaActions.FECTCH_SKILL_ASSESSMENTS_DASHBAORD_COUNTS_ACTIONS +
    "/setSkillAssessmentDashboardCountAction",
    Skill_assessments_dashbpoard_countss_sagas,
  );

  yield takeLatest(
    sagaActions.FETCH_HRMS_CONNECTIVITY_LIST_API +
    "/getHrmsConnectivityListAction",
    getHrmsConnectivityListSaga,
  );

  yield takeLatest(
    sagaActions.FETCH_ID_CARD_LIST_API + "/getIdCardListAction",
    getIdCardListSaga,
  );

  yield takeLatest(
    sagaActions.FETCH_HRMS_CONNECTIVITY_UPDATE_API +
    "/setHrmsConnectivityUpdateAction",
    hrmsConnectivityUpdateSaga,
  );

  yield takeLatest(
    sagaActions.FETCH_HRMS_CONNECTIVITY_STATUS_UPDATE_API +
    "/setHrmsConnectivityStatusUpdateAction",
    hrmsConnectivityStatusUpdateSaga,
  );

  yield takeLatest(
    sagaActions.FETCH_SMART_CONNECT_EMPLOYEE_LIST +
    "/getSmartConnectEmployeeListRequest",
    getSmartConnectEmployeeListSaga,
  );

  yield takeLatest(
    sagaActions.FETCH_SMART_CONNECT_BULK_UPLOAD +
    "/smartConnectBulkUploadRequest",
    smartConnectBulkUploadSaga,
  );

  yield takeLatest(
    getSmartConnectHiringListRequest.type,
    getSmartConnectHiringListSaga,
  );
}

export default watchGetUser;
